/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 125);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(155);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(53)('wks');
var uid = __webpack_require__(29);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var ctx = __webpack_require__(16);
var hide = __webpack_require__(11);
var has = __webpack_require__(12);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(17)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(80);
var toPrimitive = __webpack_require__(49);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(113);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(21);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(83);
var defined = __webpack_require__(47);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(160)();
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(261),
    getValue = __webpack_require__(266);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(28);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(82);
var enumBugKeys = __webpack_require__(54);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(47);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(152), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    getRawTag = __webpack_require__(262),
    objectToString = __webpack_require__(263);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(12);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(188), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(208), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(210);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(105);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(224);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(228);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(105);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(251),
    listCacheDelete = __webpack_require__(252),
    listCacheGet = __webpack_require__(253),
    listCacheHas = __webpack_require__(254),
    listCacheSet = __webpack_require__(255);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(111);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(275);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(77);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(129)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(79)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(131);
var enumBugKeys = __webpack_require__(54);
var IE_PROTO = __webpack_require__(52)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(48)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(84).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(46);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(53)('keys');
var uid = __webpack_require__(29);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(20) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(28);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(170);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisibleActivityList = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _values = __webpack_require__(63);

var _values2 = _interopRequireDefault(_values);

var _reactRedux = __webpack_require__(32);

var _moment = __webpack_require__(64);

var _moment2 = _interopRequireDefault(_moment);

var _storage = __webpack_require__(187);

var _constants = __webpack_require__(67);

var _selectors = __webpack_require__(66);

var _actions = __webpack_require__(206);

var _ActivityList = __webpack_require__(207);

var _ActivityList2 = _interopRequireDefault(_ActivityList);

var _charts = __webpack_require__(109);

var _reselect = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getActivities = function getActivities(state) {
  return state.activities;
};
var getSelectedLanguages = function getSelectedLanguages(state) {
  return state.selectedLanguages;
};
var getSelectedActivityTypes = function getSelectedActivityTypes(state) {
  return state.selectedActivityTypes;
};
var getSelectedFilters = function getSelectedFilters(state) {
  return state.selectedFilters;
};
var getActors = function getActors(state) {
  return state.actors;
};
var getLanguages = function getLanguages(state) {
  return state.languages;
};
var getSelectedActors = function getSelectedActors(state) {
  return state.selectedActors;
};

var getAvailableActivities = (0, _reselect.createSelector)([getActivities, getSelectedLanguages, getSelectedActivityTypes, getSelectedFilters, getActors, getLanguages], function (activities, selectedLanguages, selectedActivityTypes, selectedFilters, actors, languages) {
  var visibleActivities = (0, _storage.denormalizeActivities)((0, _values2.default)(activities), actors, languages);
  var selectedLanguageList = selectedLanguages.length ? selectedLanguages.split(',') : [];
  var selectedActivityTypeList = selectedActivityTypes.length ? selectedActivityTypes.split(',') : [];
  // we need to filter against the component_name of the activity, so get that data
  selectedActivityTypeList = selectedActivityTypeList.map(function (at) {
    return _constants.activityTypes.find(function (vt) {
      return vt.name === at;
    }).component_name;
  });

  // only show selected activity types
  if (selectedActivityTypeList.length) {
    visibleActivities = visibleActivities.filter(function (i) {
      return selectedActivityTypeList.includes(i.component_name);
    });
  }

  if (selectedLanguageList.length) {
    visibleActivities = visibleActivities.filter(function (item) {
      if (!item.actor.languages) {
        return false;
      }
      return item.actor.languages.some(function (s) {
        return selectedLanguageList.find(function (z) {
          return z === s.name;
        });
      });
    });
  }

  selectedFilters.forEach(function (filterName) {
    visibleActivities = visibleActivities.filter(_selectors.filterMap[filterName]);
  });

  return (0, _storage.sortActivities)(visibleActivities, _moment2.default);
});

var getVisibleActivities = (0, _reselect.createSelector)([getAvailableActivities, getSelectedActors, getActors, getLanguages], function (activities, selectedActors, actors, languages) {
  var selectedActorList = selectedActors.length ? selectedActors.split(',') : [];
  var visibleActivities = activities;

  // for direct lookups
  if (selectedActorList && selectedActorList.length) {
    return visibleActivities.filter(function (item) {
      return selectedActorList.find(function (s) {
        return s === item.actor.name;
      });
    });
  }
  return (0, _storage.sortActivities)(visibleActivities, _moment2.default);
});

var getReactSelectValues = function getReactSelectValues(actors) {
  /** (react-select only) Return available actors in format acceptable to react-select **/
  return (0, _values2.default)(actors).map(function (actor) {
    return {
      value: actor.name,
      label: actor.name
    };
  });
};

var getAvailableLanguages = (0, _reselect.createSelector)([getLanguages, getActors], function (languages, actors) {
  return (0, _storage.selectLanguagesFromActors)(languages, (0, _values2.default)(actors));
});

var getAvailableLanguagesReactSelectValues = (0, _reselect.createSelector)([getAvailableLanguages], function (languages) {
  return getReactSelectValues(languages);
});

var getAvailableActors = (0, _reselect.createSelector)([getActors, getAvailableActivities], function (actors, activities) {
  return (0, _values2.default)(actors).filter(function (actor) {
    return activities.find(function (activity) {
      return activity.actor.id === actor.id;
    });
  });
});

var getAvailableActorsReactSelectValues = (0, _reselect.createSelector)([getAvailableActors], function (actors) {
  return getReactSelectValues(actors);
});

var getCountLanguagesFromActivities = (0, _reselect.createSelector)([getVisibleActivities], function (activities) {
  return (0, _storage.countLanguagesFromActivities)(activities);
});

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    activities: getVisibleActivities(state),
    activitiesPie: (0, _charts.getActivityLanguagePieData)(getCountLanguagesFromActivities(state)),
    activitiesLine: (0, _charts.getActivityTimeChartData)(getVisibleActivities(state), _moment2.default),
    actors: state.actors,
    actors_select: getReactSelectValues(state.actors),
    availableActors: getAvailableActors(state),
    availableActors_select: getAvailableActorsReactSelectValues(state),
    selectedActors: state.selectedActors,
    languages: state.languages,
    availableLanguages: getAvailableLanguages(state),
    availableLanguages_select: getAvailableLanguagesReactSelectValues(state),
    languages_select: getReactSelectValues(state.languages),
    selectedLanguages: state.selectedLanguages,
    activityTypes: state.activityTypes,
    activityTypes_select: getReactSelectValues(state.activityTypes),
    selectedActivityTypes: state.selectedActivityTypes,
    filters: state.filters,
    selectedFilters: state.selectedFilters
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onActivityClick: function onActivityClick(id) {
      dispatch((0, _actions.toggleActivity)(id));
    },
    onSelectedActorChange: function onSelectedActorChange(value) {
      dispatch({
        type: 'CHANGE_SELECTED_ACTORS',
        value: value
      });
    },
    onSelectedLanguageChange: function onSelectedLanguageChange(value) {
      dispatch({
        type: 'CHANGE_SELECTED_LANGUAGES',
        value: value
      });
    },
    onSelectedLanguageAdd: function onSelectedLanguageAdd(value) {
      dispatch({
        type: 'ADD_SELECTED_LANGUAGE',
        value: value
      });
    },
    onSelectedActivityTypesChange: function onSelectedActivityTypesChange(value) {
      dispatch({
        type: 'CHANGE_SELECTED_ACTIVITY_TYPES',
        value: value
      });
    },
    onSelectedFiltersChange: function onSelectedFiltersChange(value) {
      dispatch({
        type: 'CHANGE_SELECTED_FILTERS',
        value: value
      });
    }
  };
};

var VisibleActivityList = exports.VisibleActivityList = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ActivityList2.default);

exports.default = VisibleActivityList;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(184), __esModule: true };

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterMap = undefined;

var _values = __webpack_require__(63);

var _values2 = _interopRequireDefault(_values);

exports.availableActivityTypes = availableActivityTypes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notTypoFixes = function notTypoFixes(activity) {
  return !activity.title.match(/(typo|Typo|spelling|Spelling|note|Note|correct|Correct|Fix type|Fix URL|print statement|Remove duplicate|f\-string)/i);
};
var notDocImprovements = function notDocImprovements(activity) {
  return !activity.title.match(/(doc|Doc|license|LICENSE|README|readme|link|Link|\.md|instructions|Instructions|guidelines|pypi|pypi badge|AUTHORS|License|changelog|label|copyright|add cookiecutter|issue template|awesome-|front-end frameworks|Examples for issue)|to other tools|sphinx|RelayHooks-Introduction|Changelog|changelog|CHANGES|highlight|Format migration/i);
};
var notCodeStyleTweaks = function notCodeStyleTweaks(activity) {
  return !activity.title.match(/(indent|Indent|whitespace|spacing|lint|Lint|sort|Sort|jshint|PEP|pep8|tabs|Tabs|Ignore|ignore|__about__|(unused|missing) import|(docs?|code|README|readability|wording) (t|T)weak|(t|T)weak param|hash|modernize|Add raven module|trivial|babelrc|dependency|MANIFEST.in|Pythonic|pythonic|exportable|empty line|Typing|typing|Typings|typings|@types|chore:|Format migration|editorconfig|bikeshed|Add \`mypy\`)/i);
};
var onlyMerged = function onlyMerged(activity) {
  return "accepted_date" in activity ? activity.accepted_date : true;
};

var filterMap = exports.filterMap = {
  "Hide Spelling Contributions": notTypoFixes,
  "Hide Documentation Contributions": notDocImprovements,
  "Hide Code Style Contributions": notCodeStyleTweaks,
  "Hide Unmerged Contributions": onlyMerged
};

function availableActivityTypes(activities, activityTypeMap) {
  return activityTypeMap.filter(function (activityType) {
    return (0, _values2.default)(activities).find(function (activity) {
      return activity.component_name === activityType.component_name;
    });
  });
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_DATA = exports.ACTIVITIES = exports.ACTORS = exports.DEFAULT_SELECTED_FILTERS = exports.activityTypes = undefined;

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(190);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _normalizr = __webpack_require__(195);

var _precheckData = __webpack_require__(196);

var _expandData = __webpack_require__(197);

var _gh_activities = __webpack_require__(202);

var _gh_activities2 = _interopRequireDefault(_gh_activities);

var _gh_actors = __webpack_require__(203);

var _gh_actors2 = _interopRequireDefault(_gh_actors);

var _my_activities = __webpack_require__(204);

var _my_activities2 = _interopRequireDefault(_my_activities);

var _my_actors = __webpack_require__(205);

var _my_actors2 = _interopRequireDefault(_my_actors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activityTypes = exports.activityTypes = [{
  name: 'Open Source Contributions',
  singular_name: 'Open Source Contribution',
  component_name: 'Patch'
}, {
  name: 'Applications',
  singular_name: 'Application',
  component_name: 'SoftwareApp'
}, {
  name: 'Libraries',
  singular_name: 'Library',
  component_name: 'SoftwareLib'
}, {
  name: 'Work',
  singular_name: 'Work',
  component_name: 'Work'
}, {
  name: 'Publications',
  singular_name: 'Publication',
  component_name: 'Publication'
}, {
  name: 'Volunteering',
  singular_name: 'Volunteering',
  component_name: 'Volunteer'
}, {
  name: 'Websites',
  singular_name: 'Website',
  component_name: 'Website'
}, {
  name: 'Articles',
  singular_name: 'Article',
  component_name: 'Article'
}]; /* eslint-disable import/no-extraneous-dependencies */
var DEFAULT_SELECTED_FILTERS = exports.DEFAULT_SELECTED_FILTERS = ['Hide Spelling Contributions', 'Hide Documentation Contributions', 'Hide Code Style Contributions', 'Hide Unmerged Contributions'];

var ACTORS = exports.ACTORS = [].concat((0, _toConsumableArray3.default)(_gh_actors2.default), (0, _toConsumableArray3.default)(_my_actors2.default));

(0, _precheckData.validateActors)(ACTORS);

// Resolve ID to object relationships so they're available in data
var ACTIVITIES = exports.ACTIVITIES = (0, _expandData.expandRelations)([].concat((0, _toConsumableArray3.default)(_gh_activities2.default), (0, _toConsumableArray3.default)(_my_activities2.default)), ACTORS);

var activityType = new _normalizr.schema.Entity('activityTypes', {}, {
  idAttribute: 'component_name'
});

var language = new _normalizr.schema.Entity('languages', {}, { idAttribute: 'name' });
var actor = new _normalizr.schema.Entity('actors', { languages: [language] }, {
  idAttribute: 'id'
});
var normalizedActivityTypes = (0, _normalizr.normalize)(activityTypes, [activityType]);
var activity = new _normalizr.schema.Entity('activities', { actor: actor, component_name: activityType }, {
  processStrategy: function processStrategy(entity) {
    return (0, _assign2.default)({}, entity, {
      visible: false,
      component_name: normalizedActivityTypes.entities.activityTypes[entity.component_name]
    });
  }
});

var INITIAL_DATA = exports.INITIAL_DATA = (0, _normalizr.normalize)(ACTIVITIES, [activity]);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var LIBRARY = __webpack_require__(20);
var wksExt = __webpack_require__(68);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(250),
    isObjectLike = __webpack_require__(27);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(267),
    mapCacheDelete = __webpack_require__(274),
    mapCacheGet = __webpack_require__(276),
    mapCacheHas = __webpack_require__(277),
    mapCacheSet = __webpack_require__(278);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(295),
    baseKeys = __webpack_require__(302),
    isArrayLike = __webpack_require__(120);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(77);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObjectLike = __webpack_require__(27);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 78 */
/***/ (function(module, exports) {



/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(20);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(81);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(22);
var $iterCreate = __webpack_require__(130);
var setToStringTag = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(85);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(17)(function () {
  return Object.defineProperty(__webpack_require__(48)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(12);
var toIObject = __webpack_require__(13);
var arrayIndexOf = __webpack_require__(132)(false);
var IE_PROTO = __webpack_require__(52)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(23);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(12);
var toObject = __webpack_require__(19);
var IE_PROTO = __webpack_require__(52)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134);
var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(22);
var TO_STRING_TAG = __webpack_require__(3)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(23);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(22);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(87);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(28);
var SPECIES = __webpack_require__(3)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(16);
var invoke = __webpack_require__(140);
var html = __webpack_require__(84);
var cel = __webpack_require__(48);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(23)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(55);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(148);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._U = 0;
  this._V = 0;
  this._W = null;
  this._X = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._Y = null;
Promise._Z = null;
Promise._0 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._V === 3) {
    self = self._W;
  }
  if (Promise._Y) {
    Promise._Y(self);
  }
  if (self._V === 0) {
    if (self._U === 0) {
      self._U = 1;
      self._X = deferred;
      return;
    }
    if (self._U === 1) {
      self._U = 2;
      self._X = [self._X, deferred];
      return;
    }
    self._X.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._V === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._V === 1) {
        resolve(deferred.promise, self._W);
      } else {
        reject(deferred.promise, self._W);
      }
      return;
    }
    var ret = tryCallOne(cb, self._W);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._V = 3;
      self._W = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._V = 1;
  self._W = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._V = 2;
  self._W = newValue;
  if (Promise._Z) {
    Promise._Z(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._U === 1) {
    handle(self, self._X);
    self._X = null;
  }
  if (self._U === 2) {
    for (var i = 0; i < self._X.length; i++) {
      handle(self, self._X[i]);
    }
    self._X = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(156);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(99);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(164);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(103);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(58);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var fails = __webpack_require__(17);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(213);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(215);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(82);
var hiddenKeys = __webpack_require__(54).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(25);
var createDesc = __webpack_require__(21);
var toIObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(49);
var has = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(80);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityListProp = exports.activityProp = undefined;

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageProp = {
  color: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired
};

var actorProp = {
  id: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  repo_url: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string,
  languages: _propTypes2.default.arrayOf(_propTypes2.default.shape(languageProp).isRequired)
};

var activityProp = exports.activityProp = {
  id: _propTypes2.default.number.isRequired,
  component_name: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string,
  actor: _propTypes2.default.shape(actorProp).isRequired,
  featured: _propTypes2.default.object,
  created_date: _propTypes2.default.string.isRequired,
  accepted_date: _propTypes2.default.string,
  end_date: _propTypes2.default.string
};

var activityListProp = exports.activityListProp = {
  activities: _propTypes2.default.arrayOf(_propTypes2.default.shape(activityProp).isRequired).isRequired
};

exports.default = activityProp;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActivityLanguagePieData = exports.getActivityTimeChartData = exports.timeLineOptions = exports.pieOptions = undefined;

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pieOptions = exports.pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  title: {
    display: true,
    text: 'Programming Languages',
    position: 'top',
    fontColor: '#4a4a4a',
    fontSize: '14',
    fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
  },
  legend: {
    display: false
  }
};

var timeLineOptions = exports.timeLineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  title: {
    display: true,
    text: 'Time',
    position: 'top',
    fontColor: '#4a4a4a',
    fontSize: '14',
    fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
  },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true
      },
      gridLines: {
        display: true
      }
    }]
  },
  legend: {
    display: false
  }
};

var getActivityTimeChartData = exports.getActivityTimeChartData = function getActivityTimeChartData(activities, moment) {
  /**
   * Return activity data structured for a line chart based on activities.
   *
   * @param activities {Array, <Object>}
   * @param moment <Object> moment.js object
   *
   * Notes on ESLint: https://github.com/airbnb/javascript/issues/719
   */
  var l = activities.reduce(function (acc1, activity) {
    var acc = acc1;
    if (activity.created_date) {
      var year = moment(activity.created_date).get('year');
      if (year in acc) {
        acc[year].count += 1;
      } else {
        acc[year] = {
          count: 1,
          name: year
        };
      }
    }
    return acc;
  }, {});

  // flatten
  l = (0, _keys2.default)(l).map(function (key) {
    return l[key];
  });
  return {
    labels: l.map(function (lang) {
      return lang.name;
    }),
    datasets: [{ data: l.map(function (lang) {
        return lang.count;
      }) }]
  };
};

var getActivityLanguagePieData = exports.getActivityLanguagePieData = function getActivityLanguagePieData(languageCount) {
  /**
   * Return activity data structured for a line chart based on activities.
   *
   * @param activities {Array, <Object>}
   */
  // flatten
  var l = (0, _keys2.default)(languageCount).map(function (key) {
    return languageCount[key];
  });
  return {
    labels: l.map(function (lang) {
      return lang.name;
    }),
    datasets: [{
      backgroundColor: l.map(function (lang) {
        return lang.color;
      }),
      data: l.map(function (lang) {
        return lang.count;
      })
    }]
  };
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(39),
    stackClear = __webpack_require__(256),
    stackDelete = __webpack_require__(257),
    stackGet = __webpack_require__(258),
    stackHas = __webpack_require__(259),
    stackSet = __webpack_require__(260);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObject = __webpack_require__(72);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 114 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(279),
    arraySome = __webpack_require__(282),
    cacheHas = __webpack_require__(283);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(297),
    isObjectLike = __webpack_require__(27);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(8),
    stubFalse = __webpack_require__(298);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ }),
/* 118 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(299),
    baseUnary = __webpack_require__(300),
    nodeUtil = __webpack_require__(301);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(112),
    isLength = __webpack_require__(75);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(72);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(124),
    toKey = __webpack_require__(44);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isKey = __webpack_require__(76),
    stringToPath = __webpack_require__(328),
    toString = __webpack_require__(331);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(126);
module.exports = __webpack_require__(151);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(127);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof _promise2.default === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(147).enable();
  window.Promise = __webpack_require__(149);
}

// fetch() polyfill for making API calls.
__webpack_require__(150);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(56);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(128), __esModule: true };

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78);
__webpack_require__(45);
__webpack_require__(86);
__webpack_require__(137);
__webpack_require__(145);
__webpack_require__(146);
module.exports = __webpack_require__(0).Promise;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(46);
var defined = __webpack_require__(47);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(50);
var descriptor = __webpack_require__(21);
var setToStringTag = __webpack_require__(30);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(18);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(13);
var toLength = __webpack_require__(51);
var toAbsoluteIndex = __webpack_require__(133);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(46);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(135);
var step = __webpack_require__(136);
var Iterators = __webpack_require__(22);
var toIObject = __webpack_require__(13);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(79)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(20);
var global = __webpack_require__(2);
var ctx = __webpack_require__(16);
var classof = __webpack_require__(87);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(10);
var aFunction = __webpack_require__(28);
var anInstance = __webpack_require__(138);
var forOf = __webpack_require__(139);
var speciesConstructor = __webpack_require__(91);
var task = __webpack_require__(92).set;
var microtask = __webpack_require__(141)();
var newPromiseCapabilityModule = __webpack_require__(55);
var perform = __webpack_require__(93);
var userAgent = __webpack_require__(142);
var promiseResolve = __webpack_require__(94);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(143)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(30)($Promise, PROMISE);
__webpack_require__(144)(PROMISE);
Wrapper = __webpack_require__(0)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(95)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(16);
var call = __webpack_require__(88);
var isArrayIter = __webpack_require__(89);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(51);
var getIterFn = __webpack_require__(90);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(92).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(23)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(11);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var core = __webpack_require__(0);
var dP = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(5);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(91);
var promiseResolve = __webpack_require__(94);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(55);
var perform = __webpack_require__(93);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(96);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._Y = null;
  Promise._Z = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._Y = function (promise) {
    if (
      promise._V === 2 && // IS REJECTED
      rejections[promise._1]
    ) {
      if (rejections[promise._1].logged) {
        onHandled(promise._1);
      } else {
        clearTimeout(rejections[promise._1].timeout);
      }
      delete rejections[promise._1];
    }
  };
  Promise._Z = function (promise, err) {
    if (promise._U === 0) { // not yet handled
      promise._1 = id++;
      rejections[promise._1] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._1),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(96);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._0);
  p._V = 1;
  p._W = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

var iterableToArray = function (iterable) {
  if (typeof Array.from === 'function') {
    // ES2015+, iterables exist
    iterableToArray = Array.from;
    return Array.from(iterable);
  }

  // ES5, only arrays and array-likes exist
  iterableToArray = function (x) { return Array.prototype.slice.call(x); };
  return Array.prototype.slice.call(iterable);
}

Promise.all = function (arr) {
  var args = iterableToArray(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._V === 3) {
            val = val._W;
          }
          if (val._V === 1) return res(i, val._W);
          if (val._V === 2) reject(val._W);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    iterableToArray(values).forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(97);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(32);

var _redux = __webpack_require__(61);

var _reduxLogger = __webpack_require__(178);

__webpack_require__(179);

__webpack_require__(180);

__webpack_require__(181);

__webpack_require__(182);

var _App = __webpack_require__(183);

var _App2 = _interopRequireDefault(_App);

var _reducers = __webpack_require__(341);

var _reducers2 = _interopRequireDefault(_reducers);

var _registerServiceWorker = __webpack_require__(348);

var _registerServiceWorker2 = _interopRequireDefault(_registerServiceWorker);

var _constants = __webpack_require__(67);

var _selectors = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _reduxLogger.createLogger)({
  // ...options
});

var store = (0, _redux.createStore)(_reducers2.default, (0, _assign2.default)({}, _constants.INITIAL_DATA.entities, {
  activityTypes: _constants.activityTypes,
  selectedActors: [],
  selectedActivityTypes: [],
  selectedFilters: _constants.DEFAULT_SELECTED_FILTERS,
  selectedLanguages: [],
  filters: _selectors.filterMap
}), (0, _redux.applyMiddleware)(logger));

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(_App2.default, null)
), document.getElementById('root'));
(0, _registerServiceWorker2.default)();

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(154) });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(57);
var pIE = __webpack_require__(25);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(83);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(17)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(56),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.1";


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),m=__webpack_require__(56),r=__webpack_require__(157);function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.1",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.1";


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(158);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(58);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(161);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(101);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(176);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(102);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(172);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31), __webpack_require__(171)(module)))

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(102);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(103);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(177);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(58);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/favicon.f4072767.ico";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ActivityList = __webpack_require__(62);

var _Lenses = __webpack_require__(239);

var _Lenses2 = _interopRequireDefault(_Lenses);

var _Charts = __webpack_require__(245);

var _Charts2 = _interopRequireDefault(_Charts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App() {
  return _react2.default.createElement(
    'div',
    { id: 'app' },
    _react2.default.createElement(
      'div',
      { id: 'v2-notice' },
      'Psst. I\'m working on something new!',
      ' ',
      _react2.default.createElement(
        'a',
        { href: 'https://cv-react-v2.git-pull.com' },
        'Take a peek?'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'github-fork' },
      _react2.default.createElement(
        'span',
        { className: 'author' },
        'Made with',
        ' ',
        _react2.default.createElement(
          'span',
          { role: 'img', 'aria-label': 'love' },
          '\u2764\uFE0F'
        ),
        ' ',
        'by',
        ' ',
        _react2.default.createElement(
          'a',
          {
            href: 'https://tony.sh',
            rel: 'noopener noreferrer',
            target: '_blank'
          },
          'Tony Narlock'
        ),
        '.'
      ),
      _react2.default.createElement('br', null),
      'Written in React (',
      _react2.default.createElement(
        'a',
        {
          href: 'https://github.com/tony/cv/tree/v1/react',
          rel: 'noopener noreferrer',
          target: '_blank'
        },
        'source'
      ),
      ').',
      _react2.default.createElement('br', null),
      'See also: ',
      _react2.default.createElement(
        'a',
        { href: 'https://cv-vue.git-pull.com' },
        'Vue.js version'
      ),
      '.'
    ),
    _react2.default.createElement(
      'div',
      { className: 'header' },
      _react2.default.createElement(
        'h1',
        null,
        'Tony Narlock\'s CV'
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'em',
          null,
          'I appreciate when hiring managers look at my contributions and projects in lieu of technical screens, that let\'s us both know my strengths match the role!'
        )
      ),
      _react2.default.createElement(_Charts2.default, null),
      _react2.default.createElement(_Lenses2.default, null)
    ),
    _react2.default.createElement(_ActivityList.VisibleActivityList, null)
  );
};

exports.default = App;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
module.exports = __webpack_require__(0).Object.values;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(186)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(18);
var toIObject = __webpack_require__(13);
var isEnum = __webpack_require__(25).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countLanguagesFromActivities = exports.selectVisibleActivities = exports.sortActivities = exports.selectActivities = exports.selectActivityIdsFromFilters = exports.selectActivityIdsFromActivityTypes = exports.selectLanguagesFromActors = exports.denormalizeActivities = undefined;

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _values = __webpack_require__(63);

var _values2 = _interopRequireDefault(_values);

exports.selectActorsFromActivities = selectActorsFromActivities;

var _selectors = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectActorsFromActivities(actors, activities) {
  /**
   * Return available Actor targets, minus ones that are filtered out.
   */
  return (0, _values2.default)(actors).filter(function (actor) {
    return activities.find(function (activity) {
      return activity.actor === actor.id;
    });
  });
}

var denormalizeActivities = exports.denormalizeActivities = function denormalizeActivities(activities, actors, languages) {
  return (0, _values2.default)(activities).map(function (activity) {
    return (0, _assign2.default)({}, activity, {
      actor: (0, _assign2.default)({}, actors[activity.actor], {
        languages: actors[activity.actor].languages ? actors[activity.actor].languages.map(function (language) {
          return languages[language];
        }) : []
      })
    });
  });
};

var selectLanguagesFromActors = exports.selectLanguagesFromActors = function selectLanguagesFromActors(languages, actors) {
  return (0, _values2.default)(languages).filter(function (language) {
    return actors.find(function (actor) {
      return actor.languages ? actor.languages.find(function (actorLang) {
        return actorLang === language.name;
      }) : false;
    });
  });
};

var selectActivityIdsFromActivityTypes = exports.selectActivityIdsFromActivityTypes = function selectActivityIdsFromActivityTypes(activityIds, activities, selectedActivityTypes) {
  if (selectedActivityTypes.length) {
    // only show selected activity types
    return activityIds.filter(function (i) {
      return selectedActivityTypes.map(function (sA) {
        return sA.component_name;
      }).includes(activities[i].component_name);
    });
  }
  return activityIds;
};

var selectActivityIdsFromFilters = exports.selectActivityIdsFromFilters = function selectActivityIdsFromFilters(activityIds, activities, selectedFilters) {
  var selectedIds = activityIds;
  if (selectedFilters.length) {
    selectedFilters.forEach(function (filterName) {
      selectedIds = selectedIds.filter(function (i) {
        return _selectors.filterMap[filterName](activities[i]);
      });
    });
    return selectedIds;
  }
  return activityIds;
};

var selectActivities = exports.selectActivities = function selectActivities(activities, selectedActivityTypes, selectedFilters) {
  /**
   * Select activities based on most filters.
   *
   * These results are used by other selectors, and do not include
   * eliminating individual actors, only applying category-type filters
   * and regex-type filters. Not direct actor lookups.
   */
  var selectedIds = (0, _keys2.default)(activities);
  selectedIds = selectActivityIdsFromActivityTypes(selectedIds, activities, selectedActivityTypes);
  selectedIds = selectActivityIdsFromFilters(selectedIds, activities, selectedFilters);

  return selectedIds.map(function (id) {
    return activities[id];
  });
};

var sortActivities = exports.sortActivities = function sortActivities(activities, moment) {
  return activities.sort(function (activity1, activity2) {
    return moment(activity2.created_date).diff(moment(activity1.created_date));
  });
};

var selectVisibleActivities = exports.selectVisibleActivities = function selectVisibleActivities(selectedLanguages, selectedActors, filteredActivities) {
  /**
   * Final selctor, includes direct proejct lookups and programming languages.
   */
  var visibleActivities = filteredActivities;
  visibleActivities = selectedLanguages.length ? visibleActivities.filter(function (activity) {
    var activityLanguages = activity.actor.languages;
    if (!activityLanguages) {
      return false;
    }
    return activityLanguages.some(function (s) {
      return selectedLanguages.find(function (z) {
        return z.name === s.name;
      });
    });
  }) : visibleActivities;

  visibleActivities = selectedActors && selectedActors.length ? visibleActivities.filter(function (activity) {
    return selectedActors.find(function (s) {
      return s.id === activity.actor.id;
    });
  }) : visibleActivities;
  return visibleActivities;
};

var countLanguagesFromActivities = exports.countLanguagesFromActivities = function countLanguagesFromActivities(activities) {
  return activities.reduce(function (languages, activity) {
    var rLanguages = languages;
    var activityLanguages = activity.actor.languages;
    if (activityLanguages && activityLanguages.length) {
      activityLanguages.forEach(function (lang) {
        if (lang.name in rLanguages) {
          rLanguages[lang.name].count += 1;
        } else {
          rLanguages[lang.name] = {
            count: 1,
            color: lang.color,
            name: lang.name
          };
        }
      });
    }
    return rLanguages;
  }, {});
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(189);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19);
var $keys = __webpack_require__(18);

__webpack_require__(104)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(191);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(192), __esModule: true };

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
__webpack_require__(193);
module.exports = __webpack_require__(0).Array.from;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(16);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(19);
var call = __webpack_require__(88);
var isArrayIter = __webpack_require__(89);
var toLength = __webpack_require__(51);
var createProperty = __webpack_require__(194);
var getIterFn = __webpack_require__(90);

$export($export.S + $export.F * !__webpack_require__(95)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(21);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "denormalize", function() { return denormalize$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "schema", function() { return schema; });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */

/**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */
function isImmutable(object) {
  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
  object._map && object._map.hasOwnProperty('__ownerID'))); // Immutable.Record
}
/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */

function denormalizeImmutable(schema, input, unvisit) {
  return Object.keys(schema).reduce(function (object, key) {
    // Immutable maps cast keys to strings on write so we need to ensure
    // we're accessing them using string keys.
    var stringKey = "" + key;

    if (object.has(stringKey)) {
      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
    } else {
      return object;
    }
  }, input);
}

var getDefaultGetId = function getDefaultGetId(idAttribute) {
  return function (input) {
    return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
  };
};

var EntitySchema = /*#__PURE__*/function () {
  function EntitySchema(key, definition, options) {
    if (definition === void 0) {
      definition = {};
    }

    if (options === void 0) {
      options = {};
    }

    if (!key || typeof key !== 'string') {
      throw new Error("Expected a string key for Entity, but found " + key + ".");
    }

    var _options = options,
        _options$idAttribute = _options.idAttribute,
        idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute,
        _options$mergeStrateg = _options.mergeStrategy,
        mergeStrategy = _options$mergeStrateg === void 0 ? function (entityA, entityB) {
      return _extends({}, entityA, entityB);
    } : _options$mergeStrateg,
        _options$processStrat = _options.processStrategy,
        processStrategy = _options$processStrat === void 0 ? function (input) {
      return _extends({}, input);
    } : _options$processStrat,
        _options$fallbackStra = _options.fallbackStrategy,
        fallbackStrategy = _options$fallbackStra === void 0 ? function (key, schema) {
      return undefined;
    } : _options$fallbackStra;
    this._key = key;
    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
    this._idAttribute = idAttribute;
    this._mergeStrategy = mergeStrategy;
    this._processStrategy = processStrategy;
    this._fallbackStrategy = fallbackStrategy;
    this.define(definition);
  }

  var _proto = EntitySchema.prototype;

  _proto.define = function define(definition) {
    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
      var _extends2;

      var schema = definition[key];
      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
    }, this.schema || {});
  };

  _proto.getId = function getId(input, parent, key) {
    return this._getId(input, parent, key);
  };

  _proto.merge = function merge(entityA, entityB) {
    return this._mergeStrategy(entityA, entityB);
  };

  _proto.fallback = function fallback(id, schema) {
    return this._fallbackStrategy(id, schema);
  };

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    var id = this.getId(input, parent, key);
    var entityType = this.key;

    if (!(entityType in visitedEntities)) {
      visitedEntities[entityType] = {};
    }

    if (!(id in visitedEntities[entityType])) {
      visitedEntities[entityType][id] = [];
    }

    if (visitedEntities[entityType][id].some(function (entity) {
      return entity === input;
    })) {
      return id;
    }

    visitedEntities[entityType][id].push(input);

    var processedEntity = this._processStrategy(input, parent, key);

    Object.keys(this.schema).forEach(function (key) {
      if (processedEntity.hasOwnProperty(key) && typeof processedEntity[key] === 'object') {
        var schema = _this.schema[key];
        var resolvedSchema = typeof schema === 'function' ? schema(input) : schema;
        processedEntity[key] = visit(processedEntity[key], processedEntity, key, resolvedSchema, addEntity, visitedEntities);
      }
    });
    addEntity(this, processedEntity, input, parent, key);
    return id;
  };

  _proto.denormalize = function denormalize(entity, unvisit) {
    var _this2 = this;

    if (isImmutable(entity)) {
      return denormalizeImmutable(this.schema, entity, unvisit);
    }

    Object.keys(this.schema).forEach(function (key) {
      if (entity.hasOwnProperty(key)) {
        var schema = _this2.schema[key];
        entity[key] = unvisit(entity[key], schema);
      }
    });
    return entity;
  };

  _createClass(EntitySchema, [{
    key: "key",
    get: function get() {
      return this._key;
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return this._idAttribute;
    }
  }]);

  return EntitySchema;
}();

var PolymorphicSchema = /*#__PURE__*/function () {
  function PolymorphicSchema(definition, schemaAttribute) {
    if (schemaAttribute) {
      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
        return input[schemaAttribute];
      } : schemaAttribute;
    }

    this.define(definition);
  }

  var _proto = PolymorphicSchema.prototype;

  _proto.define = function define(definition) {
    this.schema = definition;
  };

  _proto.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
    return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
  };

  _proto.inferSchema = function inferSchema(input, parent, key) {
    if (this.isSingleSchema) {
      return this.schema;
    }

    var attr = this.getSchemaAttribute(input, parent, key);
    return this.schema[attr];
  };

  _proto.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity, visitedEntities) {
    var schema = this.inferSchema(value, parent, key);

    if (!schema) {
      return value;
    }

    var normalizedValue = visit(value, parent, key, schema, addEntity, visitedEntities);
    return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
      id: normalizedValue,
      schema: this.getSchemaAttribute(value, parent, key)
    };
  };

  _proto.denormalizeValue = function denormalizeValue(value, unvisit) {
    var schemaKey = isImmutable(value) ? value.get('schema') : value.schema;

    if (!this.isSingleSchema && !schemaKey) {
      return value;
    }

    var id = this.isSingleSchema ? undefined : isImmutable(value) ? value.get('id') : value.id;
    var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
    return unvisit(id || value, schema);
  };

  _createClass(PolymorphicSchema, [{
    key: "isSingleSchema",
    get: function get() {
      return !this._schemaAttribute;
    }
  }]);

  return PolymorphicSchema;
}();

var UnionSchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(UnionSchema, _PolymorphicSchema);

  function UnionSchema(definition, schemaAttribute) {
    if (!schemaAttribute) {
      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
    }

    return _PolymorphicSchema.call(this, definition, schemaAttribute) || this;
  }

  var _proto = UnionSchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    return this.normalizeValue(input, parent, key, visit, addEntity, visitedEntities);
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    return this.denormalizeValue(input, unvisit);
  };

  return UnionSchema;
}(PolymorphicSchema);

var ValuesSchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(ValuesSchema, _PolymorphicSchema);

  function ValuesSchema() {
    return _PolymorphicSchema.apply(this, arguments) || this;
  }

  var _proto = ValuesSchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    return Object.keys(input).reduce(function (output, key, index) {
      var _extends2;

      var value = input[key];
      return value !== undefined && value !== null ? _extends({}, output, (_extends2 = {}, _extends2[key] = _this.normalizeValue(value, input, key, visit, addEntity, visitedEntities), _extends2)) : output;
    }, {});
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    var _this2 = this;

    return Object.keys(input).reduce(function (output, key) {
      var _extends3;

      var entityOrId = input[key];
      return _extends({}, output, (_extends3 = {}, _extends3[key] = _this2.denormalizeValue(entityOrId, unvisit), _extends3));
    }, {});
  };

  return ValuesSchema;
}(PolymorphicSchema);

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);

  if (isArray && definition.length > 1) {
    throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  schema = validateSchema(schema);
  var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly

  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity, visitedEntities);
  });
};
var denormalize = function denormalize(schema, input, unvisit) {
  schema = validateSchema(schema);
  return input && input.map ? input.map(function (entityOrId) {
    return unvisit(entityOrId, schema);
  }) : input;
};

var ArraySchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(ArraySchema, _PolymorphicSchema);

  function ArraySchema() {
    return _PolymorphicSchema.apply(this, arguments) || this;
  }

  var _proto = ArraySchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    var values = getValues(input);
    return values.map(function (value, index) {
      return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
    }).filter(function (value) {
      return value !== undefined && value !== null;
    });
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    var _this2 = this;

    return input && input.map ? input.map(function (value) {
      return _this2.denormalizeValue(value, unvisit);
    }) : input;
  };

  return ArraySchema;
}(PolymorphicSchema);

var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  var object = _extends({}, input);

  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var resolvedLocalSchema = typeof localSchema === 'function' ? localSchema(input) : localSchema;
    var value = visit(input[key], input, key, resolvedLocalSchema, addEntity, visitedEntities);

    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

var _denormalize = function denormalize(schema, input, unvisit) {
  if (isImmutable(input)) {
    return denormalizeImmutable(schema, input, unvisit);
  }

  var object = _extends({}, input);

  Object.keys(schema).forEach(function (key) {
    if (object[key] != null) {
      object[key] = unvisit(object[key], schema[key]);
    }
  });
  return object;
};

var ObjectSchema = /*#__PURE__*/function () {
  function ObjectSchema(definition) {
    this.define(definition);
  }

  var _proto = ObjectSchema.prototype;

  _proto.define = function define(definition) {
    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
      var _extends2;

      var schema = definition[key];
      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
    }, this.schema || {});
  };

  _proto.normalize = function normalize() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _normalize.apply(void 0, [this.schema].concat(args));
  };

  _proto.denormalize = function denormalize() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _denormalize.apply(void 0, [this.schema].concat(args));
  };

  return ObjectSchema;
}();

var visit = function visit(value, parent, key, schema, addEntity, visitedEntities) {
  if (typeof value !== 'object' || !value) {
    return value;
  }

  if (typeof schema === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
    var method = Array.isArray(schema) ? normalize : _normalize;
    return method(schema, value, parent, key, visit, addEntity, visitedEntities);
  }

  return schema.normalize(value, parent, key, visit, addEntity, visitedEntities);
};

var addEntities = function addEntities(entities) {
  return function (schema, processedEntity, value, parent, key) {
    var schemaKey = schema.key;
    var id = schema.getId(value, parent, key);

    if (!(schemaKey in entities)) {
      entities[schemaKey] = {};
    }

    var existingEntity = entities[schemaKey][id];

    if (existingEntity) {
      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
    } else {
      entities[schemaKey][id] = processedEntity;
    }
  };
};

var schema = {
  Array: ArraySchema,
  Entity: EntitySchema,
  Object: ObjectSchema,
  Union: UnionSchema,
  Values: ValuesSchema
};
var normalize$1 = function normalize(input, schema) {
  if (!input || typeof input !== 'object') {
    throw new Error("Unexpected input given to normalize. Expected type to be \"object\", found \"" + (input === null ? 'null' : typeof input) + "\".");
  }

  var entities = {};
  var addEntity = addEntities(entities);
  var visitedEntities = {};
  var result = visit(input, input, null, schema, addEntity, visitedEntities);
  return {
    entities: entities,
    result: result
  };
};

var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
  var entity = getEntity(id, schema);

  if (entity === undefined && schema instanceof EntitySchema) {
    entity = schema.fallback(id, schema);
  }

  if (typeof entity !== 'object' || entity === null) {
    return entity;
  }

  if (!cache[schema.key]) {
    cache[schema.key] = {};
  }

  if (!cache[schema.key][id]) {
    // Ensure we don't mutate it non-immutable objects
    var entityCopy = isImmutable(entity) ? entity : _extends({}, entity); // Need to set this first so that if it is referenced further within the
    // denormalization the reference will already exist.

    cache[schema.key][id] = entityCopy;
    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
  }

  return cache[schema.key][id];
};

var getUnvisit = function getUnvisit(entities) {
  var cache = {};
  var getEntity = getEntities(entities);
  return function unvisit(input, schema) {
    if (typeof schema === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
      var method = Array.isArray(schema) ? denormalize : _denormalize;
      return method(schema, input, unvisit);
    }

    if (input === undefined || input === null) {
      return input;
    }

    if (schema instanceof EntitySchema) {
      return unvisitEntity(input, schema, unvisit, getEntity, cache);
    }

    return schema.denormalize(input, unvisit);
  };
};

var getEntities = function getEntities(entities) {
  var isImmutable$1 = isImmutable(entities);
  return function (entityOrId, schema) {
    var schemaKey = schema.key;

    if (typeof entityOrId === 'object') {
      return entityOrId;
    }

    if (isImmutable$1) {
      return entities.getIn([schemaKey, entityOrId.toString()]);
    }

    return entities[schemaKey] && entities[schemaKey][entityOrId];
  };
};

var denormalize$1 = function denormalize(input, schema, entities) {
  if (typeof input !== 'undefined') {
    return getUnvisit(entities)(input, schema);
  }
};




/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Functions for prechecking the structure of the data on startup.
 */

function validateActor(item) {
  console.assert('name' in item, item, 'name not in item');
  console.assert('url' in item, item, 'url not in item');
}

var validateActors = exports.validateActors = function validateActors(list) {
  list.forEach(function (item) {
    return validateActor(item);
  });
};

exports.default = validateActors;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandRelations = undefined;

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-extraneous-dependencies */
/**
 * Roles for propagating relationships in data
 */
var colors = __webpack_require__(198);
var invert = __webpack_require__(201);

function lookupActorById(actors, type, id) {
  /* Lookup and resolve actor by ID */
  return actors.find(function (sub) {
    return sub.id === id;
  });
}

function expandActor(item, actors) {
  return (0, _assign2.default)({}, item, { actor: lookupActorById(actors, 'actor', item.actor) });
}

function expandLanguage(actor) {
  /** Expand Array{string} of languages to a list of objects with name and color.
   *
   * @param {Array, String} actor
   * @return {Array, Object}
   *
   * Before: ['Python']
   * After: [{
   *   'name': 'python',
   *   'color': '#3572A5'
   * }]
   */
  if (actor.languages && actor.languages.length) {
    (0, _assign2.default)(actor, {
      languages: actor.languages.map(function (lang) {
        // see https://github.com/IonicaBizau/github-colors/issues/26
        var color = colors.get(lang, true).color ? colors.get(lang, true).color : '#ccc';
        return {
          name: lang,
          color: color,
          textColor: invert(color, true)
        };
      })
    });
  }
  return actor;
}

var expandRelations = exports.expandRelations = function expandRelations(activities, rawActors) {
  /**
   * Expands primary key/ID relations with other objects.
   *
   * @param {Array, <Object>} activities
   * @param {Array, <Object>} actors
   * @return {Void}
   */
  var actors = rawActors.map(function (actor) {
    return expandLanguage(actor);
  });
  return activities.map(function (item) {
    return expandActor(item, actors);
  });
};
exports.default = expandRelations;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * GitHubColors
 *
 * @name GitHubColors
 * @function
 * @return {undefined}
 */
function GitHubColors() {
    this.colors = null;
    this.extensions = null;
}

/**
 * init
 * Inits the GitHub extensions/colors.
 *
 * @name init
 * @function
 * @param {Boolean} ext If `true`, the extensions will be initialized.
 * @return {Object} The `extensions` or `colors` object.
 */
GitHubColors.prototype.init = function (ext) {
    if (ext) {
        return this.extensions = this.extensions || __webpack_require__(199);
    }

    return this.colors = this.colors || __webpack_require__(200);
};

/**
 * get
 * Gets the color object for the provided language.
 *
 * @name get
 * @function
 * @param {String} lang The language to get the color for.
 * @param {Boolean} handleOthers If `false` and the color is not found `undefined` will be returned. Otherwise a gray color will be returned.
 * @return {Object|undefined} The color that was found.
 */
GitHubColors.prototype.get = function (lang, handleOthers) {
    this.init();
    var found = this.colors[lang];
    if (handleOthers) {
        found = found || {};
        found.color = found.color || "#ccc";
    }
    return found;
};

/**
 * ext
 * Get the color object for the provided extension.
 *
 * @name ext
 * @function
 * @param {String} ext The extension to get the color for.
 * @param {Boolean} handleOthers If `false` and the color is not found `undefined` will be returned. Otherwise a gray color will be returned.
 * @return {Object|undefined} The color that was found.
 */
GitHubColors.prototype.ext = function (ext, handleOthers) {
    this.init(true);
    var found = this.extensions[ext];
    if (handleOthers) {
        found = found || {};
        found.color = found.color || "#ccc";
    }
    return found;
};

module.exports = new GitHubColors();

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = {"1":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"2":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"4":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"5":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"6":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"7":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"8":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"9":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"bsl":{"extensions":[".bsl",".os"],"aliases":[],"type":"programming","color":"#814CCC","tm_scope":"source.bsl","ace_mode":"text","language_id":0},"os":{"extensions":[".bsl",".os"],"aliases":[],"type":"programming","color":"#814CCC","tm_scope":"source.bsl","ace_mode":"text","language_id":0},"2da":{"extensions":[".2da"],"aliases":[],"type":"data","color":"#38761D","tm_scope":"source.2da","ace_mode":"text","language_id":387204628},"4dm":{"extensions":[".4dm"],"aliases":[],"type":"programming","color":"#004289","tm_scope":"source.4dm","ace_mode":"text","language_id":577529595},"abap":{"extensions":[".abap"],"aliases":[],"type":"programming","color":"#E8274B","tm_scope":"source.abap","ace_mode":"abap","language_id":1},"asddls":{"extensions":[".asddls"],"aliases":[],"type":"programming","color":"#555e25","tm_scope":"source.abapcds","language_id":452681853,"ace_mode":"text"},"abnf":{"extensions":[".abnf"],"aliases":[],"type":"data","ace_mode":"text","tm_scope":"source.abnf","language_id":429},"ags":{"extensions":[".asc",".ash"],"aliases":["ags"],"type":"programming","color":"#B9D9FF","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":2},"asc":{"extensions":[".asc",".pub"],"aliases":[],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"asciiarmor","codemirror_mime_type":"application/pgp","language_id":298},"ash":{"extensions":[".ash"],"aliases":[],"type":"programming","color":"#B9D9B9","tm_scope":"source.ash","ace_mode":"text","language_id":852099832},"aidl":{"extensions":[".aidl"],"aliases":[],"type":"programming","color":"#34EB6B","tm_scope":"source.aidl","ace_mode":"text","interpreters":["aidl"],"language_id":451700185},"al":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"alg":{"extensions":[".alg"],"aliases":[],"type":"programming","color":"#D1E0DB","tm_scope":"source.algol60","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":79217948},"ampl":{"extensions":[".ampl",".mod"],"aliases":[],"type":"programming","color":"#E6EFBB","tm_scope":"source.ampl","ace_mode":"text","language_id":3},"mod":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"g4":{"extensions":[".g4"],"aliases":[],"type":"programming","color":"#9DC3FF","tm_scope":"source.antlr","ace_mode":"text","language_id":4},"apib":{"extensions":[".apib"],"aliases":[],"type":"markup","color":"#2ACCA8","ace_mode":"markdown","tm_scope":"text.html.markdown.source.gfm.apib","language_id":5},"apl":{"extensions":[".apl",".dyalog"],"aliases":[],"type":"programming","color":"#5A8164","interpreters":["apl","aplx","dyalog"],"tm_scope":"source.apl","ace_mode":"text","codemirror_mode":"apl","codemirror_mime_type":"text/apl","language_id":6},"dyalog":{"extensions":[".apl",".dyalog"],"aliases":[],"type":"programming","color":"#5A8164","interpreters":["apl","aplx","dyalog"],"tm_scope":"source.apl","ace_mode":"text","codemirror_mode":"apl","codemirror_mime_type":"text/apl","language_id":6},"asl":{"extensions":[".asl",".dsl"],"aliases":[],"type":"programming","ace_mode":"asl","tm_scope":"source.asl","language_id":124996147},"dsl":{"extensions":[".asl",".dsl"],"aliases":[],"type":"programming","ace_mode":"asl","tm_scope":"source.asl","language_id":124996147},"asn":{"extensions":[".asn",".asn1"],"aliases":[],"type":"data","tm_scope":"source.asn","ace_mode":"text","codemirror_mode":"asn.1","codemirror_mime_type":"text/x-ttcn-asn","language_id":7},"asn1":{"extensions":[".asn",".asn1"],"aliases":[],"type":"data","tm_scope":"source.asn","ace_mode":"text","codemirror_mode":"asn.1","codemirror_mime_type":"text/x-ttcn-asn","language_id":7},"aspx":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"aspx-vb":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"asax":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"ascx":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"ashx":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"asmx":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"axd":{"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"aliases":["aspx","aspx-vb"],"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"ats2":{"extensions":[".dats",".hats",".sats"],"aliases":["ats2"],"type":"programming","color":"#1ac620","tm_scope":"source.ats","ace_mode":"ocaml","language_id":9},"dats":{"extensions":[".dats",".hats",".sats"],"aliases":["ats2"],"type":"programming","color":"#1ac620","tm_scope":"source.ats","ace_mode":"ocaml","language_id":9},"hats":{"extensions":[".dats",".hats",".sats"],"aliases":["ats2"],"type":"programming","color":"#1ac620","tm_scope":"source.ats","ace_mode":"ocaml","language_id":9},"sats":{"extensions":[".dats",".hats",".sats"],"aliases":["ats2"],"type":"programming","color":"#1ac620","tm_scope":"source.ats","ace_mode":"ocaml","language_id":9},"actionscript 3":{"extensions":[".as"],"aliases":["actionscript 3","actionscript3","as3"],"type":"programming","tm_scope":"source.actionscript.3","color":"#882B0F","ace_mode":"actionscript","language_id":10},"actionscript3":{"extensions":[".as"],"aliases":["actionscript 3","actionscript3","as3"],"type":"programming","tm_scope":"source.actionscript.3","color":"#882B0F","ace_mode":"actionscript","language_id":10},"as3":{"extensions":[".as"],"aliases":["actionscript 3","actionscript3","as3"],"type":"programming","tm_scope":"source.actionscript.3","color":"#882B0F","ace_mode":"actionscript","language_id":10},"as":{"extensions":[".as",".angelscript"],"aliases":[],"type":"programming","color":"#C7D7DC","tm_scope":"source.angelscript","ace_mode":"text","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":389477596},"ada95":{"extensions":[".adb",".ada",".ads"],"aliases":["ada95","ada2005"],"type":"programming","color":"#02f88c","tm_scope":"source.ada","ace_mode":"ada","language_id":11},"ada2005":{"extensions":[".adb",".ada",".ads"],"aliases":["ada95","ada2005"],"type":"programming","color":"#02f88c","tm_scope":"source.ada","ace_mode":"ada","language_id":11},"adb":{"extensions":[".txt"],"aliases":["ad block filters","ad block","adb","adblock"],"type":"data","color":"#800000","ace_mode":"text","tm_scope":"text.adblock","language_id":884614762},"ada":{"extensions":[".adb",".ada",".ads"],"aliases":["ada95","ada2005"],"type":"programming","color":"#02f88c","tm_scope":"source.ada","ace_mode":"ada","language_id":11},"ads":{"extensions":[".adb",".ada",".ads"],"aliases":["ada95","ada2005"],"type":"programming","color":"#02f88c","tm_scope":"source.ada","ace_mode":"ada","language_id":11},"ad block filters":{"extensions":[".txt"],"aliases":["ad block filters","ad block","adb","adblock"],"type":"data","color":"#800000","ace_mode":"text","tm_scope":"text.adblock","language_id":884614762},"ad block":{"extensions":[".txt"],"aliases":["ad block filters","ad block","adb","adblock"],"type":"data","color":"#800000","ace_mode":"text","tm_scope":"text.adblock","language_id":884614762},"adblock":{"extensions":[".txt"],"aliases":["ad block filters","ad block","adb","adblock"],"type":"data","color":"#800000","ace_mode":"text","tm_scope":"text.adblock","language_id":884614762},"txt":{"extensions":[".txt"],"aliases":["help","vimhelp"],"type":"prose","color":"#199f4b","tm_scope":"text.vim-help","ace_mode":"text","language_id":508563686},"acfm":{"extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"type":"data","color":"#fa0f00","tm_scope":"source.afm","ace_mode":"text","language_id":147198098},"adobe composite font metrics":{"extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"type":"data","color":"#fa0f00","tm_scope":"source.afm","ace_mode":"text","language_id":147198098},"adobe multiple font metrics":{"extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"type":"data","color":"#fa0f00","tm_scope":"source.afm","ace_mode":"text","language_id":147198098},"amfm":{"extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"type":"data","color":"#fa0f00","tm_scope":"source.afm","ace_mode":"text","language_id":147198098},"afm":{"extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"type":"data","color":"#fa0f00","tm_scope":"source.afm","ace_mode":"text","language_id":147198098},"agda":{"extensions":[".agda"],"aliases":[],"type":"programming","color":"#315665","tm_scope":"source.agda","ace_mode":"text","language_id":12},"ak":{"extensions":[".ak"],"aliases":[],"type":"programming","color":"#640ff8","ace_mode":"text","tm_scope":"source.aiken","language_id":899409497},"als":{"extensions":[".als"],"aliases":[],"type":"programming","color":"#64C800","tm_scope":"source.alloy","ace_mode":"text","language_id":13},"abuild":{"extensions":[],"aliases":["abuild","apkbuild"],"type":"programming","color":"#0D597F","group":"Shell","filenames":["APKBUILD"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":14},"apkbuild":{"extensions":[],"aliases":["abuild","apkbuild"],"type":"programming","color":"#0D597F","group":"Shell","filenames":["APKBUILD"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":14},"altium":{"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"aliases":["altium"],"type":"data","color":"#A89663","tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"OutJob":{"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"aliases":["altium"],"type":"data","color":"#A89663","tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"PcbDoc":{"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"aliases":["altium"],"type":"data","color":"#A89663","tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"PrjPCB":{"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"aliases":["altium"],"type":"data","color":"#A89663","tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"SchDoc":{"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"aliases":["altium"],"type":"data","color":"#A89663","tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"angelscript":{"extensions":[".as",".angelscript"],"aliases":[],"type":"programming","color":"#C7D7DC","tm_scope":"source.angelscript","ace_mode":"text","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":389477596},"lp":{"extensions":[".lp"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":377204539},"antlers.html":{"extensions":[".antlers.html",".antlers.php",".antlers.xml"],"aliases":[],"type":"markup","color":"#ff269e","tm_scope":"text.html.statamic","ace_mode":"text","language_id":1067292663},"antlers.php":{"extensions":[".antlers.html",".antlers.php",".antlers.xml"],"aliases":[],"type":"markup","color":"#ff269e","tm_scope":"text.html.statamic","ace_mode":"text","language_id":1067292663},"antlers.xml":{"extensions":[".antlers.html",".antlers.php",".antlers.xml"],"aliases":[],"type":"markup","color":"#ff269e","tm_scope":"text.html.statamic","ace_mode":"text","language_id":1067292663},"aconf":{"extensions":[".apacheconf",".vhost"],"aliases":["aconf","apache"],"type":"data","color":"#d12127","filenames":[".htaccess","apache2.conf","httpd.conf"],"tm_scope":"source.apacheconf","ace_mode":"apache_conf","language_id":16},"apache":{"extensions":[".apacheconf",".vhost"],"aliases":["aconf","apache"],"type":"data","color":"#d12127","filenames":[".htaccess","apache2.conf","httpd.conf"],"tm_scope":"source.apacheconf","ace_mode":"apache_conf","language_id":16},"apacheconf":{"extensions":[".apacheconf",".vhost"],"aliases":["aconf","apache"],"type":"data","color":"#d12127","filenames":[".htaccess","apache2.conf","httpd.conf"],"tm_scope":"source.apacheconf","ace_mode":"apache_conf","language_id":16},"vhost":{"extensions":[".nginx",".nginxconf",".vhost"],"aliases":["nginx configuration file"],"type":"data","color":"#009639","filenames":["nginx.conf"],"tm_scope":"source.nginx","ace_mode":"nginx","codemirror_mode":"nginx","codemirror_mime_type":"text/x-nginx-conf","language_id":248},"cls":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"apex":{"extensions":[".cls",".apex",".trigger"],"aliases":[],"type":"programming","color":"#1797c0","tm_scope":"source.apex","ace_mode":"apex","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":17},"trigger":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"agc":{"extensions":[".agc"],"aliases":[],"type":"programming","color":"#0B3D91","group":"Assembly","tm_scope":"source.agc","ace_mode":"assembly_x86","language_id":18},"apples":{"extensions":[".applescript",".scpt"],"aliases":["apples","osascript"],"type":"programming","interpreters":["osascript"],"tm_scope":"source.applescript","ace_mode":"applescript","color":"#101F1F","language_id":19},"osascript":{"extensions":[".applescript",".scpt"],"aliases":["apples","osascript"],"type":"programming","interpreters":["osascript"],"tm_scope":"source.applescript","ace_mode":"applescript","color":"#101F1F","language_id":19},"applescript":{"extensions":[".applescript",".scpt"],"aliases":["apples","osascript"],"type":"programming","interpreters":["osascript"],"tm_scope":"source.applescript","ace_mode":"applescript","color":"#101F1F","language_id":19},"scpt":{"extensions":[".applescript",".scpt"],"aliases":["apples","osascript"],"type":"programming","interpreters":["osascript"],"tm_scope":"source.applescript","ace_mode":"applescript","color":"#101F1F","language_id":19},"arc":{"extensions":[".arc"],"aliases":[],"type":"programming","color":"#aa2afe","tm_scope":"none","ace_mode":"text","language_id":20},"asciidoc":{"extensions":[".asciidoc",".adoc",".asc"],"aliases":[],"type":"prose","color":"#73a0c5","ace_mode":"asciidoc","wrap":true,"tm_scope":"text.html.asciidoc","language_id":22},"adoc":{"extensions":[".asciidoc",".adoc",".asc"],"aliases":[],"type":"prose","color":"#73a0c5","ace_mode":"asciidoc","wrap":true,"tm_scope":"text.html.asciidoc","language_id":22},"aj":{"extensions":[".aj"],"aliases":[],"type":"programming","color":"#a957b0","tm_scope":"source.aspectj","ace_mode":"text","language_id":23},"asm":{"extensions":[".asm",".i",".inc",".s",".x68"],"aliases":["m68k"],"type":"programming","color":"#005daa","group":"Assembly","tm_scope":"source.m68k","ace_mode":"assembly_x86","language_id":477582706},"nasm":{"extensions":[".asm",".a51",".i",".inc",".nas",".nasm",".s"],"aliases":["asm","nasm"],"type":"programming","color":"#6E4C13","tm_scope":"source.assembly","ace_mode":"assembly_x86","language_id":24},"a51":{"extensions":[".asm",".a51",".i",".inc",".nas",".nasm",".s"],"aliases":["asm","nasm"],"type":"programming","color":"#6E4C13","tm_scope":"source.assembly","ace_mode":"assembly_x86","language_id":24},"i":{"extensions":[".i",".swg",".swig"],"aliases":[],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":1066250075},"inc":{"extensions":[".sp",".inc"],"aliases":["sourcemod"],"type":"programming","color":"#f69e1d","tm_scope":"source.sourcepawn","ace_mode":"text","language_id":354},"nas":{"extensions":[".nas"],"aliases":[],"type":"programming","color":"#1d2c4e","tm_scope":"source.nasal","ace_mode":"nasal","language_id":178322513},"s":{"extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"type":"programming","group":"Assembly","tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"astro":{"extensions":[".astro"],"aliases":[],"type":"markup","color":"#ff5a03","tm_scope":"source.astro","ace_mode":"astro","codemirror_mode":"jsx","codemirror_mime_type":"text/jsx","language_id":578209015},"asy":{"extensions":[".asy"],"aliases":[],"type":"data","tm_scope":"source.ltspice.symbol","ace_mode":"text","codemirror_mode":"spreadsheet","codemirror_mime_type":"text/x-spreadsheet","language_id":1013566805},"aug":{"extensions":[".aug"],"aliases":[],"type":"programming","color":"#9CC134","tm_scope":"none","ace_mode":"text","language_id":25},"ahk":{"extensions":[".ahk",".ahkl"],"aliases":["ahk"],"type":"programming","color":"#6594b9","tm_scope":"source.ahk","ace_mode":"autohotkey","language_id":26},"ahkl":{"extensions":[".ahk",".ahkl"],"aliases":["ahk"],"type":"programming","color":"#6594b9","tm_scope":"source.ahk","ace_mode":"autohotkey","language_id":26},"au3":{"extensions":[".au3"],"aliases":["au3","AutoIt3","AutoItScript"],"type":"programming","color":"#1C3552","tm_scope":"source.autoit","ace_mode":"autohotkey","language_id":27},"AutoIt3":{"extensions":[".au3"],"aliases":["au3","AutoIt3","AutoItScript"],"type":"programming","color":"#1C3552","tm_scope":"source.autoit","ace_mode":"autohotkey","language_id":27},"AutoItScript":{"extensions":[".au3"],"aliases":["au3","AutoIt3","AutoItScript"],"type":"programming","color":"#1C3552","tm_scope":"source.autoit","ace_mode":"autohotkey","language_id":27},"avdl":{"extensions":[".avdl"],"aliases":[],"type":"data","color":"#0040FF","tm_scope":"source.avro","ace_mode":"text","language_id":785497837},"awk":{"extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"aliases":[],"type":"programming","color":"#c30e9b","interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"auk":{"extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"aliases":[],"type":"programming","color":"#c30e9b","interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"gawk":{"extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"aliases":[],"type":"programming","color":"#c30e9b","interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"mawk":{"extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"aliases":[],"type":"programming","color":"#c30e9b","interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"nawk":{"extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"aliases":[],"type":"programming","color":"#c30e9b","interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"mch":{"extensions":[".mch"],"aliases":[],"type":"programming","color":"#8aa8c5","tm_scope":"source.b","ace_mode":"text","language_id":700792152},"basic for android":{"extensions":[".bas"],"aliases":["basic for android"],"type":"programming","color":"#00e4ff","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":96642275},"bas":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"bqn":{"extensions":[".bqn"],"aliases":[],"type":"programming","color":"#2b7067","tm_scope":"source.bqn","ace_mode":"text","language_id":330386870},"bal":{"extensions":[".bal"],"aliases":[],"type":"programming","tm_scope":"source.ballerina","ace_mode":"text","color":"#FF5000","language_id":720859680},"bat":{"extensions":[".bat",".cmd"],"aliases":["bat","batch","dosbatch","winbatch"],"type":"programming","filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"batch":{"extensions":[".bat",".cmd"],"aliases":["bat","batch","dosbatch","winbatch"],"type":"programming","filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"dosbatch":{"extensions":[".bat",".cmd"],"aliases":["bat","batch","dosbatch","winbatch"],"type":"programming","filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"winbatch":{"extensions":[".bat",".cmd"],"aliases":["bat","batch","dosbatch","winbatch"],"type":"programming","filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"cmd":{"extensions":[".bat",".cmd"],"aliases":["bat","batch","dosbatch","winbatch"],"type":"programming","filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"bf":{"extensions":[".bf"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"none","language_id":160},"befunge":{"extensions":[".befunge",".bf"],"aliases":[],"type":"programming","tm_scope":"source.befunge","ace_mode":"text","language_id":30},"be":{"extensions":[".be"],"aliases":["be"],"type":"programming","tm_scope":"source.berry","ace_mode":"text","color":"#15A13C","language_id":121855308},"bib":{"extensions":[".bib",".bibtex"],"aliases":[],"type":"markup","color":"#778899","group":"TeX","tm_scope":"text.bibtex","ace_mode":"bibtex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","language_id":982188347},"bibtex":{"extensions":[".bib",".bibtex"],"aliases":[],"type":"markup","color":"#778899","group":"TeX","tm_scope":"text.bibtex","ace_mode":"bibtex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","language_id":982188347},"bst":{"extensions":[".bst"],"aliases":[],"type":"data","color":"#006bff","tm_scope":"source.yaml","ace_mode":"yaml","language_id":84359046},"bicep":{"extensions":[".bicep",".bicepparam"],"aliases":[],"type":"programming","color":"#519aba","tm_scope":"source.bicep","ace_mode":"text","language_id":321200902},"bicepparam":{"extensions":[".bicep",".bicepparam"],"aliases":[],"type":"programming","color":"#519aba","tm_scope":"source.bicep","ace_mode":"text","language_id":321200902},"bs":{"extensions":[".bs"],"aliases":[],"type":"programming","color":"#66AABB","tm_scope":"source.brs","ace_mode":"text","language_id":943571030},"bison":{"extensions":[".bison"],"aliases":[],"type":"programming","color":"#6A463F","group":"Yacc","tm_scope":"source.yacc","ace_mode":"text","language_id":31},"bb":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"bbappend":{"extensions":[".bb",".bbappend",".bbclass",".inc"],"aliases":[],"type":"programming","color":"#00bce4","tm_scope":"source.bb","ace_mode":"text","language_id":32},"bbclass":{"extensions":[".bb",".bbappend",".bbclass",".inc"],"aliases":[],"type":"programming","color":"#00bce4","tm_scope":"source.bb","ace_mode":"text","language_id":32},"blade":{"extensions":[".blade",".blade.php"],"aliases":[],"type":"markup","color":"#f7523f","tm_scope":"text.html.php.blade","ace_mode":"php_laravel_blade","language_id":33},"blade.php":{"extensions":[".blade",".blade.php"],"aliases":[],"type":"markup","color":"#f7523f","tm_scope":"text.html.php.blade","ace_mode":"php_laravel_blade","language_id":33},"b3d":{"extensions":[".bb",".decls"],"aliases":["b3d","blitz3d","blitzplus","bplus"],"type":"programming","color":"#00FFAE","tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"blitz3d":{"extensions":[".bb",".decls"],"aliases":["b3d","blitz3d","blitzplus","bplus"],"type":"programming","color":"#00FFAE","tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"blitzplus":{"extensions":[".bb",".decls"],"aliases":["b3d","blitz3d","blitzplus","bplus"],"type":"programming","color":"#00FFAE","tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"bplus":{"extensions":[".bb",".decls"],"aliases":["b3d","blitz3d","blitzplus","bplus"],"type":"programming","color":"#00FFAE","tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"decls":{"extensions":[".bb",".decls"],"aliases":["b3d","blitz3d","blitzplus","bplus"],"type":"programming","color":"#00FFAE","tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"bmax":{"extensions":[".bmx"],"aliases":["bmax"],"type":"programming","color":"#cd6400","tm_scope":"source.blitzmax","ace_mode":"text","language_id":35},"bmx":{"extensions":[".bmx"],"aliases":["bmax"],"type":"programming","color":"#cd6400","tm_scope":"source.blitzmax","ace_mode":"text","language_id":35},"bluespec bsv":{"extensions":[".bsv"],"aliases":["bluespec bsv","bsv"],"type":"programming","color":"#12223c","tm_scope":"source.bsv","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":36},"bsv":{"extensions":[".bsv"],"aliases":["bluespec bsv","bsv"],"type":"programming","color":"#12223c","tm_scope":"source.bsv","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":36},"bh":{"extensions":[".bs"],"aliases":["bh","bluespec classic"],"type":"programming","group":"Bluespec","color":"#12223c","tm_scope":"source.bh","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":641580358},"bluespec classic":{"extensions":[".bs"],"aliases":["bh","bluespec classic"],"type":"programming","group":"Bluespec","color":"#12223c","tm_scope":"source.bh","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":641580358},"boo":{"extensions":[".boo"],"aliases":[],"type":"programming","color":"#d4bec1","ace_mode":"text","tm_scope":"source.boo","language_id":37},"bpl":{"extensions":[".bpl"],"aliases":[],"type":"programming","color":"#c80fa0","interpreters":["boogie"],"tm_scope":"source.boogie","ace_mode":"text","language_id":955017407},"b":{"extensions":[".b",".m"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":201},"brs":{"extensions":[".brs"],"aliases":[],"type":"programming","color":"#662D91","tm_scope":"source.brs","ace_mode":"text","language_id":39},"bru":{"extensions":[".bru"],"aliases":[],"type":"markup","color":"#F4AA41","tm_scope":"source.bru","ace_mode":"text","language_id":906627898},"c":{"extensions":[".c",".cats",".h",".h.in",".idc"],"aliases":[],"type":"programming","color":"#555555","interpreters":["tcc"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":41},"cats":{"extensions":[".c",".cats",".h",".h.in",".idc"],"aliases":[],"type":"programming","color":"#555555","interpreters":["tcc"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":41},"h":{"extensions":[".m",".h"],"aliases":["obj-c","objc","objectivec"],"type":"programming","tm_scope":"source.objc","color":"#438eff","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec","language_id":257},"h.in":{"extensions":[".c",".cats",".h",".h.in",".idc"],"aliases":[],"type":"programming","color":"#555555","interpreters":["tcc"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":41},"idc":{"extensions":[".c",".cats",".h",".h.in",".idc"],"aliases":[],"type":"programming","color":"#555555","interpreters":["tcc"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":41},"csharp":{"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"aliases":["csharp","cake","cakescript"],"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","language_id":42},"cake":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"cakescript":{"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"aliases":["csharp","cake","cakescript"],"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","language_id":42},"cs":{"extensions":[".st",".cs"],"aliases":["squeak"],"type":"programming","color":"#596706","tm_scope":"source.smalltalk","ace_mode":"text","codemirror_mode":"smalltalk","codemirror_mime_type":"text/x-stsrc","language_id":352},"cs.pp":{"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"aliases":["csharp","cake","cakescript"],"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","language_id":42},"csx":{"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"aliases":["csharp","cake","cakescript"],"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","language_id":42},"linq":{"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"aliases":["csharp","cake","cakescript"],"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","language_id":42},"cpp":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"c++":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"cc":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"cp":{"extensions":[".cp",".cps"],"aliases":[],"type":"programming","color":"#B0CE4E","tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":67},"cppm":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"cxx":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"h++":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"hh":{"extensions":[".hack",".hh",".hhi",".php"],"aliases":[],"type":"programming","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","tm_scope":"source.hack","color":"#878787","language_id":153},"hpp":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"hxx":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"inl":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"ino":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"ipp":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"ixx":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"re":{"extensions":[".re",".rei"],"aliases":[],"type":"programming","color":"#ff5847","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","tm_scope":"source.reason","language_id":869538413},"tcc":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"tpp":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"txx":{"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"aliases":["cpp"],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","language_id":43},"c-objdump":{"extensions":[".c-objdump"],"aliases":[],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":44},"c2hs":{"extensions":[".chs"],"aliases":["c2hs"],"type":"programming","group":"Haskell","tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":45},"chs":{"extensions":[".chs"],"aliases":["c2hs"],"type":"programming","group":"Haskell","tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":45},"c3":{"extensions":[".c3"],"aliases":[],"type":"programming","color":"#2563eb","tm_scope":"source.c3","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":769248603},"cds":{"extensions":[".cds"],"aliases":["cds"],"type":"programming","tm_scope":"source.cds","color":"#0092d1","ace_mode":"text","language_id":390788699},"cil":{"extensions":[".cil"],"aliases":[],"type":"data","tm_scope":"source.cil","ace_mode":"text","language_id":29176339},"clp":{"extensions":[".clp"],"aliases":[],"type":"programming","color":"#00A300","tm_scope":"source.clips","ace_mode":"text","language_id":46},"cmake":{"extensions":[".cmake",".cmake.in"],"aliases":[],"type":"programming","color":"#DA3434","filenames":["CMakeLists.txt"],"tm_scope":"source.cmake","ace_mode":"text","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":47},"cmake.in":{"extensions":[".cmake",".cmake.in"],"aliases":[],"type":"programming","color":"#DA3434","filenames":["CMakeLists.txt"],"tm_scope":"source.cmake","ace_mode":"text","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":47},"cob":{"extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"aliases":[],"type":"programming","tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"cbl":{"extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"aliases":[],"type":"programming","tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"ccp":{"extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"aliases":[],"type":"programming","tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"cobol":{"extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"aliases":[],"type":"programming","tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"cpy":{"extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"aliases":[],"type":"programming","tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"dae":{"extensions":[".dae"],"aliases":[],"type":"data","color":"#F1A42B","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":49},"cql":{"extensions":[".cql"],"aliases":[],"type":"programming","color":"#006091","tm_scope":"source.cql","ace_mode":"text","language_id":71155397},"cson":{"extensions":[".cson"],"aliases":[],"type":"data","color":"#244776","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","language_id":424},"css":{"extensions":[".css"],"aliases":[],"type":"markup","tm_scope":"source.css","ace_mode":"css","codemirror_mode":"css","codemirror_mime_type":"text/css","color":"#663399","language_id":50},"csv":{"extensions":[".csv"],"aliases":[],"type":"data","color":"#237346","ace_mode":"csv","tm_scope":"source.csv","language_id":51},"cue":{"extensions":[".cue"],"aliases":[],"type":"data","tm_scope":"source.cuesheet","ace_mode":"text","language_id":942714150},"w":{"extensions":[".p",".cls",".w"],"aliases":["progress","openedge","abl"],"type":"programming","color":"#5ce600","tm_scope":"source.abl","ace_mode":"text","language_id":264},"Cabal":{"extensions":[".cabal"],"aliases":["Cabal"],"type":"data","color":"#483465","filenames":["cabal.config","cabal.project"],"ace_mode":"haskell_cabal","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","tm_scope":"source.cabal","language_id":677095381},"cabal":{"extensions":[".cabal"],"aliases":["Cabal"],"type":"data","color":"#483465","filenames":["cabal.config","cabal.project"],"ace_mode":"haskell_cabal","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","tm_scope":"source.cabal","language_id":677095381},"Caddy":{"extensions":[".caddyfile"],"aliases":["Caddy"],"type":"data","color":"#22b638","filenames":["Caddyfile"],"ace_mode":"text","tm_scope":"source.Caddyfile","language_id":615465151},"caddyfile":{"extensions":[".caddyfile"],"aliases":["Caddy"],"type":"data","color":"#22b638","filenames":["Caddyfile"],"ace_mode":"text","tm_scope":"source.Caddyfile","language_id":615465151},"cdc":{"extensions":[".cdc"],"aliases":[],"type":"programming","color":"#00ef8b","ace_mode":"text","tm_scope":"source.cadence","language_id":270184138},"cairo":{"extensions":[".cairo"],"aliases":[],"type":"programming","color":"#ff4a48","ace_mode":"text","tm_scope":"source.cairo0","group":"Cairo","language_id":891399890},"mligo":{"extensions":[".mligo"],"aliases":[],"type":"programming","color":"#3be133","tm_scope":"source.mligo","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","group":"LigoLANG","language_id":829207807},"cj":{"extensions":[".cj"],"aliases":[],"type":"programming","tm_scope":"source.cj","color":"#00868B","ace_mode":"swift","codemirror_mode":"swift","codemirror_mime_type":"text/x-swift","language_id":581895317},"capnp":{"extensions":[".capnp"],"aliases":[],"type":"programming","color":"#c42727","tm_scope":"source.capnp","ace_mode":"text","language_id":52},"carbon":{"extensions":[".carbon"],"aliases":[],"type":"programming","color":"#222222","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","tm_scope":"source.v","language_id":55627273},"Carto":{"extensions":[".mss"],"aliases":["Carto"],"type":"programming","ace_mode":"text","tm_scope":"source.css.mss","language_id":53},"mss":{"extensions":[".mss"],"aliases":["Carto"],"type":"programming","ace_mode":"text","tm_scope":"source.css.mss","language_id":53},"ceylon":{"extensions":[".ceylon"],"aliases":[],"type":"programming","color":"#dfa535","tm_scope":"source.ceylon","ace_mode":"text","language_id":54},"chpl":{"extensions":[".chpl"],"aliases":["chpl"],"type":"programming","color":"#8dc63f","tm_scope":"source.chapel","ace_mode":"text","language_id":55},"ch":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421},"checksum":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"hash":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"hashes":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sum":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sums":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"crc32":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"md2":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"md4":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"md5":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha1":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha2":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha224":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha256":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha256sum":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha3":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha384":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"sha512":{"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"aliases":["checksum","hash","hashes","sum","sums"],"type":"data","tm_scope":"text.checksums","filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"ace_mode":"text","language_id":372063053},"ck":{"extensions":[".ck"],"aliases":[],"type":"programming","color":"#3f8000","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":57},"circom":{"extensions":[".circom"],"aliases":[],"type":"programming","ace_mode":"text","color":"#707575","tm_scope":"source.circom","language_id":1042332086},"cirru":{"extensions":[".cirru"],"aliases":[],"type":"programming","color":"#ccccff","tm_scope":"source.cirru","ace_mode":"cirru","language_id":58},"clw":{"extensions":[".clw"],"aliases":[],"type":"programming","color":"#db901e","ace_mode":"text","tm_scope":"source.clarion","language_id":59},"clar":{"extensions":[".clar"],"aliases":[],"type":"programming","color":"#5546ff","ace_mode":"lisp","tm_scope":"source.clar","language_id":91493841},"asp":{"extensions":[".asp"],"aliases":["asp"],"type":"programming","color":"#6a40fd","tm_scope":"text.html.asp","ace_mode":"text","language_id":8},"icl":{"extensions":[".icl",".dcl"],"aliases":[],"type":"programming","color":"#3F85AF","tm_scope":"source.clean","ace_mode":"text","language_id":60},"dcl":{"extensions":[".com"],"aliases":["dcl"],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":82},"click":{"extensions":[".click"],"aliases":[],"type":"programming","color":"#E4E6F3","tm_scope":"source.click","ace_mode":"text","language_id":61},"clj":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"boot":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cl2":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cljc":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cljs":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cljs.hl":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cljscm":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"cljx":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"hic":{"extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"aliases":[],"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"soy":{"extensions":[".soy"],"aliases":["soy"],"type":"markup","color":"#0d948f","ace_mode":"soy_template","codemirror_mode":"soy","codemirror_mime_type":"text/x-soy","tm_scope":"text.html.soy","language_id":357046146},"clue":{"extensions":[".clue"],"aliases":[],"type":"programming","color":"#0009b5","tm_scope":"source.clue","ace_mode":"text","language_id":163763508},"CoNLL":{"extensions":[".conllu",".conll"],"aliases":["CoNLL","CoNLL-X"],"type":"data","tm_scope":"text.conllu","ace_mode":"text","language_id":421026389},"CoNLL-X":{"extensions":[".conllu",".conll"],"aliases":["CoNLL","CoNLL-X"],"type":"data","tm_scope":"text.conllu","ace_mode":"text","language_id":421026389},"conllu":{"extensions":[".conllu",".conll"],"aliases":["CoNLL","CoNLL-X"],"type":"data","tm_scope":"text.conllu","ace_mode":"text","language_id":421026389},"conll":{"extensions":[".conllu",".conll"],"aliases":["CoNLL","CoNLL-X"],"type":"data","tm_scope":"text.conllu","ace_mode":"text","language_id":421026389},"ql":{"extensions":[".ql",".qll"],"aliases":["ql"],"type":"programming","color":"#140f46","tm_scope":"source.ql","ace_mode":"text","language_id":424259634},"qll":{"extensions":[".ql",".qll"],"aliases":["ql"],"type":"programming","color":"#140f46","tm_scope":"source.ql","ace_mode":"text","language_id":424259634},"coffee":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"coffee-script":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"_coffee":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"cjsx":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"iced":{"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"aliases":["coffee","coffee-script"],"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"cfm":{"extensions":[".cfm",".cfml"],"aliases":["cfm","cfml","coldfusion html"],"type":"programming","ace_mode":"coldfusion","color":"#ed2cd6","tm_scope":"text.html.cfm","language_id":64},"cfml":{"extensions":[".cfm",".cfml"],"aliases":["cfm","cfml","coldfusion html"],"type":"programming","ace_mode":"coldfusion","color":"#ed2cd6","tm_scope":"text.html.cfm","language_id":64},"coldfusion html":{"extensions":[".cfm",".cfml"],"aliases":["cfm","cfml","coldfusion html"],"type":"programming","ace_mode":"coldfusion","color":"#ed2cd6","tm_scope":"text.html.cfm","language_id":64},"cfc":{"extensions":[".cfc"],"aliases":["cfc"],"type":"programming","color":"#ed2cd6","group":"ColdFusion","ace_mode":"coldfusion","tm_scope":"source.cfscript","language_id":65},"lisp":{"extensions":[".nl",".lisp",".lsp"],"aliases":[],"type":"programming","color":"#87AED7","interpreters":["newlisp"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":247},"asd":{"extensions":[".lisp",".asd",".cl",".l",".lsp",".ny",".podsl",".sexp"],"aliases":["lisp"],"type":"programming","tm_scope":"source.commonlisp","color":"#3fb68b","interpreters":["lisp","sbcl","ccl","clisp","ecl"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":66},"cl":{"extensions":[".cl",".opencl"],"aliases":[],"type":"programming","color":"#ed2e2d","group":"C","tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":263},"l":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"lsp":{"extensions":[".nl",".lisp",".lsp"],"aliases":[],"type":"programming","color":"#87AED7","interpreters":["newlisp"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":247},"ny":{"extensions":[".lisp",".asd",".cl",".l",".lsp",".ny",".podsl",".sexp"],"aliases":["lisp"],"type":"programming","tm_scope":"source.commonlisp","color":"#3fb68b","interpreters":["lisp","sbcl","ccl","clisp","ecl"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":66},"podsl":{"extensions":[".lisp",".asd",".cl",".l",".lsp",".ny",".podsl",".sexp"],"aliases":["lisp"],"type":"programming","tm_scope":"source.commonlisp","color":"#3fb68b","interpreters":["lisp","sbcl","ccl","clisp","ecl"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":66},"sexp":{"extensions":[".lisp",".asd",".cl",".l",".lsp",".ny",".podsl",".sexp"],"aliases":["lisp"],"type":"programming","tm_scope":"source.commonlisp","color":"#3fb68b","interpreters":["lisp","sbcl","ccl","clisp","ecl"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":66},"cwl":{"extensions":[".cwl"],"aliases":["cwl"],"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","interpreters":["cwl-runner"],"color":"#B5314C","tm_scope":"source.cwl","language_id":988547172},"cps":{"extensions":[".cp",".cps"],"aliases":[],"type":"programming","color":"#B0CE4E","tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":67},"cook":{"extensions":[".cook"],"aliases":[],"type":"markup","color":"#E15A29","wrap":true,"ace_mode":"text","tm_scope":"source.cooklang","language_id":788037493},"c++-objdump":{"extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"aliases":["c++-objdump"],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":70},"cppobjdump":{"extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"aliases":["c++-objdump"],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":70},"c++objdump":{"extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"aliases":["c++-objdump"],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":70},"cpp-objdump":{"extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"aliases":["c++-objdump"],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":70},"cxx-objdump":{"extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"aliases":["c++-objdump"],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":70},"creole":{"extensions":[".creole"],"aliases":[],"type":"prose","wrap":true,"tm_scope":"text.html.creole","ace_mode":"text","language_id":71},"cr":{"extensions":[".cr"],"aliases":[],"type":"programming","color":"#000100","ace_mode":"crystal","codemirror_mode":"crystal","codemirror_mime_type":"text/x-crystal","tm_scope":"source.crystal","interpreters":["crystal"],"language_id":72},"csound-orc":{"extensions":[".orc",".udo"],"aliases":["csound-orc"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound","ace_mode":"csound_orchestra","language_id":73},"orc":{"extensions":[".orc",".udo"],"aliases":["csound-orc"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound","ace_mode":"csound_orchestra","language_id":73},"udo":{"extensions":[".orc",".udo"],"aliases":["csound-orc"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound","ace_mode":"csound_orchestra","language_id":73},"csound-csd":{"extensions":[".csd"],"aliases":["csound-csd"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound-document","ace_mode":"csound_document","language_id":74},"csd":{"extensions":[".csd"],"aliases":["csound-csd"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound-document","ace_mode":"csound_document","language_id":74},"csound-sco":{"extensions":[".sco"],"aliases":["csound-sco"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound-score","ace_mode":"csound_score","language_id":75},"sco":{"extensions":[".sco"],"aliases":["csound-sco"],"type":"programming","color":"#1a1a1a","tm_scope":"source.csound-score","ace_mode":"csound_score","language_id":75},"cu":{"extensions":[".cu",".cuh"],"aliases":[],"type":"programming","tm_scope":"source.cuda-c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#3A4E3A","language_id":77},"cuh":{"extensions":[".cu",".cuh"],"aliases":[],"type":"programming","tm_scope":"source.cuda-c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#3A4E3A","language_id":77},"curry":{"extensions":[".curry"],"aliases":[],"type":"programming","color":"#531242","tm_scope":"source.curry","ace_mode":"haskell","language_id":439829048},"cy":{"extensions":[".cy"],"aliases":[],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","language_id":78},"cylc":{"extensions":[".cylc"],"aliases":[],"type":"data","color":"#00b3fd","filenames":["suite.rc"],"tm_scope":"source.cylc","ace_mode":"ini","group":"INI","language_id":476447814},"cyp":{"extensions":[".cyp",".cypher"],"aliases":[],"type":"programming","color":"#34c0eb","tm_scope":"source.cypher","codemirror_mode":"cypher","codemirror_mime_type":"application/x-cypher-query","ace_mode":"text","language_id":850806976},"cypher":{"extensions":[".cyp",".cypher"],"aliases":[],"type":"programming","color":"#34c0eb","tm_scope":"source.cypher","codemirror_mode":"cypher","codemirror_mime_type":"application/x-cypher-query","ace_mode":"text","language_id":850806976},"pyrex":{"extensions":[".pyx",".pxd",".pxi"],"aliases":["pyrex"],"type":"programming","color":"#fedf5b","tm_scope":"source.cython","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-cython","language_id":79},"pyx":{"extensions":[".pyx",".pxd",".pxi"],"aliases":["pyrex"],"type":"programming","color":"#fedf5b","tm_scope":"source.cython","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-cython","language_id":79},"pxd":{"extensions":[".pyx",".pxd",".pxi"],"aliases":["pyrex"],"type":"programming","color":"#fedf5b","tm_scope":"source.cython","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-cython","language_id":79},"pxi":{"extensions":[".pyx",".pxd",".pxi"],"aliases":["pyrex"],"type":"programming","color":"#fedf5b","tm_scope":"source.cython","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-cython","language_id":79},"Dlang":{"extensions":[".d",".di"],"aliases":["Dlang"],"type":"programming","color":"#ba595e","tm_scope":"source.d","ace_mode":"d","codemirror_mode":"d","codemirror_mime_type":"text/x-d","language_id":80},"d":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"di":{"extensions":[".d",".di"],"aliases":["Dlang"],"type":"programming","color":"#ba595e","tm_scope":"source.d","ace_mode":"d","codemirror_mode":"d","codemirror_mime_type":"text/x-d","language_id":80},"d-objdump":{"extensions":[".d-objdump"],"aliases":[],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":81},"d2lang":{"extensions":[".d2"],"aliases":["d2lang"],"type":"markup","color":"#526ee8","tm_scope":"source.d2","ace_mode":"text","language_id":37531557},"d2":{"extensions":[".d2"],"aliases":["d2lang"],"type":"markup","color":"#526ee8","tm_scope":"source.d2","ace_mode":"text","language_id":37531557},"com":{"extensions":[".com"],"aliases":["dcl"],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":82},"byond":{"extensions":[".dm"],"aliases":["byond"],"type":"programming","color":"#447265","tm_scope":"source.dm","ace_mode":"c_cpp","language_id":83},"dm":{"extensions":[".dm"],"aliases":["byond"],"type":"programming","color":"#447265","tm_scope":"source.dm","ace_mode":"c_cpp","language_id":83},"zone":{"extensions":[".zone",".arpa"],"aliases":[],"type":"data","tm_scope":"text.zone_file","ace_mode":"text","language_id":84},"arpa":{"extensions":[".zone",".arpa"],"aliases":[],"type":"data","tm_scope":"text.zone_file","ace_mode":"text","language_id":84},"dtrace-script":{"extensions":[".d"],"aliases":["dtrace-script"],"type":"programming","interpreters":["dtrace"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":85},"dfy":{"extensions":[".dfy"],"aliases":[],"type":"programming","color":"#FFEC25","interpreters":["dafny"],"tm_scope":"text.dfy.dafny","ace_mode":"text","language_id":969323346},"dpatch":{"extensions":[".darcspatch",".dpatch"],"aliases":["dpatch"],"type":"data","color":"#8eff23","tm_scope":"none","ace_mode":"text","language_id":86},"darcspatch":{"extensions":[".darcspatch",".dpatch"],"aliases":["dpatch"],"type":"data","color":"#8eff23","tm_scope":"none","ace_mode":"text","language_id":86},"dart":{"extensions":[".dart"],"aliases":[],"type":"programming","color":"#00B4AB","interpreters":["dart"],"tm_scope":"source.dart","ace_mode":"dart","codemirror_mode":"dart","codemirror_mime_type":"application/dart","language_id":87},"das":{"extensions":[".das"],"aliases":[],"type":"programming","color":"#d3d3d3","tm_scope":"source.daslang","ace_mode":"text","language_id":648759486},"dwl":{"extensions":[".dwl"],"aliases":[],"type":"programming","color":"#003a52","ace_mode":"text","tm_scope":"source.data-weave","language_id":974514097},"dsc":{"extensions":[".dsc"],"aliases":[],"type":"programming","color":"#FBEE96","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.denizenscript","language_id":435000929},"dhall":{"extensions":[".dhall"],"aliases":[],"type":"programming","color":"#dfafff","tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":793969321},"udiff":{"extensions":[".diff",".patch"],"aliases":["udiff"],"type":"data","tm_scope":"source.diff","ace_mode":"diff","codemirror_mode":"diff","codemirror_mime_type":"text/x-diff","language_id":88},"diff":{"extensions":[".diff",".patch"],"aliases":["udiff"],"type":"data","tm_scope":"source.diff","ace_mode":"diff","codemirror_mode":"diff","codemirror_mime_type":"text/x-diff","language_id":88},"patch":{"extensions":[".diff",".patch"],"aliases":["udiff"],"type":"data","tm_scope":"source.diff","ace_mode":"diff","codemirror_mode":"diff","codemirror_mime_type":"text/x-diff","language_id":88},"x":{"extensions":[".x"],"aliases":["rpcgen","oncrpc","xdr"],"type":"programming","ace_mode":"c_cpp","tm_scope":"source.c","language_id":1031374237},"Containerfile":{"extensions":[".dockerfile",".containerfile"],"aliases":["Containerfile"],"type":"programming","color":"#384d54","tm_scope":"source.dockerfile","filenames":["Containerfile","Dockerfile"],"ace_mode":"dockerfile","codemirror_mode":"dockerfile","codemirror_mime_type":"text/x-dockerfile","language_id":89},"dockerfile":{"extensions":[".dockerfile",".containerfile"],"aliases":["Containerfile"],"type":"programming","color":"#384d54","tm_scope":"source.dockerfile","filenames":["Containerfile","Dockerfile"],"ace_mode":"dockerfile","codemirror_mode":"dockerfile","codemirror_mime_type":"text/x-dockerfile","language_id":89},"containerfile":{"extensions":[".dockerfile",".containerfile"],"aliases":["Containerfile"],"type":"programming","color":"#384d54","tm_scope":"source.dockerfile","filenames":["Containerfile","Dockerfile"],"ace_mode":"dockerfile","codemirror_mode":"dockerfile","codemirror_mime_type":"text/x-dockerfile","language_id":89},"djs":{"extensions":[".djs"],"aliases":[],"type":"programming","color":"#cca760","tm_scope":"none","ace_mode":"text","language_id":90},"env":{"extensions":[".env"],"aliases":[],"type":"data","color":"#e5d559","filenames":[".env",".env.ci",".env.dev",".env.development",".env.development.local",".env.example",".env.local",".env.prod",".env.production",".env.sample",".env.staging",".env.template",".env.test",".env.testing"],"tm_scope":"source.dotenv","ace_mode":"text","language_id":111148035},"dylan":{"extensions":[".dylan",".dyl",".intr",".lid"],"aliases":[],"type":"programming","color":"#6c616e","tm_scope":"source.dylan","ace_mode":"text","codemirror_mode":"dylan","codemirror_mime_type":"text/x-dylan","language_id":91},"dyl":{"extensions":[".dylan",".dyl",".intr",".lid"],"aliases":[],"type":"programming","color":"#6c616e","tm_scope":"source.dylan","ace_mode":"text","codemirror_mode":"dylan","codemirror_mime_type":"text/x-dylan","language_id":91},"intr":{"extensions":[".dylan",".dyl",".intr",".lid"],"aliases":[],"type":"programming","color":"#6c616e","tm_scope":"source.dylan","ace_mode":"text","codemirror_mode":"dylan","codemirror_mime_type":"text/x-dylan","language_id":91},"lid":{"extensions":[".dylan",".dyl",".intr",".lid"],"aliases":[],"type":"programming","color":"#6c616e","tm_scope":"source.dylan","ace_mode":"text","codemirror_mode":"dylan","codemirror_mime_type":"text/x-dylan","language_id":91},"e":{"extensions":[".e",".ex"],"aliases":[],"type":"programming","color":"#FF790B","interpreters":["eui","euiw"],"ace_mode":"text","tm_scope":"source.euphoria","language_id":880693982},"email":{"extensions":[".eml",".mbox"],"aliases":["email","eml","mail","mbox"],"type":"data","tm_scope":"text.eml.basic","ace_mode":"text","codemirror_mode":"mbox","codemirror_mime_type":"application/mbox","language_id":529653389},"eml":{"extensions":[".eml",".mbox"],"aliases":["email","eml","mail","mbox"],"type":"data","tm_scope":"text.eml.basic","ace_mode":"text","codemirror_mode":"mbox","codemirror_mime_type":"application/mbox","language_id":529653389},"mail":{"extensions":[".eml",".mbox"],"aliases":["email","eml","mail","mbox"],"type":"data","tm_scope":"text.eml.basic","ace_mode":"text","codemirror_mode":"mbox","codemirror_mime_type":"application/mbox","language_id":529653389},"mbox":{"extensions":[".eml",".mbox"],"aliases":["email","eml","mail","mbox"],"type":"data","tm_scope":"text.eml.basic","ace_mode":"text","codemirror_mode":"mbox","codemirror_mime_type":"application/mbox","language_id":529653389},"ebnf":{"extensions":[".ebnf"],"aliases":[],"type":"data","tm_scope":"source.ebnf","ace_mode":"text","codemirror_mode":"ebnf","codemirror_mime_type":"text/x-ebnf","language_id":430},"ecl":{"extensions":[".ecl"],"aliases":[],"type":"programming","color":"#001d9d","group":"Prolog","tm_scope":"source.prolog.eclipse","ace_mode":"prolog","language_id":94},"eclxml":{"extensions":[".ecl",".eclxml"],"aliases":[],"type":"programming","color":"#8a1267","tm_scope":"source.ecl","ace_mode":"text","codemirror_mode":"ecl","codemirror_mime_type":"text/x-ecl","language_id":93},"ejs":{"extensions":[".ejs",".ect",".ejs.t",".jst"],"aliases":[],"type":"markup","color":"#a91e50","tm_scope":"text.html.js","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-ejs","ace_mode":"ejs","language_id":95},"ect":{"extensions":[".ejs",".ect",".ejs.t",".jst"],"aliases":[],"type":"markup","color":"#a91e50","tm_scope":"text.html.js","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-ejs","ace_mode":"ejs","language_id":95},"ejs.t":{"extensions":[".ejs",".ect",".ejs.t",".jst"],"aliases":[],"type":"markup","color":"#a91e50","tm_scope":"text.html.js","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-ejs","ace_mode":"ejs","language_id":95},"jst":{"extensions":[".ejs",".ect",".ejs.t",".jst"],"aliases":[],"type":"markup","color":"#a91e50","tm_scope":"text.html.js","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-ejs","ace_mode":"ejs","language_id":95},"eq":{"extensions":[".eq"],"aliases":[],"type":"programming","color":"#a78649","tm_scope":"source.cs","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","language_id":96},"sch":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"brd":{"extensions":[".brd"],"aliases":[],"type":"data","color":"#2f4aab","tm_scope":"source.pcb.board","ace_mode":"text","language_id":140848857},"Earthfile":{"extensions":[],"aliases":["Earthfile"],"type":"programming","color":"#2af0ff","tm_scope":"source.earthfile","ace_mode":"text","filenames":["Earthfile"],"language_id":963512632},"eb":{"extensions":[".eb"],"aliases":[],"type":"data","color":"#069406","group":"Python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","tm_scope":"source.python","language_id":342840477},"epj":{"extensions":[".epj"],"aliases":[],"type":"data","color":"#913960","group":"JavaScript","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":98},"ecmarkdown":{"extensions":[".html"],"aliases":["ecmarkdown"],"type":"markup","color":"#eb8131","group":"HTML","tm_scope":"text.html.ecmarkup","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":844766630},"html":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"edge":{"extensions":[".edge"],"aliases":[],"type":"markup","color":"#0dffe0","tm_scope":"text.html.edge","ace_mode":"html","language_id":460509620},"esdl":{"extensions":[".edgeql",".esdl"],"aliases":["esdl"],"type":"programming","color":"#31A7FF","ace_mode":"text","tm_scope":"source.edgeql","language_id":925235833},"edgeql":{"extensions":[".edgeql",".esdl"],"aliases":["esdl"],"type":"programming","color":"#31A7FF","ace_mode":"text","tm_scope":"source.edgeql","language_id":925235833},"editor-config":{"extensions":[".editorconfig"],"aliases":["editor-config"],"type":"data","color":"#fff1f2","group":"INI","filenames":[".editorconfig"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.editorconfig","language_id":96139566},"editorconfig":{"extensions":[".editorconfig"],"aliases":["editor-config"],"type":"data","color":"#fff1f2","group":"INI","filenames":[".editorconfig"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.editorconfig","language_id":96139566},"edc":{"extensions":[".edc"],"aliases":[],"type":"data","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":342840478},"ex":{"extensions":[".e",".ex"],"aliases":[],"type":"programming","color":"#FF790B","interpreters":["eui","euiw"],"ace_mode":"text","tm_scope":"source.euphoria","language_id":880693982},"exs":{"extensions":[".ex",".exs"],"aliases":[],"type":"programming","color":"#6e4a7e","tm_scope":"source.elixir","ace_mode":"elixir","filenames":["mix.lock"],"interpreters":["elixir"],"language_id":100},"elm":{"extensions":[".elm"],"aliases":[],"type":"programming","color":"#60B5CC","tm_scope":"source.elm","ace_mode":"elm","codemirror_mode":"elm","codemirror_mime_type":"text/x-elm","language_id":101},"elv":{"extensions":[".elv"],"aliases":[],"type":"programming","ace_mode":"text","interpreters":["elvish"],"tm_scope":"source.elvish","color":"#55BB55","language_id":570996448},"cask":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"eask":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"elisp":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"emacs":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"el":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"emacs.desktop":{"extensions":[".el",".emacs",".emacs.desktop"],"aliases":["cask","eask","elisp","emacs"],"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"em":{"extensions":[".em",".emberscript"],"aliases":[],"type":"programming","color":"#FFF4F3","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","language_id":103},"emberscript":{"extensions":[".em",".emberscript"],"aliases":[],"type":"programming","color":"#FFF4F3","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","language_id":103},"erl":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"app":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"app.src":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"es":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"escript":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"hrl":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"xrl":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"yrl":{"extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"aliases":[],"type":"programming","color":"#B83998","filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"fsharp":{"extensions":[".fs",".fsi",".fsx"],"aliases":["fsharp"],"type":"programming","color":"#b845fc","tm_scope":"source.fsharp","ace_mode":"fsharp","codemirror_mode":"mllike","codemirror_mime_type":"text/x-fsharp","language_id":105},"fs":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"fsi":{"extensions":[".fs",".fsi",".fsx"],"aliases":["fsharp"],"type":"programming","color":"#b845fc","tm_scope":"source.fsharp","ace_mode":"fsharp","codemirror_mode":"mllike","codemirror_mime_type":"text/x-fsharp","language_id":105},"fsx":{"extensions":[".fs",".fsi",".fsx"],"aliases":["fsharp"],"type":"programming","color":"#b845fc","tm_scope":"source.fsharp","ace_mode":"fsharp","codemirror_mode":"mllike","codemirror_mime_type":"text/x-fsharp","language_id":105},"fstar":{"extensions":[".fst",".fsti"],"aliases":["fstar"],"fs_name":"Fstar","type":"programming","color":"#572e30","tm_scope":"source.fstar","ace_mode":"text","language_id":336943375},"fst":{"extensions":[".fst",".fsti"],"aliases":["fstar"],"fs_name":"Fstar","type":"programming","color":"#572e30","tm_scope":"source.fstar","ace_mode":"text","language_id":336943375},"fsti":{"extensions":[".fst",".fsti"],"aliases":["fstar"],"fs_name":"Fstar","type":"programming","color":"#572e30","tm_scope":"source.fstar","ace_mode":"text","language_id":336943375},"FIGfont":{"extensions":[".flf"],"aliases":["FIGfont"],"type":"data","color":"#FFDDBB","tm_scope":"source.figfont","ace_mode":"text","language_id":686129783},"flf":{"extensions":[".flf"],"aliases":["FIGfont"],"type":"data","color":"#FFDDBB","tm_scope":"source.figfont","ace_mode":"text","language_id":686129783},"fir":{"extensions":[".fir"],"aliases":[],"type":"programming","color":"#2f632f","tm_scope":"source.firrtl","ace_mode":"text","language_id":906694254},"fx":{"extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"aliases":[],"type":"programming","color":"#aace60","ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"flux":{"extensions":[".fx",".flux"],"aliases":[],"type":"programming","color":"#88ccff","tm_scope":"none","ace_mode":"text","language_id":106},"factor":{"extensions":[".factor"],"aliases":[],"type":"programming","color":"#636746","filenames":[".factor-boot-rc",".factor-rc"],"tm_scope":"source.factor","ace_mode":"text","codemirror_mode":"factor","codemirror_mime_type":"text/x-factor","language_id":108},"fy":{"extensions":[".fy",".fancypack"],"aliases":[],"type":"programming","color":"#7b9db4","filenames":["Fakefile"],"tm_scope":"source.fancy","ace_mode":"text","language_id":109},"fancypack":{"extensions":[".fy",".fancypack"],"aliases":[],"type":"programming","color":"#7b9db4","filenames":["Fakefile"],"tm_scope":"source.fancy","ace_mode":"text","language_id":109},"fan":{"extensions":[".fan"],"aliases":[],"type":"programming","color":"#14253c","tm_scope":"source.fan","ace_mode":"text","language_id":110},"dsp":{"extensions":[".dsp"],"aliases":[],"type":"data","tm_scope":"none","ace_mode":"text","language_id":800983837},"fnl":{"extensions":[".fnl"],"aliases":[],"type":"programming","tm_scope":"source.fnl","ace_mode":"text","color":"#fff3d7","interpreters":["fennel"],"language_id":239946126},"f":{"extensions":[".f",".f77",".for",".fpp"],"aliases":[],"group":"Fortran","type":"programming","color":"#4d41b1","tm_scope":"source.fortran","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":107},"fbs":{"extensions":[".fbs"],"aliases":[],"type":"data","color":"#ed284a","tm_scope":"source.flatbuffers","ace_mode":"text","language_id":577640576},"flix":{"extensions":[".flix"],"aliases":[],"type":"programming","color":"#d44a45","tm_scope":"source.flix","ace_mode":"flix","language_id":800935960},"ftl":{"extensions":[".ftl",".ftlh"],"aliases":["ftl"],"type":"programming","color":"#0050b2","tm_scope":"text.html.ftl","ace_mode":"ftl","language_id":115},"for":{"extensions":[".f",".f77",".for",".fpp"],"aliases":[],"group":"Fortran","type":"programming","color":"#4d41b1","tm_scope":"source.fortran","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":107},"eam.fs":{"extensions":[".for",".eam.fs"],"aliases":[],"type":"data","tm_scope":"none","ace_mode":"text","language_id":113},"fth":{"extensions":[".fth",".4th",".f",".for",".forth",".fr",".frt",".fs"],"aliases":[],"type":"programming","color":"#341708","tm_scope":"source.forth","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":114},"4th":{"extensions":[".fth",".4th",".f",".for",".forth",".fr",".frt",".fs"],"aliases":[],"type":"programming","color":"#341708","tm_scope":"source.forth","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":114},"forth":{"extensions":[".fth",".4th",".f",".for",".forth",".fr",".frt",".fs"],"aliases":[],"type":"programming","color":"#341708","tm_scope":"source.forth","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":114},"fr":{"extensions":[".txt",".fr",".nb",".ncl",".no"],"aliases":["fundamental","plain text"],"type":"prose","wrap":true,"filenames":["CITATION","CITATIONS","COPYING","COPYING.regex","COPYRIGHT.regex","FONTLOG","INSTALL","INSTALL.mysql","LICENSE","LICENSE.mysql","NEWS","README.me","README.mysql","README.nss","click.me","delete.me","keep.me","package.mask","package.use.mask","package.use.stable.mask","read.me","readme.1st","test.me","use.mask","use.stable.mask"],"tm_scope":"none","ace_mode":"text","language_id":372},"frt":{"extensions":[".fth",".4th",".f",".for",".forth",".fr",".frt",".fs"],"aliases":[],"type":"programming","color":"#341708","tm_scope":"source.forth","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":114},"f77":{"extensions":[".f",".f77",".for",".fpp"],"aliases":[],"group":"Fortran","type":"programming","color":"#4d41b1","tm_scope":"source.fortran","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":107},"fpp":{"extensions":[".f",".f77",".for",".fpp"],"aliases":[],"group":"Fortran","type":"programming","color":"#4d41b1","tm_scope":"source.fortran","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":107},"f90":{"extensions":[".f90",".f03",".f08",".f95"],"aliases":[],"group":"Fortran","color":"#4d41b1","type":"programming","tm_scope":"source.fortran.modern","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":761352333},"f03":{"extensions":[".f90",".f03",".f08",".f95"],"aliases":[],"group":"Fortran","color":"#4d41b1","type":"programming","tm_scope":"source.fortran.modern","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":761352333},"f08":{"extensions":[".f90",".f03",".f08",".f95"],"aliases":[],"group":"Fortran","color":"#4d41b1","type":"programming","tm_scope":"source.fortran.modern","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":761352333},"f95":{"extensions":[".f90",".f03",".f08",".f95"],"aliases":[],"group":"Fortran","color":"#4d41b1","type":"programming","tm_scope":"source.fortran.modern","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":761352333},"fb":{"extensions":[".bi",".bas"],"aliases":["fb"],"type":"programming","color":"#141AC9","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":472896659},"bi":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"ftlh":{"extensions":[".ftl",".ftlh"],"aliases":["ftl"],"type":"programming","color":"#0050b2","tm_scope":"text.html.ftl","ace_mode":"ftl","language_id":115},"fut":{"extensions":[".fut"],"aliases":[],"type":"programming","color":"#5f021f","tm_scope":"source.futhark","ace_mode":"text","language_id":97358117},"g":{"extensions":[".g",".gap",".gd",".gi",".tst"],"aliases":[],"type":"programming","color":"#0000cc","tm_scope":"source.gap","ace_mode":"text","language_id":119},"cnc":{"extensions":[".g",".cnc",".gco",".gcode"],"aliases":[],"type":"programming","color":"#D08CF2","tm_scope":"source.gcode","ace_mode":"gcode","language_id":117},"gco":{"extensions":[".g",".cnc",".gco",".gcode"],"aliases":[],"type":"programming","color":"#D08CF2","tm_scope":"source.gcode","ace_mode":"gcode","language_id":117},"gcode":{"extensions":[".g",".cnc",".gco",".gcode"],"aliases":[],"type":"programming","color":"#D08CF2","tm_scope":"source.gcode","ace_mode":"gcode","language_id":117},"gaml":{"extensions":[".gaml"],"aliases":[],"type":"programming","color":"#FFC766","tm_scope":"none","ace_mode":"text","language_id":290345951},"gms":{"extensions":[".gms"],"aliases":[],"type":"programming","color":"#f49a22","tm_scope":"none","ace_mode":"text","language_id":118},"gap":{"extensions":[".g",".gap",".gd",".gi",".tst"],"aliases":[],"type":"programming","color":"#0000cc","tm_scope":"source.gap","ace_mode":"text","language_id":119},"gd":{"extensions":[".gd"],"aliases":[],"type":"programming","color":"#355570","tm_scope":"source.gdscript","ace_mode":"text","language_id":123},"gi":{"extensions":[".g",".gap",".gd",".gi",".tst"],"aliases":[],"type":"programming","color":"#0000cc","tm_scope":"source.gap","ace_mode":"text","language_id":119},"tst":{"extensions":[".sci",".sce",".tst"],"aliases":[],"type":"programming","color":"#ca0f21","tm_scope":"source.scilab","ace_mode":"text","language_id":344},"md":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"gdb":{"extensions":[".gdb",".gdbinit"],"aliases":[],"type":"programming","tm_scope":"source.gdb","ace_mode":"text","language_id":122},"gdbinit":{"extensions":[".gdb",".gdbinit"],"aliases":[],"type":"programming","tm_scope":"source.gdb","ace_mode":"text","language_id":122},"gdshader":{"extensions":[".gdshader",".gdshaderinc"],"aliases":[],"type":"programming","color":"#478CBF","tm_scope":"source.gdshader","ace_mode":"glsl","language_id":694638086},"gdshaderinc":{"extensions":[".gdshader",".gdshaderinc"],"aliases":[],"type":"programming","color":"#478CBF","tm_scope":"source.gdshader","ace_mode":"glsl","language_id":694638086},"ged":{"extensions":[".ged"],"aliases":[],"type":"data","color":"#003058","ace_mode":"text","tm_scope":"source.gedcom","language_id":459577965},"glsl":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"fp":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"frag":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"frg":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"fsh":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"fshader":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"geo":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"geom":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"glslf":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"glslv":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"gs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"gshader":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"rchit":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"rmiss":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"shader":{"extensions":[".shader"],"aliases":[],"type":"programming","color":"#222c37","ace_mode":"text","tm_scope":"source.shaderlab","language_id":664257356},"tesc":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"tese":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"vert":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"vrx":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"vs":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"vsh":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"vshader":{"extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"aliases":[],"type":"programming","color":"#5686a5","tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"gn":{"extensions":[".gn",".gni"],"aliases":[],"type":"data","interpreters":["gn"],"filenames":[".gn"],"tm_scope":"source.gn","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":302957008},"gni":{"extensions":[".gn",".gni"],"aliases":[],"type":"data","interpreters":["gn"],"filenames":[".gn"],"tm_scope":"source.gn","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":302957008},"gsc":{"extensions":[".gsc",".csc",".gsh"],"aliases":[],"type":"programming","color":"#FF6800","tm_scope":"source.gsc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":257856279},"csc":{"extensions":[".gsc",".csc",".gsh"],"aliases":[],"type":"programming","color":"#FF6800","tm_scope":"source.gsc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":257856279},"gsh":{"extensions":[".gsc",".csc",".gsh"],"aliases":[],"type":"programming","color":"#FF6800","tm_scope":"source.gsc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":257856279},"gml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"gemtext":{"extensions":[".gmi"],"aliases":["gemtext"],"type":"prose","color":"#ff6900","ace_mode":"text","wrap":true,"tm_scope":"source.gemini","language_id":310828396},"gmi":{"extensions":[".gmi"],"aliases":["gemtext"],"type":"prose","color":"#ff6900","ace_mode":"text","wrap":true,"tm_scope":"source.gemini","language_id":310828396},"4gl":{"extensions":[".4gl"],"aliases":[],"type":"programming","color":"#63408e","tm_scope":"source.genero-4gl","ace_mode":"text","language_id":986054050},"per":{"extensions":[".per"],"aliases":[],"type":"markup","color":"#d8df39","tm_scope":"source.genero-per","ace_mode":"text","language_id":902995658},"xml+genshi":{"extensions":[".kid"],"aliases":["xml+genshi","xml+kid"],"type":"programming","color":"#951531","tm_scope":"text.xml.genshi","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":126},"xml+kid":{"extensions":[".kid"],"aliases":["xml+genshi","xml+kid"],"type":"programming","color":"#951531","tm_scope":"text.xml.genshi","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":126},"kid":{"extensions":[".kid"],"aliases":["xml+genshi","xml+kid"],"type":"programming","color":"#951531","tm_scope":"text.xml.genshi","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":126},"ebuild":{"extensions":[".ebuild"],"aliases":[],"type":"programming","color":"#9400ff","group":"Shell","tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":127},"eclass":{"extensions":[".eclass"],"aliases":[],"type":"programming","color":"#9400ff","group":"Shell","tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":128},"rs-274x":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gbr":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"cmp":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gbl":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gbo":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gbp":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gbs":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gko":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gpb":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gpt":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gtl":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gto":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gtp":{"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"aliases":["rs-274x"],"type":"data","color":"#d20b00","interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"gts":{"extensions":[".gts"],"aliases":["gts"],"type":"programming","ace_mode":"typescript","color":"#3178c6","tm_scope":"source.gts","group":"TypeScript","language_id":95110458},"ncl":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"sol":{"extensions":[".sol"],"aliases":[],"type":"programming","color":"#AA6746","ace_mode":"text","tm_scope":"source.solidity","language_id":237469032},"pot":{"extensions":[".po",".pot"],"aliases":["pot"],"type":"prose","tm_scope":"source.po","ace_mode":"text","language_id":129},"po":{"extensions":[".po",".pot"],"aliases":["pot"],"type":"prose","tm_scope":"source.po","ace_mode":"text","language_id":129},"cucumber":{"extensions":[".feature",".story"],"aliases":["cucumber"],"type":"programming","tm_scope":"text.gherkin.feature","codemirror_mode":"gherkin","codemirror_mime_type":"text/x-feature","ace_mode":"gherkin","color":"#5B2063","language_id":76},"feature":{"extensions":[".feature",".story"],"aliases":["cucumber"],"type":"programming","tm_scope":"text.gherkin.feature","codemirror_mode":"gherkin","codemirror_mime_type":"text/x-feature","ace_mode":"gherkin","color":"#5B2063","language_id":76},"story":{"extensions":[".feature",".story"],"aliases":["cucumber"],"type":"programming","tm_scope":"text.gherkin.feature","codemirror_mode":"gherkin","codemirror_mime_type":"text/x-feature","ace_mode":"gherkin","color":"#5B2063","language_id":76},"gitattributes":{"extensions":[],"aliases":["gitattributes"],"type":"data","color":"#F44D27","filenames":[".gitattributes"],"tm_scope":"source.gitattributes","ace_mode":"gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":956324166},"commit":{"extensions":[],"aliases":["commit"],"type":"data","color":"#F44D27","filenames":["COMMIT_EDITMSG"],"ace_mode":"text","tm_scope":"text.git-commit","wrap":true,"language_id":131750475},"gitconfig":{"extensions":[".gitconfig"],"aliases":["gitconfig","gitmodules"],"type":"data","color":"#F44D27","group":"INI","filenames":[".gitconfig",".gitmodules"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.gitconfig","language_id":807968997},"gitmodules":{"extensions":[".gitconfig"],"aliases":["gitconfig","gitmodules"],"type":"data","color":"#F44D27","group":"INI","filenames":[".gitconfig",".gitmodules"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.gitconfig","language_id":807968997},"Git Blame Ignore Revs":{"extensions":[],"aliases":["Git Blame Ignore Revs"],"type":"data","color":"#F44D27","filenames":[".git-blame-ignore-revs"],"tm_scope":"source.git-revlist","ace_mode":"text","language_id":461881235},"gleam":{"extensions":[".gleam"],"aliases":[],"type":"programming","color":"#ffaff3","ace_mode":"text","tm_scope":"source.gleam","language_id":1054258749},"gjs":{"extensions":[".gjs"],"aliases":["gjs"],"type":"programming","ace_mode":"javascript","color":"#F5835F","tm_scope":"source.gjs","group":"JavaScript","language_id":5523150},"glf":{"extensions":[".glf"],"aliases":[],"type":"programming","color":"#c1ac7f","tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":130},"bdf":{"extensions":[".bdf"],"aliases":[],"type":"data","tm_scope":"source.bdf","ace_mode":"text","language_id":997665271},"gp":{"extensions":[".gp",".gnu",".gnuplot",".p",".plot",".plt"],"aliases":[],"type":"programming","color":"#f0a9f0","interpreters":["gnuplot"],"tm_scope":"source.gnuplot","ace_mode":"text","language_id":131},"gnu":{"extensions":[".gp",".gnu",".gnuplot",".p",".plot",".plt"],"aliases":[],"type":"programming","color":"#f0a9f0","interpreters":["gnuplot"],"tm_scope":"source.gnuplot","ace_mode":"text","language_id":131},"gnuplot":{"extensions":[".gp",".gnu",".gnuplot",".p",".plot",".plt"],"aliases":[],"type":"programming","color":"#f0a9f0","interpreters":["gnuplot"],"tm_scope":"source.gnuplot","ace_mode":"text","language_id":131},"p":{"extensions":[".p",".cls",".w"],"aliases":["progress","openedge","abl"],"type":"programming","color":"#5ce600","tm_scope":"source.abl","ace_mode":"text","language_id":264},"plot":{"extensions":[".gp",".gnu",".gnuplot",".p",".plot",".plt"],"aliases":[],"type":"programming","color":"#f0a9f0","interpreters":["gnuplot"],"tm_scope":"source.gnuplot","ace_mode":"text","language_id":131},"plt":{"extensions":[".pl",".plt",".pro",".prolog",".yap"],"aliases":[],"type":"programming","color":"#74283c","interpreters":["swipl","yap"],"tm_scope":"source.prolog","ace_mode":"prolog","language_id":295},"golang":{"extensions":[".go"],"aliases":["golang"],"type":"programming","color":"#00ADD8","tm_scope":"source.go","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","language_id":132},"go":{"extensions":[".go"],"aliases":["golang"],"type":"programming","color":"#00ADD8","tm_scope":"source.go","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","language_id":132},"go.sum":{"extensions":[],"aliases":["go.sum","go sum","go.work.sum","go work sum"],"type":"data","color":"#00ADD8","filenames":["go.sum","go.work.sum"],"tm_scope":"go.sum","ace_mode":"text","language_id":1054391671},"go sum":{"extensions":[],"aliases":["go.sum","go sum","go.work.sum","go work sum"],"type":"data","color":"#00ADD8","filenames":["go.sum","go.work.sum"],"tm_scope":"go.sum","ace_mode":"text","language_id":1054391671},"go.work.sum":{"extensions":[],"aliases":["go.sum","go sum","go.work.sum","go work sum"],"type":"data","color":"#00ADD8","filenames":["go.sum","go.work.sum"],"tm_scope":"go.sum","ace_mode":"text","language_id":1054391671},"go work sum":{"extensions":[],"aliases":["go.sum","go sum","go.work.sum","go work sum"],"type":"data","color":"#00ADD8","filenames":["go.sum","go.work.sum"],"tm_scope":"go.sum","ace_mode":"text","language_id":1054391671},"go.mod":{"extensions":[],"aliases":["go.mod","go mod"],"type":"data","color":"#00ADD8","filenames":["go.mod"],"tm_scope":"go.mod","ace_mode":"text","language_id":947461016},"go mod":{"extensions":[],"aliases":["go.mod","go mod"],"type":"data","color":"#00ADD8","filenames":["go.mod"],"tm_scope":"go.mod","ace_mode":"text","language_id":947461016},"gotmpl":{"extensions":[".gohtml",".gotmpl",".html.tmpl",".tmpl",".tpl"],"aliases":["gotmpl"],"type":"markup","color":"#00ADD8","filenames":["_helpers.tpl"],"tm_scope":"source.go-template","ace_mode":"text","language_id":247918769},"gohtml":{"extensions":[".gohtml",".gotmpl",".html.tmpl",".tmpl",".tpl"],"aliases":["gotmpl"],"type":"markup","color":"#00ADD8","filenames":["_helpers.tpl"],"tm_scope":"source.go-template","ace_mode":"text","language_id":247918769},"html.tmpl":{"extensions":[".gohtml",".gotmpl",".html.tmpl",".tmpl",".tpl"],"aliases":["gotmpl"],"type":"markup","color":"#00ADD8","filenames":["_helpers.tpl"],"tm_scope":"source.go-template","ace_mode":"text","language_id":247918769},"tmpl":{"extensions":[".gohtml",".gotmpl",".html.tmpl",".tmpl",".tpl"],"aliases":["gotmpl"],"type":"markup","color":"#00ADD8","filenames":["_helpers.tpl"],"tm_scope":"source.go-template","ace_mode":"text","language_id":247918769},"tpl":{"extensions":[".tpl"],"aliases":[],"type":"programming","color":"#f0c040","ace_mode":"smarty","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","tm_scope":"text.html.smarty","language_id":353},"go.work":{"extensions":[],"aliases":["go.work","go work"],"type":"data","color":"#00ADD8","filenames":["go.work"],"tm_scope":"go.mod","ace_mode":"text","language_id":934546256},"go work":{"extensions":[],"aliases":["go.work","go work"],"type":"data","color":"#00ADD8","filenames":["go.work"],"tm_scope":"go.mod","ace_mode":"text","language_id":934546256},"gdnlib":{"extensions":[".gdnlib",".gdns",".tres",".tscn"],"aliases":[],"type":"data","color":"#355570","filenames":["project.godot"],"tm_scope":"source.gdresource","ace_mode":"text","language_id":738107771},"gdns":{"extensions":[".gdnlib",".gdns",".tres",".tscn"],"aliases":[],"type":"data","color":"#355570","filenames":["project.godot"],"tm_scope":"source.gdresource","ace_mode":"text","language_id":738107771},"tres":{"extensions":[".gdnlib",".gdns",".tres",".tscn"],"aliases":[],"type":"data","color":"#355570","filenames":["project.godot"],"tm_scope":"source.gdresource","ace_mode":"text","language_id":738107771},"tscn":{"extensions":[".gdnlib",".gdns",".tres",".tscn"],"aliases":[],"type":"data","color":"#355570","filenames":["project.godot"],"tm_scope":"source.gdresource","ace_mode":"text","language_id":738107771},"golo":{"extensions":[".golo"],"aliases":[],"type":"programming","color":"#88562A","tm_scope":"source.golo","ace_mode":"text","language_id":133},"gst":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"gsx":{"extensions":[".gs",".gst",".gsx",".vark"],"aliases":[],"type":"programming","color":"#82937f","tm_scope":"source.gosu.2","ace_mode":"text","language_id":134},"vark":{"extensions":[".gs",".gst",".gsx",".vark"],"aliases":[],"type":"programming","color":"#82937f","tm_scope":"source.gosu.2","ace_mode":"text","language_id":134},"grace":{"extensions":[".grace"],"aliases":[],"type":"programming","color":"#615f8b","tm_scope":"source.grace","ace_mode":"text","language_id":135},"gradle":{"extensions":[".gradle"],"aliases":[],"type":"data","color":"#02303a","tm_scope":"source.groovy.gradle","ace_mode":"text","language_id":136},"gradle.kts":{"extensions":[".gradle.kts"],"aliases":[],"group":"Gradle","type":"data","color":"#02303a","ace_mode":"text","tm_scope":"source.kotlin","language_id":432600901},"gf":{"extensions":[".gf"],"aliases":["gf"],"type":"programming","color":"#ff0000","tm_scope":"source.gf","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":137},"graphql":{"extensions":[".graphql",".gql",".graphqls"],"aliases":[],"type":"data","color":"#e10098","tm_scope":"source.graphql","ace_mode":"graphqlschema","language_id":139},"gql":{"extensions":[".graphql",".gql",".graphqls"],"aliases":[],"type":"data","color":"#e10098","tm_scope":"source.graphql","ace_mode":"graphqlschema","language_id":139},"graphqls":{"extensions":[".graphql",".gql",".graphqls"],"aliases":[],"type":"data","color":"#e10098","tm_scope":"source.graphql","ace_mode":"graphqlschema","language_id":139},"dot":{"extensions":[".dot",".gv"],"aliases":[],"type":"data","color":"#2596be","tm_scope":"source.dot","ace_mode":"dot","language_id":140},"gv":{"extensions":[".dot",".gv"],"aliases":[],"type":"data","color":"#2596be","tm_scope":"source.dot","ace_mode":"dot","language_id":140},"groovy":{"extensions":[".groovy",".grt",".gtpl",".gvy"],"aliases":[],"type":"programming","tm_scope":"source.groovy","ace_mode":"groovy","codemirror_mode":"groovy","codemirror_mime_type":"text/x-groovy","color":"#4298b8","interpreters":["groovy"],"filenames":["Jenkinsfile"],"language_id":142},"grt":{"extensions":[".groovy",".grt",".gtpl",".gvy"],"aliases":[],"type":"programming","tm_scope":"source.groovy","ace_mode":"groovy","codemirror_mode":"groovy","codemirror_mime_type":"text/x-groovy","color":"#4298b8","interpreters":["groovy"],"filenames":["Jenkinsfile"],"language_id":142},"gtpl":{"extensions":[".groovy",".grt",".gtpl",".gvy"],"aliases":[],"type":"programming","tm_scope":"source.groovy","ace_mode":"groovy","codemirror_mode":"groovy","codemirror_mime_type":"text/x-groovy","color":"#4298b8","interpreters":["groovy"],"filenames":["Jenkinsfile"],"language_id":142},"gvy":{"extensions":[".groovy",".grt",".gtpl",".gvy"],"aliases":[],"type":"programming","tm_scope":"source.groovy","ace_mode":"groovy","codemirror_mode":"groovy","codemirror_mime_type":"text/x-groovy","color":"#4298b8","interpreters":["groovy"],"filenames":["Jenkinsfile"],"language_id":142},"gsp":{"extensions":[".gsp"],"aliases":["gsp","java server page"],"type":"programming","color":"#4298b8","group":"Groovy","tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":143},"java server page":{"extensions":[".gsp"],"aliases":["gsp","java server page"],"type":"programming","color":"#4298b8","group":"Groovy","tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":143},"cfg":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"HashiCorp Configuration Language":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"opentofu":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"terraform":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"hcl":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"nomad":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"tf":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"tfvars":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"tofu":{"extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"type":"programming","color":"#844FBA","ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"workflow":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"hip":{"extensions":[".hip"],"aliases":[],"type":"programming","color":"#4F3A4F","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":674379998},"hlsl":{"extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"aliases":[],"type":"programming","color":"#aace60","ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"cginc":{"extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"aliases":[],"type":"programming","color":"#aace60","ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"fxh":{"extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"aliases":[],"type":"programming","color":"#aace60","ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"hlsli":{"extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"aliases":[],"type":"programming","color":"#aace60","ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"hocon":{"extensions":[".hocon"],"aliases":[],"type":"data","color":"#9ff8ee","filenames":[".scalafix.conf",".scalafmt.conf"],"tm_scope":"source.hocon","ace_mode":"text","language_id":679725279},"xhtml":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"hta":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"htm":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"html.hl":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"xht":{"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"aliases":["xhtml"],"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","language_id":146},"ecr":{"extensions":[".ecr"],"aliases":["ecr"],"type":"markup","color":"#2e1052","tm_scope":"text.html.ecr","group":"HTML","ace_mode":"html_ruby","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":148},"eex":{"extensions":[".html.eex",".heex",".leex"],"aliases":["eex","heex","leex"],"type":"markup","color":"#6e4a7e","tm_scope":"text.html.elixir","group":"HTML","ace_mode":"html_elixir","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":149},"heex":{"extensions":[".html.eex",".heex",".leex"],"aliases":["eex","heex","leex"],"type":"markup","color":"#6e4a7e","tm_scope":"text.html.elixir","group":"HTML","ace_mode":"html_elixir","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":149},"leex":{"extensions":[".html.eex",".heex",".leex"],"aliases":["eex","heex","leex"],"type":"markup","color":"#6e4a7e","tm_scope":"text.html.elixir","group":"HTML","ace_mode":"html_elixir","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":149},"html.eex":{"extensions":[".html.eex",".heex",".leex"],"aliases":["eex","heex","leex"],"type":"markup","color":"#6e4a7e","tm_scope":"text.html.elixir","group":"HTML","ace_mode":"html_elixir","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":149},"erb":{"extensions":[".erb",".erb.deface",".rhtml"],"aliases":["erb","rhtml","html+ruby"],"type":"markup","color":"#701516","tm_scope":"text.html.erb","group":"HTML","ace_mode":"html_ruby","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-erb","language_id":150},"rhtml":{"extensions":[".erb",".erb.deface",".rhtml"],"aliases":["erb","rhtml","html+ruby"],"type":"markup","color":"#701516","tm_scope":"text.html.erb","group":"HTML","ace_mode":"html_ruby","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-erb","language_id":150},"html+ruby":{"extensions":[".erb",".erb.deface",".rhtml"],"aliases":["erb","rhtml","html+ruby"],"type":"markup","color":"#701516","tm_scope":"text.html.erb","group":"HTML","ace_mode":"html_ruby","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-erb","language_id":150},"erb.deface":{"extensions":[".erb",".erb.deface",".rhtml"],"aliases":["erb","rhtml","html+ruby"],"type":"markup","color":"#701516","tm_scope":"text.html.erb","group":"HTML","ace_mode":"html_ruby","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-erb","language_id":150},"phtml":{"extensions":[".phtml"],"aliases":[],"type":"markup","color":"#4f5d95","tm_scope":"text.html.php","group":"HTML","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","language_id":151},"razor":{"extensions":[".cshtml",".razor"],"aliases":["razor"],"type":"markup","color":"#512be4","tm_scope":"text.html.cshtml","group":"HTML","ace_mode":"razor","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":479039817},"cshtml":{"extensions":[".cshtml",".razor"],"aliases":["razor"],"type":"markup","color":"#512be4","tm_scope":"text.html.cshtml","group":"HTML","ace_mode":"razor","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":479039817},"http":{"extensions":[".http"],"aliases":[],"type":"data","color":"#005C9C","tm_scope":"source.httpspec","ace_mode":"text","codemirror_mode":"http","codemirror_mime_type":"message/http","language_id":152},"hxml":{"extensions":[".hxml"],"aliases":[],"type":"data","color":"#f68712","ace_mode":"text","tm_scope":"source.hxml","codemirror_mode":"haxe","codemirror_mime_type":"text/x-hxml","language_id":786683730},"hack":{"extensions":[".hack",".hh",".hhi",".php"],"aliases":[],"type":"programming","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","tm_scope":"source.hack","color":"#878787","language_id":153},"hhi":{"extensions":[".hack",".hh",".hhi",".php"],"aliases":[],"type":"programming","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","tm_scope":"source.hack","color":"#878787","language_id":153},"php":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"haml":{"extensions":[".haml",".haml.deface"],"aliases":[],"type":"markup","color":"#ece2a9","tm_scope":"text.haml","ace_mode":"haml","codemirror_mode":"haml","codemirror_mime_type":"text/x-haml","language_id":154},"haml.deface":{"extensions":[".haml",".haml.deface"],"aliases":[],"type":"markup","color":"#ece2a9","tm_scope":"text.haml","ace_mode":"haml","codemirror_mode":"haml","codemirror_mime_type":"text/x-haml","language_id":154},"hbs":{"extensions":[".handlebars",".hbs"],"aliases":["hbs","htmlbars"],"type":"markup","color":"#f7931e","tm_scope":"text.html.handlebars","ace_mode":"handlebars","language_id":155},"htmlbars":{"extensions":[".handlebars",".hbs"],"aliases":["hbs","htmlbars"],"type":"markup","color":"#f7931e","tm_scope":"text.html.handlebars","ace_mode":"handlebars","language_id":155},"handlebars":{"extensions":[".handlebars",".hbs"],"aliases":["hbs","htmlbars"],"type":"markup","color":"#f7931e","tm_scope":"text.html.handlebars","ace_mode":"handlebars","language_id":155},"hb":{"extensions":[".hb"],"aliases":[],"type":"programming","color":"#0e60e3","tm_scope":"source.harbour","ace_mode":"text","language_id":156},"ha":{"extensions":[".ha"],"aliases":[],"type":"programming","color":"#9d7424","ace_mode":"text","language_id":463518941,"tm_scope":"none"},"hs":{"extensions":[".hs",".hs-boot",".hsc"],"aliases":[],"type":"programming","color":"#5e5086","interpreters":["runghc","runhaskell","runhugs"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":157},"hs-boot":{"extensions":[".hs",".hs-boot",".hsc"],"aliases":[],"type":"programming","color":"#5e5086","interpreters":["runghc","runhaskell","runhugs"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":157},"hsc":{"extensions":[".hs",".hs-boot",".hsc"],"aliases":[],"type":"programming","color":"#5e5086","interpreters":["runghc","runhaskell","runhugs"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":157},"hx":{"extensions":[".hx",".hxsl"],"aliases":[],"type":"programming","ace_mode":"haxe","codemirror_mode":"haxe","codemirror_mime_type":"text/x-haxe","color":"#df7900","tm_scope":"source.hx","language_id":158},"hxsl":{"extensions":[".hx",".hxsl"],"aliases":[],"type":"programming","ace_mode":"haxe","codemirror_mode":"haxe","codemirror_mime_type":"text/x-haxe","color":"#df7900","tm_scope":"source.hx","language_id":158},"q":{"extensions":[".q"],"aliases":[],"type":"programming","tm_scope":"source.q","ace_mode":"text","codemirror_mode":"q","codemirror_mime_type":"text/x-q","color":"#0040cd","language_id":970539067},"hql":{"extensions":[".q",".hql"],"aliases":[],"type":"programming","color":"#dce200","tm_scope":"source.hql","ace_mode":"sql","language_id":931814087},"hc":{"extensions":[".hc"],"aliases":[],"type":"programming","color":"#ffefaf","tm_scope":"source.hc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":928121743},"hosts":{"extensions":[],"aliases":["hosts"],"type":"data","color":"#308888","filenames":["HOSTS","hosts","hosts.txt"],"tm_scope":"source.hosts","ace_mode":"text","language_id":231021894},"hurl":{"extensions":[".hurl"],"aliases":[],"type":"programming","color":"#FF0288","tm_scope":"source.hurl","ace_mode":"text","language_id":959040217},"hylang":{"extensions":[".hy"],"aliases":["hylang"],"type":"programming","ace_mode":"text","color":"#7790B2","interpreters":["hy"],"tm_scope":"source.hy","language_id":159},"hy":{"extensions":[".hy"],"aliases":["hylang"],"type":"programming","ace_mode":"text","color":"#7790B2","interpreters":["hy"],"tm_scope":"source.hy","language_id":159},"pro":{"extensions":[".pro",".pri"],"aliases":[],"type":"programming","interpreters":["qmake"],"tm_scope":"source.qmake","ace_mode":"text","language_id":306},"dlm":{"extensions":[".pro",".dlm"],"aliases":[],"type":"programming","color":"#a3522f","tm_scope":"source.idl","ace_mode":"text","codemirror_mode":"idl","codemirror_mime_type":"text/x-idl","language_id":161},"igor":{"extensions":[".ipf"],"aliases":["igor","igorpro"],"type":"programming","color":"#0000cc","tm_scope":"source.igor","ace_mode":"text","language_id":162},"igorpro":{"extensions":[".ipf"],"aliases":["igor","igorpro"],"type":"programming","color":"#0000cc","tm_scope":"source.igor","ace_mode":"text","language_id":162},"ipf":{"extensions":[".ipf"],"aliases":["igor","igorpro"],"type":"programming","color":"#0000cc","tm_scope":"source.igor","ace_mode":"text","language_id":162},"dosini":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"ini":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"cnf":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"dof":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"frm":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"lektorproject":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"prefs":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"properties":{"extensions":[".properties"],"aliases":[],"type":"data","color":"#2A6277","tm_scope":"source.java-properties","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":519377561},"url":{"extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"aliases":["dosini"],"type":"data","color":"#d1dbe0","filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"irc":{"extensions":[".irclog",".weechatlog"],"aliases":["irc","irc logs"],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"mirc","codemirror_mime_type":"text/mirc","language_id":164},"irc logs":{"extensions":[".irclog",".weechatlog"],"aliases":["irc","irc logs"],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"mirc","codemirror_mime_type":"text/mirc","language_id":164},"irclog":{"extensions":[".irclog",".weechatlog"],"aliases":["irc","irc logs"],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"mirc","codemirror_mime_type":"text/mirc","language_id":164},"weechatlog":{"extensions":[".irclog",".weechatlog"],"aliases":["irc","irc logs"],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"mirc","codemirror_mime_type":"text/mirc","language_id":164},"ispc":{"extensions":[".ispc"],"aliases":[],"type":"programming","color":"#2D68B1","tm_scope":"source.ispc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":327071},"idr":{"extensions":[".idr",".lidr"],"aliases":[],"type":"programming","color":"#b30000","ace_mode":"text","tm_scope":"source.idris","language_id":165},"lidr":{"extensions":[".idr",".lidr"],"aliases":[],"type":"programming","color":"#b30000","ace_mode":"text","tm_scope":"source.idris","language_id":165},"ignore":{"extensions":[".gitignore"],"aliases":["ignore","gitignore","git-ignore"],"type":"data","color":"#000000","filenames":[".atomignore",".babelignore",".bzrignore",".coffeelintignore",".cvsignore",".dockerignore",".easignore",".eleventyignore",".eslintignore",".gitignore",".ignore",".markdownlintignore",".nodemonignore",".npmignore",".prettierignore",".stylelintignore",".vercelignore",".vscodeignore","gitignore-global","gitignore_global"],"ace_mode":"gitignore","tm_scope":"source.gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":74444240},"gitignore":{"extensions":[".gitignore"],"aliases":["ignore","gitignore","git-ignore"],"type":"data","color":"#000000","filenames":[".atomignore",".babelignore",".bzrignore",".coffeelintignore",".cvsignore",".dockerignore",".easignore",".eleventyignore",".eslintignore",".gitignore",".ignore",".markdownlintignore",".nodemonignore",".npmignore",".prettierignore",".stylelintignore",".vercelignore",".vscodeignore","gitignore-global","gitignore_global"],"ace_mode":"gitignore","tm_scope":"source.gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":74444240},"git-ignore":{"extensions":[".gitignore"],"aliases":["ignore","gitignore","git-ignore"],"type":"data","color":"#000000","filenames":[".atomignore",".babelignore",".bzrignore",".coffeelintignore",".cvsignore",".dockerignore",".easignore",".eleventyignore",".eslintignore",".gitignore",".ignore",".markdownlintignore",".nodemonignore",".npmignore",".prettierignore",".stylelintignore",".vercelignore",".vscodeignore","gitignore-global","gitignore_global"],"ace_mode":"gitignore","tm_scope":"source.gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":74444240},"ijm":{"extensions":[".ijm"],"aliases":["ijm"],"type":"programming","color":"#99AAFF","ace_mode":"text","tm_scope":"none","language_id":575143428},"imba":{"extensions":[".imba"],"aliases":[],"type":"programming","color":"#16cec6","ace_mode":"text","tm_scope":"source.imba","language_id":1057618448},"i7":{"extensions":[".ni",".i7x"],"aliases":["i7","inform7"],"type":"programming","wrap":true,"tm_scope":"source.inform7","ace_mode":"text","language_id":166},"inform7":{"extensions":[".ni",".i7x"],"aliases":["i7","inform7"],"type":"programming","wrap":true,"tm_scope":"source.inform7","ace_mode":"text","language_id":166},"ni":{"extensions":[".ni",".i7x"],"aliases":["i7","inform7"],"type":"programming","wrap":true,"tm_scope":"source.inform7","ace_mode":"text","language_id":166},"i7x":{"extensions":[".ni",".i7x"],"aliases":["i7","inform7"],"type":"programming","wrap":true,"tm_scope":"source.inform7","ace_mode":"text","language_id":166},"ink":{"extensions":[".ink"],"aliases":[],"type":"programming","wrap":true,"tm_scope":"source.ink","ace_mode":"text","language_id":838252715},"iss":{"extensions":[".iss",".isl"],"aliases":[],"type":"programming","color":"#264b99","tm_scope":"source.inno","ace_mode":"text","language_id":167},"isl":{"extensions":[".iss",".isl"],"aliases":[],"type":"programming","color":"#264b99","tm_scope":"source.inno","ace_mode":"text","language_id":167},"io":{"extensions":[".io"],"aliases":[],"type":"programming","color":"#a9188d","interpreters":["io"],"tm_scope":"source.io","ace_mode":"io","language_id":168},"ik":{"extensions":[".ik"],"aliases":[],"type":"programming","color":"#078193","interpreters":["ioke"],"tm_scope":"source.ioke","ace_mode":"text","language_id":169},"thy":{"extensions":[".thy"],"aliases":[],"type":"programming","color":"#FEFE00","tm_scope":"source.isabelle.theory","ace_mode":"text","language_id":170},"ijs":{"extensions":[".ijs"],"aliases":[],"type":"programming","color":"#9EEDFF","interpreters":["jconsole"],"tm_scope":"source.j","ace_mode":"text","language_id":172},"jcl":{"extensions":[".jcl"],"aliases":[],"type":"programming","color":"#d90e09","tm_scope":"source.jcl","ace_mode":"text","language_id":316620079},"flex":{"extensions":[".l",".lex"],"aliases":["flex"],"type":"programming","color":"#DBCA00","filenames":["Lexer.x","lexer.x"],"tm_scope":"source.lex","ace_mode":"text","language_id":199},"jflex":{"extensions":[".flex",".jflex"],"aliases":[],"type":"programming","color":"#DBCA00","group":"Lex","tm_scope":"source.jflex","ace_mode":"text","language_id":173},"geojson":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"jsonl":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"sarif":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"topojson":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"json":{"extensions":[".json"],"aliases":[],"type":"data","color":"#85ea2d","group":"OpenAPI Specification v3","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":980062566},"4DForm":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"4DProject":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"avsc":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"gltf":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"har":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"ice":{"extensions":[".ice"],"aliases":[],"type":"programming","color":"#003fa2","tm_scope":"source.ice","ace_mode":"text","language_id":894641667},"JSON-tmLanguage":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"json.example":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"mcmeta":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"tact":{"extensions":[".tact"],"aliases":[],"type":"programming","color":"#48b5ff","ace_mode":"text","tm_scope":"source.tact","language_id":606708469},"tfstate":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"tfstate.backup":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"webapp":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"webmanifest":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"yy":{"extensions":[".y",".yacc",".yy"],"aliases":[],"type":"programming","tm_scope":"source.yacc","ace_mode":"text","color":"#4B6C4B","language_id":409},"yyp":{"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"aliases":["geojson","jsonl","sarif","topojson"],"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"jsonc":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"code-snippets":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"code-workspace":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-build":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-color-scheme":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-commands":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-completions":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-keymap":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-macro":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-menu":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-mousemap":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-project":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-settings":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-theme":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime-workspace":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime_metrics":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"sublime_session":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"tsconfig.json":{"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"aliases":["jsonc"],"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"json5":{"extensions":[".json5"],"aliases":[],"type":"data","color":"#267CB9","tm_scope":"source.js","ace_mode":"json5","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":175},"jsonld":{"extensions":[".jsonld"],"aliases":[],"type":"data","color":"#0c479c","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/ld+json","language_id":176},"jq":{"extensions":[".jq"],"aliases":[],"color":"#c7254e","ace_mode":"text","type":"programming","interpreters":["gojq","jaq","jq","jqjq","jqq","query-json"],"tm_scope":"source.jq","language_id":905371884},"jac":{"extensions":[".jac"],"aliases":[],"type":"programming","color":"#FC792D","tm_scope":"source.jac","ace_mode":"text","language_id":235277043},"jai":{"extensions":[".jai"],"aliases":[],"type":"programming","color":"#ab8b4b","ace_mode":"text","tm_scope":"source.jai","language_id":70127133},"janet":{"extensions":[".janet"],"aliases":[],"type":"programming","color":"#0886a5","tm_scope":"source.janet","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","interpreters":["janet"],"language_id":1028705371},"j":{"extensions":[".j",".sj"],"aliases":["obj-j","objectivej","objj"],"type":"programming","color":"#ff0c5a","tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"java":{"extensions":[".java",".jav",".jsh"],"aliases":[],"type":"programming","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","color":"#b07219","language_id":181},"jav":{"extensions":[".java",".jav",".jsh"],"aliases":[],"type":"programming","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","color":"#b07219","language_id":181},"jsh":{"extensions":[".java",".jav",".jsh"],"aliases":[],"type":"programming","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","color":"#b07219","language_id":181},"jsp":{"extensions":[".jsp",".tag"],"aliases":["jsp"],"type":"programming","color":"#2A6277","group":"Java","tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":182},"tag":{"extensions":[".jsp",".tag"],"aliases":["jsp"],"type":"programming","color":"#2A6277","group":"Java","tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":182},"jte":{"extensions":[".jte"],"aliases":["jte"],"type":"programming","color":"#2A6277","group":"Java","ace_mode":"text","tm_scope":"text.html.jte","language_id":599494012},"js":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"node":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"_js":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"bones":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"cjs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"es6":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jake":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"javascript":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jsb":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jscad":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jsfl":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jslib":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jsm":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jspre":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jss":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"jsx":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"mjs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"njs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"pac":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"sjs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"ssjs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"xsjs":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"xsjslib":{"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"aliases":["js","node"],"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"js.erb":{"extensions":[".js.erb"],"aliases":[],"type":"programming","color":"#f1e05a","tm_scope":"source.js","group":"JavaScript","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/javascript","language_id":914318960},"snap":{"extensions":[".snap"],"aliases":[],"type":"data","color":"#15c213","tm_scope":"source.jest.snap","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/javascript","language_id":774635084},"mps":{"extensions":[".mps"],"aliases":[],"type":"programming","color":"#0530ad","tm_scope":"text.source.mps","ace_mode":"text","language_id":429002699},"mpl":{"extensions":[".mps",".mpl",".msd"],"aliases":["mps"],"type":"programming","color":"#21D789","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","tm_scope":"none","language_id":465165328},"msd":{"extensions":[".mps",".mpl",".msd"],"aliases":["mps"],"type":"programming","color":"#21D789","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","tm_scope":"none","language_id":465165328},"django":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"html+django":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"html+jinja":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"htmldjango":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"jinja":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"j2":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"jinja2":{"extensions":[".jinja",".j2",".jinja2"],"aliases":["django","html+django","html+jinja","htmldjango"],"type":"markup","color":"#a52a22","tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"jison":{"extensions":[".jison"],"aliases":[],"type":"programming","color":"#56b3cb","group":"Yacc","tm_scope":"source.jison","ace_mode":"text","language_id":284531423},"jisonlex":{"extensions":[".jisonlex"],"aliases":[],"type":"programming","color":"#56b3cb","group":"Lex","tm_scope":"source.jisonlex","ace_mode":"text","language_id":406395330},"ol":{"extensions":[".ol",".iol"],"aliases":[],"type":"programming","interpreters":["jolie"],"color":"#843179","ace_mode":"text","tm_scope":"source.jolie","language_id":998078858},"iol":{"extensions":[".ol",".iol"],"aliases":[],"type":"programming","interpreters":["jolie"],"color":"#843179","ace_mode":"text","tm_scope":"source.jolie","language_id":998078858},"jsonnet":{"extensions":[".jsonnet",".libsonnet"],"aliases":[],"color":"#0064bd","type":"programming","ace_mode":"text","tm_scope":"source.jsonnet","language_id":664885656},"libsonnet":{"extensions":[".jsonnet",".libsonnet"],"aliases":[],"color":"#0064bd","type":"programming","ace_mode":"text","tm_scope":"source.jsonnet","language_id":664885656},"jl":{"extensions":[".jl"],"aliases":[],"type":"programming","interpreters":["julia"],"color":"#a270ba","tm_scope":"source.julia","ace_mode":"julia","codemirror_mode":"julia","codemirror_mime_type":"text/x-julia","language_id":184},"IPython Notebook":{"extensions":[".ipynb"],"aliases":["IPython Notebook"],"type":"markup","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","tm_scope":"source.json","color":"#DA5B0B","filenames":["Notebook"],"language_id":185},"ipynb":{"extensions":[".ipynb"],"aliases":["IPython Notebook"],"type":"markup","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","tm_scope":"source.json","color":"#DA5B0B","filenames":["Notebook"],"language_id":185},"Justfile":{"extensions":[".just"],"aliases":["Justfile"],"type":"programming","color":"#384d54","tm_scope":"source.just","filenames":[".JUSTFILE",".Justfile",".justfile","JUSTFILE","Justfile","justfile"],"ace_mode":"text","language_id":128447695},"just":{"extensions":[".just"],"aliases":["Justfile"],"type":"programming","color":"#384d54","tm_scope":"source.just","filenames":[".JUSTFILE",".Justfile",".justfile","JUSTFILE","Justfile","justfile"],"ace_mode":"text","language_id":128447695},"k":{"extensions":[".k"],"aliases":[],"type":"programming","color":"#4195c5","tm_scope":"text.k","ace_mode":"text","language_id":9479532},"kdl":{"extensions":[".kdl"],"aliases":[],"type":"data","color":"#ffb3b3","tm_scope":"source.kdl","ace_mode":"tcl","codemirror_mode":"yacas","codemirror_mime_type":"text/x-yacas","language_id":931123626},"krl":{"extensions":[".krl"],"aliases":[],"type":"programming","color":"#28430A","tm_scope":"none","ace_mode":"text","language_id":186},"ksy":{"extensions":[".ksy"],"aliases":["ksy"],"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","color":"#773b37","tm_scope":"source.yaml","language_id":818804755},"kak":{"extensions":[".kak"],"aliases":["kak","kakscript"],"type":"programming","color":"#6f8042","tm_scope":"source.kakscript","filenames":["kakrc"],"ace_mode":"text","language_id":603336474},"kakscript":{"extensions":[".kak"],"aliases":["kak","kakscript"],"type":"programming","color":"#6f8042","tm_scope":"source.kakscript","filenames":["kakrc"],"ace_mode":"text","language_id":603336474},"ks":{"extensions":[".ks"],"aliases":[],"type":"data","ace_mode":"text","tm_scope":"source.kickstart","language_id":692635484},"pcbnew":{"extensions":[".kicad_pcb",".kicad_mod",".kicad_wks"],"aliases":["pcbnew"],"type":"data","color":"#2f4aab","filenames":["fp-lib-table"],"tm_scope":"source.pcb.sexp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":187},"kicad_pcb":{"extensions":[".kicad_pcb",".kicad_mod",".kicad_wks"],"aliases":["pcbnew"],"type":"data","color":"#2f4aab","filenames":["fp-lib-table"],"tm_scope":"source.pcb.sexp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":187},"kicad_mod":{"extensions":[".kicad_pcb",".kicad_mod",".kicad_wks"],"aliases":["pcbnew"],"type":"data","color":"#2f4aab","filenames":["fp-lib-table"],"tm_scope":"source.pcb.sexp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":187},"kicad_wks":{"extensions":[".kicad_pcb",".kicad_mod",".kicad_wks"],"aliases":["pcbnew"],"type":"data","color":"#2f4aab","filenames":["fp-lib-table"],"tm_scope":"source.pcb.sexp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":187},"eeschema schematic":{"extensions":[".kicad_sch",".kicad_sym",".sch"],"aliases":["eeschema schematic"],"type":"data","color":"#2f4aab","tm_scope":"source.pcb.schematic","ace_mode":"text","language_id":622447435},"kicad_sch":{"extensions":[".kicad_sch",".kicad_sym",".sch"],"aliases":["eeschema schematic"],"type":"data","color":"#2f4aab","tm_scope":"source.pcb.schematic","ace_mode":"text","language_id":622447435},"kicad_sym":{"extensions":[".kicad_sch",".kicad_sym",".sch"],"aliases":["eeschema schematic"],"type":"data","color":"#2f4aab","tm_scope":"source.pcb.schematic","ace_mode":"text","language_id":622447435},"kit":{"extensions":[".kit"],"aliases":[],"type":"markup","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","tm_scope":"text.html.basic","language_id":188},"kk":{"extensions":[".kk"],"aliases":[],"type":"programming","ace_mode":"text","interpreters":["koka"],"color":"#215166","tm_scope":"source.koka","language_id":597930447},"kt":{"extensions":[".kt",".ktm",".kts"],"aliases":[],"type":"programming","color":"#A97BFF","tm_scope":"source.kotlin","ace_mode":"kotlin","codemirror_mode":"clike","codemirror_mime_type":"text/x-kotlin","language_id":189},"ktm":{"extensions":[".kt",".ktm",".kts"],"aliases":[],"type":"programming","color":"#A97BFF","tm_scope":"source.kotlin","ace_mode":"kotlin","codemirror_mode":"clike","codemirror_mime_type":"text/x-kotlin","language_id":189},"kts":{"extensions":[".kt",".ktm",".kts"],"aliases":[],"type":"programming","color":"#A97BFF","tm_scope":"source.kotlin","ace_mode":"kotlin","codemirror_mode":"clike","codemirror_mime_type":"text/x-kotlin","language_id":189},"csl":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"kql":{"extensions":[".csl",".kql"],"aliases":[],"type":"data","tm_scope":"source.kusto","ace_mode":"text","language_id":225697190},"lfe":{"extensions":[".lfe"],"aliases":[],"type":"programming","color":"#4C3023","tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":190},"ll":{"extensions":[".ll"],"aliases":[],"type":"programming","tm_scope":"source.llvm","ace_mode":"text","color":"#185619","language_id":191},"lol":{"extensions":[".lol"],"aliases":[],"type":"programming","color":"#cc9900","tm_scope":"source.lolcode","ace_mode":"text","language_id":192},"lsl":{"extensions":[".lsl",".lslp"],"aliases":[],"type":"programming","tm_scope":"source.lsl","ace_mode":"lsl","interpreters":["lsl"],"color":"#3d9970","language_id":193},"lslp":{"extensions":[".lsl",".lslp"],"aliases":[],"type":"programming","tm_scope":"source.lsl","ace_mode":"lsl","interpreters":["lsl"],"color":"#3d9970","language_id":193},"lvproj":{"extensions":[".lvproj",".lvclass",".lvlib"],"aliases":[],"type":"programming","color":"#fede06","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":194},"lvclass":{"extensions":[".lvproj",".lvclass",".lvlib"],"aliases":[],"type":"programming","color":"#fede06","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":194},"lvlib":{"extensions":[".lvproj",".lvclass",".lvlib"],"aliases":[],"type":"programming","color":"#fede06","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":194},"langium":{"extensions":[".langium"],"aliases":[],"type":"programming","color":"#2c8c87","tm_scope":"source.langium","ace_mode":"text","language_id":548603830},"lark":{"extensions":[".lark"],"aliases":[],"type":"data","color":"#2980B9","tm_scope":"source.lark","ace_mode":"text","codemirror_mode":"ebnf","codemirror_mime_type":"text/x-ebnf","language_id":758480799},"lassoscript":{"extensions":[".lasso",".las",".lasso8",".lasso9"],"aliases":["lassoscript"],"type":"programming","color":"#999999","tm_scope":"file.lasso","ace_mode":"text","language_id":195},"lasso":{"extensions":[".lasso",".las",".lasso8",".lasso9"],"aliases":["lassoscript"],"type":"programming","color":"#999999","tm_scope":"file.lasso","ace_mode":"text","language_id":195},"las":{"extensions":[".lasso",".las",".lasso8",".lasso9"],"aliases":["lassoscript"],"type":"programming","color":"#999999","tm_scope":"file.lasso","ace_mode":"text","language_id":195},"lasso8":{"extensions":[".lasso",".las",".lasso8",".lasso9"],"aliases":["lassoscript"],"type":"programming","color":"#999999","tm_scope":"file.lasso","ace_mode":"text","language_id":195},"lasso9":{"extensions":[".lasso",".las",".lasso8",".lasso9"],"aliases":["lassoscript"],"type":"programming","color":"#999999","tm_scope":"file.lasso","ace_mode":"text","language_id":195},"latte":{"extensions":[".latte"],"aliases":[],"type":"markup","color":"#f2a542","tm_scope":"text.html.smarty","ace_mode":"latte","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","language_id":196},"lean":{"extensions":[".lean"],"aliases":["lean4"],"type":"programming","group":"Lean","tm_scope":"source.lean4","ace_mode":"text","language_id":455147478},"hlean":{"extensions":[".lean",".hlean"],"aliases":[],"type":"programming","tm_scope":"source.lean","ace_mode":"text","language_id":197},"lean4":{"extensions":[".lean"],"aliases":["lean4"],"type":"programming","group":"Lean","tm_scope":"source.lean4","ace_mode":"text","language_id":455147478},"leo":{"extensions":[".leo"],"aliases":[],"type":"programming","color":"#C4FFC2","tm_scope":"source.leo","ace_mode":"text","wrap":true,"language_id":916034822},"less-css":{"extensions":[".less"],"aliases":["less-css"],"type":"markup","color":"#1d365d","tm_scope":"source.css.less","ace_mode":"less","codemirror_mode":"css","codemirror_mime_type":"text/x-less","language_id":198},"less":{"extensions":[".less"],"aliases":["less-css"],"type":"markup","color":"#1d365d","tm_scope":"source.css.less","ace_mode":"less","codemirror_mode":"css","codemirror_mime_type":"text/x-less","language_id":198},"lex":{"extensions":[".l",".lex"],"aliases":["flex"],"type":"programming","color":"#DBCA00","filenames":["Lexer.x","lexer.x"],"tm_scope":"source.lex","ace_mode":"text","language_id":199},"ligo":{"extensions":[".ligo"],"aliases":[],"type":"programming","color":"#0e74ff","tm_scope":"source.ligo","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","group":"LigoLANG","language_id":1040646257},"ly":{"extensions":[".ly",".ily"],"aliases":[],"type":"programming","color":"#9ccc7c","tm_scope":"source.lilypond","ace_mode":"text","language_id":200},"ily":{"extensions":[".ly",".ily"],"aliases":[],"type":"programming","color":"#9ccc7c","tm_scope":"source.lilypond","ace_mode":"text","language_id":200},"m":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"ld":{"extensions":[".ld",".lds",".x"],"aliases":[],"type":"programming","filenames":["ld.script"],"tm_scope":"source.c.linker","ace_mode":"text","language_id":202},"lds":{"extensions":[".ld",".lds",".x"],"aliases":[],"type":"programming","filenames":["ld.script"],"tm_scope":"source.c.linker","ace_mode":"text","language_id":202},"liquid":{"extensions":[".liquid"],"aliases":[],"type":"markup","color":"#67b8de","tm_scope":"text.html.liquid","ace_mode":"liquid","language_id":204},"liq":{"extensions":[".liq"],"aliases":[],"type":"programming","color":"#990066","tm_scope":"source.liquidsoap","ace_mode":"text","language_id":614641732},"lagda":{"extensions":[".lagda"],"aliases":[],"type":"programming","color":"#315665","group":"Agda","tm_scope":"none","ace_mode":"text","language_id":205},"litcoffee":{"extensions":[".litcoffee",".coffee.md"],"aliases":["litcoffee"],"type":"programming","color":"#244776","tm_scope":"source.litcoffee","group":"CoffeeScript","ace_mode":"text","wrap":true,"language_id":206},"coffee.md":{"extensions":[".litcoffee",".coffee.md"],"aliases":["litcoffee"],"type":"programming","color":"#244776","tm_scope":"source.litcoffee","group":"CoffeeScript","ace_mode":"text","wrap":true,"language_id":206},"lhaskell":{"extensions":[".lhs"],"aliases":["lhaskell","lhs"],"type":"programming","color":"#5e5086","group":"Haskell","tm_scope":"text.tex.latex.haskell","ace_mode":"text","codemirror_mode":"haskell-literate","codemirror_mime_type":"text/x-literate-haskell","language_id":207},"lhs":{"extensions":[".lhs"],"aliases":["lhaskell","lhs"],"type":"programming","color":"#5e5086","group":"Haskell","tm_scope":"text.tex.latex.haskell","ace_mode":"text","codemirror_mode":"haskell-literate","codemirror_mime_type":"text/x-literate-haskell","language_id":207},"livecodescript":{"extensions":[".livecodescript"],"aliases":[],"type":"programming","color":"#0c5ba5","tm_scope":"source.livecodescript","ace_mode":"text","language_id":891017},"live-script":{"extensions":[".ls","._ls"],"aliases":["live-script","ls"],"type":"programming","color":"#499886","filenames":["Slakefile"],"tm_scope":"source.livescript","ace_mode":"livescript","codemirror_mode":"livescript","codemirror_mime_type":"text/x-livescript","language_id":208},"ls":{"extensions":[".ls"],"aliases":[],"type":"programming","tm_scope":"source.loomscript","ace_mode":"text","language_id":212},"_ls":{"extensions":[".ls","._ls"],"aliases":["live-script","ls"],"type":"programming","color":"#499886","filenames":["Slakefile"],"tm_scope":"source.livescript","ace_mode":"livescript","codemirror_mode":"livescript","codemirror_mime_type":"text/x-livescript","language_id":208},"xm":{"extensions":[".xm",".x",".xi"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.logos","language_id":209},"xi":{"extensions":[".xm",".x",".xi"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.logos","language_id":209},"lgt":{"extensions":[".lgt",".logtalk"],"aliases":[],"type":"programming","color":"#295b9a","tm_scope":"source.logtalk","ace_mode":"logtalk","language_id":210},"logtalk":{"extensions":[".lgt",".logtalk"],"aliases":[],"type":"programming","color":"#295b9a","tm_scope":"source.logtalk","ace_mode":"logtalk","language_id":210},"lkml":{"extensions":[".lkml",".lookml"],"aliases":[],"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","color":"#652B81","tm_scope":"source.yaml","language_id":211},"lookml":{"extensions":[".lkml",".lookml"],"aliases":[],"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","color":"#652B81","tm_scope":"source.yaml","language_id":211},"lua":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"fcgi":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"nse":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"p8":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"pd_lua":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"rbxs":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"rockspec":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"wlua":{"extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"aliases":[],"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"luau":{"extensions":[".luau"],"aliases":[],"type":"programming","tm_scope":"source.luau","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#00A2FF","interpreters":["luau"],"language_id":365050359},"mumps":{"extensions":[".mumps",".m"],"aliases":["mumps"],"type":"programming","ace_mode":"text","codemirror_mode":"mumps","codemirror_mime_type":"text/x-mumps","language_id":214,"tm_scope":"none"},"hls playlist":{"extensions":[".m3u",".m3u8"],"aliases":["hls playlist","m3u playlist"],"type":"data","color":"#179C7D","tm_scope":"source.m3u","ace_mode":"text","language_id":89638692},"m3u playlist":{"extensions":[".m3u",".m3u8"],"aliases":["hls playlist","m3u playlist"],"type":"data","color":"#179C7D","tm_scope":"source.m3u","ace_mode":"text","language_id":89638692},"m3u":{"extensions":[".m3u",".m3u8"],"aliases":["hls playlist","m3u playlist"],"type":"data","color":"#179C7D","tm_scope":"source.m3u","ace_mode":"text","language_id":89638692},"m3u8":{"extensions":[".m3u",".m3u8"],"aliases":["hls playlist","m3u playlist"],"type":"data","color":"#179C7D","tm_scope":"source.m3u","ace_mode":"text","language_id":89638692},"m4":{"extensions":[".m4"],"aliases":["autoconf"],"type":"programming","group":"M4","filenames":["configure.ac"],"tm_scope":"source.m4","ace_mode":"text","language_id":216},"mc":{"extensions":[".mc"],"aliases":[],"type":"data","tm_scope":"source.win32-messages","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":950967261},"autoconf":{"extensions":[".m4"],"aliases":["autoconf"],"type":"programming","group":"M4","filenames":["configure.ac"],"tm_scope":"source.m4","ace_mode":"text","language_id":216},"octave":{"extensions":[".matlab",".m"],"aliases":["octave"],"type":"programming","color":"#e16737","tm_scope":"source.matlab","ace_mode":"matlab","codemirror_mode":"octave","codemirror_mime_type":"text/x-octave","language_id":225},"matlab":{"extensions":[".matlab",".m"],"aliases":["octave"],"type":"programming","color":"#e16737","tm_scope":"source.matlab","ace_mode":"matlab","codemirror_mode":"octave","codemirror_mime_type":"text/x-octave","language_id":225},"ms":{"extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"type":"programming","group":"Assembly","tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"mcr":{"extensions":[".ms",".mcr"],"aliases":[],"type":"programming","color":"#00a6a6","tm_scope":"source.maxscript","ace_mode":"text","language_id":217},"mdx":{"extensions":[".mdx"],"aliases":[],"type":"markup","color":"#fcb32c","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"tm_scope":"source.mdx","language_id":512838272},"mlir":{"extensions":[".mlir"],"aliases":[],"type":"programming","color":"#5EC8DB","tm_scope":"source.mlir","ace_mode":"text","language_id":448253929},"mq4":{"extensions":[".mq4",".mqh"],"aliases":[],"type":"programming","color":"#62A8D6","tm_scope":"source.mql5","ace_mode":"c_cpp","language_id":426},"mqh":{"extensions":[".mq5",".mqh"],"aliases":[],"type":"programming","color":"#4A76B8","tm_scope":"source.mql5","ace_mode":"c_cpp","language_id":427},"mq5":{"extensions":[".mq5",".mqh"],"aliases":[],"type":"programming","color":"#4A76B8","tm_scope":"source.mql5","ace_mode":"c_cpp","language_id":427},"mtml":{"extensions":[".mtml"],"aliases":[],"type":"markup","color":"#b7e1f4","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":218},"muf":{"extensions":[".muf",".m"],"aliases":[],"type":"programming","group":"Forth","tm_scope":"none","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":219},"m2":{"extensions":[".m2"],"aliases":["m2"],"type":"programming","interpreters":["M2"],"ace_mode":"text","tm_scope":"source.m2","color":"#d8ffff","language_id":34167825},"bsdmake":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"make":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"mf":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"mak":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"makefile":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"mk":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"mkfile":{"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"aliases":["bsdmake","make","mf"],"type":"programming","color":"#427819","filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"mako":{"extensions":[".mako",".mao"],"aliases":[],"type":"programming","color":"#7e858d","tm_scope":"text.html.mako","ace_mode":"text","language_id":221},"mao":{"extensions":[".mako",".mao"],"aliases":[],"type":"programming","color":"#7e858d","tm_scope":"text.html.mako","ace_mode":"text","language_id":221},"pandoc":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"livemd":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"markdown":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"mdown":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"mdwn":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"mkd":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"mkdn":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"mkdown":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"ronn":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"scd":{"extensions":[".sc",".scd"],"aliases":[],"type":"programming","color":"#46390b","interpreters":["sclang","scsynth"],"tm_scope":"source.supercollider","ace_mode":"text","language_id":361},"workbook":{"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"aliases":["md","pandoc"],"type":"prose","color":"#083fa1","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"markojs":{"extensions":[".marko"],"aliases":["markojs"],"type":"markup","color":"#42bff2","tm_scope":"text.marko","ace_mode":"text","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":932782397},"marko":{"extensions":[".marko"],"aliases":["markojs"],"type":"markup","color":"#42bff2","tm_scope":"text.marko","ace_mode":"text","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":932782397},"mask":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"max/msp":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"maxmsp":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"maxpat":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"maxhelp":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"maxproj":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"mxt":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"pat":{"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"aliases":["max/msp","maxmsp"],"type":"programming","color":"#c4a79c","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"metta":{"extensions":[".metta"],"aliases":[],"type":"programming","color":"#6a5acd","tm_scope":"source.metta","ace_mode":"text","language_id":1037612668},"moo":{"extensions":[".moo"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":237},"mermaid example":{"extensions":[".mmd",".mermaid"],"aliases":["mermaid example"],"type":"markup","color":"#ff3670","tm_scope":"source.mermaid","ace_mode":"text","language_id":385992043},"mmd":{"extensions":[".mmd",".mermaid"],"aliases":["mermaid example"],"type":"markup","color":"#ff3670","tm_scope":"source.mermaid","ace_mode":"text","language_id":385992043},"mermaid":{"extensions":[".mmd",".mermaid"],"aliases":["mermaid example"],"type":"markup","color":"#ff3670","tm_scope":"source.mermaid","ace_mode":"text","language_id":385992043},"metal":{"extensions":[".metal"],"aliases":[],"type":"programming","color":"#8f14e9","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":230},"sln":{"extensions":[".sln"],"aliases":[],"type":"data","tm_scope":"source.solution","ace_mode":"text","language_id":849523096},"minid":{"extensions":[".minid"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":231},"yaml":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"yml":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"mzn":{"extensions":[".mzn"],"aliases":[],"type":"programming","color":"#06a9e6","tm_scope":"source.mzn","ace_mode":"text","language_id":238874535},"dzn":{"extensions":[".dzn"],"aliases":[],"type":"data","tm_scope":"source.mzn","ace_mode":"text","language_id":938193433},"mint":{"extensions":[".mint"],"aliases":[],"type":"programming","ace_mode":"text","color":"#02b046","tm_scope":"source.mint","language_id":968740319},"druby":{"extensions":[".druby",".duby",".mirah"],"aliases":[],"type":"programming","color":"#c7a938","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","language_id":232},"duby":{"extensions":[".druby",".duby",".mirah"],"aliases":[],"type":"programming","color":"#c7a938","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","language_id":232},"mirah":{"extensions":[".druby",".duby",".mirah"],"aliases":[],"type":"programming","color":"#c7a938","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","language_id":232},"mo":{"extensions":[".mo"],"aliases":[],"type":"programming","color":"#fbb03b","tm_scope":"source.mo","ace_mode":"text","language_id":202937027},"i3":{"extensions":[".i3",".ig",".m3",".mg"],"aliases":[],"type":"programming","color":"#223388","ace_mode":"text","tm_scope":"source.modula-3","language_id":564743864},"ig":{"extensions":[".i3",".ig",".m3",".mg"],"aliases":[],"type":"programming","color":"#223388","ace_mode":"text","tm_scope":"source.modula-3","language_id":564743864},"m3":{"extensions":[".i3",".ig",".m3",".mg"],"aliases":[],"type":"programming","color":"#223388","ace_mode":"text","tm_scope":"source.modula-3","language_id":564743864},"mg":{"extensions":[".i3",".ig",".m3",".mg"],"aliases":[],"type":"programming","color":"#223388","ace_mode":"text","tm_scope":"source.modula-3","language_id":564743864},"mms":{"extensions":[".mms",".mmk"],"aliases":[],"type":"programming","filenames":["descrip.mmk","descrip.mms"],"tm_scope":"none","ace_mode":"text","language_id":235},"mmk":{"extensions":[".mms",".mmk"],"aliases":[],"type":"programming","filenames":["descrip.mmk","descrip.mms"],"tm_scope":"none","ace_mode":"text","language_id":235},"mojo":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"monkey":{"extensions":[".monkey",".monkey2"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.monkey","language_id":236},"monkey2":{"extensions":[".monkey",".monkey2"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.monkey","language_id":236},"mbt":{"extensions":[".mbt"],"aliases":[],"type":"programming","color":"#b92381","tm_scope":"source.moonbit","ace_mode":"text","language_id":181453007},"moon":{"extensions":[".moon"],"aliases":[],"type":"programming","color":"#ff4585","interpreters":["moon"],"tm_scope":"source.moonscript","ace_mode":"text","language_id":238},"m68k":{"extensions":[".asm",".i",".inc",".s",".x68"],"aliases":["m68k"],"type":"programming","color":"#005daa","group":"Assembly","tm_scope":"source.m68k","ace_mode":"assembly_x86","language_id":477582706},"x68":{"extensions":[".asm",".i",".inc",".s",".x68"],"aliases":["m68k"],"type":"programming","color":"#005daa","group":"Assembly","tm_scope":"source.m68k","ace_mode":"assembly_x86","language_id":477582706},"move":{"extensions":[".move"],"aliases":[],"type":"programming","color":"#4a137a","tm_scope":"source.move","ace_mode":"text","language_id":638334599},"amusewiki":{"extensions":[".muse"],"aliases":["amusewiki","emacs muse"],"type":"prose","tm_scope":"text.muse","ace_mode":"text","wrap":true,"language_id":474864066},"emacs muse":{"extensions":[".muse"],"aliases":["amusewiki","emacs muse"],"type":"prose","tm_scope":"text.muse","ace_mode":"text","wrap":true,"language_id":474864066},"muse":{"extensions":[".muse"],"aliases":["amusewiki","emacs muse"],"type":"prose","tm_scope":"text.muse","ace_mode":"text","wrap":true,"language_id":474864066},"mustache":{"extensions":[".mustache"],"aliases":[],"type":"markup","color":"#724b3b","tm_scope":"text.html.smarty","ace_mode":"smarty","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","language_id":638334590},"myt":{"extensions":[".myt"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":239},"nasl":{"extensions":[".nasl",".inc"],"aliases":[],"type":"programming","tm_scope":"source.nasl","ace_mode":"text","language_id":171666519},"nette object notation":{"extensions":[".neon"],"aliases":["nette object notation","ne-on"],"type":"data","tm_scope":"source.neon","ace_mode":"text","language_id":481192983},"ne-on":{"extensions":[".neon"],"aliases":["nette object notation","ne-on"],"type":"data","tm_scope":"source.neon","ace_mode":"text","language_id":481192983},"neon":{"extensions":[".neon"],"aliases":["nette object notation","ne-on"],"type":"data","tm_scope":"source.neon","ace_mode":"text","language_id":481192983},"nl":{"extensions":[".nl",".lisp",".lsp"],"aliases":[],"type":"programming","color":"#87AED7","interpreters":["newlisp"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":247},"npmrc":{"extensions":[],"aliases":["npmrc"],"type":"data","color":"#cb3837","group":"INI","filenames":[".npmrc"],"tm_scope":"source.ini.npmrc","ace_mode":"text","language_id":685022663},"nsi":{"extensions":[".nsi",".nsh"],"aliases":[],"type":"programming","tm_scope":"source.nsis","ace_mode":"nsis","codemirror_mode":"nsis","codemirror_mime_type":"text/x-nsis","language_id":242},"nsh":{"extensions":[".nsi",".nsh"],"aliases":[],"type":"programming","tm_scope":"source.nsis","ace_mode":"nsis","codemirror_mode":"nsis","codemirror_mime_type":"text/x-nsis","language_id":242},"nss":{"extensions":[".nss"],"aliases":[],"type":"programming","color":"#111522","tm_scope":"source.c.nwscript","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":731233819},"ne":{"extensions":[".ne",".nearley"],"aliases":[],"type":"programming","ace_mode":"text","color":"#990000","tm_scope":"source.ne","language_id":521429430},"nearley":{"extensions":[".ne",".nearley"],"aliases":[],"type":"programming","ace_mode":"text","color":"#990000","tm_scope":"source.ne","language_id":521429430},"n":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"axs":{"extensions":[".axs",".axi"],"aliases":[],"type":"programming","color":"#0aa0ff","tm_scope":"source.netlinx","ace_mode":"text","language_id":244},"axi":{"extensions":[".axs",".axi"],"aliases":[],"type":"programming","color":"#0aa0ff","tm_scope":"source.netlinx","ace_mode":"text","language_id":244},"axs.erb":{"extensions":[".axs.erb",".axi.erb"],"aliases":[],"type":"programming","color":"#747faa","tm_scope":"source.netlinx.erb","ace_mode":"text","language_id":245},"axi.erb":{"extensions":[".axs.erb",".axi.erb"],"aliases":[],"type":"programming","color":"#747faa","tm_scope":"source.netlinx.erb","ace_mode":"text","language_id":245},"nlogo":{"extensions":[".nlogo"],"aliases":[],"type":"programming","color":"#ff6375","tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":246},"nf":{"extensions":[".nf"],"aliases":[],"type":"programming","ace_mode":"groovy","tm_scope":"source.nextflow","color":"#3ac486","filenames":["nextflow.config"],"interpreters":["nextflow"],"language_id":506780613},"nginx configuration file":{"extensions":[".nginx",".nginxconf",".vhost"],"aliases":["nginx configuration file"],"type":"data","color":"#009639","filenames":["nginx.conf"],"tm_scope":"source.nginx","ace_mode":"nginx","codemirror_mode":"nginx","codemirror_mime_type":"text/x-nginx-conf","language_id":248},"nginx":{"extensions":[".nginx",".nginxconf",".vhost"],"aliases":["nginx configuration file"],"type":"data","color":"#009639","filenames":["nginx.conf"],"tm_scope":"source.nginx","ace_mode":"nginx","codemirror_mode":"nginx","codemirror_mime_type":"text/x-nginx-conf","language_id":248},"nginxconf":{"extensions":[".nginx",".nginxconf",".vhost"],"aliases":["nginx configuration file"],"type":"data","color":"#009639","filenames":["nginx.conf"],"tm_scope":"source.nginx","ace_mode":"nginx","codemirror_mode":"nginx","codemirror_mime_type":"text/x-nginx-conf","language_id":248},"nim":{"extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"aliases":[],"type":"programming","color":"#ffc200","filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"nim.cfg":{"extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"aliases":[],"type":"programming","color":"#ffc200","filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"nimble":{"extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"aliases":[],"type":"programming","color":"#ffc200","filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"nimrod":{"extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"aliases":[],"type":"programming","color":"#ffc200","filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"nims":{"extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"aliases":[],"type":"programming","color":"#ffc200","filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"ninja":{"extensions":[".ninja"],"aliases":[],"type":"data","tm_scope":"source.ninja","ace_mode":"text","language_id":250},"nit":{"extensions":[".nit"],"aliases":[],"type":"programming","color":"#009917","tm_scope":"source.nit","ace_mode":"text","language_id":251},"nixos":{"extensions":[".nix"],"aliases":["nixos"],"type":"programming","color":"#7e7eff","tm_scope":"source.nix","ace_mode":"nix","language_id":252},"nix":{"extensions":[".nix"],"aliases":["nixos"],"type":"programming","color":"#7e7eff","tm_scope":"source.nix","ace_mode":"nix","language_id":252},"nargo":{"extensions":[".nr"],"aliases":["nargo"],"type":"programming","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","color":"#2f1f49","tm_scope":"source.nr","language_id":813068465},"nr":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"nush":{"extensions":[".nu"],"aliases":["nush"],"type":"programming","color":"#c9df40","filenames":["Nukefile"],"tm_scope":"source.nu","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","interpreters":["nush"],"language_id":253},"nu":{"extensions":[".nu"],"aliases":["nu-script","nushell-script"],"type":"programming","color":"#4E9906","interpreters":["nu"],"tm_scope":"source.nushell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":446573572},"numpy":{"extensions":[".numpy",".numpyw",".numsc"],"aliases":[],"type":"programming","color":"#9C8AF9","group":"Python","tm_scope":"none","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":254},"numpyw":{"extensions":[".numpy",".numpyw",".numsc"],"aliases":[],"type":"programming","color":"#9C8AF9","group":"Python","tm_scope":"none","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":254},"numsc":{"extensions":[".numpy",".numpyw",".numsc"],"aliases":[],"type":"programming","color":"#9C8AF9","group":"Python","tm_scope":"none","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":254},"njk":{"extensions":[".njk"],"aliases":["njk"],"type":"markup","color":"#3d8137","tm_scope":"text.html.nunjucks","ace_mode":"nunjucks","language_id":461856962},"nu-script":{"extensions":[".nu"],"aliases":["nu-script","nushell-script"],"type":"programming","color":"#4E9906","interpreters":["nu"],"tm_scope":"source.nushell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":446573572},"nushell-script":{"extensions":[".nu"],"aliases":["nu-script","nushell-script"],"type":"programming","color":"#4E9906","interpreters":["nu"],"tm_scope":"source.nushell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":446573572},"ml":{"extensions":[".ml",".fun",".sig",".sml"],"aliases":["sml"],"type":"programming","color":"#dc566d","tm_scope":"source.ml","ace_mode":"text","codemirror_mode":"mllike","codemirror_mime_type":"text/x-sml","language_id":357},"eliom":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"eliomi":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"ml4":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"mli":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"mll":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"mly":{"extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"aliases":[],"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"omnetpp-msg":{"extensions":[".msg"],"aliases":["omnetpp-msg"],"type":"programming","color":"#a0e0a0","tm_scope":"source.msg","ace_mode":"text","language_id":664100008},"msg":{"extensions":[".msg",".action",".srv"],"aliases":["rosmsg"],"type":"data","color":"#22314e","ace_mode":"text","tm_scope":"source.rosmsg","language_id":809230569},"omnetpp-ned":{"extensions":[".ned"],"aliases":["omnetpp-ned"],"type":"programming","color":"#08607c","tm_scope":"source.ned","ace_mode":"text","language_id":924868392},"ned":{"extensions":[".ned"],"aliases":["omnetpp-ned"],"type":"programming","color":"#08607c","tm_scope":"source.ned","ace_mode":"text","language_id":924868392},"ob2":{"extensions":[".ob2"],"aliases":[],"type":"programming","tm_scope":"source.modula2","ace_mode":"text","language_id":677210597},"objdump":{"extensions":[".objdump"],"aliases":[],"type":"data","tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":256},"odin":{"extensions":[".odin"],"aliases":["odinlang","odin-lang"],"type":"programming","color":"#60AFFE","tm_scope":"source.odin","ace_mode":"odin","language_id":889244082},"obj-c":{"extensions":[".m",".h"],"aliases":["obj-c","objc","objectivec"],"type":"programming","tm_scope":"source.objc","color":"#438eff","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec","language_id":257},"objc":{"extensions":[".m",".h"],"aliases":["obj-c","objc","objectivec"],"type":"programming","tm_scope":"source.objc","color":"#438eff","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec","language_id":257},"objectivec":{"extensions":[".m",".h"],"aliases":["obj-c","objc","objectivec"],"type":"programming","tm_scope":"source.objc","color":"#438eff","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec","language_id":257},"obj-c++":{"extensions":[".mm"],"aliases":["obj-c++","objc++","objectivec++"],"type":"programming","tm_scope":"source.objc++","color":"#6866fb","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec++","language_id":258},"objc++":{"extensions":[".mm"],"aliases":["obj-c++","objc++","objectivec++"],"type":"programming","tm_scope":"source.objc++","color":"#6866fb","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec++","language_id":258},"objectivec++":{"extensions":[".mm"],"aliases":["obj-c++","objc++","objectivec++"],"type":"programming","tm_scope":"source.objc++","color":"#6866fb","ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec++","language_id":258},"mm":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"obj-j":{"extensions":[".j",".sj"],"aliases":["obj-j","objectivej","objj"],"type":"programming","color":"#ff0c5a","tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"objectivej":{"extensions":[".j",".sj"],"aliases":["obj-j","objectivej","objj"],"type":"programming","color":"#ff0c5a","tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"objj":{"extensions":[".j",".sj"],"aliases":["obj-j","objectivej","objj"],"type":"programming","color":"#ff0c5a","tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"sj":{"extensions":[".j",".sj"],"aliases":["obj-j","objectivej","objj"],"type":"programming","color":"#ff0c5a","tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"odinlang":{"extensions":[".odin"],"aliases":["odinlang","odin-lang"],"type":"programming","color":"#60AFFE","tm_scope":"source.odin","ace_mode":"odin","language_id":889244082},"odin-lang":{"extensions":[".odin"],"aliases":["odinlang","odin-lang"],"type":"programming","color":"#60AFFE","tm_scope":"source.odin","ace_mode":"odin","language_id":889244082},"omgrofl":{"extensions":[".omgrofl"],"aliases":[],"type":"programming","color":"#cabbff","tm_scope":"none","ace_mode":"text","language_id":260},"opa":{"extensions":[".opa"],"aliases":[],"type":"programming","tm_scope":"source.opa","ace_mode":"text","language_id":261},"opal":{"extensions":[".opal"],"aliases":[],"type":"programming","color":"#f7ede0","tm_scope":"source.opal","ace_mode":"text","language_id":262},"rego":{"extensions":[".rego"],"aliases":[],"type":"programming","color":"#7d9199","ace_mode":"text","language_id":840483232,"tm_scope":"source.rego"},"oasv2":{"extensions":[],"aliases":["oasv2"],"type":"data","color":"#85ea2d","tm_scope":"none","ace_mode":"text","language_id":848295328},"oasv3":{"extensions":[],"aliases":["oasv3"],"type":"data","color":"#85ea2d","tm_scope":"none","ace_mode":"text","language_id":557959099},"opencl":{"extensions":[".cl",".opencl"],"aliases":[],"type":"programming","color":"#ed2e2d","group":"C","tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":263},"progress":{"extensions":[".p",".cls",".w"],"aliases":["progress","openedge","abl"],"type":"programming","color":"#5ce600","tm_scope":"source.abl","ace_mode":"text","language_id":264},"openedge":{"extensions":[".p",".cls",".w"],"aliases":["progress","openedge","abl"],"type":"programming","color":"#5ce600","tm_scope":"source.abl","ace_mode":"text","language_id":264},"abl":{"extensions":[".p",".cls",".w"],"aliases":["progress","openedge","abl"],"type":"programming","color":"#5ce600","tm_scope":"source.abl","ace_mode":"text","language_id":264},"qasm":{"extensions":[".qasm"],"aliases":[],"type":"programming","color":"#AA70FF","tm_scope":"source.qasm","ace_mode":"text","language_id":153739399},"openrc":{"extensions":[],"aliases":["openrc"],"type":"programming","group":"Shell","interpreters":["openrc-run"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":265},"scad":{"extensions":[".scad"],"aliases":[],"type":"programming","color":"#e5cd45","tm_scope":"source.scad","ace_mode":"scad","language_id":266},"plist":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"glyphs":{"extensions":[".plist",".glyphs"],"aliases":[],"type":"data","tm_scope":"source.plist","ace_mode":"text","language_id":598917541},"AFDKO":{"extensions":[".fea"],"aliases":["AFDKO"],"type":"data","tm_scope":"source.opentype","ace_mode":"text","language_id":374317347},"fea":{"extensions":[".fea"],"aliases":["AFDKO"],"type":"data","tm_scope":"source.opentype","ace_mode":"text","language_id":374317347},"opts":{"extensions":[],"aliases":["opts","ackrc"],"type":"data","color":"#476732","filenames":[".ackrc",".rspec",".yardopts","ackrc","mocha.opts"],"tm_scope":"source.opts","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":723589315},"ackrc":{"extensions":[],"aliases":["opts","ackrc"],"type":"data","color":"#476732","filenames":[".ackrc",".rspec",".yardopts","ackrc","mocha.opts"],"tm_scope":"source.opts","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":723589315},"org":{"extensions":[".org"],"aliases":[],"type":"prose","color":"#77aa99","wrap":true,"tm_scope":"none","ace_mode":"text","language_id":267},"overpassql":{"extensions":[".overpassql"],"aliases":[],"type":"programming","color":"#cce2aa","wrap":true,"tm_scope":"source.overpassql","ace_mode":"text","language_id":689079655},"ox":{"extensions":[".ox",".oxh",".oxo"],"aliases":[],"type":"programming","tm_scope":"source.ox","ace_mode":"text","language_id":268},"oxh":{"extensions":[".ox",".oxh",".oxo"],"aliases":[],"type":"programming","tm_scope":"source.ox","ace_mode":"text","language_id":268},"oxo":{"extensions":[".ox",".oxh",".oxo"],"aliases":[],"type":"programming","tm_scope":"source.ox","ace_mode":"text","language_id":268},"oxygene":{"extensions":[".oxygene"],"aliases":[],"type":"programming","color":"#cdd0e3","tm_scope":"none","ace_mode":"text","language_id":269},"oz":{"extensions":[".oz"],"aliases":[],"type":"programming","color":"#fab738","tm_scope":"source.oz","ace_mode":"text","codemirror_mode":"oz","codemirror_mime_type":"text/x-oz","language_id":270},"p4":{"extensions":[".p4"],"aliases":[],"type":"programming","color":"#7055b5","tm_scope":"source.p4","ace_mode":"text","language_id":348895984},"pddl":{"extensions":[".pddl"],"aliases":[],"type":"programming","color":"#0d00ff","tm_scope":"source.pddl","ace_mode":"text","language_id":736235603},"pegjs":{"extensions":[".pegjs",".peggy"],"aliases":[],"type":"programming","color":"#234d6b","tm_scope":"source.peggy","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","language_id":81442128},"peggy":{"extensions":[".pegjs",".peggy"],"aliases":[],"type":"programming","color":"#234d6b","tm_scope":"source.peggy","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","language_id":81442128},"aw":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"ctp":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"php3":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"php4":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"php5":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"phps":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"phpt":{"extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"aliases":["inc"],"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"language_id":272},"pls":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"bdy":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"ddl":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"fnc":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"pck":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"pkb":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"pks":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"plb":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"plsql":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"prc":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"spc":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"sql":{"extensions":[".sql"],"aliases":[],"type":"programming","color":"#e38c00","ace_mode":"sql","tm_scope":"source.tsql","language_id":918334941},"tpb":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"tps":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"trg":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"vw":{"extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"aliases":[],"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","language_id":273},"pgsql":{"extensions":[".pgsql",".sql"],"aliases":[],"type":"programming","color":"#336790","ace_mode":"pgsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","tm_scope":"source.sql","language_id":274},"pov-ray":{"extensions":[".pov",".inc"],"aliases":["pov-ray","povray"],"type":"programming","color":"#6bac65","tm_scope":"source.pov-ray sdl","ace_mode":"text","language_id":275},"povray":{"extensions":[".pov",".inc"],"aliases":["pov-ray","povray"],"type":"programming","color":"#6bac65","tm_scope":"source.pov-ray sdl","ace_mode":"text","language_id":275},"pov":{"extensions":[".pov",".inc"],"aliases":["pov-ray","povray"],"type":"programming","color":"#6bac65","tm_scope":"source.pov-ray sdl","ace_mode":"text","language_id":275},"pact":{"extensions":[".pact"],"aliases":[],"type":"programming","color":"#F7A8B8","ace_mode":"text","tm_scope":"source.pact","language_id":756774415},"pan":{"extensions":[".pan"],"aliases":[],"type":"programming","color":"#cc0000","tm_scope":"source.pan","ace_mode":"text","language_id":276},"psc":{"extensions":[".psc"],"aliases":[],"type":"programming","color":"#6600cc","tm_scope":"source.papyrus.skyrim","ace_mode":"text","language_id":277},"parrot":{"extensions":[".parrot"],"aliases":[],"type":"programming","color":"#f3ca0a","tm_scope":"none","ace_mode":"text","language_id":278},"pasm":{"extensions":[".pasm"],"aliases":["pasm"],"group":"Parrot","type":"programming","interpreters":["parrot"],"tm_scope":"none","ace_mode":"text","language_id":279},"pir":{"extensions":[".pir"],"aliases":["pir"],"group":"Parrot","tm_scope":"source.parrot.pir","type":"programming","interpreters":["parrot"],"ace_mode":"text","language_id":280},"delphi":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"objectpascal":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"pas":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"dfm":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"dpr":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"lpr":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"pascal":{"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"aliases":["delphi","objectpascal"],"type":"programming","color":"#E3F171","interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"pp":{"extensions":[".pp"],"aliases":[],"type":"programming","color":"#302B6D","filenames":["Modulefile"],"ace_mode":"puppet","codemirror_mode":"puppet","codemirror_mime_type":"text/x-puppet","tm_scope":"source.puppet","language_id":299},"pwn":{"extensions":[".pwn",".inc",".sma"],"aliases":[],"type":"programming","color":"#dbb284","tm_scope":"source.pawn","ace_mode":"text","language_id":271},"sma":{"extensions":[".pwn",".inc",".sma"],"aliases":[],"type":"programming","color":"#dbb284","tm_scope":"source.pawn","ace_mode":"text","language_id":271},"pep":{"extensions":[".pep"],"aliases":[],"type":"programming","color":"#C76F5B","ace_mode":"text","tm_scope":"source.pep8","language_id":840372442},"cperl":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"pl":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"cgi":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"perl":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"ph":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"plx":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"pm":{"extensions":[".xpm",".pm"],"aliases":["xpm"],"type":"data","group":"C","ace_mode":"c_cpp","tm_scope":"source.c","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":781846279},"psgi":{"extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"aliases":["cperl"],"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"language_id":282},"t":{"extensions":[".t",".tu"],"aliases":[],"type":"programming","color":"#cf142b","tm_scope":"source.turing","ace_mode":"text","language_id":375},"pikchr":{"extensions":[".pic",".chem"],"aliases":["pikchr"],"type":"markup","group":"Roff","tm_scope":"source.pic","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":425},"pic":{"extensions":[".pic",".chem"],"aliases":["pikchr"],"type":"markup","group":"Roff","tm_scope":"source.pic","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":425},"chem":{"extensions":[".pic",".chem"],"aliases":["pikchr"],"type":"markup","group":"Roff","tm_scope":"source.pic","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":425},"pkl":{"extensions":[".pkl"],"aliases":[],"type":"programming","color":"#6b9543","interpreters":["pkl"],"tm_scope":"source.pkl","ace_mode":"text","language_id":288822799},"pig":{"extensions":[".pig"],"aliases":[],"type":"programming","color":"#fcd7de","tm_scope":"source.pig_latin","ace_mode":"pig","codemirror_mode":"pig","codemirror_mime_type":"text/x-pig","language_id":286},"pike":{"extensions":[".pike",".pmod"],"aliases":[],"type":"programming","color":"#005390","interpreters":["pike"],"tm_scope":"source.pike","ace_mode":"text","language_id":287},"pmod":{"extensions":[".pike",".pmod"],"aliases":[],"type":"programming","color":"#005390","interpreters":["pike"],"tm_scope":"source.pike","ace_mode":"text","language_id":287},"puml":{"extensions":[".puml",".iuml",".plantuml"],"aliases":[],"type":"data","color":"#fbbd16","tm_scope":"source.wsd","ace_mode":"text","language_id":833504686},"iuml":{"extensions":[".puml",".iuml",".plantuml"],"aliases":[],"type":"data","color":"#fbbd16","tm_scope":"source.wsd","ace_mode":"text","language_id":833504686},"plantuml":{"extensions":[".puml",".iuml",".plantuml"],"aliases":[],"type":"data","color":"#fbbd16","tm_scope":"source.wsd","ace_mode":"text","language_id":833504686},"pod":{"extensions":[".pod",".pod6"],"aliases":[],"type":"prose","ace_mode":"perl","tm_scope":"source.raku","wrap":true,"interpreters":["perl6"],"language_id":155357471},"pod6":{"extensions":[".pod",".pod6"],"aliases":[],"type":"prose","ace_mode":"perl","tm_scope":"source.raku","wrap":true,"interpreters":["perl6"],"language_id":155357471},"pogo":{"extensions":[".pogo"],"aliases":[],"type":"programming","color":"#d80074","tm_scope":"source.pogoscript","ace_mode":"text","language_id":289},"polar":{"extensions":[".polar"],"aliases":[],"type":"programming","color":"#ae81ff","tm_scope":"source.polar","ace_mode":"text","language_id":839112914},"pony":{"extensions":[".pony"],"aliases":[],"type":"programming","tm_scope":"source.pony","ace_mode":"text","language_id":290},"por":{"extensions":[".por"],"aliases":[],"type":"programming","color":"#f8bd00","tm_scope":"source.portugol","ace_mode":"text","language_id":832391833},"pcss":{"extensions":[".pcss",".postcss"],"aliases":[],"type":"markup","color":"#dc3a0c","tm_scope":"source.postcss","group":"CSS","ace_mode":"text","language_id":262764437},"postcss":{"extensions":[".pcss",".postcss"],"aliases":[],"type":"markup","color":"#dc3a0c","tm_scope":"source.postcss","group":"CSS","ace_mode":"text","language_id":262764437},"postscr":{"extensions":[".ps",".eps",".epsi",".pfa"],"aliases":["postscr"],"type":"markup","color":"#da291c","tm_scope":"source.postscript","ace_mode":"text","language_id":291},"ps":{"extensions":[".ps",".eps",".epsi",".pfa"],"aliases":["postscr"],"type":"markup","color":"#da291c","tm_scope":"source.postscript","ace_mode":"text","language_id":291},"eps":{"extensions":[".ps",".eps",".epsi",".pfa"],"aliases":["postscr"],"type":"markup","color":"#da291c","tm_scope":"source.postscript","ace_mode":"text","language_id":291},"epsi":{"extensions":[".ps",".eps",".epsi",".pfa"],"aliases":["postscr"],"type":"markup","color":"#da291c","tm_scope":"source.postscript","ace_mode":"text","language_id":291},"pfa":{"extensions":[".ps",".eps",".epsi",".pfa"],"aliases":["postscr"],"type":"markup","color":"#da291c","tm_scope":"source.postscript","ace_mode":"text","language_id":291},"pbt":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"sra":{"extensions":[".pbt",".sra",".sru",".srw"],"aliases":[],"type":"programming","color":"#8f0f8d","tm_scope":"source.powerbuilder","ace_mode":"text","language_id":292},"sru":{"extensions":[".pbt",".sra",".sru",".srw"],"aliases":[],"type":"programming","color":"#8f0f8d","tm_scope":"source.powerbuilder","ace_mode":"text","language_id":292},"srw":{"extensions":[".pbt",".sra",".sru",".srw"],"aliases":[],"type":"programming","color":"#8f0f8d","tm_scope":"source.powerbuilder","ace_mode":"text","language_id":292},"posh":{"extensions":[".ps1",".psd1",".psm1"],"aliases":["posh","pwsh"],"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","interpreters":["pwsh"],"language_id":293},"pwsh":{"extensions":[".ps1",".psd1",".psm1"],"aliases":["posh","pwsh"],"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","interpreters":["pwsh"],"language_id":293},"ps1":{"extensions":[".ps1",".psd1",".psm1"],"aliases":["posh","pwsh"],"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","interpreters":["pwsh"],"language_id":293},"psd1":{"extensions":[".ps1",".psd1",".psm1"],"aliases":["posh","pwsh"],"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","interpreters":["pwsh"],"language_id":293},"psm1":{"extensions":[".ps1",".psd1",".psm1"],"aliases":["posh","pwsh"],"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","interpreters":["pwsh"],"language_id":293},"praat":{"extensions":[".praat"],"aliases":[],"type":"programming","color":"#c8506d","tm_scope":"source.praat","ace_mode":"praat","language_id":106029007},"prisma":{"extensions":[".prisma"],"aliases":[],"type":"data","color":"#0c344b","tm_scope":"source.prisma","ace_mode":"prisma","language_id":499933428},"pde":{"extensions":[".pde"],"aliases":[],"type":"programming","color":"#0096D8","tm_scope":"source.processing","ace_mode":"text","language_id":294},"prolog":{"extensions":[".pl",".plt",".pro",".prolog",".yap"],"aliases":[],"type":"programming","color":"#74283c","interpreters":["swipl","yap"],"tm_scope":"source.prolog","ace_mode":"prolog","language_id":295},"yap":{"extensions":[".pl",".plt",".pro",".prolog",".yap"],"aliases":[],"type":"programming","color":"#74283c","interpreters":["swipl","yap"],"tm_scope":"source.prolog","ace_mode":"prolog","language_id":295},"pml":{"extensions":[".pml"],"aliases":[],"type":"programming","color":"#de0000","tm_scope":"source.promela","ace_mode":"text","language_id":441858312},"spin":{"extensions":[".spin"],"aliases":[],"type":"programming","color":"#7fa2a7","tm_scope":"source.spin","ace_mode":"text","language_id":296},"proto":{"extensions":[".proto"],"aliases":["proto","protobuf","Protocol Buffers"],"type":"data","tm_scope":"source.proto","ace_mode":"protobuf","codemirror_mode":"protobuf","codemirror_mime_type":"text/x-protobuf","language_id":297},"protobuf":{"extensions":[".proto"],"aliases":["proto","protobuf","Protocol Buffers"],"type":"data","tm_scope":"source.proto","ace_mode":"protobuf","codemirror_mode":"protobuf","codemirror_mime_type":"text/x-protobuf","language_id":297},"Protocol Buffers":{"extensions":[".proto"],"aliases":["proto","protobuf","Protocol Buffers"],"type":"data","tm_scope":"source.proto","ace_mode":"protobuf","codemirror_mode":"protobuf","codemirror_mime_type":"text/x-protobuf","language_id":297},"text proto":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"protobuf text format":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"textproto":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"pbtxt":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"txtpb":{"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"aliases":["text proto","protobuf text format"],"type":"data","tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"pub":{"extensions":[".asc",".pub"],"aliases":[],"type":"data","tm_scope":"none","ace_mode":"text","codemirror_mode":"asciiarmor","codemirror_mime_type":"application/pgp","language_id":298},"jade":{"extensions":[".jade",".pug"],"aliases":[],"type":"markup","color":"#a86454","tm_scope":"text.jade","ace_mode":"jade","codemirror_mode":"pug","codemirror_mime_type":"text/x-pug","language_id":179},"pug":{"extensions":[".jade",".pug"],"aliases":[],"type":"markup","color":"#a86454","tm_scope":"text.jade","ace_mode":"jade","codemirror_mode":"pug","codemirror_mime_type":"text/x-pug","language_id":179},"pd":{"extensions":[".pd"],"aliases":[],"type":"data","tm_scope":"none","ace_mode":"text","language_id":300},"pb":{"extensions":[".pb",".pbi"],"aliases":[],"type":"programming","color":"#5a6986","tm_scope":"none","ace_mode":"text","language_id":301},"pbi":{"extensions":[".pb",".pbi"],"aliases":[],"type":"programming","color":"#5a6986","tm_scope":"none","ace_mode":"text","language_id":301},"purs":{"extensions":[".purs"],"aliases":[],"type":"programming","color":"#1D222D","tm_scope":"source.purescript","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":302},"arr":{"extensions":[".arr"],"aliases":[],"type":"programming","color":"#ee1e10","ace_mode":"python","tm_scope":"source.arr","language_id":252961827},"py":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"py3":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"python3":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"rusthon":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"gyp":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"gypi":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"lmi":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pyde":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pyi":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pyp":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pyt":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pyw":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"rpy":{"extensions":[".rpy"],"aliases":["renpy"],"type":"programming","color":"#ff7f7f","tm_scope":"source.renpy","ace_mode":"python","language_id":322},"spec":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"tac":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"wsgi":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"xpy":{"extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"aliases":["py","py3","python3","rusthon"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"language_id":303},"pycon":{"extensions":[],"aliases":["pycon"],"type":"programming","color":"#3572A5","group":"Python","tm_scope":"text.python.console","ace_mode":"text","language_id":428},"pytb":{"extensions":[".pytb"],"aliases":[],"type":"data","color":"#3572A5","group":"Python","tm_scope":"text.python.traceback","ace_mode":"text","language_id":304},"qsharp":{"extensions":[".qs"],"aliases":["qsharp"],"type":"programming","color":"#fed659","ace_mode":"text","tm_scope":"source.qsharp","language_id":697448245},"qs":{"extensions":[".qs"],"aliases":[],"type":"programming","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","filenames":["installscript.qs","toolchain_installscript.qs"],"color":"#00b841","tm_scope":"source.js","language_id":558193693},"qml":{"extensions":[".qml",".qbs"],"aliases":[],"type":"programming","color":"#44a51c","tm_scope":"source.qml","ace_mode":"qml","language_id":305},"qbs":{"extensions":[".qml",".qbs"],"aliases":[],"type":"programming","color":"#44a51c","tm_scope":"source.qml","ace_mode":"qml","language_id":305},"pri":{"extensions":[".pro",".pri"],"aliases":[],"type":"programming","interpreters":["qmake"],"tm_scope":"source.qmake","ace_mode":"text","language_id":306},"qc":{"extensions":[".qc"],"aliases":[],"type":"programming","color":"#975777","ace_mode":"text","tm_scope":"source.quakec","language_id":472308069},"qb":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"qbasic":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"qb64":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"classic qbasic":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"classic quickbasic":{"extensions":[".bas",".bi"],"aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"type":"programming","color":"#008080","tm_scope":"source.QB64","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"Rscript":{"extensions":[".r",".rd",".rsx"],"aliases":["Rscript","splus"],"type":"programming","color":"#198CE7","filenames":[".Rprofile","expr-dist"],"interpreters":["Rscript"],"tm_scope":"source.r","ace_mode":"r","codemirror_mode":"r","codemirror_mime_type":"text/x-rsrc","language_id":307},"splus":{"extensions":[".r",".rd",".rsx"],"aliases":["Rscript","splus"],"type":"programming","color":"#198CE7","filenames":[".Rprofile","expr-dist"],"interpreters":["Rscript"],"tm_scope":"source.r","ace_mode":"r","codemirror_mode":"r","codemirror_mime_type":"text/x-rsrc","language_id":307},"r":{"extensions":[".r"],"aliases":[],"type":"programming","tm_scope":"source.rez","ace_mode":"text","color":"#FFDAB3","language_id":498022874},"rd":{"extensions":[".r",".rd",".rsx"],"aliases":["Rscript","splus"],"type":"programming","color":"#198CE7","filenames":[".Rprofile","expr-dist"],"interpreters":["Rscript"],"tm_scope":"source.r","ace_mode":"r","codemirror_mode":"r","codemirror_mime_type":"text/x-rsrc","language_id":307},"rsx":{"extensions":[".r",".rd",".rsx"],"aliases":["Rscript","splus"],"type":"programming","color":"#198CE7","filenames":[".Rprofile","expr-dist"],"interpreters":["Rscript"],"tm_scope":"source.r","ace_mode":"r","codemirror_mode":"r","codemirror_mime_type":"text/x-rsrc","language_id":307},"raml":{"extensions":[".raml"],"aliases":[],"type":"markup","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","color":"#77d9fb","language_id":308},"rascript":{"extensions":[".rascript"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.rascript","color":"#2C97FA","language_id":601118790},"rbs":{"extensions":[".rbs"],"aliases":[],"type":"data","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","tm_scope":"source.rbs","group":"Ruby","language_id":899227493},"rdoc":{"extensions":[".rdoc"],"aliases":[],"type":"prose","color":"#701516","ace_mode":"rdoc","wrap":true,"tm_scope":"text.rdoc","language_id":309},"rbbas":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"rbfrm":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"rbmnu":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"rbres":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"rbtbar":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"rbuistate":{"extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"aliases":[],"type":"programming","tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"arexx":{"extensions":[".rexx",".pprx",".rex"],"aliases":["arexx"],"type":"programming","color":"#d90e09","interpreters":["regina","rexx"],"tm_scope":"source.rexx","ace_mode":"text","language_id":311},"rexx":{"extensions":[".rexx",".pprx",".rex"],"aliases":["arexx"],"type":"programming","color":"#d90e09","interpreters":["regina","rexx"],"tm_scope":"source.rexx","ace_mode":"text","language_id":311},"pprx":{"extensions":[".rexx",".pprx",".rex"],"aliases":["arexx"],"type":"programming","color":"#d90e09","interpreters":["regina","rexx"],"tm_scope":"source.rexx","ace_mode":"text","language_id":311},"rex":{"extensions":[".rexx",".pprx",".rex"],"aliases":["arexx"],"type":"programming","color":"#d90e09","interpreters":["regina","rexx"],"tm_scope":"source.rexx","ace_mode":"text","language_id":311},"qmd":{"extensions":[".qmd",".rmd"],"aliases":[],"type":"prose","color":"#198ce7","wrap":true,"ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","tm_scope":"text.md","language_id":313},"rmd":{"extensions":[".qmd",".rmd"],"aliases":[],"type":"prose","color":"#198ce7","wrap":true,"ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","tm_scope":"text.md","language_id":313},"ron":{"extensions":[".ron"],"aliases":[],"type":"data","color":"#a62c00","ace_mode":"rust","tm_scope":"source.ron","language_id":587855233},"rosmsg":{"extensions":[".msg",".action",".srv"],"aliases":["rosmsg"],"type":"data","color":"#22314e","ace_mode":"text","tm_scope":"source.rosmsg","language_id":809230569},"action":{"extensions":[".msg",".action",".srv"],"aliases":["rosmsg"],"type":"data","color":"#22314e","ace_mode":"text","tm_scope":"source.rosmsg","language_id":809230569},"srv":{"extensions":[".msg",".action",".srv"],"aliases":["rosmsg"],"type":"data","color":"#22314e","ace_mode":"text","tm_scope":"source.rosmsg","language_id":809230569},"rpcgen":{"extensions":[".x"],"aliases":["rpcgen","oncrpc","xdr"],"type":"programming","ace_mode":"c_cpp","tm_scope":"source.c","language_id":1031374237},"oncrpc":{"extensions":[".x"],"aliases":["rpcgen","oncrpc","xdr"],"type":"programming","ace_mode":"c_cpp","tm_scope":"source.c","language_id":1031374237},"xdr":{"extensions":[".x"],"aliases":["rpcgen","oncrpc","xdr"],"type":"programming","ace_mode":"c_cpp","tm_scope":"source.c","language_id":1031374237},"ile rpg":{"extensions":[".rpgle",".sqlrpgle"],"aliases":["ile rpg","sqlrpgle"],"type":"programming","ace_mode":"text","color":"#2BDE21","tm_scope":"source.rpgle","language_id":609977990},"sqlrpgle":{"extensions":[".rpgle",".sqlrpgle"],"aliases":["ile rpg","sqlrpgle"],"type":"programming","ace_mode":"text","color":"#2BDE21","tm_scope":"source.rpgle","language_id":609977990},"rpgle":{"extensions":[".rpgle",".sqlrpgle"],"aliases":["ile rpg","sqlrpgle"],"type":"programming","ace_mode":"text","color":"#2BDE21","tm_scope":"source.rpgle","language_id":609977990},"specfile":{"extensions":[".spec"],"aliases":["specfile"],"type":"data","tm_scope":"source.rpm-spec","ace_mode":"text","codemirror_mode":"rpm","codemirror_mime_type":"text/x-rpm-spec","language_id":314},"rnh":{"extensions":[".rnh",".rno"],"aliases":[],"type":"markup","color":"#665a4e","wrap":true,"tm_scope":"text.runoff","ace_mode":"text","language_id":315},"rno":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"rkt":{"extensions":[".rkt",".rktd",".rktl",".scrbl"],"aliases":[],"type":"programming","color":"#3c5caa","interpreters":["racket"],"tm_scope":"source.racket","ace_mode":"lisp","language_id":316},"rktd":{"extensions":[".rkt",".rktd",".rktl",".scrbl"],"aliases":[],"type":"programming","color":"#3c5caa","interpreters":["racket"],"tm_scope":"source.racket","ace_mode":"lisp","language_id":316},"rktl":{"extensions":[".rkt",".rktd",".rktl",".scrbl"],"aliases":[],"type":"programming","color":"#3c5caa","interpreters":["racket"],"tm_scope":"source.racket","ace_mode":"lisp","language_id":316},"scrbl":{"extensions":[".rkt",".rktd",".rktl",".scrbl"],"aliases":[],"type":"programming","color":"#3c5caa","interpreters":["racket"],"tm_scope":"source.racket","ace_mode":"lisp","language_id":316},"ragel-rb":{"extensions":[".rl"],"aliases":["ragel-rb","ragel-ruby"],"type":"programming","color":"#9d5200","tm_scope":"none","ace_mode":"text","language_id":317},"ragel-ruby":{"extensions":[".rl"],"aliases":["ragel-rb","ragel-ruby"],"type":"programming","color":"#9d5200","tm_scope":"none","ace_mode":"text","language_id":317},"rl":{"extensions":[".rl"],"aliases":["ragel-rb","ragel-ruby"],"type":"programming","color":"#9d5200","tm_scope":"none","ace_mode":"text","language_id":317},"perl6":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"perl-6":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"6pl":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"6pm":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"nqp":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"p6":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"p6l":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"p6m":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"pl6":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"pm6":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"raku":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"rakumod":{"extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"aliases":["perl6","perl-6"],"type":"programming","color":"#0000fb","interpreters":["perl6","raku","rakudo"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"rsc":{"extensions":[".rsc"],"aliases":[],"type":"programming","ace_mode":"text","interpreters":["RouterOS"],"color":"#DE3941","tm_scope":"none","language_id":592853203},"raw":{"extensions":[".raw"],"aliases":["raw"],"type":"data","tm_scope":"none","ace_mode":"text","language_id":318},"res":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"resi":{"extensions":[".res",".resi"],"aliases":[],"type":"programming","color":"#ed5051","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","interpreters":["ocaml"],"tm_scope":"source.rescript","language_id":501875647},"inputrc":{"extensions":[],"aliases":["inputrc","readline"],"type":"data","group":"INI","filenames":[".inputrc","inputrc"],"tm_scope":"source.inputrc","ace_mode":"text","language_id":538732839},"readline":{"extensions":[],"aliases":["inputrc","readline"],"type":"data","group":"INI","filenames":[".inputrc","inputrc"],"tm_scope":"source.inputrc","ace_mode":"text","language_id":538732839},"rei":{"extensions":[".re",".rei"],"aliases":[],"type":"programming","color":"#ff5847","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","tm_scope":"source.reason","language_id":869538413},"religo":{"extensions":[".religo"],"aliases":[],"type":"programming","color":"#ff5847","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","group":"LigoLANG","tm_scope":"source.religo","language_id":319002153},"reb":{"extensions":[".reb",".r",".r2",".r3",".rebol"],"aliases":[],"type":"programming","color":"#358a5b","ace_mode":"text","tm_scope":"source.rebol","language_id":319},"r2":{"extensions":[".reb",".r",".r2",".r3",".rebol"],"aliases":[],"type":"programming","color":"#358a5b","ace_mode":"text","tm_scope":"source.rebol","language_id":319},"r3":{"extensions":[".reb",".r",".r2",".r3",".rebol"],"aliases":[],"type":"programming","color":"#358a5b","ace_mode":"text","tm_scope":"source.rebol","language_id":319},"rebol":{"extensions":[".reb",".r",".r2",".r3",".rebol"],"aliases":[],"type":"programming","color":"#358a5b","ace_mode":"text","tm_scope":"source.rebol","language_id":319},"red/system":{"extensions":[".red",".reds"],"aliases":["red/system"],"type":"programming","color":"#f50000","tm_scope":"source.red","ace_mode":"red","language_id":320},"red":{"extensions":[".red",".reds"],"aliases":["red/system"],"type":"programming","color":"#f50000","tm_scope":"source.red","ace_mode":"red","language_id":320},"reds":{"extensions":[".red",".reds"],"aliases":["red/system"],"type":"programming","color":"#f50000","tm_scope":"source.red","ace_mode":"red","language_id":320},"cw":{"extensions":[".cw"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":321},"redirects":{"extensions":[],"aliases":["redirects"],"type":"data","filenames":["_redirects"],"tm_scope":"source.redirects","ace_mode":"text","language_id":1020148948},"regexp":{"extensions":[".regexp",".regex"],"aliases":["regexp","regex"],"type":"data","color":"#009a00","ace_mode":"text","tm_scope":"source.regexp","language_id":363378884},"regex":{"extensions":[".regexp",".regex"],"aliases":["regexp","regex"],"type":"data","color":"#009a00","ace_mode":"text","tm_scope":"source.regexp","language_id":363378884},"renpy":{"extensions":[".rpy"],"aliases":["renpy"],"type":"programming","color":"#ff7f7f","tm_scope":"source.renpy","ace_mode":"python","language_id":322},"rs":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"rsh":{"extensions":[".rs",".rsh"],"aliases":[],"type":"programming","tm_scope":"none","ace_mode":"text","language_id":323},"rtf":{"extensions":[".rtf"],"aliases":[],"type":"markup","tm_scope":"text.rtf","ace_mode":"text","language_id":51601661},"ring":{"extensions":[".ring"],"aliases":[],"type":"programming","color":"#2D54CB","tm_scope":"source.ring","ace_mode":"text","language_id":431},"riot":{"extensions":[".riot"],"aliases":[],"type":"markup","color":"#A71E49","ace_mode":"html","tm_scope":"text.html.riot","language_id":878396783},"robot":{"extensions":[".robot",".resource"],"aliases":[],"type":"programming","color":"#00c0b5","tm_scope":"text.robot","ace_mode":"robot","language_id":324},"resource":{"extensions":[".robot",".resource"],"aliases":[],"type":"programming","color":"#00c0b5","tm_scope":"text.robot","ace_mode":"robot","language_id":324},"roc":{"extensions":[".roc"],"aliases":[],"type":"programming","color":"#7c38f5","tm_scope":"source.roc","ace_mode":"text","language_id":440182480},"coq":{"extensions":[".v",".coq"],"aliases":["coq","rocq"],"type":"programming","color":"#d0b68c","tm_scope":"source.coq","ace_mode":"text","language_id":69},"rocq":{"extensions":[".v",".coq"],"aliases":["coq","rocq"],"type":"programming","color":"#d0b68c","tm_scope":"source.coq","ace_mode":"text","language_id":69},"v":{"extensions":[".v",".veo"],"aliases":[],"type":"programming","color":"#b2b7f8","tm_scope":"source.verilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-verilog","language_id":387},"groff":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"man":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"manpage":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"man page":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"man-page":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"mdoc":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"nroff":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"troff":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"roff":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"1in":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"1m":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"1x":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3in":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3m":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3p":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3pm":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3qt":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"3x":{"extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"aliases":[],"type":"markup","color":"#ecdebe","group":"Roff","wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"me":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"tmac":{"extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"type":"markup","color":"#ecdebe","filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"rg":{"extensions":[".rg"],"aliases":[],"type":"programming","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#cc0088","tm_scope":"source.clojure","language_id":325},"jruby":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"macruby":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rake":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rb":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rbx":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"builder":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"eye":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"gemspec":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"god":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"jbuilder":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"mspec":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"pluginspec":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"podspec":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"prawn":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rabl":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rbi":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rbuild":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rbw":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"ru":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"ruby":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"thor":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"watchr":{"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"aliases":["jruby","macruby","rake","rb","rbx"],"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"rs.in":{"extensions":[".rs",".rs.in"],"aliases":["rs"],"type":"programming","color":"#dea584","tm_scope":"source.rust","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","interpreters":["rust-script"],"language_id":327},"sas":{"extensions":[".sas"],"aliases":[],"type":"programming","color":"#B34936","tm_scope":"source.sas","ace_mode":"text","codemirror_mode":"sas","codemirror_mime_type":"text/x-sas","language_id":328},"scss":{"extensions":[".scss"],"aliases":[],"type":"markup","color":"#c6538c","tm_scope":"source.css.scss","ace_mode":"scss","codemirror_mode":"css","codemirror_mime_type":"text/x-scss","language_id":329},"SELinux Kernel Policy Language":{"extensions":[".te"],"aliases":["SELinux Kernel Policy Language","sepolicy"],"type":"data","tm_scope":"source.sepolicy","filenames":["file_contexts","genfs_contexts","initial_sids","port_contexts","security_classes"],"ace_mode":"text","language_id":880010326},"sepolicy":{"extensions":[".te"],"aliases":["SELinux Kernel Policy Language","sepolicy"],"type":"data","tm_scope":"source.sepolicy","filenames":["file_contexts","genfs_contexts","initial_sids","port_contexts","security_classes"],"ace_mode":"text","language_id":880010326},"te":{"extensions":[".te"],"aliases":["SELinux Kernel Policy Language","sepolicy"],"type":"data","tm_scope":"source.sepolicy","filenames":["file_contexts","genfs_contexts","initial_sids","port_contexts","security_classes"],"ace_mode":"text","language_id":880010326},"smt2":{"extensions":[".smt2",".smt",".z3"],"aliases":[],"type":"programming","interpreters":["boolector","cvc4","mathsat5","opensmt","smtinterpol","smt-rat","stp","verit","yices2","z3"],"tm_scope":"source.smt","ace_mode":"text","language_id":330},"smt":{"extensions":[".smt2",".smt",".z3"],"aliases":[],"type":"programming","interpreters":["boolector","cvc4","mathsat5","opensmt","smtinterpol","smt-rat","stp","verit","yices2","z3"],"tm_scope":"source.smt","ace_mode":"text","language_id":330},"z3":{"extensions":[".smt2",".smt",".z3"],"aliases":[],"type":"programming","interpreters":["boolector","cvc4","mathsat5","opensmt","smtinterpol","smt-rat","stp","verit","yices2","z3"],"tm_scope":"source.smt","ace_mode":"text","language_id":330},"sparql":{"extensions":[".sparql",".rq"],"aliases":[],"type":"data","color":"#0C4597","tm_scope":"source.sparql","ace_mode":"sparql","codemirror_mode":"sparql","codemirror_mime_type":"application/sparql-query","language_id":331},"rq":{"extensions":[".sparql",".rq"],"aliases":[],"type":"data","color":"#0C4597","tm_scope":"source.sparql","ace_mode":"sparql","codemirror_mode":"sparql","codemirror_mime_type":"application/sparql-query","language_id":331},"sqf":{"extensions":[".sqf",".hqf"],"aliases":[],"type":"programming","color":"#3F3F3F","tm_scope":"source.sqf","ace_mode":"text","language_id":332},"hqf":{"extensions":[".sqf",".hqf"],"aliases":[],"type":"programming","color":"#3F3F3F","tm_scope":"source.sqf","ace_mode":"text","language_id":332},"mysql":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"tab":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"udf":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"viw":{"extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"aliases":[],"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","language_id":333},"db2":{"extensions":[".sql",".db2"],"aliases":[],"type":"programming","color":"#e38c00","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","tm_scope":"source.sql","language_id":334},"srt":{"extensions":[".srt"],"aliases":[],"type":"data","color":"#9e0101","ace_mode":"text","tm_scope":"text.srt","language_id":360},"sshconfig":{"extensions":[],"aliases":["sshconfig","sshdconfig","ssh_config","sshd_config"],"type":"data","group":"INI","filenames":["ssh-config","ssh_config","sshconfig","sshconfig.snip","sshd-config","sshd_config"],"ace_mode":"text","tm_scope":"source.ssh-config","language_id":554920715},"sshdconfig":{"extensions":[],"aliases":["sshconfig","sshdconfig","ssh_config","sshd_config"],"type":"data","group":"INI","filenames":["ssh-config","ssh_config","sshconfig","sshconfig.snip","sshd-config","sshd_config"],"ace_mode":"text","tm_scope":"source.ssh-config","language_id":554920715},"ssh_config":{"extensions":[],"aliases":["sshconfig","sshdconfig","ssh_config","sshd_config"],"type":"data","group":"INI","filenames":["ssh-config","ssh_config","sshconfig","sshconfig.snip","sshd-config","sshd_config"],"ace_mode":"text","tm_scope":"source.ssh-config","language_id":554920715},"sshd_config":{"extensions":[],"aliases":["sshconfig","sshdconfig","ssh_config","sshd_config"],"type":"data","group":"INI","filenames":["ssh-config","ssh_config","sshconfig","sshconfig.snip","sshd-config","sshd_config"],"ace_mode":"text","tm_scope":"source.ssh-config","language_id":554920715},"star":{"extensions":[".bzl",".star"],"aliases":["bazel","bzl"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#76d275","filenames":["BUCK","BUILD","BUILD.bazel","MODULE.bazel","Tiltfile","WORKSPACE","WORKSPACE.bazel","WORKSPACE.bzlmod"],"language_id":960266174},"ascii stl":{"extensions":[".stl"],"aliases":["ascii stl","stla"],"type":"data","color":"#373b5e","tm_scope":"source.stl","ace_mode":"text","language_id":455361735},"stla":{"extensions":[".stl"],"aliases":["ascii stl","stla"],"type":"data","color":"#373b5e","tm_scope":"source.stl","ace_mode":"text","language_id":455361735},"stl":{"extensions":[".stl"],"aliases":["ascii stl","stla"],"type":"data","color":"#373b5e","tm_scope":"source.stl","ace_mode":"text","language_id":455361735},"ston":{"extensions":[".ston"],"aliases":[],"type":"data","group":"Smalltalk","tm_scope":"source.smalltalk","ace_mode":"text","language_id":336},"svg":{"extensions":[".svg"],"aliases":[],"type":"data","color":"#ff9900","tm_scope":"text.xml.svg","ace_mode":"svg","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":337},"swg":{"extensions":[".i",".swg",".swig"],"aliases":[],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":1066250075},"swig":{"extensions":[".i",".swg",".swig"],"aliases":[],"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":1066250075},"sage":{"extensions":[".sage",".sagews"],"aliases":[],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":338},"sagews":{"extensions":[".sage",".sagews"],"aliases":[],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":338},"sail":{"extensions":[".sail"],"aliases":[],"type":"programming","color":"#259dd5","ace_mode":"text","tm_scope":"source.sail","language_id":1029438153},"saltstate":{"extensions":[".sls"],"aliases":["saltstate","salt"],"type":"programming","color":"#646464","tm_scope":"source.yaml.salt","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":339},"salt":{"extensions":[".sls"],"aliases":["saltstate","salt"],"type":"programming","color":"#646464","tm_scope":"source.yaml.salt","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":339},"sls":{"extensions":[".scm",".sch",".sld",".sls",".sps",".ss"],"aliases":[],"type":"programming","color":"#1e4aec","interpreters":["scheme","guile","bigloo","chicken","csi","gosh","r6rs"],"tm_scope":"source.scheme","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","language_id":343},"sass":{"extensions":[".sass"],"aliases":[],"type":"markup","color":"#a53b70","tm_scope":"source.sass","ace_mode":"sass","codemirror_mode":"sass","codemirror_mime_type":"text/x-sass","language_id":340},"scala":{"extensions":[".scala",".kojo",".sbt",".sc"],"aliases":[],"type":"programming","tm_scope":"source.scala","ace_mode":"scala","codemirror_mode":"clike","codemirror_mime_type":"text/x-scala","color":"#c22d40","interpreters":["scala"],"language_id":341},"kojo":{"extensions":[".scala",".kojo",".sbt",".sc"],"aliases":[],"type":"programming","tm_scope":"source.scala","ace_mode":"scala","codemirror_mode":"clike","codemirror_mime_type":"text/x-scala","color":"#c22d40","interpreters":["scala"],"language_id":341},"sbt":{"extensions":[".scala",".kojo",".sbt",".sc"],"aliases":[],"type":"programming","tm_scope":"source.scala","ace_mode":"scala","codemirror_mode":"clike","codemirror_mime_type":"text/x-scala","color":"#c22d40","interpreters":["scala"],"language_id":341},"sc":{"extensions":[".sc",".scd"],"aliases":[],"type":"programming","color":"#46390b","interpreters":["sclang","scsynth"],"tm_scope":"source.supercollider","ace_mode":"text","language_id":361},"scaml":{"extensions":[".scaml"],"aliases":[],"type":"markup","color":"#bd181a","tm_scope":"source.scaml","ace_mode":"text","language_id":342},"scenic":{"extensions":[".scenic"],"aliases":[],"type":"programming","color":"#fdc700","tm_scope":"source.scenic","ace_mode":"text","interpreters":["scenic"],"language_id":619814037},"scm":{"extensions":[".scm"],"aliases":["tsq"],"type":"programming","color":"#8ea64c","tm_scope":"source.scm","ace_mode":"text","language_id":436081647},"sld":{"extensions":[".scm",".sch",".sld",".sls",".sps",".ss"],"aliases":[],"type":"programming","color":"#1e4aec","interpreters":["scheme","guile","bigloo","chicken","csi","gosh","r6rs"],"tm_scope":"source.scheme","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","language_id":343},"sps":{"extensions":[".scm",".sch",".sld",".sls",".sps",".ss"],"aliases":[],"type":"programming","color":"#1e4aec","interpreters":["scheme","guile","bigloo","chicken","csi","gosh","r6rs"],"tm_scope":"source.scheme","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","language_id":343},"ss":{"extensions":[".scm",".sch",".sld",".sls",".sps",".ss"],"aliases":[],"type":"programming","color":"#1e4aec","interpreters":["scheme","guile","bigloo","chicken","csi","gosh","r6rs"],"tm_scope":"source.scheme","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","language_id":343},"sci":{"extensions":[".sci",".sce",".tst"],"aliases":[],"type":"programming","color":"#ca0f21","tm_scope":"source.scilab","ace_mode":"text","language_id":344},"sce":{"extensions":[".sci",".sce",".tst"],"aliases":[],"type":"programming","color":"#ca0f21","tm_scope":"source.scilab","ace_mode":"text","language_id":344},"self":{"extensions":[".self"],"aliases":[],"type":"programming","color":"#0579aa","tm_scope":"none","ace_mode":"text","language_id":345},"sh":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"shell-script":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"bash":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"zsh":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"envrc":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"bats":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"command":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"ksh":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"sbatch":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"sh.in":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"slurm":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"tmux":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"tool":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"zsh-theme":{"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"aliases":["sh","shell-script","bash","zsh","envrc"],"type":"programming","color":"#89e051","filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"shellcheckrc":{"extensions":[],"aliases":["shellcheckrc"],"type":"data","color":"#cecfcb","filenames":[".shellcheckrc"],"tm_scope":"source.shellcheckrc","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":687511714},"bash session":{"extensions":[".sh-session"],"aliases":["bash session","console"],"type":"programming","tm_scope":"text.shell-session","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":347},"console":{"extensions":[".sh-session"],"aliases":["bash session","console"],"type":"programming","tm_scope":"text.shell-session","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":347},"sh-session":{"extensions":[".sh-session"],"aliases":["bash session","console"],"type":"programming","tm_scope":"text.shell-session","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":347},"shen":{"extensions":[".shen"],"aliases":[],"type":"programming","color":"#120F14","tm_scope":"source.shen","ace_mode":"text","language_id":348},"sieve":{"extensions":[".sieve"],"aliases":[],"type":"programming","tm_scope":"source.sieve","ace_mode":"text","codemirror_mode":"sieve","codemirror_mime_type":"application/sieve","language_id":208976687},"sfv":{"extensions":[".sfv"],"aliases":["sfv"],"type":"data","group":"Checksums","color":"#C9BFED","tm_scope":"source.sfv","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":735623761},"slang":{"extensions":[".slang"],"aliases":[],"type":"programming","color":"#1fbec9","tm_scope":"source.slang","ace_mode":"text","language_id":239357863},"sl":{"extensions":[".sl"],"aliases":[],"type":"programming","color":"#007eff","tm_scope":"text.html.slash","ace_mode":"text","language_id":349},"slim":{"extensions":[".slim"],"aliases":[],"type":"markup","color":"#2b2b2b","tm_scope":"text.slim","ace_mode":"slim","codemirror_mode":"slim","codemirror_mime_type":"text/x-slim","language_id":350},"slint":{"extensions":[".slint"],"aliases":[],"type":"markup","color":"#2379F4","tm_scope":"source.slint","ace_mode":"text","language_id":119900149},"coccinelle":{"extensions":[".cocci"],"aliases":["coccinelle"],"type":"programming","ace_mode":"text","tm_scope":"source.smpl","color":"#c94949","language_id":164123055},"cocci":{"extensions":[".cocci"],"aliases":["coccinelle"],"type":"programming","ace_mode":"text","tm_scope":"source.smpl","color":"#c94949","language_id":164123055},"smali":{"extensions":[".smali"],"aliases":[],"type":"programming","ace_mode":"text","tm_scope":"source.smali","language_id":351},"squeak":{"extensions":[".st",".cs"],"aliases":["squeak"],"type":"programming","color":"#596706","tm_scope":"source.smalltalk","ace_mode":"text","codemirror_mode":"smalltalk","codemirror_mime_type":"text/x-stsrc","language_id":352},"st":{"extensions":[".st"],"aliases":[],"type":"markup","color":"#3fb34f","tm_scope":"source.string-template","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":89855901},"smithy":{"extensions":[".smithy"],"aliases":[],"type":"programming","ace_mode":"smithy","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","tm_scope":"source.smithy","color":"#c44536","language_id":1027892786},"snakefile":{"extensions":[".smk",".snakefile"],"aliases":["snakefile"],"type":"programming","group":"Python","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#419179","filenames":["Snakefile"],"language_id":151241392},"smk":{"extensions":[".smk",".snakefile"],"aliases":["snakefile"],"type":"programming","group":"Python","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#419179","filenames":["Snakefile"],"language_id":151241392},"sourcemod":{"extensions":[".sp",".inc"],"aliases":["sourcemod"],"type":"programming","color":"#f69e1d","tm_scope":"source.sourcepawn","ace_mode":"text","language_id":354},"sp":{"extensions":[".sp",".inc"],"aliases":["sourcemod"],"type":"programming","color":"#f69e1d","tm_scope":"source.sourcepawn","ace_mode":"text","language_id":354},"zed":{"extensions":[".zed"],"aliases":[],"type":"data","color":"#a5318a","tm_scope":"source.spicedb","ace_mode":"text","language_id":864005057},"sfd":{"extensions":[".sfd"],"aliases":[],"type":"data","tm_scope":"text.sfd","ace_mode":"yaml","language_id":767169629},"nut":{"extensions":[".nut"],"aliases":[],"type":"programming","color":"#800000","tm_scope":"source.nut","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-squirrel","language_id":355},"stan":{"extensions":[".stan"],"aliases":[],"type":"programming","color":"#b2011d","ace_mode":"text","tm_scope":"source.stan","language_id":356},"sml":{"extensions":[".ml",".fun",".sig",".sml"],"aliases":["sml"],"type":"programming","color":"#dc566d","tm_scope":"source.ml","ace_mode":"text","codemirror_mode":"mllike","codemirror_mime_type":"text/x-sml","language_id":357},"fun":{"extensions":[".ml",".fun",".sig",".sml"],"aliases":["sml"],"type":"programming","color":"#dc566d","tm_scope":"source.ml","ace_mode":"text","codemirror_mode":"mllike","codemirror_mime_type":"text/x-sml","language_id":357},"sig":{"extensions":[".ml",".fun",".sig",".sml"],"aliases":["sml"],"type":"programming","color":"#dc566d","tm_scope":"source.ml","ace_mode":"text","codemirror_mode":"mllike","codemirror_mime_type":"text/x-sml","language_id":357},"bazel":{"extensions":[".bzl",".star"],"aliases":["bazel","bzl"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#76d275","filenames":["BUCK","BUILD","BUILD.bazel","MODULE.bazel","Tiltfile","WORKSPACE","WORKSPACE.bazel","WORKSPACE.bzlmod"],"language_id":960266174},"bzl":{"extensions":[".bzl",".star"],"aliases":["bazel","bzl"],"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#76d275","filenames":["BUCK","BUILD","BUILD.bazel","MODULE.bazel","Tiltfile","WORKSPACE","WORKSPACE.bazel","WORKSPACE.bzlmod"],"language_id":960266174},"do":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"ado":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"doh":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"ihlp":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"mata":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"matah":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"sthlp":{"extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"aliases":[],"type":"programming","color":"#1a5f91","tm_scope":"source.stata","ace_mode":"text","language_id":358},"styl":{"extensions":[".styl"],"aliases":[],"type":"markup","color":"#ff6347","tm_scope":"source.stylus","ace_mode":"stylus","codemirror_mode":"stylus","codemirror_mime_type":"text/x-styl","language_id":359},"sss":{"extensions":[".sss"],"aliases":[],"type":"markup","color":"#2fcc9f","tm_scope":"source.css.postcss.sugarss","ace_mode":"text","language_id":826404698},"surql":{"extensions":[".surql"],"aliases":["surql"],"type":"programming","color":"#ff00a0","ace_mode":"text","tm_scope":"source.surrealql","language_id":735141027},"svx":{"extensions":[".svx"],"aliases":[],"type":"markup","color":"#5f9ea0","tm_scope":"none","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"language_id":566198445},"svelte":{"extensions":[".svelte"],"aliases":[],"type":"markup","color":"#ff3e00","tm_scope":"source.svelte","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":928734530},"sw":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"rnw":{"extensions":[".rnw"],"aliases":[],"type":"prose","color":"#198ce7","tm_scope":"text.tex.latex.sweave","ace_mode":"tex","language_id":558779190},"swift":{"extensions":[".swift"],"aliases":[],"type":"programming","color":"#F05138","tm_scope":"source.swift","ace_mode":"swift","codemirror_mode":"swift","codemirror_mime_type":"text/x-swift","language_id":362},"sv":{"extensions":[".sv",".svh",".vh"],"aliases":[],"type":"programming","color":"#DAE1C2","tm_scope":"source.systemverilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":363},"svh":{"extensions":[".sv",".svh",".vh"],"aliases":[],"type":"programming","color":"#DAE1C2","tm_scope":"source.systemverilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":363},"vh":{"extensions":[".sv",".svh",".vh"],"aliases":[],"type":"programming","color":"#DAE1C2","tm_scope":"source.systemverilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":363},"8xp":{"extensions":[".8xp",".8xp.txt"],"aliases":[],"type":"programming","ace_mode":"text","color":"#A0AA87","language_id":422,"tm_scope":"source.8xp"},"8xp.txt":{"extensions":[".8xp",".8xp.txt"],"aliases":[],"type":"programming","ace_mode":"text","color":"#A0AA87","language_id":422,"tm_scope":"source.8xp"},"tlv":{"extensions":[".tlv"],"aliases":[],"type":"programming","tm_scope":"source.tlverilog","ace_mode":"verilog","color":"#C40023","language_id":118656070},"tla":{"extensions":[".tla"],"aliases":[],"type":"programming","color":"#4b0079","tm_scope":"source.tla","ace_mode":"text","language_id":364},"Tabular Model Definition Language":{"extensions":[".tmdl"],"aliases":["Tabular Model Definition Language"],"type":"data","color":"#f0c913","tm_scope":"source.tmdl","ace_mode":"text","language_id":769162295},"tmdl":{"extensions":[".tmdl"],"aliases":["Tabular Model Definition Language"],"type":"data","color":"#f0c913","tm_scope":"source.tmdl","ace_mode":"text","language_id":769162295},"toml":{"extensions":[".toml",".toml.example"],"aliases":[],"type":"data","color":"#9c4221","filenames":["Cargo.lock","Cargo.toml.orig","Gopkg.lock","Pipfile","mise.local.lock","mise.lock","pdm.lock","poetry.lock","uv.lock"],"tm_scope":"source.toml","ace_mode":"toml","codemirror_mode":"toml","codemirror_mime_type":"text/x-toml","language_id":365},"toml.example":{"extensions":[".toml",".toml.example"],"aliases":[],"type":"data","color":"#9c4221","filenames":["Cargo.lock","Cargo.toml.orig","Gopkg.lock","Pipfile","mise.local.lock","mise.lock","pdm.lock","poetry.lock","uv.lock"],"tm_scope":"source.toml","ace_mode":"toml","codemirror_mode":"toml","codemirror_mime_type":"text/x-toml","language_id":365},"travelling salesman problem":{"extensions":[".tsp"],"aliases":["travelling salesman problem","traveling salesman problem"],"type":"data","tm_scope":"none","ace_mode":"text","language_id":89289301},"traveling salesman problem":{"extensions":[".tsp"],"aliases":["travelling salesman problem","traveling salesman problem"],"type":"data","tm_scope":"none","ace_mode":"text","language_id":89289301},"tsp":{"extensions":[".tsp"],"aliases":["tsp"],"type":"programming","color":"#4A3665","tm_scope":"source.tsp","ace_mode":"text","language_id":952272597},"tab-seperated values":{"extensions":[".tsv",".vcf"],"aliases":["tab-seperated values"],"type":"data","color":"#237346","ace_mode":"tsv","tm_scope":"source.tsv","language_id":1035892117},"tsv":{"extensions":[".tsv",".vcf"],"aliases":["tab-seperated values"],"type":"data","color":"#237346","ace_mode":"tsv","tm_scope":"source.tsv","language_id":1035892117},"vcf":{"extensions":[".vcf"],"aliases":["virtual contact file","electronic business card"],"type":"data","color":"#ee2647","tm_scope":"source.vcard","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":851476558},"typescriptreact":{"extensions":[".tsx"],"aliases":["typescriptreact"],"type":"programming","color":"#3178c6","group":"TypeScript","tm_scope":"source.tsx","ace_mode":"tsx","codemirror_mode":"jsx","codemirror_mime_type":"text/typescript-jsx","language_id":94901924},"tsx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"txl":{"extensions":[".txl"],"aliases":[],"type":"programming","color":"#0178b8","tm_scope":"source.txl","ace_mode":"text","language_id":366},"talon":{"extensions":[".talon"],"aliases":[],"type":"programming","ace_mode":"text","color":"#333333","tm_scope":"source.talon","language_id":959889508},"sdc":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"xdc":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"tcl":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"adp":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"tcl.in":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"tm":{"extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"type":"programming","color":"#e4cc98","filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"tcsh":{"extensions":[".tcsh",".csh"],"aliases":[],"type":"programming","group":"Shell","interpreters":["tcsh","csh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":368},"csh":{"extensions":[".tcsh",".csh"],"aliases":[],"type":"programming","group":"Shell","interpreters":["tcsh","csh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":368},"latex":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"tex":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"aux":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"bbx":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"cbx":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"dtx":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"ins":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"lbx":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"ltx":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"mkii":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"mkiv":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"mkvi":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"sty":{"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"aliases":["latex"],"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"language_id":369},"toc":{"extensions":[".toc"],"aliases":[],"type":"data","color":"#f7e43f","tm_scope":"source.toc","ace_mode":"text","language_id":396},"tea":{"extensions":[".tea"],"aliases":[],"type":"markup","tm_scope":"source.tea","ace_mode":"text","language_id":370},"tl":{"extensions":[".tl"],"aliases":["tl"],"type":"data","tm_scope":"source.tl","ace_mode":"text","language_id":632765617},"tftpl":{"extensions":[".tftpl"],"aliases":[],"type":"markup","color":"#7b42bb","tm_scope":"source.hcl.terraform","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","group":"HCL","language_id":856832701},"texinfo":{"extensions":[".texinfo",".texi",".txi"],"aliases":[],"type":"prose","wrap":true,"ace_mode":"text","tm_scope":"text.texinfo","interpreters":["makeinfo"],"language_id":988020015},"texi":{"extensions":[".texinfo",".texi",".txi"],"aliases":[],"type":"prose","wrap":true,"ace_mode":"text","tm_scope":"text.texinfo","interpreters":["makeinfo"],"language_id":988020015},"txi":{"extensions":[".texinfo",".texi",".txi"],"aliases":[],"type":"prose","wrap":true,"ace_mode":"text","tm_scope":"text.texinfo","interpreters":["makeinfo"],"language_id":988020015},"fundamental":{"extensions":[".txt",".fr",".nb",".ncl",".no"],"aliases":["fundamental","plain text"],"type":"prose","wrap":true,"filenames":["CITATION","CITATIONS","COPYING","COPYING.regex","COPYRIGHT.regex","FONTLOG","INSTALL","INSTALL.mysql","LICENSE","LICENSE.mysql","NEWS","README.me","README.mysql","README.nss","click.me","delete.me","keep.me","package.mask","package.use.mask","package.use.stable.mask","read.me","readme.1st","test.me","use.mask","use.stable.mask"],"tm_scope":"none","ace_mode":"text","language_id":372},"plain text":{"extensions":[".txt",".fr",".nb",".ncl",".no"],"aliases":["fundamental","plain text"],"type":"prose","wrap":true,"filenames":["CITATION","CITATIONS","COPYING","COPYING.regex","COPYRIGHT.regex","FONTLOG","INSTALL","INSTALL.mysql","LICENSE","LICENSE.mysql","NEWS","README.me","README.mysql","README.nss","click.me","delete.me","keep.me","package.mask","package.use.mask","package.use.stable.mask","read.me","readme.1st","test.me","use.mask","use.stable.mask"],"tm_scope":"none","ace_mode":"text","language_id":372},"nb":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"no":{"extensions":[".txt",".fr",".nb",".ncl",".no"],"aliases":["fundamental","plain text"],"type":"prose","wrap":true,"filenames":["CITATION","CITATIONS","COPYING","COPYING.regex","COPYRIGHT.regex","FONTLOG","INSTALL","INSTALL.mysql","LICENSE","LICENSE.mysql","NEWS","README.me","README.mysql","README.nss","click.me","delete.me","keep.me","package.mask","package.use.mask","package.use.stable.mask","read.me","readme.1st","test.me","use.mask","use.stable.mask"],"tm_scope":"none","ace_mode":"text","language_id":372},"TextGrid":{"extensions":[".TextGrid"],"aliases":[],"type":"data","color":"#c8506d","tm_scope":"source.textgrid","ace_mode":"text","language_id":965696054},"tm-properties":{"extensions":[],"aliases":["tm-properties"],"type":"data","color":"#df66e4","filenames":[".tm_properties"],"ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.tm-properties","language_id":981795023},"textile":{"extensions":[".textile"],"aliases":[],"type":"prose","color":"#ffe7ac","ace_mode":"textile","codemirror_mode":"textile","codemirror_mime_type":"text/x-textile","wrap":true,"tm_scope":"none","language_id":373},"thrift":{"extensions":[".thrift"],"aliases":[],"type":"programming","color":"#D12127","tm_scope":"source.thrift","ace_mode":"text","language_id":374},"toit":{"extensions":[".toit"],"aliases":[],"type":"programming","color":"#c2c9fb","tm_scope":"source.toit","ace_mode":"text","language_id":356554395},"torrc":{"extensions":[],"aliases":["torrc"],"type":"data","color":"#59316b","filenames":["torrc"],"tm_scope":"source.torrc","ace_mode":"apache_conf","language_id":1016912802},"tsq":{"extensions":[".scm"],"aliases":["tsq"],"type":"programming","color":"#8ea64c","tm_scope":"source.scm","ace_mode":"text","language_id":436081647},"tu":{"extensions":[".t",".tu"],"aliases":[],"type":"programming","color":"#cf142b","tm_scope":"source.turing","ace_mode":"text","language_id":375},"ttl":{"extensions":[".ttl"],"aliases":[],"type":"data","tm_scope":"source.turtle","ace_mode":"turtle","codemirror_mode":"turtle","codemirror_mime_type":"text/turtle","language_id":376},"twig":{"extensions":[".twig"],"aliases":[],"type":"markup","color":"#c1d026","tm_scope":"text.html.twig","ace_mode":"twig","codemirror_mode":"twig","codemirror_mime_type":"text/x-twig","language_id":377},"ts":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"cts":{"extensions":[".ts",".cts",".mts"],"aliases":["ts"],"type":"programming","color":"#3178c6","interpreters":["bun","deno","ts-node","tsx"],"tm_scope":"source.ts","ace_mode":"typescript","codemirror_mode":"javascript","codemirror_mime_type":"application/typescript","language_id":378},"mts":{"extensions":[".ts",".cts",".mts"],"aliases":["ts"],"type":"programming","color":"#3178c6","interpreters":["bun","deno","ts-node","tsx"],"tm_scope":"source.ts","ace_mode":"typescript","codemirror_mode":"javascript","codemirror_mime_type":"application/typescript","language_id":378},"typ":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"upc":{"extensions":[".upc"],"aliases":[],"type":"programming","color":"#4e3617","group":"C","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","tm_scope":"source.c","language_id":379},"anim":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"asset":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"mat":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"meta":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"prefab":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"unity":{"extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"aliases":[],"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","language_id":380},"gas":{"extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"type":"programming","group":"Assembly","tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"gnu asm":{"extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"type":"programming","group":"Assembly","tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"unix asm":{"extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"type":"programming","group":"Assembly","tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"uno":{"extensions":[".uno"],"aliases":[],"type":"programming","color":"#9933cc","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","language_id":381},"uc":{"extensions":[".uc"],"aliases":[],"type":"programming","color":"#a54c4d","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":382},"uplc":{"extensions":[".uplc"],"aliases":[],"type":"programming","color":"#36adbd","ace_mode":"text","tm_scope":"source.uplc","language_id":1061635506},"Ur/Web":{"extensions":[".ur",".urs"],"aliases":["Ur/Web","Ur"],"type":"programming","color":"#ccccee","tm_scope":"source.ur","ace_mode":"text","language_id":383},"Ur":{"extensions":[".ur",".urs"],"aliases":["Ur/Web","Ur"],"type":"programming","color":"#ccccee","tm_scope":"source.ur","ace_mode":"text","language_id":383},"ur":{"extensions":[".ur",".urs"],"aliases":["Ur/Web","Ur"],"type":"programming","color":"#ccccee","tm_scope":"source.ur","ace_mode":"text","language_id":383},"urs":{"extensions":[".ur",".urs"],"aliases":["Ur/Web","Ur"],"type":"programming","color":"#ccccee","tm_scope":"source.ur","ace_mode":"text","language_id":383},"vlang":{"extensions":[".v"],"aliases":["vlang"],"type":"programming","color":"#4f87c4","tm_scope":"source.v","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","language_id":603371597},"visual basic for applications":{"extensions":[".bas",".cls",".frm",".vba"],"aliases":["visual basic for applications"],"type":"programming","color":"#867db1","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":399230729},"vba":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"vbs":{"extensions":[".vbs"],"aliases":[],"type":"programming","color":"#15dcdc","tm_scope":"source.vbnet","ace_mode":"vbscript","codemirror_mode":"vbscript","codemirror_mime_type":"text/vbscript","language_id":408016005},"vcl":{"extensions":[".vcl"],"aliases":[],"type":"programming","color":"#148AA8","tm_scope":"source.vcl","ace_mode":"text","language_id":384},"vhdl":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vhd":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vhf":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vhi":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vho":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vhs":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vht":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vhw":{"extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"aliases":[],"type":"programming","color":"#adb2cb","tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"vala":{"extensions":[".vala",".vapi"],"aliases":[],"type":"programming","color":"#a56de2","tm_scope":"source.vala","ace_mode":"vala","language_id":386},"vapi":{"extensions":[".vala",".vapi"],"aliases":[],"type":"programming","color":"#a56de2","tm_scope":"source.vala","ace_mode":"vala","language_id":386},"keyvalues":{"extensions":[".vdf"],"aliases":["keyvalues","vdf"],"type":"data","color":"#f26025","ace_mode":"text","tm_scope":"source.keyvalues","language_id":544060961},"vdf":{"extensions":[".vdf"],"aliases":["keyvalues","vdf"],"type":"data","color":"#f26025","ace_mode":"text","tm_scope":"source.keyvalues","language_id":544060961},"vtl":{"extensions":[".vtl"],"aliases":["vtl","velocity"],"type":"markup","color":"#507cff","ace_mode":"velocity","tm_scope":"source.velocity","codemirror_mode":"velocity","codemirror_mime_type":"text/velocity","language_id":292377326},"velocity":{"extensions":[".vtl"],"aliases":["vtl","velocity"],"type":"markup","color":"#507cff","ace_mode":"velocity","tm_scope":"source.velocity","codemirror_mode":"velocity","codemirror_mime_type":"text/velocity","language_id":292377326},"vto":{"extensions":[".vto"],"aliases":[],"type":"markup","color":"#ff0080","tm_scope":"source.vento","ace_mode":"text","language_id":757053899},"veo":{"extensions":[".v",".veo"],"aliases":[],"type":"programming","color":"#b2b7f8","tm_scope":"source.verilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-verilog","language_id":387},"help":{"extensions":[".txt"],"aliases":["help","vimhelp"],"type":"prose","color":"#199f4b","tm_scope":"text.vim-help","ace_mode":"text","language_id":508563686},"vimhelp":{"extensions":[".txt"],"aliases":["help","vimhelp"],"type":"prose","color":"#199f4b","tm_scope":"text.vim-help","ace_mode":"text","language_id":508563686},"vim":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"viml":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"nvim":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"vimscript":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"vimrc":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"vmb":{"extensions":[".vim",".vba",".vimrc",".vmb"],"aliases":["vim","viml","nvim","vimscript"],"type":"programming","color":"#199f4b","tm_scope":"source.viml","filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"SnipMate":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"UltiSnip":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"UltiSnips":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"NeoSnippet":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"snip":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"snippet":{"extensions":[".yasnippet"],"aliases":["snippet","yas"],"type":"markup","color":"#32AB90","tm_scope":"source.yasnippet","ace_mode":"text","language_id":378760102},"snippets":{"extensions":[".snip",".snippet",".snippets"],"aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"type":"markup","color":"#199f4b","tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"visual basic":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vbnet":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vb .net":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vb.net":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vb":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vbhtml":{"extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"type":"programming","color":"#945db7","tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"vb6":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"vb 6":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"visual basic 6":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"visual basic classic":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"classic visual basic":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"ctl":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"Dsr":{"extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"type":"programming","color":"#2c6353","tm_scope":"source.vba","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"volt":{"extensions":[".volt"],"aliases":[],"type":"programming","color":"#1F1F1F","tm_scope":"source.d","ace_mode":"d","codemirror_mode":"d","codemirror_mime_type":"text/x-d","language_id":390},"vue":{"extensions":[".vue"],"aliases":[],"type":"markup","color":"#41b883","tm_scope":"text.html.vue","ace_mode":"vue","codemirror_mode":"vue","codemirror_mime_type":"text/x-vue","language_id":391},"vy":{"extensions":[".vy"],"aliases":[],"type":"programming","color":"#9F4CF2","ace_mode":"text","tm_scope":"source.vyper","language_id":1055641948},"Workflow Description Language":{"extensions":[".wdl"],"aliases":["Workflow Description Language"],"type":"programming","color":"#42f1f4","tm_scope":"source.wdl","ace_mode":"text","language_id":374521672},"wdl":{"extensions":[".wdl"],"aliases":["Workflow Description Language"],"type":"programming","color":"#42f1f4","tm_scope":"source.wdl","ace_mode":"text","language_id":374521672},"wgsl":{"extensions":[".wgsl"],"aliases":[],"type":"programming","color":"#1a5e9a","tm_scope":"source.wgsl","ace_mode":"text","language_id":836605993},"mtl":{"extensions":[".mtl"],"aliases":[],"type":"data","tm_scope":"source.wavefront.mtl","ace_mode":"text","language_id":392},"obj":{"extensions":[".obj"],"aliases":[],"type":"data","tm_scope":"source.wavefront.obj","ace_mode":"text","language_id":393},"owl":{"extensions":[".owl"],"aliases":[],"type":"data","color":"#5b70bd","tm_scope":"text.xml","ace_mode":"xml","language_id":394},"wast":{"extensions":[".wast",".wat"],"aliases":["wast","wasm"],"type":"programming","color":"#04133b","tm_scope":"source.webassembly","ace_mode":"lisp","codemirror_mode":"wast","codemirror_mime_type":"text/webassembly","language_id":956556503},"wasm":{"extensions":[".wast",".wat"],"aliases":["wast","wasm"],"type":"programming","color":"#04133b","tm_scope":"source.webassembly","ace_mode":"lisp","codemirror_mode":"wast","codemirror_mime_type":"text/webassembly","language_id":956556503},"wat":{"extensions":[".wast",".wat"],"aliases":["wast","wasm"],"type":"programming","color":"#04133b","tm_scope":"source.webassembly","ace_mode":"lisp","codemirror_mode":"wast","codemirror_mime_type":"text/webassembly","language_id":956556503},"wit":{"extensions":[".wit"],"aliases":["wit"],"type":"data","color":"#6250e7","ace_mode":"text","tm_scope":"source.wit","codemirror_mode":"webidl","codemirror_mime_type":"text/x-webidl","language_id":134534086},"webidl":{"extensions":[".webidl"],"aliases":[],"type":"programming","tm_scope":"source.webidl","ace_mode":"text","codemirror_mode":"webidl","codemirror_mime_type":"text/x-webidl","language_id":395},"vtt":{"extensions":[".vtt"],"aliases":["vtt"],"type":"data","wrap":true,"tm_scope":"text.vtt","ace_mode":"text","language_id":658679714},"wgetrc":{"extensions":[],"aliases":["wgetrc"],"type":"data","group":"INI","filenames":[".wgetrc"],"tm_scope":"source.wgetrc","ace_mode":"text","language_id":668457123},"whiley":{"extensions":[".whiley"],"aliases":[],"type":"programming","color":"#d5c397","tm_scope":"source.whiley","ace_mode":"text","language_id":888779559},"mediawiki":{"extensions":[".mediawiki",".wiki",".wikitext"],"aliases":["mediawiki","wiki"],"type":"prose","color":"#fc5757","wrap":true,"tm_scope":"text.html.mediawiki","ace_mode":"mediawiki","language_id":228},"wiki":{"extensions":[".mediawiki",".wiki",".wikitext"],"aliases":["mediawiki","wiki"],"type":"prose","color":"#fc5757","wrap":true,"tm_scope":"text.html.mediawiki","ace_mode":"mediawiki","language_id":228},"wikitext":{"extensions":[".mediawiki",".wiki",".wikitext"],"aliases":["mediawiki","wiki"],"type":"prose","color":"#fc5757","wrap":true,"tm_scope":"text.html.mediawiki","ace_mode":"mediawiki","language_id":228},"reg":{"extensions":[".reg"],"aliases":[],"type":"data","color":"#52d5ff","tm_scope":"source.reg","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":969674868},"ws":{"extensions":[".ws"],"aliases":[],"type":"programming","color":"#ff0000","ace_mode":"text","tm_scope":"source.witcherscript","language_id":686821385},"mathematica":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"mma":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wolfram":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wolfram lang":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wl":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"cdf":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"ma":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"mt":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"nbp":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wls":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wlt":{"extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"type":"programming","color":"#dd1100","interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"wlk":{"extensions":[".wlk"],"aliases":[],"type":"programming","color":"#a23738","ace_mode":"wollok","tm_scope":"source.wollok","language_id":632745969},"wrenlang":{"extensions":[".wren"],"aliases":["wrenlang"],"type":"programming","color":"#383838","tm_scope":"source.wren","ace_mode":"text","language_id":713580619},"wren":{"extensions":[".wren"],"aliases":["wrenlang"],"type":"programming","color":"#383838","tm_scope":"source.wren","ace_mode":"text","language_id":713580619},"xbm":{"extensions":[".xbm"],"aliases":["xbm"],"type":"data","group":"C","ace_mode":"c_cpp","tm_scope":"source.c","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":782911107},"xpm":{"extensions":[".xpm",".pm"],"aliases":["xpm"],"type":"data","group":"C","ace_mode":"c_cpp","tm_scope":"source.c","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":781846279},"xten":{"extensions":[".x10"],"aliases":["xten"],"type":"programming","ace_mode":"text","color":"#4B6BEF","tm_scope":"source.x10","language_id":397},"x10":{"extensions":[".x10"],"aliases":["xten"],"type":"programming","ace_mode":"text","color":"#4B6BEF","tm_scope":"source.x10","language_id":397},"xc":{"extensions":[".xc"],"aliases":[],"type":"programming","color":"#99DA07","tm_scope":"source.xc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":398},"rss":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xsd":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wsdl":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"adml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"admx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ant":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"axaml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"axml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"builds":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ccproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ccxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"clixml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"cproject":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"cscfg":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"csdef":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"csproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ct":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"depproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"dita":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ditamap":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ditaval":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"dll.config":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"dotsettings":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"filters":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"fsproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"fxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"glade":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"gmx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"gpx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"grxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"hzp":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"icls":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"iml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ivy":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"jelly":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"jsproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"kml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"launch":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"mdpolicy":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"mjml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"mxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"natvis":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ndproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"nproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"nuspec":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"odd":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"osm":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"pkgproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"proj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"props":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ps1xml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"psc1":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"pt":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"pubxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"qhelp":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"rdf":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"resx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"scxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"sfproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"shproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"slnx":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"srdf":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"storyboard":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"sublime-snippet":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"targets":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"tml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ui":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"urdf":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"ux":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vbproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vcxproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vsixmanifest":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vssettings":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vstemplate":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"vxml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wixproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wsf":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wxi":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wxl":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"wxs":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"x3d":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xacro":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xaml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xib":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xlf":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xliff":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xmi":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xml.dist":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xmp":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xproj":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xspec":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"xul":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"zcml":{"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"aliases":["rss","xsd","wsdl"],"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"stTheme":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"tmCommand":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"tmLanguage":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"tmPreferences":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"tmSnippet":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"tmTheme":{"extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"aliases":[],"type":"data","color":"#0060ac","group":"XML","tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"xsp-config":{"extensions":[".xsp-config",".xsp.metadata"],"aliases":[],"type":"data","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":400},"xsp.metadata":{"extensions":[".xsp-config",".xsp.metadata"],"aliases":[],"type":"data","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":400},"xpl":{"extensions":[".xpl",".xproc"],"aliases":[],"type":"programming","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":401},"xproc":{"extensions":[".xpl",".xproc"],"aliases":[],"type":"programming","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":401},"xquery":{"extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"aliases":[],"type":"programming","color":"#5232e7","ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"xq":{"extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"aliases":[],"type":"programming","color":"#5232e7","ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"xql":{"extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"aliases":[],"type":"programming","color":"#5232e7","ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"xqm":{"extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"aliases":[],"type":"programming","color":"#5232e7","ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"xqy":{"extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"aliases":[],"type":"programming","color":"#5232e7","ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"xs":{"extensions":[".xs"],"aliases":[],"type":"programming","tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":403},"xsl":{"extensions":[".xslt",".xsl"],"aliases":["xsl"],"type":"programming","tm_scope":"text.xml.xsl","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","color":"#EB8CEB","language_id":404},"xslt":{"extensions":[".xslt",".xsl"],"aliases":["xsl"],"type":"programming","tm_scope":"text.xml.xsl","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","color":"#EB8CEB","language_id":404},"xojo_code":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xojo_menu":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xojo_report":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xojo_script":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xojo_toolbar":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xojo_window":{"extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"aliases":[],"type":"programming","color":"#81bd41","tm_scope":"source.xojo","ace_mode":"text","language_id":405},"xsh":{"extensions":[".xsh"],"aliases":[],"type":"programming","color":"#285EEF","tm_scope":"source.python","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":614078284},"xtend":{"extensions":[".xtend"],"aliases":[],"type":"programming","color":"#24255d","tm_scope":"source.xtend","ace_mode":"text","language_id":406},"mir":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"reek":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"rviz":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"sublime-syntax":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"syntax":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"yaml-tmlanguage":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"yaml.sed":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"yml.mysql":{"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"aliases":["yml"],"type":"data","color":"#cb171e","tm_scope":"source.yaml","filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"yang":{"extensions":[".yang"],"aliases":[],"type":"data","tm_scope":"source.yang","ace_mode":"text","language_id":408},"yar":{"extensions":[".yar",".yara"],"aliases":[],"type":"programming","color":"#220000","ace_mode":"text","tm_scope":"source.yara","language_id":805122868},"yara":{"extensions":[".yar",".yara"],"aliases":[],"type":"programming","color":"#220000","ace_mode":"text","tm_scope":"source.yara","language_id":805122868},"yas":{"extensions":[".yasnippet"],"aliases":["snippet","yas"],"type":"markup","color":"#32AB90","tm_scope":"source.yasnippet","ace_mode":"text","language_id":378760102},"yasnippet":{"extensions":[".yasnippet"],"aliases":["snippet","yas"],"type":"markup","color":"#32AB90","tm_scope":"source.yasnippet","ace_mode":"text","language_id":378760102},"y":{"extensions":[".y",".yacc",".yy"],"aliases":[],"type":"programming","tm_scope":"source.yacc","ace_mode":"text","color":"#4B6C4B","language_id":409},"yacc":{"extensions":[".y",".yacc",".yy"],"aliases":[],"type":"programming","tm_scope":"source.yacc","ace_mode":"text","color":"#4B6C4B","language_id":409},"yul":{"extensions":[".yul"],"aliases":[],"type":"programming","color":"#794932","ace_mode":"text","tm_scope":"source.yul","language_id":237469033},"zap":{"extensions":[".zap",".xzap"],"aliases":[],"type":"programming","color":"#0d665e","tm_scope":"source.zap","ace_mode":"text","language_id":952972794},"xzap":{"extensions":[".zap",".xzap"],"aliases":[],"type":"programming","color":"#0d665e","tm_scope":"source.zap","ace_mode":"text","language_id":952972794},"zil":{"extensions":[".zil",".mud"],"aliases":[],"type":"programming","color":"#dc75e5","tm_scope":"source.zil","ace_mode":"text","language_id":973483626},"mud":{"extensions":[".zil",".mud"],"aliases":[],"type":"programming","color":"#dc75e5","tm_scope":"source.zil","ace_mode":"text","language_id":973483626},"bro":{"extensions":[".zeek",".bro"],"aliases":["bro"],"type":"programming","tm_scope":"source.zeek","ace_mode":"zeek","language_id":40},"zeek":{"extensions":[".zeek",".bro"],"aliases":["bro"],"type":"programming","tm_scope":"source.zeek","ace_mode":"zeek","language_id":40},"zs":{"extensions":[".zs"],"aliases":[],"type":"programming","color":"#00BCD1","tm_scope":"source.zenscript","ace_mode":"text","language_id":494938890},"zep":{"extensions":[".zep"],"aliases":[],"type":"programming","color":"#118f9e","tm_scope":"source.php.zephir","ace_mode":"php","language_id":410},"zig":{"extensions":[".zig",".zig.zon"],"aliases":[],"type":"programming","color":"#ec915c","tm_scope":"source.zig","ace_mode":"zig","language_id":646424281},"zig.zon":{"extensions":[".zig",".zig.zon"],"aliases":[],"type":"programming","color":"#ec915c","tm_scope":"source.zig","ace_mode":"zig","language_id":646424281},"zimpl":{"extensions":[".zimpl",".zmpl",".zpl"],"aliases":[],"type":"programming","color":"#d67711","tm_scope":"none","ace_mode":"text","language_id":411},"zmpl":{"extensions":[".zimpl",".zmpl",".zpl"],"aliases":[],"type":"programming","color":"#d67711","tm_scope":"none","ace_mode":"text","language_id":411},"zpl":{"extensions":[".zimpl",".zmpl",".zpl"],"aliases":[],"type":"programming","color":"#d67711","tm_scope":"none","ace_mode":"text","language_id":411},"zmodel":{"extensions":[".zmodel"],"aliases":[],"type":"data","color":"#ff7100","tm_scope":"source.zmodel","ace_mode":"text","language_id":803760908},"curlrc":{"extensions":[],"aliases":["curlrc"],"type":"data","group":"INI","filenames":[".curlrc","_curlrc"],"tm_scope":"source.curlrc","ace_mode":"text","language_id":992375436},"cron":{"extensions":[],"aliases":["cron","cron table"],"type":"data","color":"#ead7ac","filenames":["crontab"],"tm_scope":"text.crontab","ace_mode":"tcl","language_id":705203557},"cron table":{"extensions":[],"aliases":["cron","cron table"],"type":"data","color":"#ead7ac","filenames":["crontab"],"tm_scope":"text.crontab","ace_mode":"tcl","language_id":705203557},"desktop":{"extensions":[".desktop",".desktop.in",".service"],"aliases":[],"type":"data","tm_scope":"source.desktop","ace_mode":"text","language_id":412},"desktop.in":{"extensions":[".desktop",".desktop.in",".service"],"aliases":[],"type":"data","tm_scope":"source.desktop","ace_mode":"text","language_id":412},"service":{"extensions":[".desktop",".desktop.in",".service"],"aliases":[],"type":"data","tm_scope":"source.desktop","ace_mode":"text","language_id":412},"dircolors":{"extensions":[".dircolors"],"aliases":[],"type":"data","filenames":[".dir_colors",".dircolors","DIR_COLORS","_dir_colors","_dircolors","dir_colors"],"tm_scope":"source.dircolors","ace_mode":"text","language_id":691605112},"ec":{"extensions":[".ec",".eh"],"aliases":[],"type":"programming","color":"#913960","tm_scope":"source.c.ec","ace_mode":"text","language_id":413},"eh":{"extensions":[".ec",".eh"],"aliases":[],"type":"programming","color":"#913960","tm_scope":"source.c.ec","ace_mode":"text","language_id":413},"edn":{"extensions":[".edn"],"aliases":[],"type":"data","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"application/edn","tm_scope":"source.clojure","language_id":414},"fish":{"extensions":[".fish"],"aliases":[],"type":"programming","color":"#4aae47","group":"Shell","interpreters":["fish"],"tm_scope":"source.fish","ace_mode":"text","language_id":415},"hoon":{"extensions":[".hoon"],"aliases":[],"type":"programming","color":"#00b171","tm_scope":"source.hoon","ace_mode":"text","language_id":560883276},"iCal":{"extensions":[".ics",".ical"],"aliases":["iCal"],"type":"data","color":"#ec564c","tm_scope":"source.iCalendar","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":98384424},"ics":{"extensions":[".ics",".ical"],"aliases":["iCal"],"type":"data","color":"#ec564c","tm_scope":"source.iCalendar","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":98384424},"ical":{"extensions":[".ics",".ical"],"aliases":["iCal"],"type":"data","color":"#ec564c","tm_scope":"source.iCalendar","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":98384424},"kv":{"extensions":[".kv"],"aliases":[],"type":"markup","ace_mode":"text","color":"#1da6e0","tm_scope":"source.python.kivy","language_id":970675279},"mrc":{"extensions":[".mrc"],"aliases":[],"type":"programming","color":"#3d57c3","tm_scope":"source.msl","ace_mode":"text","language_id":517654727},"mcfunction":{"extensions":[".mcfunction"],"aliases":[],"type":"programming","color":"#E22837","tm_scope":"source.mcfunction","ace_mode":"text","language_id":462488745},"mu":{"extensions":[".mu"],"aliases":[],"type":"programming","color":"#244963","tm_scope":"source.mupad","ace_mode":"text","language_id":416},"nanorc":{"extensions":[".nanorc"],"aliases":[],"type":"data","color":"#2d004d","group":"INI","filenames":[".nanorc","nanorc"],"tm_scope":"source.nanorc","ace_mode":"text","language_id":775996197},"nc":{"extensions":[".nc"],"aliases":[],"type":"programming","color":"#94B0C7","ace_mode":"text","tm_scope":"source.nesc","language_id":417},"ooc":{"extensions":[".ooc"],"aliases":[],"type":"programming","color":"#b0b77e","tm_scope":"source.ooc","ace_mode":"text","language_id":418},"rst":{"extensions":[".rst",".rest",".rest.txt",".rst.txt"],"aliases":["rst"],"type":"prose","color":"#141414","wrap":true,"tm_scope":"text.restructuredtext","ace_mode":"rst","codemirror_mode":"rst","codemirror_mime_type":"text/x-rst","language_id":419},"rest":{"extensions":[".rst",".rest",".rest.txt",".rst.txt"],"aliases":["rst"],"type":"prose","color":"#141414","wrap":true,"tm_scope":"text.restructuredtext","ace_mode":"rst","codemirror_mode":"rst","codemirror_mime_type":"text/x-rst","language_id":419},"rest.txt":{"extensions":[".rst",".rest",".rest.txt",".rst.txt"],"aliases":["rst"],"type":"prose","color":"#141414","wrap":true,"tm_scope":"text.restructuredtext","ace_mode":"rst","codemirror_mode":"rst","codemirror_mime_type":"text/x-rst","language_id":419},"rst.txt":{"extensions":[".rst",".rest",".rest.txt",".rst.txt"],"aliases":["rst"],"type":"prose","color":"#141414","wrap":true,"tm_scope":"text.restructuredtext","ace_mode":"rst","codemirror_mode":"rst","codemirror_mime_type":"text/x-rst","language_id":419},"robots":{"extensions":[],"aliases":["robots","robots txt"],"type":"data","filenames":["robots.txt"],"ace_mode":"text","tm_scope":"text.robots-txt","language_id":674736065},"robots txt":{"extensions":[],"aliases":["robots","robots txt"],"type":"data","filenames":["robots.txt"],"ace_mode":"text","tm_scope":"text.robots-txt","language_id":674736065},"sed":{"extensions":[".sed"],"aliases":[],"type":"programming","color":"#64b970","interpreters":["gsed","minised","sed","ssed"],"ace_mode":"text","tm_scope":"source.sed","language_id":847830017},"templ":{"extensions":[".templ"],"aliases":[],"type":"markup","color":"#66D0DD","ace_mode":"text","tm_scope":"source.templ","language_id":795579337},"virtual contact file":{"extensions":[".vcf"],"aliases":["virtual contact file","electronic business card"],"type":"data","color":"#ee2647","tm_scope":"source.vcard","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":851476558},"electronic business card":{"extensions":[".vcf"],"aliases":["virtual contact file","electronic business card"],"type":"data","color":"#ee2647","tm_scope":"source.vcard","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":851476558},"wisp":{"extensions":[".wisp"],"aliases":[],"type":"programming","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#7582D1","tm_scope":"source.clojure","language_id":420},"advpl":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421},"clipper":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421},"foxpro":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421},"prg":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421},"prw":{"extensions":[".prg",".ch",".prw"],"aliases":["advpl","clipper","foxpro"],"type":"programming","color":"#403a40","tm_scope":"source.harbour","ace_mode":"text","language_id":421}}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = {"1C Enterprise":{"type":"programming","color":"#814CCC","extensions":[".bsl",".os"],"tm_scope":"source.bsl","ace_mode":"text","language_id":0},"2-Dimensional Array":{"type":"data","color":"#38761D","extensions":[".2da"],"tm_scope":"source.2da","ace_mode":"text","language_id":387204628},"4D":{"type":"programming","color":"#004289","extensions":[".4dm"],"tm_scope":"source.4dm","ace_mode":"text","language_id":577529595},"ABAP":{"type":"programming","color":"#E8274B","extensions":[".abap"],"tm_scope":"source.abap","ace_mode":"abap","language_id":1},"ABAP CDS":{"type":"programming","color":"#555e25","extensions":[".asddls"],"tm_scope":"source.abapcds","language_id":452681853,"ace_mode":"text"},"ABNF":{"type":"data","ace_mode":"text","extensions":[".abnf"],"tm_scope":"source.abnf","language_id":429},"AGS Script":{"type":"programming","color":"#B9D9FF","aliases":["ags"],"extensions":[".asc",".ash"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":2},"AIDL":{"type":"programming","color":"#34EB6B","tm_scope":"source.aidl","extensions":[".aidl"],"ace_mode":"text","interpreters":["aidl"],"language_id":451700185},"AL":{"type":"programming","color":"#3AA2B5","extensions":[".al"],"tm_scope":"source.al","ace_mode":"text","language_id":658971832},"ALGOL":{"type":"programming","color":"#D1E0DB","extensions":[".alg"],"tm_scope":"source.algol60","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":79217948},"AMPL":{"type":"programming","color":"#E6EFBB","extensions":[".ampl",".mod"],"tm_scope":"source.ampl","ace_mode":"text","language_id":3},"ANTLR":{"type":"programming","color":"#9DC3FF","extensions":[".g4"],"tm_scope":"source.antlr","ace_mode":"text","language_id":4},"API Blueprint":{"type":"markup","color":"#2ACCA8","ace_mode":"markdown","extensions":[".apib"],"tm_scope":"text.html.markdown.source.gfm.apib","language_id":5},"APL":{"type":"programming","color":"#5A8164","extensions":[".apl",".dyalog"],"interpreters":["apl","aplx","dyalog"],"tm_scope":"source.apl","ace_mode":"text","codemirror_mode":"apl","codemirror_mime_type":"text/apl","language_id":6},"ASL":{"type":"programming","ace_mode":"asl","extensions":[".asl",".dsl"],"tm_scope":"source.asl","language_id":124996147},"ASN.1":{"type":"data","extensions":[".asn",".asn1"],"tm_scope":"source.asn","ace_mode":"text","codemirror_mode":"asn.1","codemirror_mime_type":"text/x-ttcn-asn","language_id":7},"ASP.NET":{"type":"programming","tm_scope":"text.html.asp","color":"#9400ff","aliases":["aspx","aspx-vb"],"extensions":[".asax",".ascx",".ashx",".asmx",".aspx",".axd"],"ace_mode":"text","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-aspx","language_id":564186416},"ATS":{"type":"programming","color":"#1ac620","aliases":["ats2"],"extensions":[".dats",".hats",".sats"],"tm_scope":"source.ats","ace_mode":"ocaml","language_id":9},"ActionScript":{"type":"programming","tm_scope":"source.actionscript.3","color":"#882B0F","aliases":["actionscript 3","actionscript3","as3"],"extensions":[".as"],"ace_mode":"actionscript","language_id":10},"Ada":{"type":"programming","color":"#02f88c","extensions":[".adb",".ada",".ads"],"aliases":["ada95","ada2005"],"tm_scope":"source.ada","ace_mode":"ada","language_id":11},"Adblock Filter List":{"type":"data","color":"#800000","ace_mode":"text","extensions":[".txt"],"aliases":["ad block filters","ad block","adb","adblock"],"tm_scope":"text.adblock","language_id":884614762},"Adobe Font Metrics":{"type":"data","color":"#fa0f00","tm_scope":"source.afm","extensions":[".afm"],"aliases":["acfm","adobe composite font metrics","adobe multiple font metrics","amfm"],"ace_mode":"text","language_id":147198098},"Agda":{"type":"programming","color":"#315665","extensions":[".agda"],"tm_scope":"source.agda","ace_mode":"text","language_id":12},"Aiken":{"type":"programming","color":"#640ff8","ace_mode":"text","extensions":[".ak"],"tm_scope":"source.aiken","language_id":899409497},"Alloy":{"type":"programming","color":"#64C800","extensions":[".als"],"tm_scope":"source.alloy","ace_mode":"text","language_id":13},"Alpine Abuild":{"type":"programming","color":"#0D597F","group":"Shell","aliases":["abuild","apkbuild"],"filenames":["APKBUILD"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":14},"Altium Designer":{"type":"data","color":"#A89663","aliases":["altium"],"extensions":[".OutJob",".PcbDoc",".PrjPCB",".SchDoc"],"tm_scope":"source.ini","ace_mode":"ini","language_id":187772328},"AngelScript":{"type":"programming","color":"#C7D7DC","extensions":[".as",".angelscript"],"tm_scope":"source.angelscript","ace_mode":"text","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":389477596},"Answer Set Programming":{"type":"programming","color":"#A9CC29","extensions":[".lp"],"interpreters":["clingo"],"tm_scope":"source.answersetprogramming","ace_mode":"prolog","language_id":433009171},"Ant Build System":{"type":"data","color":"#A9157E","tm_scope":"text.xml.ant","filenames":["ant.xml","build.xml"],"ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"application/xml","language_id":15},"Antlers":{"type":"markup","color":"#ff269e","extensions":[".antlers.html",".antlers.php",".antlers.xml"],"tm_scope":"text.html.statamic","ace_mode":"text","language_id":1067292663},"ApacheConf":{"type":"data","color":"#d12127","aliases":["aconf","apache"],"extensions":[".apacheconf",".vhost"],"filenames":[".htaccess","apache2.conf","httpd.conf"],"tm_scope":"source.apacheconf","ace_mode":"apache_conf","language_id":16},"Apex":{"type":"programming","color":"#1797c0","extensions":[".cls",".apex",".trigger"],"tm_scope":"source.apex","ace_mode":"apex","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":17},"Apollo Guidance Computer":{"type":"programming","color":"#0B3D91","group":"Assembly","extensions":[".agc"],"tm_scope":"source.agc","ace_mode":"assembly_x86","language_id":18},"AppleScript":{"type":"programming","aliases":["apples","osascript"],"extensions":[".applescript",".scpt"],"interpreters":["osascript"],"tm_scope":"source.applescript","ace_mode":"applescript","color":"#101F1F","language_id":19},"Arc":{"type":"programming","color":"#aa2afe","extensions":[".arc"],"tm_scope":"none","ace_mode":"text","language_id":20},"AsciiDoc":{"type":"prose","color":"#73a0c5","ace_mode":"asciidoc","wrap":true,"extensions":[".asciidoc",".adoc",".asc"],"tm_scope":"text.html.asciidoc","language_id":22},"AspectJ":{"type":"programming","color":"#a957b0","extensions":[".aj"],"tm_scope":"source.aspectj","ace_mode":"text","language_id":23},"Assembly":{"type":"programming","color":"#6E4C13","aliases":["asm","nasm"],"extensions":[".asm",".a51",".i",".inc",".nas",".nasm",".s"],"tm_scope":"source.assembly","ace_mode":"assembly_x86","language_id":24},"Astro":{"type":"markup","color":"#ff5a03","extensions":[".astro"],"tm_scope":"source.astro","ace_mode":"astro","codemirror_mode":"jsx","codemirror_mime_type":"text/jsx","language_id":578209015},"Asymptote":{"type":"programming","color":"#ff0000","extensions":[".asy"],"interpreters":["asy"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-kotlin","language_id":591605007},"Augeas":{"type":"programming","color":"#9CC134","extensions":[".aug"],"tm_scope":"none","ace_mode":"text","language_id":25},"AutoHotkey":{"type":"programming","color":"#6594b9","aliases":["ahk"],"extensions":[".ahk",".ahkl"],"tm_scope":"source.ahk","ace_mode":"autohotkey","language_id":26},"AutoIt":{"type":"programming","color":"#1C3552","aliases":["au3","AutoIt3","AutoItScript"],"extensions":[".au3"],"tm_scope":"source.autoit","ace_mode":"autohotkey","language_id":27},"Avro IDL":{"type":"data","color":"#0040FF","extensions":[".avdl"],"tm_scope":"source.avro","ace_mode":"text","language_id":785497837},"Awk":{"type":"programming","color":"#c30e9b","extensions":[".awk",".auk",".gawk",".mawk",".nawk"],"interpreters":["awk","gawk","mawk","nawk"],"tm_scope":"source.awk","ace_mode":"text","language_id":28},"B (Formal Method)":{"type":"programming","color":"#8aa8c5","extensions":[".mch"],"tm_scope":"source.b","ace_mode":"text","language_id":700792152},"B4X":{"type":"programming","color":"#00e4ff","extensions":[".bas"],"tm_scope":"source.vba","aliases":["basic for android"],"ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":96642275},"BASIC":{"type":"programming","extensions":[".bas"],"tm_scope":"source.basic","ace_mode":"basic","color":"#ff0000","language_id":28923963},"BQN":{"type":"programming","color":"#2b7067","extensions":[".bqn"],"tm_scope":"source.bqn","ace_mode":"text","language_id":330386870},"Ballerina":{"type":"programming","extensions":[".bal"],"tm_scope":"source.ballerina","ace_mode":"text","color":"#FF5000","language_id":720859680},"Batchfile":{"type":"programming","aliases":["bat","batch","dosbatch","winbatch"],"extensions":[".bat",".cmd"],"filenames":["gradlew.bat","mvnw.cmd"],"tm_scope":"source.batchfile","ace_mode":"batchfile","color":"#C1F12E","language_id":29},"Beef":{"type":"programming","color":"#a52f4e","extensions":[".bf"],"tm_scope":"source.cs","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","language_id":545626333},"Befunge":{"type":"programming","extensions":[".befunge",".bf"],"tm_scope":"source.befunge","ace_mode":"text","language_id":30},"Berry":{"type":"programming","extensions":[".be"],"tm_scope":"source.berry","ace_mode":"text","color":"#15A13C","aliases":["be"],"language_id":121855308},"BibTeX":{"type":"markup","color":"#778899","group":"TeX","extensions":[".bib",".bibtex"],"tm_scope":"text.bibtex","ace_mode":"bibtex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","language_id":982188347},"BibTeX Style":{"type":"programming","extensions":[".bst"],"tm_scope":"source.bst","ace_mode":"text","language_id":909569041},"Bicep":{"type":"programming","color":"#519aba","extensions":[".bicep",".bicepparam"],"tm_scope":"source.bicep","ace_mode":"text","language_id":321200902},"Bikeshed":{"type":"markup","color":"#5562ac","extensions":[".bs"],"tm_scope":"source.csswg","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":1055528081},"Bison":{"type":"programming","color":"#6A463F","group":"Yacc","tm_scope":"source.yacc","extensions":[".bison"],"ace_mode":"text","language_id":31},"BitBake":{"type":"programming","color":"#00bce4","tm_scope":"source.bb","extensions":[".bb",".bbappend",".bbclass",".inc"],"ace_mode":"text","language_id":32},"Blade":{"type":"markup","color":"#f7523f","extensions":[".blade",".blade.php"],"tm_scope":"text.html.php.blade","ace_mode":"php_laravel_blade","language_id":33},"BlitzBasic":{"type":"programming","color":"#00FFAE","aliases":["b3d","blitz3d","blitzplus","bplus"],"extensions":[".bb",".decls"],"tm_scope":"source.blitzmax","ace_mode":"text","language_id":34},"BlitzMax":{"type":"programming","color":"#cd6400","extensions":[".bmx"],"aliases":["bmax"],"tm_scope":"source.blitzmax","ace_mode":"text","language_id":35},"Bluespec":{"type":"programming","color":"#12223c","extensions":[".bsv"],"aliases":["bluespec bsv","bsv"],"tm_scope":"source.bsv","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":36},"Bluespec BH":{"type":"programming","group":"Bluespec","color":"#12223c","extensions":[".bs"],"aliases":["bh","bluespec classic"],"tm_scope":"source.bh","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":641580358},"Boo":{"type":"programming","color":"#d4bec1","extensions":[".boo"],"ace_mode":"text","tm_scope":"source.boo","language_id":37},"Boogie":{"type":"programming","color":"#c80fa0","extensions":[".bpl"],"interpreters":["boogie"],"tm_scope":"source.boogie","ace_mode":"text","language_id":955017407},"Brainfuck":{"type":"programming","color":"#2F2530","extensions":[".b",".bf"],"tm_scope":"source.bf","ace_mode":"text","codemirror_mode":"brainfuck","codemirror_mime_type":"text/x-brainfuck","language_id":38},"BrighterScript":{"type":"programming","color":"#66AABB","extensions":[".bs"],"tm_scope":"source.brs","ace_mode":"text","language_id":943571030},"Brightscript":{"type":"programming","color":"#662D91","extensions":[".brs"],"tm_scope":"source.brs","ace_mode":"text","language_id":39},"Browserslist":{"type":"data","color":"#ffd539","filenames":[".browserslistrc","browserslist"],"tm_scope":"text.browserslist","ace_mode":"text","language_id":153503348},"Bru":{"type":"markup","color":"#F4AA41","extensions":[".bru"],"tm_scope":"source.bru","ace_mode":"text","language_id":906627898},"BuildStream":{"type":"data","color":"#006bff","extensions":[".bst"],"tm_scope":"source.yaml","ace_mode":"yaml","language_id":84359046},"C":{"type":"programming","color":"#555555","extensions":[".c",".cats",".h",".h.in",".idc"],"interpreters":["tcc"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":41},"C#":{"type":"programming","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","color":"#178600","aliases":["csharp","cake","cakescript"],"extensions":[".cs",".cake",".cs.pp",".csx",".linq"],"language_id":42},"C++":{"type":"programming","tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#f34b7d","aliases":["cpp"],"extensions":[".cpp",".c++",".cc",".cp",".cppm",".cxx",".h",".h++",".hh",".hpp",".hxx",".inc",".inl",".ino",".ipp",".ixx",".re",".tcc",".tpp",".txx"],"language_id":43},"C-ObjDump":{"type":"data","extensions":[".c-objdump"],"tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":44},"C2hs Haskell":{"type":"programming","group":"Haskell","aliases":["c2hs"],"extensions":[".chs"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":45},"C3":{"type":"programming","color":"#2563eb","extensions":[".c3"],"tm_scope":"source.c3","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":769248603},"CAP CDS":{"type":"programming","tm_scope":"source.cds","color":"#0092d1","aliases":["cds"],"extensions":[".cds"],"ace_mode":"text","language_id":390788699},"CIL":{"type":"data","tm_scope":"source.cil","extensions":[".cil"],"ace_mode":"text","language_id":29176339},"CLIPS":{"type":"programming","color":"#00A300","extensions":[".clp"],"tm_scope":"source.clips","ace_mode":"text","language_id":46},"CMake":{"type":"programming","color":"#DA3434","extensions":[".cmake",".cmake.in"],"filenames":["CMakeLists.txt"],"tm_scope":"source.cmake","ace_mode":"text","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":47},"COBOL":{"type":"programming","extensions":[".cob",".cbl",".ccp",".cobol",".cpy"],"tm_scope":"source.cobol","ace_mode":"cobol","codemirror_mode":"cobol","codemirror_mime_type":"text/x-cobol","language_id":48},"CODEOWNERS":{"type":"data","filenames":["CODEOWNERS"],"tm_scope":"text.codeowners","ace_mode":"gitignore","language_id":321684729},"COLLADA":{"type":"data","color":"#F1A42B","extensions":[".dae"],"tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":49},"CQL":{"type":"programming","color":"#006091","extensions":[".cql"],"tm_scope":"source.cql","ace_mode":"text","language_id":71155397},"CSON":{"type":"data","color":"#244776","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","extensions":[".cson"],"language_id":424},"CSS":{"type":"markup","tm_scope":"source.css","ace_mode":"css","codemirror_mode":"css","codemirror_mime_type":"text/css","color":"#663399","extensions":[".css"],"language_id":50},"CSV":{"type":"data","color":"#237346","ace_mode":"csv","tm_scope":"source.csv","extensions":[".csv"],"language_id":51},"CUE":{"type":"programming","extensions":[".cue"],"tm_scope":"source.cue","ace_mode":"text","color":"#5886E1","language_id":356063509},"CWeb":{"type":"programming","color":"#00007a","extensions":[".w"],"tm_scope":"none","ace_mode":"text","language_id":657332628},"Cabal Config":{"type":"data","color":"#483465","aliases":["Cabal"],"extensions":[".cabal"],"filenames":["cabal.config","cabal.project"],"ace_mode":"haskell_cabal","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","tm_scope":"source.cabal","language_id":677095381},"Caddyfile":{"type":"data","color":"#22b638","aliases":["Caddy"],"extensions":[".caddyfile"],"filenames":["Caddyfile"],"ace_mode":"text","tm_scope":"source.Caddyfile","language_id":615465151},"Cadence":{"type":"programming","color":"#00ef8b","ace_mode":"text","tm_scope":"source.cadence","extensions":[".cdc"],"language_id":270184138},"Cairo":{"type":"programming","color":"#ff4a48","ace_mode":"text","tm_scope":"source.cairo","extensions":[".cairo"],"group":"Cairo","language_id":620599567},"Cairo Zero":{"type":"programming","color":"#ff4a48","ace_mode":"text","tm_scope":"source.cairo0","extensions":[".cairo"],"group":"Cairo","language_id":891399890},"CameLIGO":{"type":"programming","color":"#3be133","extensions":[".mligo"],"tm_scope":"source.mligo","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","group":"LigoLANG","language_id":829207807},"Cangjie":{"type":"programming","tm_scope":"source.cj","extensions":[".cj"],"color":"#00868B","ace_mode":"swift","codemirror_mode":"swift","codemirror_mime_type":"text/x-swift","language_id":581895317},"Cap'n Proto":{"type":"programming","color":"#c42727","tm_scope":"source.capnp","extensions":[".capnp"],"ace_mode":"text","language_id":52},"Carbon":{"type":"programming","color":"#222222","extensions":[".carbon"],"ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","tm_scope":"source.v","language_id":55627273},"CartoCSS":{"type":"programming","aliases":["Carto"],"extensions":[".mss"],"ace_mode":"text","tm_scope":"source.css.mss","language_id":53},"Ceylon":{"type":"programming","color":"#dfa535","extensions":[".ceylon"],"tm_scope":"source.ceylon","ace_mode":"text","language_id":54},"Chapel":{"type":"programming","color":"#8dc63f","aliases":["chpl"],"extensions":[".chpl"],"tm_scope":"source.chapel","ace_mode":"text","language_id":55},"Charity":{"type":"programming","extensions":[".ch"],"tm_scope":"none","ace_mode":"text","language_id":56},"Checksums":{"type":"data","tm_scope":"text.checksums","aliases":["checksum","hash","hashes","sum","sums"],"filenames":["MD5SUMS","SHA1SUMS","SHA256SUMS","SHA256SUMS.txt","SHA512SUMS","checksums.txt","cksums","md5sum.txt"],"extensions":[".crc32",".md2",".md4",".md5",".sha1",".sha2",".sha224",".sha256",".sha256sum",".sha3",".sha384",".sha512"],"ace_mode":"text","language_id":372063053},"ChucK":{"type":"programming","color":"#3f8000","extensions":[".ck"],"tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":57},"Circom":{"type":"programming","ace_mode":"text","extensions":[".circom"],"color":"#707575","tm_scope":"source.circom","language_id":1042332086},"Cirru":{"type":"programming","color":"#ccccff","tm_scope":"source.cirru","ace_mode":"cirru","extensions":[".cirru"],"language_id":58},"Clarion":{"type":"programming","color":"#db901e","ace_mode":"text","extensions":[".clw"],"tm_scope":"source.clarion","language_id":59},"Clarity":{"type":"programming","color":"#5546ff","ace_mode":"lisp","extensions":[".clar"],"tm_scope":"source.clar","language_id":91493841},"Classic ASP":{"type":"programming","color":"#6a40fd","tm_scope":"text.html.asp","aliases":["asp"],"extensions":[".asp"],"ace_mode":"text","language_id":8},"Clean":{"type":"programming","color":"#3F85AF","extensions":[".icl",".dcl"],"tm_scope":"source.clean","ace_mode":"text","language_id":60},"Click":{"type":"programming","color":"#E4E6F3","extensions":[".click"],"tm_scope":"source.click","ace_mode":"text","language_id":61},"Clojure":{"type":"programming","tm_scope":"source.clojure","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#db5855","extensions":[".clj",".bb",".boot",".cl2",".cljc",".cljs",".cljs.hl",".cljscm",".cljx",".hic"],"filenames":["riemann.config"],"interpreters":["bb"],"language_id":62},"Closure Templates":{"type":"markup","color":"#0d948f","ace_mode":"soy_template","codemirror_mode":"soy","codemirror_mime_type":"text/x-soy","aliases":["soy"],"extensions":[".soy"],"tm_scope":"text.html.soy","language_id":357046146},"Cloud Firestore Security Rules":{"type":"data","color":"#FFA000","ace_mode":"less","codemirror_mode":"css","codemirror_mime_type":"text/css","tm_scope":"source.firestore","filenames":["firestore.rules"],"language_id":407996372},"Clue":{"type":"programming","color":"#0009b5","extensions":[".clue"],"tm_scope":"source.clue","ace_mode":"text","language_id":163763508},"CoNLL-U":{"type":"data","extensions":[".conllu",".conll"],"tm_scope":"text.conllu","ace_mode":"text","aliases":["CoNLL","CoNLL-X"],"language_id":421026389},"CodeQL":{"type":"programming","color":"#140f46","extensions":[".ql",".qll"],"tm_scope":"source.ql","ace_mode":"text","language_id":424259634,"aliases":["ql"]},"CoffeeScript":{"type":"programming","tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","color":"#244776","aliases":["coffee","coffee-script"],"extensions":[".coffee","._coffee",".cake",".cjsx",".iced"],"filenames":["Cakefile"],"interpreters":["coffee"],"language_id":63},"ColdFusion":{"type":"programming","ace_mode":"coldfusion","color":"#ed2cd6","aliases":["cfm","cfml","coldfusion html"],"extensions":[".cfm",".cfml"],"tm_scope":"text.html.cfm","language_id":64},"ColdFusion CFC":{"type":"programming","color":"#ed2cd6","group":"ColdFusion","ace_mode":"coldfusion","aliases":["cfc"],"extensions":[".cfc"],"tm_scope":"source.cfscript","language_id":65},"Common Lisp":{"type":"programming","tm_scope":"source.commonlisp","color":"#3fb68b","aliases":["lisp"],"extensions":[".lisp",".asd",".cl",".l",".lsp",".ny",".podsl",".sexp"],"interpreters":["lisp","sbcl","ccl","clisp","ecl"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":66},"Common Workflow Language":{"aliases":["cwl"],"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","extensions":[".cwl"],"interpreters":["cwl-runner"],"color":"#B5314C","tm_scope":"source.cwl","language_id":988547172},"Component Pascal":{"type":"programming","color":"#B0CE4E","extensions":[".cp",".cps"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":67},"Cooklang":{"type":"markup","color":"#E15A29","wrap":true,"extensions":[".cook"],"ace_mode":"text","tm_scope":"source.cooklang","language_id":788037493},"Cool":{"type":"programming","extensions":[".cl"],"tm_scope":"source.cool","ace_mode":"text","language_id":68},"Cpp-ObjDump":{"type":"data","extensions":[".cppobjdump",".c++-objdump",".c++objdump",".cpp-objdump",".cxx-objdump"],"tm_scope":"objdump.x86asm","aliases":["c++-objdump"],"ace_mode":"assembly_x86","language_id":70},"Creole":{"type":"prose","wrap":true,"extensions":[".creole"],"tm_scope":"text.html.creole","ace_mode":"text","language_id":71},"Crystal":{"type":"programming","color":"#000100","extensions":[".cr"],"ace_mode":"crystal","codemirror_mode":"crystal","codemirror_mime_type":"text/x-crystal","tm_scope":"source.crystal","interpreters":["crystal"],"language_id":72},"Csound":{"type":"programming","color":"#1a1a1a","aliases":["csound-orc"],"extensions":[".orc",".udo"],"tm_scope":"source.csound","ace_mode":"csound_orchestra","language_id":73},"Csound Document":{"type":"programming","color":"#1a1a1a","aliases":["csound-csd"],"extensions":[".csd"],"tm_scope":"source.csound-document","ace_mode":"csound_document","language_id":74},"Csound Score":{"type":"programming","color":"#1a1a1a","aliases":["csound-sco"],"extensions":[".sco"],"tm_scope":"source.csound-score","ace_mode":"csound_score","language_id":75},"Cuda":{"type":"programming","extensions":[".cu",".cuh"],"tm_scope":"source.cuda-c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","color":"#3A4E3A","language_id":77},"Cue Sheet":{"type":"data","extensions":[".cue"],"tm_scope":"source.cuesheet","ace_mode":"text","language_id":942714150},"Curry":{"type":"programming","color":"#531242","extensions":[".curry"],"tm_scope":"source.curry","ace_mode":"haskell","language_id":439829048},"Cycript":{"type":"programming","extensions":[".cy"],"tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","language_id":78},"Cylc":{"type":"data","color":"#00b3fd","extensions":[".cylc"],"filenames":["suite.rc"],"tm_scope":"source.cylc","ace_mode":"ini","group":"INI","language_id":476447814},"Cypher":{"type":"programming","color":"#34c0eb","extensions":[".cyp",".cypher"],"tm_scope":"source.cypher","codemirror_mode":"cypher","codemirror_mime_type":"application/x-cypher-query","ace_mode":"text","language_id":850806976},"Cython":{"type":"programming","color":"#fedf5b","extensions":[".pyx",".pxd",".pxi"],"aliases":["pyrex"],"tm_scope":"source.cython","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-cython","language_id":79},"D":{"type":"programming","color":"#ba595e","aliases":["Dlang"],"extensions":[".d",".di"],"tm_scope":"source.d","ace_mode":"d","codemirror_mode":"d","codemirror_mime_type":"text/x-d","language_id":80},"D-ObjDump":{"type":"data","extensions":[".d-objdump"],"tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":81},"D2":{"type":"markup","color":"#526ee8","extensions":[".d2"],"aliases":["d2lang"],"tm_scope":"source.d2","ace_mode":"text","language_id":37531557},"DIGITAL Command Language":{"type":"programming","aliases":["dcl"],"extensions":[".com"],"tm_scope":"none","ace_mode":"text","language_id":82},"DM":{"type":"programming","color":"#447265","extensions":[".dm"],"aliases":["byond"],"tm_scope":"source.dm","ace_mode":"c_cpp","language_id":83},"DNS Zone":{"type":"data","extensions":[".zone",".arpa"],"tm_scope":"text.zone_file","ace_mode":"text","language_id":84},"DTrace":{"type":"programming","aliases":["dtrace-script"],"extensions":[".d"],"interpreters":["dtrace"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":85},"Dafny":{"type":"programming","color":"#FFEC25","extensions":[".dfy"],"interpreters":["dafny"],"tm_scope":"text.dfy.dafny","ace_mode":"text","language_id":969323346},"Darcs Patch":{"type":"data","color":"#8eff23","aliases":["dpatch"],"extensions":[".darcspatch",".dpatch"],"tm_scope":"none","ace_mode":"text","language_id":86},"Dart":{"type":"programming","color":"#00B4AB","extensions":[".dart"],"interpreters":["dart"],"tm_scope":"source.dart","ace_mode":"dart","codemirror_mode":"dart","codemirror_mime_type":"application/dart","language_id":87},"Daslang":{"type":"programming","color":"#d3d3d3","extensions":[".das"],"tm_scope":"source.daslang","ace_mode":"text","language_id":648759486},"DataWeave":{"type":"programming","color":"#003a52","extensions":[".dwl"],"ace_mode":"text","tm_scope":"source.data-weave","language_id":974514097},"Debian Package Control File":{"type":"data","color":"#D70751","extensions":[".dsc"],"tm_scope":"source.deb-control","ace_mode":"text","language_id":527438264},"DenizenScript":{"type":"programming","color":"#FBEE96","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","extensions":[".dsc"],"tm_scope":"source.denizenscript","language_id":435000929},"Dhall":{"type":"programming","color":"#dfafff","extensions":[".dhall"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":793969321},"Diff":{"type":"data","extensions":[".diff",".patch"],"aliases":["udiff"],"tm_scope":"source.diff","ace_mode":"diff","codemirror_mode":"diff","codemirror_mime_type":"text/x-diff","language_id":88},"DirectX 3D File":{"type":"data","color":"#aace60","extensions":[".x"],"ace_mode":"text","tm_scope":"none","language_id":201049282},"Dockerfile":{"type":"programming","aliases":["Containerfile"],"color":"#384d54","tm_scope":"source.dockerfile","extensions":[".dockerfile",".containerfile"],"filenames":["Containerfile","Dockerfile"],"ace_mode":"dockerfile","codemirror_mode":"dockerfile","codemirror_mime_type":"text/x-dockerfile","language_id":89},"Dogescript":{"type":"programming","color":"#cca760","extensions":[".djs"],"tm_scope":"none","ace_mode":"text","language_id":90},"Dotenv":{"type":"data","color":"#e5d559","extensions":[".env"],"filenames":[".env",".env.ci",".env.dev",".env.development",".env.development.local",".env.example",".env.local",".env.prod",".env.production",".env.sample",".env.staging",".env.template",".env.test",".env.testing"],"tm_scope":"source.dotenv","ace_mode":"text","language_id":111148035},"Dune":{"type":"programming","ace_mode":"lisp","filenames":["dune-project"],"tm_scope":"source.dune","color":"#89421e","language_id":754574151},"Dylan":{"type":"programming","color":"#6c616e","extensions":[".dylan",".dyl",".intr",".lid"],"tm_scope":"source.dylan","ace_mode":"text","codemirror_mode":"dylan","codemirror_mime_type":"text/x-dylan","language_id":91},"E":{"type":"programming","color":"#ccce35","extensions":[".e"],"interpreters":["rune"],"tm_scope":"none","ace_mode":"text","language_id":92},"E-mail":{"type":"data","aliases":["email","eml","mail","mbox"],"extensions":[".eml",".mbox"],"tm_scope":"text.eml.basic","ace_mode":"text","codemirror_mode":"mbox","codemirror_mime_type":"application/mbox","language_id":529653389},"EBNF":{"type":"data","extensions":[".ebnf"],"tm_scope":"source.ebnf","ace_mode":"text","codemirror_mode":"ebnf","codemirror_mime_type":"text/x-ebnf","language_id":430},"ECL":{"type":"programming","color":"#8a1267","extensions":[".ecl",".eclxml"],"tm_scope":"source.ecl","ace_mode":"text","codemirror_mode":"ecl","codemirror_mime_type":"text/x-ecl","language_id":93},"ECLiPSe":{"type":"programming","color":"#001d9d","group":"Prolog","extensions":[".ecl"],"tm_scope":"source.prolog.eclipse","ace_mode":"prolog","language_id":94},"EJS":{"type":"markup","color":"#a91e50","extensions":[".ejs",".ect",".ejs.t",".jst"],"tm_scope":"text.html.js","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-ejs","ace_mode":"ejs","language_id":95},"EQ":{"type":"programming","color":"#a78649","extensions":[".eq"],"tm_scope":"source.cs","ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","language_id":96},"Eagle":{"type":"data","extensions":[".sch",".brd"],"tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":97},"Earthly":{"type":"programming","aliases":["Earthfile"],"color":"#2af0ff","tm_scope":"source.earthfile","ace_mode":"text","filenames":["Earthfile"],"language_id":963512632},"Easybuild":{"type":"data","color":"#069406","group":"Python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","tm_scope":"source.python","extensions":[".eb"],"language_id":342840477},"Ecere Projects":{"type":"data","color":"#913960","group":"JavaScript","extensions":[".epj"],"tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":98},"Ecmarkup":{"type":"markup","color":"#eb8131","group":"HTML","extensions":[".html"],"tm_scope":"text.html.ecmarkup","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","aliases":["ecmarkdown"],"language_id":844766630},"Edge":{"type":"markup","color":"#0dffe0","extensions":[".edge"],"tm_scope":"text.html.edge","ace_mode":"html","language_id":460509620},"EdgeQL":{"type":"programming","color":"#31A7FF","aliases":["esdl"],"extensions":[".edgeql",".esdl"],"ace_mode":"text","tm_scope":"source.edgeql","language_id":925235833},"EditorConfig":{"type":"data","color":"#fff1f2","group":"INI","extensions":[".editorconfig"],"filenames":[".editorconfig"],"aliases":["editor-config"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.editorconfig","language_id":96139566},"Edje Data Collection":{"type":"data","extensions":[".edc"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":342840478},"Eiffel":{"type":"programming","color":"#4d6977","extensions":[".e"],"tm_scope":"source.eiffel","ace_mode":"eiffel","codemirror_mode":"eiffel","codemirror_mime_type":"text/x-eiffel","language_id":99},"Elixir":{"type":"programming","color":"#6e4a7e","extensions":[".ex",".exs"],"tm_scope":"source.elixir","ace_mode":"elixir","filenames":["mix.lock"],"interpreters":["elixir"],"language_id":100},"Elm":{"type":"programming","color":"#60B5CC","extensions":[".elm"],"tm_scope":"source.elm","ace_mode":"elm","codemirror_mode":"elm","codemirror_mime_type":"text/x-elm","language_id":101},"Elvish":{"type":"programming","ace_mode":"text","extensions":[".elv"],"interpreters":["elvish"],"tm_scope":"source.elvish","color":"#55BB55","language_id":570996448},"Elvish Transcript":{"type":"programming","group":"Elvish","ace_mode":"text","tm_scope":"source.elvish-transcript","color":"#55BB55","language_id":452025714},"Emacs Lisp":{"type":"programming","tm_scope":"source.emacs.lisp","color":"#c065db","aliases":["cask","eask","elisp","emacs"],"filenames":[".abbrev_defs",".emacs",".emacs.desktop",".gnus",".spacemacs",".viper","Cask","Eask","Project.ede","_emacs","abbrev_defs"],"extensions":[".el",".emacs",".emacs.desktop"],"ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":102},"EmberScript":{"type":"programming","color":"#FFF4F3","extensions":[".em",".emberscript"],"tm_scope":"source.coffee","ace_mode":"coffee","codemirror_mode":"coffeescript","codemirror_mime_type":"text/x-coffeescript","language_id":103},"Erlang":{"type":"programming","color":"#B83998","extensions":[".erl",".app",".app.src",".es",".escript",".hrl",".xrl",".yrl"],"filenames":["Emakefile","rebar.config","rebar.config.lock","rebar.lock"],"tm_scope":"source.erlang","ace_mode":"erlang","codemirror_mode":"erlang","codemirror_mime_type":"text/x-erlang","interpreters":["escript"],"language_id":104},"Euphoria":{"type":"programming","color":"#FF790B","extensions":[".e",".ex"],"interpreters":["eui","euiw"],"ace_mode":"text","tm_scope":"source.euphoria","language_id":880693982},"F#":{"type":"programming","color":"#b845fc","aliases":["fsharp"],"extensions":[".fs",".fsi",".fsx"],"tm_scope":"source.fsharp","ace_mode":"fsharp","codemirror_mode":"mllike","codemirror_mime_type":"text/x-fsharp","language_id":105},"F*":{"fs_name":"Fstar","type":"programming","color":"#572e30","aliases":["fstar"],"extensions":[".fst",".fsti"],"tm_scope":"source.fstar","ace_mode":"text","language_id":336943375},"FIGlet Font":{"type":"data","color":"#FFDDBB","aliases":["FIGfont"],"extensions":[".flf"],"tm_scope":"source.figfont","ace_mode":"text","language_id":686129783},"FIRRTL":{"type":"programming","color":"#2f632f","extensions":[".fir"],"tm_scope":"source.firrtl","ace_mode":"text","language_id":906694254},"FLUX":{"type":"programming","color":"#88ccff","extensions":[".fx",".flux"],"tm_scope":"none","ace_mode":"text","language_id":106},"Factor":{"type":"programming","color":"#636746","extensions":[".factor"],"filenames":[".factor-boot-rc",".factor-rc"],"tm_scope":"source.factor","ace_mode":"text","codemirror_mode":"factor","codemirror_mime_type":"text/x-factor","language_id":108},"Fancy":{"type":"programming","color":"#7b9db4","extensions":[".fy",".fancypack"],"filenames":["Fakefile"],"tm_scope":"source.fancy","ace_mode":"text","language_id":109},"Fantom":{"type":"programming","color":"#14253c","extensions":[".fan"],"tm_scope":"source.fan","ace_mode":"text","language_id":110},"Faust":{"type":"programming","color":"#c37240","extensions":[".dsp"],"tm_scope":"source.faust","ace_mode":"text","language_id":622529198},"Fennel":{"type":"programming","tm_scope":"source.fnl","ace_mode":"text","color":"#fff3d7","interpreters":["fennel"],"extensions":[".fnl"],"language_id":239946126},"Filebench WML":{"type":"programming","color":"#F6B900","extensions":[".f"],"tm_scope":"none","ace_mode":"text","language_id":111},"Filterscript":{"type":"programming","group":"RenderScript","extensions":[".fs"],"tm_scope":"none","ace_mode":"text","language_id":112},"FlatBuffers":{"type":"data","color":"#ed284a","extensions":[".fbs"],"tm_scope":"source.flatbuffers","ace_mode":"text","language_id":577640576},"Flix":{"type":"programming","color":"#d44a45","extensions":[".flix"],"tm_scope":"source.flix","ace_mode":"flix","language_id":800935960},"Fluent":{"type":"programming","color":"#ffcc33","extensions":[".ftl"],"tm_scope":"source.ftl","ace_mode":"text","language_id":206353404},"Formatted":{"type":"data","extensions":[".for",".eam.fs"],"tm_scope":"none","ace_mode":"text","language_id":113},"Forth":{"type":"programming","color":"#341708","extensions":[".fth",".4th",".f",".for",".forth",".fr",".frt",".fs"],"tm_scope":"source.forth","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":114},"Fortran":{"group":"Fortran","type":"programming","color":"#4d41b1","extensions":[".f",".f77",".for",".fpp"],"tm_scope":"source.fortran","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":107},"Fortran Free Form":{"group":"Fortran","color":"#4d41b1","type":"programming","extensions":[".f90",".f03",".f08",".f95"],"tm_scope":"source.fortran.modern","ace_mode":"fortran","codemirror_mode":"fortran","codemirror_mime_type":"text/x-fortran","language_id":761352333},"FreeBASIC":{"type":"programming","color":"#141AC9","extensions":[".bi",".bas"],"tm_scope":"source.vbnet","aliases":["fb"],"ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":472896659},"FreeMarker":{"type":"programming","color":"#0050b2","aliases":["ftl"],"extensions":[".ftl",".ftlh"],"tm_scope":"text.html.ftl","ace_mode":"ftl","language_id":115},"Frege":{"type":"programming","color":"#00cafe","extensions":[".fr"],"tm_scope":"source.haskell","ace_mode":"haskell","language_id":116},"Futhark":{"type":"programming","color":"#5f021f","extensions":[".fut"],"tm_scope":"source.futhark","ace_mode":"text","language_id":97358117},"G-code":{"type":"programming","color":"#D08CF2","extensions":[".g",".cnc",".gco",".gcode"],"tm_scope":"source.gcode","ace_mode":"gcode","language_id":117},"GAML":{"type":"programming","color":"#FFC766","extensions":[".gaml"],"tm_scope":"none","ace_mode":"text","language_id":290345951},"GAMS":{"type":"programming","color":"#f49a22","extensions":[".gms"],"tm_scope":"none","ace_mode":"text","language_id":118},"GAP":{"type":"programming","color":"#0000cc","extensions":[".g",".gap",".gd",".gi",".tst"],"tm_scope":"source.gap","ace_mode":"text","language_id":119},"GCC Machine Description":{"type":"programming","color":"#FFCFAB","extensions":[".md"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":121},"GDB":{"type":"programming","extensions":[".gdb",".gdbinit"],"tm_scope":"source.gdb","ace_mode":"text","language_id":122},"GDScript":{"type":"programming","color":"#355570","extensions":[".gd"],"tm_scope":"source.gdscript","ace_mode":"text","language_id":123},"GDShader":{"type":"programming","color":"#478CBF","extensions":[".gdshader",".gdshaderinc"],"tm_scope":"source.gdshader","ace_mode":"glsl","language_id":694638086},"GEDCOM":{"type":"data","color":"#003058","ace_mode":"text","extensions":[".ged"],"tm_scope":"source.gedcom","language_id":459577965},"GLSL":{"type":"programming","color":"#5686a5","extensions":[".glsl",".fp",".frag",".frg",".fs",".fsh",".fshader",".geo",".geom",".glslf",".glslv",".gs",".gshader",".rchit",".rmiss",".shader",".tesc",".tese",".vert",".vrx",".vs",".vsh",".vshader"],"tm_scope":"source.glsl","ace_mode":"glsl","language_id":124},"GN":{"type":"data","extensions":[".gn",".gni"],"interpreters":["gn"],"filenames":[".gn"],"tm_scope":"source.gn","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":302957008},"GSC":{"type":"programming","color":"#FF6800","extensions":[".gsc",".csc",".gsh"],"tm_scope":"source.gsc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":257856279},"Game Maker Language":{"type":"programming","color":"#71b417","extensions":[".gml"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":125},"Gemfile.lock":{"type":"data","color":"#701516","searchable":false,"tm_scope":"source.gemfile-lock","ace_mode":"text","filenames":["Gemfile.lock"],"language_id":907065713},"Gemini":{"type":"prose","color":"#ff6900","ace_mode":"text","extensions":[".gmi"],"aliases":["gemtext"],"wrap":true,"tm_scope":"source.gemini","language_id":310828396},"Genero 4gl":{"type":"programming","color":"#63408e","extensions":[".4gl"],"tm_scope":"source.genero-4gl","ace_mode":"text","language_id":986054050},"Genero per":{"type":"markup","color":"#d8df39","extensions":[".per"],"tm_scope":"source.genero-per","ace_mode":"text","language_id":902995658},"Genie":{"type":"programming","ace_mode":"text","extensions":[".gs"],"color":"#fb855d","tm_scope":"none","language_id":792408528},"Genshi":{"type":"programming","color":"#951531","extensions":[".kid"],"tm_scope":"text.xml.genshi","aliases":["xml+genshi","xml+kid"],"ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":126},"Gentoo Ebuild":{"type":"programming","color":"#9400ff","group":"Shell","extensions":[".ebuild"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":127},"Gentoo Eclass":{"type":"programming","color":"#9400ff","group":"Shell","extensions":[".eclass"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":128},"Gerber Image":{"type":"data","color":"#d20b00","aliases":["rs-274x"],"extensions":[".gbr",".cmp",".gbl",".gbo",".gbp",".gbs",".gko",".gml",".gpb",".gpt",".gtl",".gto",".gtp",".gts",".ncl",".sol"],"interpreters":["gerbv","gerbview"],"tm_scope":"source.gerber","ace_mode":"text","language_id":404627610},"Gettext Catalog":{"type":"prose","aliases":["pot"],"extensions":[".po",".pot"],"tm_scope":"source.po","ace_mode":"text","language_id":129},"Gherkin":{"type":"programming","extensions":[".feature",".story"],"tm_scope":"text.gherkin.feature","codemirror_mode":"gherkin","codemirror_mime_type":"text/x-feature","aliases":["cucumber"],"ace_mode":"gherkin","color":"#5B2063","language_id":76},"Git Attributes":{"type":"data","color":"#F44D27","aliases":["gitattributes"],"filenames":[".gitattributes"],"tm_scope":"source.gitattributes","ace_mode":"gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":956324166},"Git Commit":{"type":"data","color":"#F44D27","aliases":["commit"],"filenames":["COMMIT_EDITMSG"],"ace_mode":"text","tm_scope":"text.git-commit","wrap":true,"language_id":131750475},"Git Config":{"type":"data","color":"#F44D27","group":"INI","aliases":["gitconfig","gitmodules"],"extensions":[".gitconfig"],"filenames":[".gitconfig",".gitmodules"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.gitconfig","language_id":807968997},"Git Revision List":{"type":"data","color":"#F44D27","aliases":["Git Blame Ignore Revs"],"filenames":[".git-blame-ignore-revs"],"tm_scope":"source.git-revlist","ace_mode":"text","language_id":461881235},"Gleam":{"type":"programming","color":"#ffaff3","ace_mode":"text","extensions":[".gleam"],"tm_scope":"source.gleam","language_id":1054258749},"Glimmer JS":{"type":"programming","aliases":["gjs"],"extensions":[".gjs"],"ace_mode":"javascript","color":"#F5835F","tm_scope":"source.gjs","group":"JavaScript","language_id":5523150},"Glimmer TS":{"type":"programming","aliases":["gts"],"extensions":[".gts"],"ace_mode":"typescript","color":"#3178c6","tm_scope":"source.gts","group":"TypeScript","language_id":95110458},"Glyph":{"type":"programming","color":"#c1ac7f","extensions":[".glf"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":130},"Glyph Bitmap Distribution Format":{"type":"data","extensions":[".bdf"],"tm_scope":"source.bdf","ace_mode":"text","language_id":997665271},"Gnuplot":{"type":"programming","color":"#f0a9f0","extensions":[".gp",".gnu",".gnuplot",".p",".plot",".plt"],"interpreters":["gnuplot"],"tm_scope":"source.gnuplot","ace_mode":"text","language_id":131},"Go":{"type":"programming","color":"#00ADD8","aliases":["golang"],"extensions":[".go"],"tm_scope":"source.go","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","language_id":132},"Go Checksums":{"type":"data","color":"#00ADD8","aliases":["go.sum","go sum","go.work.sum","go work sum"],"filenames":["go.sum","go.work.sum"],"tm_scope":"go.sum","ace_mode":"text","language_id":1054391671},"Go Module":{"type":"data","color":"#00ADD8","aliases":["go.mod","go mod"],"filenames":["go.mod"],"tm_scope":"go.mod","ace_mode":"text","language_id":947461016},"Go Template":{"type":"markup","color":"#00ADD8","aliases":["gotmpl"],"extensions":[".gohtml",".gotmpl",".html.tmpl",".tmpl",".tpl"],"filenames":["_helpers.tpl"],"tm_scope":"source.go-template","ace_mode":"text","language_id":247918769},"Go Workspace":{"type":"data","color":"#00ADD8","aliases":["go.work","go work"],"filenames":["go.work"],"tm_scope":"go.mod","ace_mode":"text","language_id":934546256},"Godot Resource":{"type":"data","color":"#355570","extensions":[".gdnlib",".gdns",".tres",".tscn"],"filenames":["project.godot"],"tm_scope":"source.gdresource","ace_mode":"text","language_id":738107771},"Golo":{"type":"programming","color":"#88562A","extensions":[".golo"],"tm_scope":"source.golo","ace_mode":"text","language_id":133},"Gosu":{"type":"programming","color":"#82937f","extensions":[".gs",".gst",".gsx",".vark"],"tm_scope":"source.gosu.2","ace_mode":"text","language_id":134},"Grace":{"type":"programming","color":"#615f8b","extensions":[".grace"],"tm_scope":"source.grace","ace_mode":"text","language_id":135},"Gradle":{"type":"data","color":"#02303a","extensions":[".gradle"],"tm_scope":"source.groovy.gradle","ace_mode":"text","language_id":136},"Gradle Kotlin DSL":{"group":"Gradle","type":"data","color":"#02303a","extensions":[".gradle.kts"],"ace_mode":"text","tm_scope":"source.kotlin","language_id":432600901},"Grammatical Framework":{"type":"programming","aliases":["gf"],"extensions":[".gf"],"color":"#ff0000","tm_scope":"source.gf","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":137},"Graph Modeling Language":{"type":"data","extensions":[".gml"],"tm_scope":"none","ace_mode":"text","language_id":138},"GraphQL":{"type":"data","color":"#e10098","extensions":[".graphql",".gql",".graphqls"],"tm_scope":"source.graphql","ace_mode":"graphqlschema","language_id":139},"Graphviz (DOT)":{"type":"data","color":"#2596be","tm_scope":"source.dot","extensions":[".dot",".gv"],"ace_mode":"dot","language_id":140},"Groovy":{"type":"programming","tm_scope":"source.groovy","ace_mode":"groovy","codemirror_mode":"groovy","codemirror_mime_type":"text/x-groovy","color":"#4298b8","extensions":[".groovy",".grt",".gtpl",".gvy"],"interpreters":["groovy"],"filenames":["Jenkinsfile"],"language_id":142},"Groovy Server Pages":{"type":"programming","color":"#4298b8","group":"Groovy","aliases":["gsp","java server page"],"extensions":[".gsp"],"tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":143},"HAProxy":{"type":"data","color":"#106da9","extensions":[".cfg"],"filenames":["haproxy.cfg"],"tm_scope":"source.haproxy-config","ace_mode":"text","language_id":366607477},"HCL":{"type":"programming","color":"#844FBA","extensions":[".hcl",".nomad",".tf",".tfvars",".tofu",".workflow"],"aliases":["HashiCorp Configuration Language","opentofu","terraform"],"ace_mode":"terraform","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","tm_scope":"source.hcl","language_id":144},"HIP":{"type":"programming","color":"#4F3A4F","extensions":[".hip"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":674379998},"HLSL":{"type":"programming","color":"#aace60","extensions":[".hlsl",".cginc",".fx",".fxh",".hlsli"],"ace_mode":"text","tm_scope":"source.hlsl","language_id":145},"HOCON":{"type":"data","color":"#9ff8ee","extensions":[".hocon"],"filenames":[".scalafix.conf",".scalafmt.conf"],"tm_scope":"source.hocon","ace_mode":"text","language_id":679725279},"HTML":{"type":"markup","tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","color":"#e34c26","aliases":["xhtml"],"extensions":[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],"language_id":146},"HTML+ECR":{"type":"markup","color":"#2e1052","tm_scope":"text.html.ecr","group":"HTML","aliases":["ecr"],"extensions":[".ecr"],"ace_mode":"html_ruby","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":148},"HTML+EEX":{"type":"markup","color":"#6e4a7e","tm_scope":"text.html.elixir","group":"HTML","aliases":["eex","heex","leex"],"extensions":[".html.eex",".heex",".leex"],"ace_mode":"html_elixir","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":149},"HTML+ERB":{"type":"markup","color":"#701516","tm_scope":"text.html.erb","group":"HTML","aliases":["erb","rhtml","html+ruby"],"extensions":[".erb",".erb.deface",".rhtml"],"ace_mode":"html_ruby","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-erb","language_id":150},"HTML+PHP":{"type":"markup","color":"#4f5d95","tm_scope":"text.html.php","group":"HTML","extensions":[".phtml"],"ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","language_id":151},"HTML+Razor":{"type":"markup","color":"#512be4","tm_scope":"text.html.cshtml","group":"HTML","aliases":["razor"],"extensions":[".cshtml",".razor"],"ace_mode":"razor","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":479039817},"HTTP":{"type":"data","color":"#005C9C","extensions":[".http"],"tm_scope":"source.httpspec","ace_mode":"text","codemirror_mode":"http","codemirror_mime_type":"message/http","language_id":152},"HXML":{"type":"data","color":"#f68712","ace_mode":"text","extensions":[".hxml"],"tm_scope":"source.hxml","codemirror_mode":"haxe","codemirror_mime_type":"text/x-hxml","language_id":786683730},"Hack":{"type":"programming","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","extensions":[".hack",".hh",".hhi",".php"],"tm_scope":"source.hack","color":"#878787","language_id":153},"Haml":{"type":"markup","color":"#ece2a9","extensions":[".haml",".haml.deface"],"tm_scope":"text.haml","ace_mode":"haml","codemirror_mode":"haml","codemirror_mime_type":"text/x-haml","language_id":154},"Handlebars":{"type":"markup","color":"#f7931e","aliases":["hbs","htmlbars"],"extensions":[".handlebars",".hbs"],"tm_scope":"text.html.handlebars","ace_mode":"handlebars","language_id":155},"Harbour":{"type":"programming","color":"#0e60e3","extensions":[".hb"],"tm_scope":"source.harbour","ace_mode":"text","language_id":156},"Hare":{"type":"programming","color":"#9d7424","extensions":[".ha"],"ace_mode":"text","language_id":463518941,"tm_scope":"none"},"Haskell":{"type":"programming","color":"#5e5086","extensions":[".hs",".hs-boot",".hsc"],"interpreters":["runghc","runhaskell","runhugs"],"tm_scope":"source.haskell","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":157},"Haxe":{"type":"programming","ace_mode":"haxe","codemirror_mode":"haxe","codemirror_mime_type":"text/x-haxe","color":"#df7900","extensions":[".hx",".hxsl"],"tm_scope":"source.hx","language_id":158},"HiveQL":{"type":"programming","extensions":[".q",".hql"],"color":"#dce200","tm_scope":"source.hql","ace_mode":"sql","language_id":931814087},"HolyC":{"type":"programming","color":"#ffefaf","extensions":[".hc"],"tm_scope":"source.hc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":928121743},"Hosts File":{"type":"data","color":"#308888","filenames":["HOSTS","hosts","hosts.txt"],"aliases":["hosts"],"tm_scope":"source.hosts","ace_mode":"text","language_id":231021894},"Hurl":{"type":"programming","color":"#FF0288","extensions":[".hurl"],"tm_scope":"source.hurl","ace_mode":"text","language_id":959040217},"Hy":{"type":"programming","ace_mode":"text","color":"#7790B2","extensions":[".hy"],"interpreters":["hy"],"aliases":["hylang"],"tm_scope":"source.hy","language_id":159},"HyPhy":{"type":"programming","ace_mode":"text","extensions":[".bf"],"tm_scope":"none","language_id":160},"IDL":{"type":"programming","color":"#a3522f","extensions":[".pro",".dlm"],"tm_scope":"source.idl","ace_mode":"text","codemirror_mode":"idl","codemirror_mime_type":"text/x-idl","language_id":161},"IGOR Pro":{"type":"programming","color":"#0000cc","extensions":[".ipf"],"aliases":["igor","igorpro"],"tm_scope":"source.igor","ace_mode":"text","language_id":162},"INI":{"type":"data","color":"#d1dbe0","extensions":[".ini",".cfg",".cnf",".dof",".frm",".lektorproject",".prefs",".pro",".properties",".url"],"filenames":[".buckconfig",".coveragerc",".flake8",".pylintrc","HOSTS","buildozer.spec","hosts","pylintrc","vlcrc"],"tm_scope":"source.ini","aliases":["dosini"],"ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":163},"IRC log":{"type":"data","aliases":["irc","irc logs"],"extensions":[".irclog",".weechatlog"],"tm_scope":"none","ace_mode":"text","codemirror_mode":"mirc","codemirror_mime_type":"text/mirc","language_id":164},"ISPC":{"type":"programming","color":"#2D68B1","extensions":[".ispc"],"tm_scope":"source.ispc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":327071},"Idris":{"type":"programming","color":"#b30000","extensions":[".idr",".lidr"],"ace_mode":"text","tm_scope":"source.idris","language_id":165},"Ignore List":{"type":"data","color":"#000000","aliases":["ignore","gitignore","git-ignore"],"extensions":[".gitignore"],"filenames":[".atomignore",".babelignore",".bzrignore",".coffeelintignore",".cvsignore",".dockerignore",".easignore",".eleventyignore",".eslintignore",".gitignore",".ignore",".markdownlintignore",".nodemonignore",".npmignore",".prettierignore",".stylelintignore",".vercelignore",".vscodeignore","gitignore-global","gitignore_global"],"ace_mode":"gitignore","tm_scope":"source.gitignore","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":74444240},"ImageJ Macro":{"type":"programming","color":"#99AAFF","aliases":["ijm"],"extensions":[".ijm"],"ace_mode":"text","tm_scope":"none","language_id":575143428},"Imba":{"type":"programming","color":"#16cec6","extensions":[".imba"],"ace_mode":"text","tm_scope":"source.imba","language_id":1057618448},"Inform 7":{"type":"programming","wrap":true,"extensions":[".ni",".i7x"],"tm_scope":"source.inform7","aliases":["i7","inform7"],"ace_mode":"text","language_id":166},"Ink":{"type":"programming","wrap":true,"extensions":[".ink"],"tm_scope":"source.ink","ace_mode":"text","language_id":838252715},"Inno Setup":{"type":"programming","color":"#264b99","extensions":[".iss",".isl"],"tm_scope":"source.inno","ace_mode":"text","language_id":167},"Io":{"type":"programming","color":"#a9188d","extensions":[".io"],"interpreters":["io"],"tm_scope":"source.io","ace_mode":"io","language_id":168},"Ioke":{"type":"programming","color":"#078193","extensions":[".ik"],"interpreters":["ioke"],"tm_scope":"source.ioke","ace_mode":"text","language_id":169},"Isabelle":{"type":"programming","color":"#FEFE00","extensions":[".thy"],"tm_scope":"source.isabelle.theory","ace_mode":"text","language_id":170},"Isabelle ROOT":{"type":"programming","color":"#FEFE00","group":"Isabelle","filenames":["ROOT"],"tm_scope":"source.isabelle.root","ace_mode":"text","language_id":171},"J":{"type":"programming","color":"#9EEDFF","extensions":[".ijs"],"interpreters":["jconsole"],"tm_scope":"source.j","ace_mode":"text","language_id":172},"JAR Manifest":{"type":"data","color":"#b07219","filenames":["MANIFEST.MF"],"tm_scope":"source.yaml","ace_mode":"text","language_id":447261135},"JCL":{"type":"programming","color":"#d90e09","extensions":[".jcl"],"tm_scope":"source.jcl","ace_mode":"text","language_id":316620079},"JFlex":{"type":"programming","color":"#DBCA00","group":"Lex","extensions":[".flex",".jflex"],"tm_scope":"source.jflex","ace_mode":"text","language_id":173},"JSON":{"type":"data","color":"#292929","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","aliases":["geojson","jsonl","sarif","topojson"],"extensions":[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".json.example",".jsonl",".mcmeta",".sarif",".tact",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],"filenames":[".all-contributorsrc",".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","MODULE.bazel.lock","Package.resolved","Pipfile.lock","bun.lock","composer.lock","deno.lock","flake.lock","mcmod.info"],"language_id":174},"JSON with Comments":{"type":"data","color":"#292929","group":"JSON","tm_scope":"source.json.comments","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","aliases":["jsonc"],"extensions":[".jsonc",".code-snippets",".code-workspace",".sublime-build",".sublime-color-scheme",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session",".tsconfig.json"],"filenames":[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc",".oxlintrc.json",".swcrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],"language_id":423},"JSON5":{"type":"data","color":"#267CB9","extensions":[".json5"],"tm_scope":"source.js","ace_mode":"json5","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":175},"JSONLD":{"type":"data","color":"#0c479c","extensions":[".jsonld"],"tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/ld+json","language_id":176},"JSONiq":{"color":"#40d47e","type":"programming","ace_mode":"jsoniq","codemirror_mode":"javascript","codemirror_mime_type":"application/json","extensions":[".jq"],"tm_scope":"source.jsoniq","language_id":177},"Jac":{"type":"programming","color":"#FC792D","extensions":[".jac"],"tm_scope":"source.jac","ace_mode":"text","language_id":235277043},"Jai":{"type":"programming","color":"#ab8b4b","ace_mode":"text","tm_scope":"source.jai","extensions":[".jai"],"language_id":70127133},"Janet":{"type":"programming","color":"#0886a5","extensions":[".janet"],"tm_scope":"source.janet","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","interpreters":["janet"],"language_id":1028705371},"Jasmin":{"type":"programming","color":"#d03600","ace_mode":"java","extensions":[".j"],"tm_scope":"source.jasmin","language_id":180},"Java":{"type":"programming","tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","color":"#b07219","extensions":[".java",".jav",".jsh"],"language_id":181},"Java Properties":{"type":"data","color":"#2A6277","extensions":[".properties"],"tm_scope":"source.java-properties","ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":519377561},"Java Server Pages":{"type":"programming","color":"#2A6277","group":"Java","aliases":["jsp"],"extensions":[".jsp",".tag"],"tm_scope":"text.html.jsp","ace_mode":"jsp","codemirror_mode":"htmlembedded","codemirror_mime_type":"application/x-jsp","language_id":182},"Java Template Engine":{"type":"programming","color":"#2A6277","group":"Java","aliases":["jte"],"extensions":[".jte"],"ace_mode":"text","tm_scope":"text.html.jte","language_id":599494012},"JavaScript":{"type":"programming","tm_scope":"source.js","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","color":"#f1e05a","aliases":["js","node"],"extensions":[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],"filenames":["Jakefile"],"interpreters":["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],"language_id":183},"JavaScript+ERB":{"type":"programming","color":"#f1e05a","tm_scope":"source.js","group":"JavaScript","extensions":[".js.erb"],"ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/javascript","language_id":914318960},"Jest Snapshot":{"type":"data","color":"#15c213","tm_scope":"source.jest.snap","extensions":[".snap"],"ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"application/javascript","language_id":774635084},"JetBrains MPS":{"type":"programming","aliases":["mps"],"color":"#21D789","extensions":[".mps",".mpl",".msd"],"ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","tm_scope":"none","language_id":465165328},"Jinja":{"type":"markup","color":"#a52a22","aliases":["django","html+django","html+jinja","htmldjango"],"extensions":[".jinja",".j2",".jinja2"],"tm_scope":"text.html.django","ace_mode":"django","codemirror_mode":"jinja2","codemirror_mime_type":"text/jinja2","language_id":147},"Jison":{"type":"programming","color":"#56b3cb","group":"Yacc","extensions":[".jison"],"tm_scope":"source.jison","ace_mode":"text","language_id":284531423},"Jison Lex":{"type":"programming","color":"#56b3cb","group":"Lex","extensions":[".jisonlex"],"tm_scope":"source.jisonlex","ace_mode":"text","language_id":406395330},"Jolie":{"type":"programming","extensions":[".ol",".iol"],"interpreters":["jolie"],"color":"#843179","ace_mode":"text","tm_scope":"source.jolie","language_id":998078858},"Jsonnet":{"color":"#0064bd","type":"programming","ace_mode":"text","extensions":[".jsonnet",".libsonnet"],"tm_scope":"source.jsonnet","language_id":664885656},"Julia":{"type":"programming","extensions":[".jl"],"interpreters":["julia"],"color":"#a270ba","tm_scope":"source.julia","ace_mode":"julia","codemirror_mode":"julia","codemirror_mime_type":"text/x-julia","language_id":184},"Julia REPL":{"type":"programming","color":"#a270ba","tm_scope":"source.julia.console","group":"Julia","ace_mode":"text","language_id":220689142},"Jupyter Notebook":{"type":"markup","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","tm_scope":"source.json","color":"#DA5B0B","extensions":[".ipynb"],"filenames":["Notebook"],"aliases":["IPython Notebook"],"language_id":185},"Just":{"type":"programming","aliases":["Justfile"],"color":"#384d54","tm_scope":"source.just","filenames":[".JUSTFILE",".Justfile",".justfile","JUSTFILE","Justfile","justfile"],"extensions":[".just"],"ace_mode":"text","language_id":128447695},"KCL":{"type":"programming","color":"#7ABABF","tm_scope":"source.kcl","extensions":[".k"],"filenames":["kcl.mod","kcl.mod.lock"],"ace_mode":"text","language_id":1052003890},"KDL":{"type":"data","color":"#ffb3b3","extensions":[".kdl"],"tm_scope":"source.kdl","ace_mode":"tcl","codemirror_mode":"yacas","codemirror_mime_type":"text/x-yacas","language_id":931123626},"KFramework":{"type":"programming","color":"#4195c5","tm_scope":"text.k","extensions":[".k"],"ace_mode":"text","language_id":9479532},"KRL":{"type":"programming","color":"#28430A","extensions":[".krl"],"tm_scope":"none","ace_mode":"text","language_id":186},"Kaitai Struct":{"type":"programming","aliases":["ksy"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","color":"#773b37","extensions":[".ksy"],"tm_scope":"source.yaml","language_id":818804755},"KakouneScript":{"type":"programming","color":"#6f8042","tm_scope":"source.kakscript","aliases":["kak","kakscript"],"extensions":[".kak"],"filenames":["kakrc"],"ace_mode":"text","language_id":603336474},"KerboScript":{"type":"programming","ace_mode":"text","extensions":[".ks"],"color":"#41adf0","tm_scope":"source.kerboscript","language_id":59716426},"KiCad Layout":{"type":"data","color":"#2f4aab","aliases":["pcbnew"],"extensions":[".kicad_pcb",".kicad_mod",".kicad_wks"],"filenames":["fp-lib-table"],"tm_scope":"source.pcb.sexp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":187},"KiCad Legacy Layout":{"type":"data","color":"#2f4aab","extensions":[".brd"],"tm_scope":"source.pcb.board","ace_mode":"text","language_id":140848857},"KiCad Schematic":{"type":"data","color":"#2f4aab","aliases":["eeschema schematic"],"extensions":[".kicad_sch",".kicad_sym",".sch"],"tm_scope":"source.pcb.schematic","ace_mode":"text","language_id":622447435},"Kickstart":{"type":"data","ace_mode":"text","extensions":[".ks"],"tm_scope":"source.kickstart","language_id":692635484},"Kit":{"type":"markup","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","extensions":[".kit"],"tm_scope":"text.html.basic","language_id":188},"KoLmafia ASH":{"type":"programming","color":"#B9D9B9","extensions":[".ash"],"tm_scope":"source.ash","ace_mode":"text","language_id":852099832},"Koka":{"type":"programming","ace_mode":"text","extensions":[".kk"],"interpreters":["koka"],"color":"#215166","tm_scope":"source.koka","language_id":597930447},"Kotlin":{"type":"programming","color":"#A97BFF","extensions":[".kt",".ktm",".kts"],"tm_scope":"source.kotlin","ace_mode":"kotlin","codemirror_mode":"clike","codemirror_mime_type":"text/x-kotlin","language_id":189},"Kusto":{"type":"data","extensions":[".csl",".kql"],"tm_scope":"source.kusto","ace_mode":"text","language_id":225697190},"LFE":{"type":"programming","color":"#4C3023","extensions":[".lfe"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":190},"LLVM":{"type":"programming","extensions":[".ll"],"tm_scope":"source.llvm","ace_mode":"text","color":"#185619","language_id":191},"LOLCODE":{"type":"programming","extensions":[".lol"],"color":"#cc9900","tm_scope":"source.lolcode","ace_mode":"text","language_id":192},"LSL":{"type":"programming","tm_scope":"source.lsl","ace_mode":"lsl","extensions":[".lsl",".lslp"],"interpreters":["lsl"],"color":"#3d9970","language_id":193},"LTspice Symbol":{"type":"data","extensions":[".asy"],"tm_scope":"source.ltspice.symbol","ace_mode":"text","codemirror_mode":"spreadsheet","codemirror_mime_type":"text/x-spreadsheet","language_id":1013566805},"LabVIEW":{"type":"programming","color":"#fede06","extensions":[".lvproj",".lvclass",".lvlib"],"tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":194},"Lambdapi":{"type":"programming","color":"#8027a3","extensions":[".lp"],"tm_scope":"source.lp","ace_mode":"text","language_id":759240513},"Langium":{"type":"programming","color":"#2c8c87","extensions":[".langium"],"tm_scope":"source.langium","ace_mode":"text","language_id":548603830},"Lark":{"type":"data","color":"#2980B9","extensions":[".lark"],"tm_scope":"source.lark","ace_mode":"text","codemirror_mode":"ebnf","codemirror_mime_type":"text/x-ebnf","language_id":758480799},"Lasso":{"type":"programming","color":"#999999","extensions":[".lasso",".las",".lasso8",".lasso9"],"tm_scope":"file.lasso","aliases":["lassoscript"],"ace_mode":"text","language_id":195},"Latte":{"type":"markup","color":"#f2a542","extensions":[".latte"],"tm_scope":"text.html.smarty","ace_mode":"latte","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","language_id":196},"Lean":{"type":"programming","extensions":[".lean",".hlean"],"tm_scope":"source.lean","ace_mode":"text","language_id":197},"Lean 4":{"type":"programming","group":"Lean","aliases":["lean4"],"extensions":[".lean"],"tm_scope":"source.lean4","ace_mode":"text","language_id":455147478},"Leo":{"type":"programming","color":"#C4FFC2","extensions":[".leo"],"tm_scope":"source.leo","ace_mode":"text","wrap":true,"language_id":916034822},"Less":{"type":"markup","color":"#1d365d","aliases":["less-css"],"extensions":[".less"],"tm_scope":"source.css.less","ace_mode":"less","codemirror_mode":"css","codemirror_mime_type":"text/x-less","language_id":198},"Lex":{"type":"programming","color":"#DBCA00","aliases":["flex"],"extensions":[".l",".lex"],"filenames":["Lexer.x","lexer.x"],"tm_scope":"source.lex","ace_mode":"text","language_id":199},"LigoLANG":{"type":"programming","color":"#0e74ff","extensions":[".ligo"],"tm_scope":"source.ligo","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","group":"LigoLANG","language_id":1040646257},"LilyPond":{"type":"programming","color":"#9ccc7c","extensions":[".ly",".ily"],"tm_scope":"source.lilypond","ace_mode":"text","language_id":200},"Limbo":{"type":"programming","extensions":[".b",".m"],"tm_scope":"none","ace_mode":"text","language_id":201},"Linear Programming":{"type":"programming","extensions":[".lp"],"tm_scope":"none","ace_mode":"text","language_id":377204539},"Linker Script":{"type":"programming","extensions":[".ld",".lds",".x"],"filenames":["ld.script"],"tm_scope":"source.c.linker","ace_mode":"text","language_id":202},"Linux Kernel Module":{"type":"data","extensions":[".mod"],"tm_scope":"none","ace_mode":"text","language_id":203},"Liquid":{"type":"markup","color":"#67b8de","extensions":[".liquid"],"tm_scope":"text.html.liquid","ace_mode":"liquid","language_id":204},"Liquidsoap":{"type":"programming","color":"#990066","extensions":[".liq"],"tm_scope":"source.liquidsoap","ace_mode":"text","language_id":614641732},"Literate Agda":{"type":"programming","color":"#315665","group":"Agda","extensions":[".lagda"],"tm_scope":"none","ace_mode":"text","language_id":205},"Literate CoffeeScript":{"type":"programming","color":"#244776","tm_scope":"source.litcoffee","group":"CoffeeScript","ace_mode":"text","wrap":true,"aliases":["litcoffee"],"extensions":[".litcoffee",".coffee.md"],"language_id":206},"Literate Haskell":{"type":"programming","color":"#5e5086","group":"Haskell","aliases":["lhaskell","lhs"],"extensions":[".lhs"],"tm_scope":"text.tex.latex.haskell","ace_mode":"text","codemirror_mode":"haskell-literate","codemirror_mime_type":"text/x-literate-haskell","language_id":207},"LiveCode Script":{"type":"programming","color":"#0c5ba5","extensions":[".livecodescript"],"tm_scope":"source.livecodescript","ace_mode":"text","language_id":891017},"LiveScript":{"type":"programming","color":"#499886","aliases":["live-script","ls"],"extensions":[".ls","._ls"],"filenames":["Slakefile"],"tm_scope":"source.livescript","ace_mode":"livescript","codemirror_mode":"livescript","codemirror_mime_type":"text/x-livescript","language_id":208},"Logos":{"type":"programming","extensions":[".xm",".x",".xi"],"ace_mode":"text","tm_scope":"source.logos","language_id":209},"Logtalk":{"type":"programming","color":"#295b9a","extensions":[".lgt",".logtalk"],"tm_scope":"source.logtalk","ace_mode":"logtalk","language_id":210},"LookML":{"type":"programming","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","color":"#652B81","extensions":[".lkml",".lookml"],"tm_scope":"source.yaml","language_id":211},"LoomScript":{"type":"programming","extensions":[".ls"],"tm_scope":"source.loomscript","ace_mode":"text","language_id":212},"Lua":{"type":"programming","tm_scope":"source.lua","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#000080","extensions":[".lua",".fcgi",".nse",".p8",".pd_lua",".rbxs",".rockspec",".wlua"],"filenames":[".luacheckrc"],"interpreters":["lua","luajit"],"language_id":213},"Luau":{"type":"programming","tm_scope":"source.luau","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","color":"#00A2FF","extensions":[".luau"],"interpreters":["luau"],"language_id":365050359},"M":{"type":"programming","aliases":["mumps"],"extensions":[".mumps",".m"],"ace_mode":"text","codemirror_mode":"mumps","codemirror_mime_type":"text/x-mumps","language_id":214,"tm_scope":"none"},"M3U":{"type":"data","aliases":["hls playlist","m3u playlist"],"extensions":[".m3u",".m3u8"],"color":"#179C7D","tm_scope":"source.m3u","ace_mode":"text","language_id":89638692},"M4":{"type":"programming","extensions":[".m4",".mc"],"tm_scope":"source.m4","ace_mode":"text","language_id":215},"M4Sugar":{"type":"programming","group":"M4","aliases":["autoconf"],"extensions":[".m4"],"filenames":["configure.ac"],"tm_scope":"source.m4","ace_mode":"text","language_id":216},"MATLAB":{"type":"programming","color":"#e16737","aliases":["octave"],"extensions":[".matlab",".m"],"tm_scope":"source.matlab","ace_mode":"matlab","codemirror_mode":"octave","codemirror_mime_type":"text/x-octave","language_id":225},"MAXScript":{"type":"programming","color":"#00a6a6","extensions":[".ms",".mcr"],"tm_scope":"source.maxscript","ace_mode":"text","language_id":217},"MDX":{"type":"markup","color":"#fcb32c","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"extensions":[".mdx"],"tm_scope":"source.mdx","language_id":512838272},"MLIR":{"type":"programming","color":"#5EC8DB","extensions":[".mlir"],"tm_scope":"source.mlir","ace_mode":"text","language_id":448253929},"MQL4":{"type":"programming","color":"#62A8D6","extensions":[".mq4",".mqh"],"tm_scope":"source.mql5","ace_mode":"c_cpp","language_id":426},"MQL5":{"type":"programming","color":"#4A76B8","extensions":[".mq5",".mqh"],"tm_scope":"source.mql5","ace_mode":"c_cpp","language_id":427},"MTML":{"type":"markup","color":"#b7e1f4","extensions":[".mtml"],"tm_scope":"text.html.basic","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":218},"MUF":{"type":"programming","group":"Forth","extensions":[".muf",".m"],"tm_scope":"none","ace_mode":"forth","codemirror_mode":"forth","codemirror_mime_type":"text/x-forth","language_id":219},"Macaulay2":{"type":"programming","extensions":[".m2"],"aliases":["m2"],"interpreters":["M2"],"ace_mode":"text","tm_scope":"source.m2","color":"#d8ffff","language_id":34167825},"Makefile":{"type":"programming","color":"#427819","aliases":["bsdmake","make","mf"],"extensions":[".mak",".d",".make",".makefile",".mk",".mkfile"],"filenames":["BSDmakefile","GNUmakefile","Kbuild","Makefile","Makefile.am","Makefile.boot","Makefile.frag","Makefile.in","Makefile.inc","Makefile.wat","makefile","makefile.sco","mkfile"],"interpreters":["make"],"tm_scope":"source.makefile","ace_mode":"makefile","codemirror_mode":"cmake","codemirror_mime_type":"text/x-cmake","language_id":220},"Mako":{"type":"programming","color":"#7e858d","extensions":[".mako",".mao"],"tm_scope":"text.html.mako","ace_mode":"text","language_id":221},"Markdown":{"type":"prose","color":"#083fa1","aliases":["md","pandoc"],"ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"extensions":[".md",".livemd",".markdown",".mdown",".mdwn",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],"filenames":["contents.lr"],"tm_scope":"text.md","language_id":222},"Marko":{"type":"markup","color":"#42bff2","tm_scope":"text.marko","extensions":[".marko"],"aliases":["markojs"],"ace_mode":"text","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":932782397},"Mask":{"type":"markup","color":"#f97732","ace_mode":"mask","extensions":[".mask"],"tm_scope":"source.mask","language_id":223},"Mathematical Programming System":{"type":"programming","color":"#0530ad","extensions":[".mps"],"tm_scope":"text.source.mps","ace_mode":"text","language_id":429002699},"Maven POM":{"type":"data","group":"XML","tm_scope":"text.xml.pom","filenames":["pom.xml"],"ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":226},"Max":{"type":"programming","color":"#c4a79c","aliases":["max/msp","maxmsp"],"extensions":[".maxpat",".maxhelp",".maxproj",".mxt",".pat"],"tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":227},"MeTTa":{"type":"programming","color":"#6a5acd","extensions":[".metta"],"tm_scope":"source.metta","ace_mode":"text","language_id":1037612668},"Mercury":{"type":"programming","color":"#ff2b2b","ace_mode":"prolog","interpreters":["mmi"],"extensions":[".m",".moo"],"tm_scope":"source.mercury","language_id":229},"Mermaid":{"type":"markup","color":"#ff3670","aliases":["mermaid example"],"extensions":[".mmd",".mermaid"],"tm_scope":"source.mermaid","ace_mode":"text","language_id":385992043},"Meson":{"type":"programming","color":"#007800","filenames":["meson.build","meson_options.txt"],"tm_scope":"source.meson","ace_mode":"text","language_id":799141244},"Metal":{"type":"programming","color":"#8f14e9","extensions":[".metal"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":230},"Microsoft Developer Studio Project":{"type":"data","extensions":[".dsp"],"tm_scope":"none","ace_mode":"text","language_id":800983837},"Microsoft Visual Studio Solution":{"type":"data","extensions":[".sln"],"tm_scope":"source.solution","ace_mode":"text","language_id":849523096},"MiniD":{"type":"programming","extensions":[".minid"],"tm_scope":"none","ace_mode":"text","language_id":231},"MiniYAML":{"type":"data","color":"#ff1111","tm_scope":"source.miniyaml","extensions":[".yaml",".yml"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":4896465},"MiniZinc":{"type":"programming","color":"#06a9e6","extensions":[".mzn"],"tm_scope":"source.mzn","ace_mode":"text","language_id":238874535},"MiniZinc Data":{"type":"data","extensions":[".dzn"],"tm_scope":"source.mzn","ace_mode":"text","language_id":938193433},"Mint":{"type":"programming","extensions":[".mint"],"ace_mode":"text","color":"#02b046","tm_scope":"source.mint","language_id":968740319},"Mirah":{"type":"programming","color":"#c7a938","extensions":[".druby",".duby",".mirah"],"tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","language_id":232},"Modelica":{"type":"programming","color":"#de1d31","extensions":[".mo"],"tm_scope":"source.modelica","ace_mode":"text","codemirror_mode":"modelica","codemirror_mime_type":"text/x-modelica","language_id":233},"Modula-2":{"type":"programming","color":"#10253f","extensions":[".mod"],"tm_scope":"source.modula2","ace_mode":"text","language_id":234},"Modula-3":{"type":"programming","extensions":[".i3",".ig",".m3",".mg"],"color":"#223388","ace_mode":"text","tm_scope":"source.modula-3","language_id":564743864},"Module Management System":{"type":"programming","extensions":[".mms",".mmk"],"filenames":["descrip.mmk","descrip.mms"],"tm_scope":"none","ace_mode":"text","language_id":235},"Mojo":{"type":"programming","color":"#ff4c1f","extensions":[".mojo"],"ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","tm_scope":"source.mojo","language_id":1045019587},"Monkey":{"type":"programming","extensions":[".monkey",".monkey2"],"ace_mode":"text","tm_scope":"source.monkey","language_id":236},"Monkey C":{"type":"programming","color":"#8D6747","extensions":[".mc"],"tm_scope":"source.mc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":231751931},"Moocode":{"type":"programming","extensions":[".moo"],"tm_scope":"none","ace_mode":"text","language_id":237},"MoonBit":{"type":"programming","color":"#b92381","extensions":[".mbt"],"tm_scope":"source.moonbit","ace_mode":"text","language_id":181453007},"MoonScript":{"type":"programming","color":"#ff4585","extensions":[".moon"],"interpreters":["moon"],"tm_scope":"source.moonscript","ace_mode":"text","language_id":238},"Motoko":{"type":"programming","color":"#fbb03b","extensions":[".mo"],"tm_scope":"source.mo","ace_mode":"text","language_id":202937027},"Motorola 68K Assembly":{"type":"programming","color":"#005daa","group":"Assembly","aliases":["m68k"],"extensions":[".asm",".i",".inc",".s",".x68"],"tm_scope":"source.m68k","ace_mode":"assembly_x86","language_id":477582706},"Move":{"type":"programming","color":"#4a137a","extensions":[".move"],"tm_scope":"source.move","ace_mode":"text","language_id":638334599},"Muse":{"type":"prose","extensions":[".muse"],"tm_scope":"text.muse","ace_mode":"text","wrap":true,"language_id":474864066,"aliases":["amusewiki","emacs muse"]},"Mustache":{"type":"markup","color":"#724b3b","extensions":[".mustache"],"tm_scope":"text.html.smarty","ace_mode":"smarty","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","language_id":638334590},"Myghty":{"type":"programming","extensions":[".myt"],"tm_scope":"none","ace_mode":"text","language_id":239},"NASL":{"type":"programming","extensions":[".nasl",".inc"],"tm_scope":"source.nasl","ace_mode":"text","language_id":171666519},"NCL":{"type":"programming","color":"#28431f","extensions":[".ncl"],"tm_scope":"source.ncl","ace_mode":"text","language_id":240},"NEON":{"type":"data","extensions":[".neon"],"tm_scope":"source.neon","ace_mode":"text","aliases":["nette object notation","ne-on"],"language_id":481192983},"NL":{"type":"data","extensions":[".nl"],"tm_scope":"none","ace_mode":"text","language_id":241},"NMODL":{"type":"programming","color":"#00356B","extensions":[".mod"],"tm_scope":"none","ace_mode":"text","language_id":136456478},"NPM Config":{"type":"data","color":"#cb3837","group":"INI","aliases":["npmrc"],"filenames":[".npmrc"],"tm_scope":"source.ini.npmrc","ace_mode":"text","language_id":685022663},"NSIS":{"type":"programming","extensions":[".nsi",".nsh"],"tm_scope":"source.nsis","ace_mode":"nsis","codemirror_mode":"nsis","codemirror_mime_type":"text/x-nsis","language_id":242},"NWScript":{"type":"programming","color":"#111522","extensions":[".nss"],"tm_scope":"source.c.nwscript","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":731233819},"Nasal":{"type":"programming","color":"#1d2c4e","extensions":[".nas"],"tm_scope":"source.nasal","ace_mode":"nasal","language_id":178322513},"Nearley":{"type":"programming","ace_mode":"text","color":"#990000","extensions":[".ne",".nearley"],"tm_scope":"source.ne","language_id":521429430},"Nemerle":{"type":"programming","color":"#3d3c6e","extensions":[".n"],"tm_scope":"source.nemerle","ace_mode":"text","language_id":243},"NetLinx":{"type":"programming","color":"#0aa0ff","extensions":[".axs",".axi"],"tm_scope":"source.netlinx","ace_mode":"text","language_id":244},"NetLinx+ERB":{"type":"programming","color":"#747faa","extensions":[".axs.erb",".axi.erb"],"tm_scope":"source.netlinx.erb","ace_mode":"text","language_id":245},"NetLogo":{"type":"programming","color":"#ff6375","extensions":[".nlogo"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":246},"NewLisp":{"type":"programming","color":"#87AED7","extensions":[".nl",".lisp",".lsp"],"interpreters":["newlisp"],"tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","language_id":247},"Nextflow":{"type":"programming","ace_mode":"groovy","tm_scope":"source.nextflow","color":"#3ac486","extensions":[".nf"],"filenames":["nextflow.config"],"interpreters":["nextflow"],"language_id":506780613},"Nginx":{"type":"data","color":"#009639","extensions":[".nginx",".nginxconf",".vhost"],"filenames":["nginx.conf"],"tm_scope":"source.nginx","aliases":["nginx configuration file"],"ace_mode":"nginx","codemirror_mode":"nginx","codemirror_mime_type":"text/x-nginx-conf","language_id":248},"Nickel":{"type":"programming","color":"#E0C3FC","extensions":[".ncl"],"tm_scope":"source.nickel","ace_mode":"text","language_id":1067292664},"Nim":{"type":"programming","color":"#ffc200","extensions":[".nim",".nim.cfg",".nimble",".nimrod",".nims"],"filenames":["nim.cfg"],"ace_mode":"nim","tm_scope":"source.nim","language_id":249},"Ninja":{"type":"data","tm_scope":"source.ninja","extensions":[".ninja"],"ace_mode":"text","language_id":250},"Nit":{"type":"programming","color":"#009917","extensions":[".nit"],"tm_scope":"source.nit","ace_mode":"text","language_id":251},"Nix":{"type":"programming","color":"#7e7eff","extensions":[".nix"],"aliases":["nixos"],"tm_scope":"source.nix","ace_mode":"nix","language_id":252},"Noir":{"type":"programming","aliases":["nargo"],"ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","extensions":[".nr"],"color":"#2f1f49","tm_scope":"source.nr","language_id":813068465},"Nu":{"type":"programming","color":"#c9df40","aliases":["nush"],"extensions":[".nu"],"filenames":["Nukefile"],"tm_scope":"source.nu","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","interpreters":["nush"],"language_id":253},"NumPy":{"type":"programming","color":"#9C8AF9","group":"Python","extensions":[".numpy",".numpyw",".numsc"],"tm_scope":"none","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":254},"Nunjucks":{"type":"markup","color":"#3d8137","extensions":[".njk"],"aliases":["njk"],"tm_scope":"text.html.nunjucks","ace_mode":"nunjucks","language_id":461856962},"Nushell":{"type":"programming","color":"#4E9906","extensions":[".nu"],"interpreters":["nu"],"aliases":["nu-script","nushell-script"],"tm_scope":"source.nushell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":446573572},"OASv2-json":{"type":"data","color":"#85ea2d","extensions":[".json"],"group":"OpenAPI Specification v2","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":834374816},"OASv2-yaml":{"type":"data","color":"#85ea2d","extensions":[".yaml",".yml"],"group":"OpenAPI Specification v2","tm_scope":"source.yaml","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":105187618},"OASv3-json":{"type":"data","color":"#85ea2d","extensions":[".json"],"group":"OpenAPI Specification v3","tm_scope":"source.json","ace_mode":"json","codemirror_mode":"javascript","codemirror_mime_type":"application/json","language_id":980062566},"OASv3-yaml":{"type":"data","color":"#85ea2d","extensions":[".yaml",".yml"],"group":"OpenAPI Specification v3","tm_scope":"source.yaml","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":51239111},"OCaml":{"type":"programming","ace_mode":"ocaml","codemirror_mode":"mllike","codemirror_mime_type":"text/x-ocaml","color":"#ef7a08","extensions":[".ml",".eliom",".eliomi",".ml4",".mli",".mll",".mly"],"interpreters":["ocaml","ocamlrun","ocamlscript"],"tm_scope":"source.ocaml","language_id":255},"OMNeT++ MSG":{"type":"programming","extensions":[".msg"],"color":"#a0e0a0","tm_scope":"source.msg","ace_mode":"text","aliases":["omnetpp-msg"],"language_id":664100008},"OMNeT++ NED":{"type":"programming","extensions":[".ned"],"color":"#08607c","tm_scope":"source.ned","ace_mode":"text","aliases":["omnetpp-ned"],"language_id":924868392},"Oberon":{"type":"programming","extensions":[".ob2"],"tm_scope":"source.modula2","ace_mode":"text","language_id":677210597},"ObjDump":{"type":"data","extensions":[".objdump"],"tm_scope":"objdump.x86asm","ace_mode":"assembly_x86","language_id":256},"Object Data Instance Notation":{"type":"data","extensions":[".odin"],"tm_scope":"source.odin-ehr","ace_mode":"text","language_id":985227236},"ObjectScript":{"type":"programming","extensions":[".cls"],"language_id":202735509,"tm_scope":"source.objectscript","color":"#424893","ace_mode":"text"},"Objective-C":{"type":"programming","tm_scope":"source.objc","color":"#438eff","aliases":["obj-c","objc","objectivec"],"extensions":[".m",".h"],"ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec","language_id":257},"Objective-C++":{"type":"programming","tm_scope":"source.objc++","color":"#6866fb","aliases":["obj-c++","objc++","objectivec++"],"extensions":[".mm"],"ace_mode":"objectivec","codemirror_mode":"clike","codemirror_mime_type":"text/x-objectivec++","language_id":258},"Objective-J":{"type":"programming","color":"#ff0c5a","aliases":["obj-j","objectivej","objj"],"extensions":[".j",".sj"],"tm_scope":"source.js.objj","ace_mode":"text","language_id":259},"Odin":{"type":"programming","color":"#60AFFE","aliases":["odinlang","odin-lang"],"extensions":[".odin"],"tm_scope":"source.odin","ace_mode":"odin","language_id":889244082},"Omgrofl":{"type":"programming","extensions":[".omgrofl"],"color":"#cabbff","tm_scope":"none","ace_mode":"text","language_id":260},"Opa":{"type":"programming","extensions":[".opa"],"tm_scope":"source.opa","ace_mode":"text","language_id":261},"Opal":{"type":"programming","color":"#f7ede0","extensions":[".opal"],"tm_scope":"source.opal","ace_mode":"text","language_id":262},"Open Policy Agent":{"type":"programming","color":"#7d9199","ace_mode":"text","extensions":[".rego"],"language_id":840483232,"tm_scope":"source.rego"},"OpenAPI Specification v2":{"aliases":["oasv2"],"type":"data","color":"#85ea2d","tm_scope":"none","ace_mode":"text","language_id":848295328},"OpenAPI Specification v3":{"aliases":["oasv3"],"type":"data","color":"#85ea2d","tm_scope":"none","ace_mode":"text","language_id":557959099},"OpenCL":{"type":"programming","color":"#ed2e2d","group":"C","extensions":[".cl",".opencl"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":263},"OpenEdge ABL":{"type":"programming","color":"#5ce600","aliases":["progress","openedge","abl"],"extensions":[".p",".cls",".w"],"tm_scope":"source.abl","ace_mode":"text","language_id":264},"OpenQASM":{"type":"programming","extensions":[".qasm"],"color":"#AA70FF","tm_scope":"source.qasm","ace_mode":"text","language_id":153739399},"OpenRC runscript":{"type":"programming","group":"Shell","aliases":["openrc"],"interpreters":["openrc-run"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":265},"OpenSCAD":{"type":"programming","color":"#e5cd45","extensions":[".scad"],"tm_scope":"source.scad","ace_mode":"scad","language_id":266},"OpenStep Property List":{"type":"data","extensions":[".plist",".glyphs"],"tm_scope":"source.plist","ace_mode":"text","language_id":598917541},"OpenType Feature File":{"type":"data","aliases":["AFDKO"],"extensions":[".fea"],"tm_scope":"source.opentype","ace_mode":"text","language_id":374317347},"Option List":{"type":"data","color":"#476732","aliases":["opts","ackrc"],"filenames":[".ackrc",".rspec",".yardopts","ackrc","mocha.opts"],"tm_scope":"source.opts","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":723589315},"Org":{"type":"prose","color":"#77aa99","wrap":true,"extensions":[".org"],"tm_scope":"none","ace_mode":"text","language_id":267},"OverpassQL":{"type":"programming","color":"#cce2aa","wrap":true,"extensions":[".overpassql"],"tm_scope":"source.overpassql","ace_mode":"text","language_id":689079655},"Ox":{"type":"programming","extensions":[".ox",".oxh",".oxo"],"tm_scope":"source.ox","ace_mode":"text","language_id":268},"Oxygene":{"type":"programming","color":"#cdd0e3","extensions":[".oxygene"],"tm_scope":"none","ace_mode":"text","language_id":269},"Oz":{"type":"programming","color":"#fab738","extensions":[".oz"],"tm_scope":"source.oz","ace_mode":"text","codemirror_mode":"oz","codemirror_mime_type":"text/x-oz","language_id":270},"P4":{"type":"programming","color":"#7055b5","extensions":[".p4"],"tm_scope":"source.p4","ace_mode":"text","language_id":348895984},"PDDL":{"type":"programming","color":"#0d00ff","extensions":[".pddl"],"tm_scope":"source.pddl","ace_mode":"text","language_id":736235603},"PEG.js":{"type":"programming","color":"#234d6b","extensions":[".pegjs",".peggy"],"tm_scope":"source.peggy","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","language_id":81442128},"PHP":{"type":"programming","tm_scope":"text.html.php","ace_mode":"php","codemirror_mode":"php","codemirror_mime_type":"application/x-httpd-php","color":"#4F5D95","extensions":[".php",".aw",".ctp",".fcgi",".inc",".php3",".php4",".php5",".phps",".phpt"],"filenames":[".php",".php_cs",".php_cs.dist","Phakefile"],"interpreters":["php"],"aliases":["inc"],"language_id":272},"PLSQL":{"type":"programming","ace_mode":"plsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-plsql","tm_scope":"none","color":"#dad8d8","extensions":[".pls",".bdy",".ddl",".fnc",".pck",".pkb",".pks",".plb",".plsql",".prc",".spc",".sql",".tpb",".tps",".trg",".vw"],"language_id":273},"PLpgSQL":{"type":"programming","color":"#336790","ace_mode":"pgsql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","tm_scope":"source.sql","extensions":[".pgsql",".sql"],"language_id":274},"POV-Ray SDL":{"type":"programming","color":"#6bac65","aliases":["pov-ray","povray"],"extensions":[".pov",".inc"],"tm_scope":"source.pov-ray sdl","ace_mode":"text","language_id":275},"Pact":{"type":"programming","color":"#F7A8B8","ace_mode":"text","tm_scope":"source.pact","extensions":[".pact"],"language_id":756774415},"Pan":{"type":"programming","color":"#cc0000","extensions":[".pan"],"tm_scope":"source.pan","ace_mode":"text","language_id":276},"Papyrus":{"type":"programming","color":"#6600cc","extensions":[".psc"],"tm_scope":"source.papyrus.skyrim","ace_mode":"text","language_id":277},"Parrot":{"type":"programming","color":"#f3ca0a","extensions":[".parrot"],"tm_scope":"none","ace_mode":"text","language_id":278},"Parrot Assembly":{"group":"Parrot","type":"programming","aliases":["pasm"],"extensions":[".pasm"],"interpreters":["parrot"],"tm_scope":"none","ace_mode":"text","language_id":279},"Parrot Internal Representation":{"group":"Parrot","tm_scope":"source.parrot.pir","type":"programming","aliases":["pir"],"extensions":[".pir"],"interpreters":["parrot"],"ace_mode":"text","language_id":280},"Pascal":{"type":"programming","color":"#E3F171","aliases":["delphi","objectpascal"],"extensions":[".pas",".dfm",".dpr",".inc",".lpr",".pascal",".pp"],"interpreters":["instantfpc"],"tm_scope":"source.pascal","ace_mode":"pascal","codemirror_mode":"pascal","codemirror_mime_type":"text/x-pascal","language_id":281},"Pawn":{"type":"programming","color":"#dbb284","extensions":[".pwn",".inc",".sma"],"tm_scope":"source.pawn","ace_mode":"text","language_id":271},"Pep8":{"type":"programming","color":"#C76F5B","extensions":[".pep"],"ace_mode":"text","tm_scope":"source.pep8","language_id":840372442},"Perl":{"type":"programming","tm_scope":"source.perl","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","color":"#0298c3","extensions":[".pl",".al",".cgi",".fcgi",".perl",".ph",".plx",".pm",".psgi",".t"],"filenames":[".latexmkrc","Makefile.PL","Rexfile","ack","cpanfile","latexmkrc"],"interpreters":["cperl","perl"],"aliases":["cperl"],"language_id":282},"Pic":{"type":"markup","group":"Roff","tm_scope":"source.pic","extensions":[".pic",".chem"],"aliases":["pikchr"],"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":425},"Pickle":{"type":"data","extensions":[".pkl"],"tm_scope":"none","ace_mode":"text","language_id":284},"PicoLisp":{"type":"programming","color":"#6067af","extensions":[".l"],"interpreters":["picolisp","pil"],"tm_scope":"source.lisp","ace_mode":"lisp","language_id":285},"PigLatin":{"type":"programming","color":"#fcd7de","extensions":[".pig"],"tm_scope":"source.pig_latin","ace_mode":"pig","codemirror_mode":"pig","codemirror_mime_type":"text/x-pig","language_id":286},"Pike":{"type":"programming","color":"#005390","extensions":[".pike",".pmod"],"interpreters":["pike"],"tm_scope":"source.pike","ace_mode":"text","language_id":287},"Pip Requirements":{"type":"data","color":"#FFD343","filenames":["dev-requirements.txt","requirements-dev.txt","requirements.lock.txt","requirements.txt"],"ace_mode":"text","tm_scope":"source.pip-requirements","language_id":684385621},"Pkl":{"type":"programming","color":"#6b9543","extensions":[".pkl"],"interpreters":["pkl"],"tm_scope":"source.pkl","ace_mode":"text","language_id":288822799},"PlantUML":{"type":"data","color":"#fbbd16","extensions":[".puml",".iuml",".plantuml"],"tm_scope":"source.wsd","ace_mode":"text","language_id":833504686},"Pod":{"type":"prose","ace_mode":"perl","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","wrap":true,"extensions":[".pod"],"interpreters":["perl"],"tm_scope":"none","language_id":288},"Pod 6":{"type":"prose","ace_mode":"perl","tm_scope":"source.raku","wrap":true,"extensions":[".pod",".pod6"],"interpreters":["perl6"],"language_id":155357471},"PogoScript":{"type":"programming","color":"#d80074","extensions":[".pogo"],"tm_scope":"source.pogoscript","ace_mode":"text","language_id":289},"Polar":{"type":"programming","color":"#ae81ff","extensions":[".polar"],"tm_scope":"source.polar","ace_mode":"text","language_id":839112914},"Pony":{"type":"programming","extensions":[".pony"],"tm_scope":"source.pony","ace_mode":"text","language_id":290},"Portugol":{"type":"programming","color":"#f8bd00","extensions":[".por"],"tm_scope":"source.portugol","ace_mode":"text","language_id":832391833},"PostCSS":{"type":"markup","color":"#dc3a0c","tm_scope":"source.postcss","group":"CSS","extensions":[".pcss",".postcss"],"ace_mode":"text","language_id":262764437},"PostScript":{"type":"markup","color":"#da291c","extensions":[".ps",".eps",".epsi",".pfa"],"tm_scope":"source.postscript","aliases":["postscr"],"ace_mode":"text","language_id":291},"PowerBuilder":{"type":"programming","color":"#8f0f8d","extensions":[".pbt",".sra",".sru",".srw"],"tm_scope":"source.powerbuilder","ace_mode":"text","language_id":292},"PowerShell":{"type":"programming","color":"#012456","tm_scope":"source.powershell","ace_mode":"powershell","codemirror_mode":"powershell","codemirror_mime_type":"application/x-powershell","aliases":["posh","pwsh"],"extensions":[".ps1",".psd1",".psm1"],"interpreters":["pwsh"],"language_id":293},"Praat":{"type":"programming","color":"#c8506d","tm_scope":"source.praat","ace_mode":"praat","extensions":[".praat"],"language_id":106029007},"Prisma":{"type":"data","color":"#0c344b","extensions":[".prisma"],"tm_scope":"source.prisma","ace_mode":"prisma","language_id":499933428},"Processing":{"type":"programming","color":"#0096D8","extensions":[".pde"],"tm_scope":"source.processing","ace_mode":"text","language_id":294},"Procfile":{"type":"programming","color":"#3B2F63","filenames":["Procfile"],"tm_scope":"source.procfile","ace_mode":"batchfile","language_id":305313959},"Proguard":{"type":"data","extensions":[".pro"],"tm_scope":"none","ace_mode":"text","language_id":716513858},"Prolog":{"type":"programming","color":"#74283c","extensions":[".pl",".plt",".pro",".prolog",".yap"],"interpreters":["swipl","yap"],"tm_scope":"source.prolog","ace_mode":"prolog","language_id":295},"Promela":{"type":"programming","color":"#de0000","tm_scope":"source.promela","ace_mode":"text","extensions":[".pml"],"language_id":441858312},"Propeller Spin":{"type":"programming","color":"#7fa2a7","extensions":[".spin"],"tm_scope":"source.spin","ace_mode":"text","language_id":296},"Protocol Buffer":{"type":"data","aliases":["proto","protobuf","Protocol Buffers"],"extensions":[".proto"],"tm_scope":"source.proto","ace_mode":"protobuf","codemirror_mode":"protobuf","codemirror_mime_type":"text/x-protobuf","language_id":297},"Protocol Buffer Text Format":{"type":"data","aliases":["text proto","protobuf text format"],"extensions":[".textproto",".pbt",".pbtxt",".txtpb"],"tm_scope":"source.textproto","ace_mode":"text","language_id":436568854},"Public Key":{"type":"data","extensions":[".asc",".pub"],"tm_scope":"none","ace_mode":"text","codemirror_mode":"asciiarmor","codemirror_mime_type":"application/pgp","language_id":298},"Pug":{"type":"markup","color":"#a86454","extensions":[".jade",".pug"],"tm_scope":"text.jade","ace_mode":"jade","codemirror_mode":"pug","codemirror_mime_type":"text/x-pug","language_id":179},"Puppet":{"type":"programming","color":"#302B6D","extensions":[".pp"],"filenames":["Modulefile"],"ace_mode":"puppet","codemirror_mode":"puppet","codemirror_mime_type":"text/x-puppet","tm_scope":"source.puppet","language_id":299},"Pure Data":{"type":"data","extensions":[".pd"],"tm_scope":"none","ace_mode":"text","language_id":300},"PureBasic":{"type":"programming","color":"#5a6986","extensions":[".pb",".pbi"],"tm_scope":"none","ace_mode":"text","language_id":301},"PureScript":{"type":"programming","color":"#1D222D","extensions":[".purs"],"tm_scope":"source.purescript","ace_mode":"haskell","codemirror_mode":"haskell","codemirror_mime_type":"text/x-haskell","language_id":302},"Pyret":{"type":"programming","color":"#ee1e10","extensions":[".arr"],"ace_mode":"python","tm_scope":"source.arr","language_id":252961827},"Python":{"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#3572A5","extensions":[".py",".cgi",".fcgi",".gyp",".gypi",".lmi",".py3",".pyde",".pyi",".pyp",".pyt",".pyw",".rpy",".spec",".tac",".wsgi",".xpy"],"filenames":[".gclient","DEPS","SConscript","SConstruct","wscript"],"interpreters":["python","python2","python3","py","pypy","pypy3","uv"],"aliases":["py","py3","python3","rusthon"],"language_id":303},"Python console":{"type":"programming","color":"#3572A5","group":"Python","aliases":["pycon"],"tm_scope":"text.python.console","ace_mode":"text","language_id":428},"Python traceback":{"type":"data","color":"#3572A5","group":"Python","extensions":[".pytb"],"tm_scope":"text.python.traceback","ace_mode":"text","language_id":304},"Q#":{"type":"programming","extensions":[".qs"],"aliases":["qsharp"],"color":"#fed659","ace_mode":"text","tm_scope":"source.qsharp","language_id":697448245},"QML":{"type":"programming","color":"#44a51c","extensions":[".qml",".qbs"],"tm_scope":"source.qml","ace_mode":"qml","language_id":305},"QMake":{"type":"programming","extensions":[".pro",".pri"],"interpreters":["qmake"],"tm_scope":"source.qmake","ace_mode":"text","language_id":306},"Qt Script":{"type":"programming","ace_mode":"javascript","codemirror_mode":"javascript","codemirror_mime_type":"text/javascript","extensions":[".qs"],"filenames":["installscript.qs","toolchain_installscript.qs"],"color":"#00b841","tm_scope":"source.js","language_id":558193693},"Quake":{"type":"programming","filenames":["m3makefile","m3overrides"],"color":"#882233","ace_mode":"text","tm_scope":"source.quake","language_id":375265331},"QuakeC":{"type":"programming","extensions":[".qc"],"color":"#975777","ace_mode":"text","tm_scope":"source.quakec","language_id":472308069},"QuickBASIC":{"type":"programming","color":"#008080","extensions":[".bas",".bi"],"tm_scope":"source.QB64","aliases":["qb","qbasic","qb64","classic qbasic","classic quickbasic"],"ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":593107205},"R":{"type":"programming","color":"#198CE7","aliases":["Rscript","splus"],"extensions":[".r",".rd",".rsx"],"filenames":[".Rprofile","expr-dist"],"interpreters":["Rscript"],"tm_scope":"source.r","ace_mode":"r","codemirror_mode":"r","codemirror_mime_type":"text/x-rsrc","language_id":307},"RAML":{"type":"markup","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","tm_scope":"source.yaml","color":"#77d9fb","extensions":[".raml"],"language_id":308},"RAScript":{"type":"programming","ace_mode":"text","extensions":[".rascript"],"tm_scope":"source.rascript","color":"#2C97FA","language_id":601118790},"RBS":{"type":"data","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","extensions":[".rbs"],"color":"#701516","tm_scope":"source.rbs","group":"Ruby","language_id":899227493},"RDoc":{"type":"prose","color":"#701516","ace_mode":"rdoc","wrap":true,"extensions":[".rdoc"],"tm_scope":"text.rdoc","language_id":309},"REALbasic":{"type":"programming","extensions":[".rbbas",".rbfrm",".rbmnu",".rbres",".rbtbar",".rbuistate"],"tm_scope":"source.vbnet","ace_mode":"text","language_id":310},"REXX":{"type":"programming","color":"#d90e09","aliases":["arexx"],"extensions":[".rexx",".pprx",".rex"],"interpreters":["regina","rexx"],"tm_scope":"source.rexx","ace_mode":"text","language_id":311},"RMarkdown":{"type":"prose","color":"#198ce7","wrap":true,"ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","extensions":[".qmd",".rmd"],"tm_scope":"text.md","language_id":313},"RON":{"type":"data","color":"#a62c00","extensions":[".ron"],"ace_mode":"rust","tm_scope":"source.ron","language_id":587855233},"ROS Interface":{"type":"data","color":"#22314e","aliases":["rosmsg"],"ace_mode":"text","extensions":[".msg",".action",".srv"],"tm_scope":"source.rosmsg","language_id":809230569},"RPC":{"type":"programming","aliases":["rpcgen","oncrpc","xdr"],"ace_mode":"c_cpp","extensions":[".x"],"tm_scope":"source.c","language_id":1031374237},"RPGLE":{"type":"programming","ace_mode":"text","color":"#2BDE21","aliases":["ile rpg","sqlrpgle"],"extensions":[".rpgle",".sqlrpgle"],"tm_scope":"source.rpgle","language_id":609977990},"RPM Spec":{"type":"data","tm_scope":"source.rpm-spec","extensions":[".spec"],"aliases":["specfile"],"ace_mode":"text","codemirror_mode":"rpm","codemirror_mime_type":"text/x-rpm-spec","language_id":314},"RUNOFF":{"type":"markup","color":"#665a4e","extensions":[".rnh",".rno"],"wrap":true,"tm_scope":"text.runoff","ace_mode":"text","language_id":315},"Racket":{"type":"programming","color":"#3c5caa","extensions":[".rkt",".rktd",".rktl",".scrbl"],"interpreters":["racket"],"tm_scope":"source.racket","ace_mode":"lisp","language_id":316},"Ragel":{"type":"programming","color":"#9d5200","extensions":[".rl"],"aliases":["ragel-rb","ragel-ruby"],"tm_scope":"none","ace_mode":"text","language_id":317},"Raku":{"type":"programming","color":"#0000fb","extensions":[".6pl",".6pm",".nqp",".p6",".p6l",".p6m",".pl",".pl6",".pm",".pm6",".raku",".rakumod",".t"],"interpreters":["perl6","raku","rakudo"],"aliases":["perl6","perl-6"],"tm_scope":"source.raku","ace_mode":"raku","codemirror_mode":"perl","codemirror_mime_type":"text/x-perl","language_id":283},"Rascal":{"type":"programming","color":"#fffaa0","extensions":[".rsc"],"tm_scope":"source.rascal","ace_mode":"text","language_id":173616037},"Raw token data":{"type":"data","aliases":["raw"],"extensions":[".raw"],"tm_scope":"none","ace_mode":"text","language_id":318},"ReScript":{"type":"programming","color":"#ed5051","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","extensions":[".res",".resi"],"interpreters":["ocaml"],"tm_scope":"source.rescript","language_id":501875647},"Readline Config":{"type":"data","group":"INI","aliases":["inputrc","readline"],"filenames":[".inputrc","inputrc"],"tm_scope":"source.inputrc","ace_mode":"text","language_id":538732839},"Reason":{"type":"programming","color":"#ff5847","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","extensions":[".re",".rei"],"tm_scope":"source.reason","language_id":869538413},"ReasonLIGO":{"type":"programming","color":"#ff5847","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","group":"LigoLANG","extensions":[".religo"],"tm_scope":"source.religo","language_id":319002153},"Rebol":{"type":"programming","color":"#358a5b","extensions":[".reb",".r",".r2",".r3",".rebol"],"ace_mode":"text","tm_scope":"source.rebol","language_id":319},"Record Jar":{"type":"data","filenames":["language-subtag-registry.txt"],"tm_scope":"source.record-jar","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","ace_mode":"text","color":"#0673ba","language_id":865765202},"Red":{"type":"programming","color":"#f50000","extensions":[".red",".reds"],"aliases":["red/system"],"tm_scope":"source.red","ace_mode":"red","language_id":320},"Redcode":{"type":"programming","extensions":[".cw"],"tm_scope":"none","ace_mode":"text","language_id":321},"Redirect Rules":{"type":"data","aliases":["redirects"],"filenames":["_redirects"],"tm_scope":"source.redirects","ace_mode":"text","language_id":1020148948},"Regular Expression":{"type":"data","color":"#009a00","extensions":[".regexp",".regex"],"aliases":["regexp","regex"],"ace_mode":"text","tm_scope":"source.regexp","language_id":363378884},"Ren'Py":{"type":"programming","aliases":["renpy"],"color":"#ff7f7f","extensions":[".rpy"],"tm_scope":"source.renpy","ace_mode":"python","language_id":322},"RenderScript":{"type":"programming","extensions":[".rs",".rsh"],"tm_scope":"none","ace_mode":"text","language_id":323},"Rez":{"type":"programming","extensions":[".r"],"tm_scope":"source.rez","ace_mode":"text","color":"#FFDAB3","language_id":498022874},"Rich Text Format":{"type":"markup","extensions":[".rtf"],"tm_scope":"text.rtf","ace_mode":"text","language_id":51601661},"Ring":{"type":"programming","color":"#2D54CB","extensions":[".ring"],"tm_scope":"source.ring","ace_mode":"text","language_id":431},"Riot":{"type":"markup","color":"#A71E49","ace_mode":"html","extensions":[".riot"],"tm_scope":"text.html.riot","language_id":878396783},"RobotFramework":{"type":"programming","color":"#00c0b5","extensions":[".robot",".resource"],"tm_scope":"text.robot","ace_mode":"robot","language_id":324},"Roc":{"type":"programming","color":"#7c38f5","extensions":[".roc"],"tm_scope":"source.roc","ace_mode":"text","language_id":440182480},"Rocq Prover":{"type":"programming","color":"#d0b68c","extensions":[".v",".coq"],"aliases":["coq","rocq"],"tm_scope":"source.coq","ace_mode":"text","language_id":69},"Roff":{"type":"markup","color":"#ecdebe","extensions":[".roff",".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".l",".man",".mdoc",".me",".ms",".n",".nr",".rno",".tmac"],"filenames":["eqnrc","mmn","mmt","troffrc","troffrc-end"],"tm_scope":"text.roff","aliases":["groff","man","manpage","man page","man-page","mdoc","nroff","troff"],"wrap":true,"ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":141},"Roff Manpage":{"type":"markup","color":"#ecdebe","group":"Roff","extensions":[".1",".1in",".1m",".1x",".2",".3",".3in",".3m",".3p",".3pm",".3qt",".3x",".4",".5",".6",".7",".8",".9",".man",".mdoc"],"wrap":true,"tm_scope":"text.roff","ace_mode":"text","codemirror_mode":"troff","codemirror_mime_type":"text/troff","language_id":612669833},"Rouge":{"type":"programming","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#cc0088","extensions":[".rg"],"tm_scope":"source.clojure","language_id":325},"RouterOS Script":{"type":"programming","ace_mode":"text","extensions":[".rsc"],"interpreters":["RouterOS"],"color":"#DE3941","tm_scope":"none","language_id":592853203},"Ruby":{"type":"programming","tm_scope":"source.ruby","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","color":"#701516","aliases":["jruby","macruby","rake","rb","rbx"],"extensions":[".rb",".builder",".eye",".fcgi",".gemspec",".god",".jbuilder",".mspec",".pluginspec",".podspec",".prawn",".rabl",".rake",".rbi",".rbuild",".rbw",".rbx",".ru",".ruby",".spec",".thor",".watchr"],"interpreters":["ruby","macruby","rake","jruby","rbx"],"filenames":[".irbrc",".pryrc",".simplecov","Appraisals","Berksfile","Brewfile","Buildfile","Capfile","Dangerfile","Deliverfile","Fastfile","Gemfile","Guardfile","Jarfile","Mavenfile","Podfile","Puppetfile","Rakefile","Snapfile","Steepfile","Thorfile","Vagrantfile","buildfile"],"language_id":326},"Rust":{"type":"programming","aliases":["rs"],"color":"#dea584","extensions":[".rs",".rs.in"],"tm_scope":"source.rust","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","interpreters":["rust-script"],"language_id":327},"SAS":{"type":"programming","color":"#B34936","extensions":[".sas"],"tm_scope":"source.sas","ace_mode":"text","codemirror_mode":"sas","codemirror_mime_type":"text/x-sas","language_id":328},"SCSS":{"type":"markup","color":"#c6538c","tm_scope":"source.css.scss","ace_mode":"scss","codemirror_mode":"css","codemirror_mime_type":"text/x-scss","extensions":[".scss"],"language_id":329},"SELinux Policy":{"aliases":["SELinux Kernel Policy Language","sepolicy"],"type":"data","tm_scope":"source.sepolicy","extensions":[".te"],"filenames":["file_contexts","genfs_contexts","initial_sids","port_contexts","security_classes"],"ace_mode":"text","language_id":880010326},"SMT":{"type":"programming","extensions":[".smt2",".smt",".z3"],"interpreters":["boolector","cvc4","mathsat5","opensmt","smtinterpol","smt-rat","stp","verit","yices2","z3"],"tm_scope":"source.smt","ace_mode":"text","language_id":330},"SPARQL":{"type":"data","color":"#0C4597","tm_scope":"source.sparql","ace_mode":"sparql","codemirror_mode":"sparql","codemirror_mime_type":"application/sparql-query","extensions":[".sparql",".rq"],"language_id":331},"SQF":{"type":"programming","color":"#3F3F3F","extensions":[".sqf",".hqf"],"tm_scope":"source.sqf","ace_mode":"text","language_id":332},"SQL":{"type":"data","color":"#e38c00","tm_scope":"source.sql","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","extensions":[".sql",".ddl",".inc",".mysql",".prc",".tab",".udf",".viw"],"language_id":333},"SQLPL":{"type":"programming","color":"#e38c00","ace_mode":"sql","codemirror_mode":"sql","codemirror_mime_type":"text/x-sql","tm_scope":"source.sql","extensions":[".sql",".db2"],"language_id":334},"SRecode Template":{"type":"markup","color":"#348a34","tm_scope":"source.lisp","ace_mode":"lisp","codemirror_mode":"commonlisp","codemirror_mime_type":"text/x-common-lisp","extensions":[".srt"],"language_id":335},"SSH Config":{"type":"data","group":"INI","aliases":["sshconfig","sshdconfig","ssh_config","sshd_config"],"filenames":["ssh-config","ssh_config","sshconfig","sshconfig.snip","sshd-config","sshd_config"],"ace_mode":"text","tm_scope":"source.ssh-config","language_id":554920715},"STAR":{"type":"data","extensions":[".star"],"tm_scope":"source.star","ace_mode":"text","language_id":424510560},"STL":{"type":"data","color":"#373b5e","aliases":["ascii stl","stla"],"extensions":[".stl"],"tm_scope":"source.stl","ace_mode":"text","language_id":455361735},"STON":{"type":"data","group":"Smalltalk","extensions":[".ston"],"tm_scope":"source.smalltalk","ace_mode":"text","language_id":336},"SVG":{"type":"data","color":"#ff9900","extensions":[".svg"],"tm_scope":"text.xml.svg","ace_mode":"svg","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":337},"SWIG":{"type":"programming","extensions":[".i",".swg",".swig"],"tm_scope":"source.c++","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-c++src","language_id":1066250075},"Sage":{"type":"programming","extensions":[".sage",".sagews"],"tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":338},"Sail":{"type":"programming","color":"#259dd5","ace_mode":"text","extensions":[".sail"],"tm_scope":"source.sail","language_id":1029438153},"SaltStack":{"type":"programming","color":"#646464","aliases":["saltstate","salt"],"extensions":[".sls"],"tm_scope":"source.yaml.salt","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":339},"Sass":{"type":"markup","color":"#a53b70","tm_scope":"source.sass","extensions":[".sass"],"ace_mode":"sass","codemirror_mode":"sass","codemirror_mime_type":"text/x-sass","language_id":340},"Scala":{"type":"programming","tm_scope":"source.scala","ace_mode":"scala","codemirror_mode":"clike","codemirror_mime_type":"text/x-scala","color":"#c22d40","extensions":[".scala",".kojo",".sbt",".sc"],"interpreters":["scala"],"language_id":341},"Scaml":{"type":"markup","color":"#bd181a","extensions":[".scaml"],"tm_scope":"source.scaml","ace_mode":"text","language_id":342},"Scenic":{"type":"programming","color":"#fdc700","extensions":[".scenic"],"tm_scope":"source.scenic","ace_mode":"text","interpreters":["scenic"],"language_id":619814037},"Scheme":{"type":"programming","color":"#1e4aec","extensions":[".scm",".sch",".sld",".sls",".sps",".ss"],"interpreters":["scheme","guile","bigloo","chicken","csi","gosh","r6rs"],"tm_scope":"source.scheme","ace_mode":"scheme","codemirror_mode":"scheme","codemirror_mime_type":"text/x-scheme","language_id":343},"Scilab":{"type":"programming","color":"#ca0f21","extensions":[".sci",".sce",".tst"],"tm_scope":"source.scilab","ace_mode":"text","language_id":344},"Self":{"type":"programming","color":"#0579aa","extensions":[".self"],"tm_scope":"none","ace_mode":"text","language_id":345},"ShaderLab":{"type":"programming","color":"#222c37","extensions":[".shader"],"ace_mode":"text","tm_scope":"source.shaderlab","language_id":664257356},"Shell":{"type":"programming","color":"#89e051","aliases":["sh","shell-script","bash","zsh","envrc"],"extensions":[".sh",".bash",".bats",".cgi",".command",".fcgi",".ksh",".sbatch",".sh.in",".slurm",".tmux",".tool",".trigger",".zsh",".zsh-theme"],"filenames":[".bash_aliases",".bash_functions",".bash_history",".bash_logout",".bash_profile",".bashrc",".cshrc",".envrc",".flaskenv",".kshrc",".login",".profile",".tmux.conf",".xinitrc",".xsession",".zlogin",".zlogout",".zprofile",".zshenv",".zshrc","9fs","PKGBUILD","bash_aliases","bash_logout","bash_profile","bashrc","cshrc","gradlew","kshrc","login","man","mvnw","profile","tmux.conf","xinitrc","xsession","zlogin","zlogout","zprofile","zshenv","zshrc"],"interpreters":["ash","bash","dash","ksh","mksh","pdksh","rc","sh","zsh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":346},"ShellCheck Config":{"type":"data","color":"#cecfcb","filenames":[".shellcheckrc"],"aliases":["shellcheckrc"],"tm_scope":"source.shellcheckrc","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":687511714},"ShellSession":{"type":"programming","extensions":[".sh-session"],"aliases":["bash session","console"],"tm_scope":"text.shell-session","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":347},"Shen":{"type":"programming","color":"#120F14","extensions":[".shen"],"tm_scope":"source.shen","ace_mode":"text","language_id":348},"Sieve":{"type":"programming","tm_scope":"source.sieve","ace_mode":"text","extensions":[".sieve"],"codemirror_mode":"sieve","codemirror_mime_type":"application/sieve","language_id":208976687},"Simple File Verification":{"type":"data","group":"Checksums","color":"#C9BFED","extensions":[".sfv"],"aliases":["sfv"],"tm_scope":"source.sfv","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":735623761},"Singularity":{"type":"programming","color":"#64E6AD","tm_scope":"source.singularity","filenames":["Singularity"],"ace_mode":"text","language_id":987024632},"Slang":{"type":"programming","color":"#1fbec9","extensions":[".slang"],"tm_scope":"source.slang","ace_mode":"text","language_id":239357863},"Slash":{"type":"programming","color":"#007eff","extensions":[".sl"],"tm_scope":"text.html.slash","ace_mode":"text","language_id":349},"Slice":{"type":"programming","color":"#003fa2","tm_scope":"source.ice","ace_mode":"text","extensions":[".ice"],"language_id":894641667},"Slim":{"type":"markup","color":"#2b2b2b","extensions":[".slim"],"tm_scope":"text.slim","ace_mode":"slim","codemirror_mode":"slim","codemirror_mime_type":"text/x-slim","language_id":350},"Slint":{"type":"markup","color":"#2379F4","extensions":[".slint"],"tm_scope":"source.slint","ace_mode":"text","language_id":119900149},"SmPL":{"type":"programming","extensions":[".cocci"],"aliases":["coccinelle"],"ace_mode":"text","tm_scope":"source.smpl","color":"#c94949","language_id":164123055},"Smali":{"type":"programming","extensions":[".smali"],"ace_mode":"text","tm_scope":"source.smali","language_id":351},"Smalltalk":{"type":"programming","color":"#596706","extensions":[".st",".cs"],"aliases":["squeak"],"tm_scope":"source.smalltalk","ace_mode":"text","codemirror_mode":"smalltalk","codemirror_mime_type":"text/x-stsrc","language_id":352},"Smarty":{"type":"programming","color":"#f0c040","extensions":[".tpl"],"ace_mode":"smarty","codemirror_mode":"smarty","codemirror_mime_type":"text/x-smarty","tm_scope":"text.html.smarty","language_id":353},"Smithy":{"type":"programming","ace_mode":"smithy","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","tm_scope":"source.smithy","color":"#c44536","extensions":[".smithy"],"language_id":1027892786},"Snakemake":{"type":"programming","group":"Python","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#419179","extensions":[".smk",".snakefile"],"filenames":["Snakefile"],"aliases":["snakefile"],"language_id":151241392},"Solidity":{"type":"programming","color":"#AA6746","ace_mode":"text","tm_scope":"source.solidity","extensions":[".sol"],"language_id":237469032},"Soong":{"type":"data","tm_scope":"source.bp","ace_mode":"text","filenames":["Android.bp"],"language_id":222900098},"SourcePawn":{"type":"programming","color":"#f69e1d","aliases":["sourcemod"],"extensions":[".sp",".inc"],"tm_scope":"source.sourcepawn","ace_mode":"text","language_id":354},"SpiceDB Schema":{"type":"data","color":"#a5318a","extensions":[".zed"],"tm_scope":"source.spicedb","ace_mode":"text","language_id":864005057},"Spline Font Database":{"type":"data","extensions":[".sfd"],"tm_scope":"text.sfd","ace_mode":"yaml","language_id":767169629},"Squirrel":{"type":"programming","color":"#800000","extensions":[".nut"],"tm_scope":"source.nut","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-squirrel","language_id":355},"Stan":{"type":"programming","color":"#b2011d","extensions":[".stan"],"ace_mode":"text","tm_scope":"source.stan","language_id":356},"Standard ML":{"type":"programming","color":"#dc566d","aliases":["sml"],"extensions":[".ml",".fun",".sig",".sml"],"tm_scope":"source.ml","ace_mode":"text","codemirror_mode":"mllike","codemirror_mime_type":"text/x-sml","language_id":357},"Starlark":{"type":"programming","tm_scope":"source.python","ace_mode":"python","codemirror_mode":"python","codemirror_mime_type":"text/x-python","color":"#76d275","extensions":[".bzl",".star"],"filenames":["BUCK","BUILD","BUILD.bazel","MODULE.bazel","Tiltfile","WORKSPACE","WORKSPACE.bazel","WORKSPACE.bzlmod"],"aliases":["bazel","bzl"],"language_id":960266174},"Stata":{"type":"programming","color":"#1a5f91","extensions":[".do",".ado",".doh",".ihlp",".mata",".matah",".sthlp"],"tm_scope":"source.stata","ace_mode":"text","language_id":358},"StringTemplate":{"type":"markup","color":"#3fb34f","extensions":[".st"],"tm_scope":"source.string-template","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","language_id":89855901},"Stylus":{"type":"markup","color":"#ff6347","extensions":[".styl"],"tm_scope":"source.stylus","ace_mode":"stylus","codemirror_mode":"stylus","codemirror_mime_type":"text/x-styl","language_id":359},"SubRip Text":{"type":"data","color":"#9e0101","extensions":[".srt"],"ace_mode":"text","tm_scope":"text.srt","language_id":360},"SugarSS":{"type":"markup","color":"#2fcc9f","tm_scope":"source.css.postcss.sugarss","extensions":[".sss"],"ace_mode":"text","language_id":826404698},"SuperCollider":{"type":"programming","color":"#46390b","extensions":[".sc",".scd"],"interpreters":["sclang","scsynth"],"tm_scope":"source.supercollider","ace_mode":"text","language_id":361},"SurrealQL":{"type":"programming","color":"#ff00a0","aliases":["surql"],"extensions":[".surql"],"ace_mode":"text","tm_scope":"source.surrealql","language_id":735141027},"Survex data":{"type":"data","color":"#ffcc99","tm_scope":"none","ace_mode":"text","extensions":[".svx"],"language_id":24470517},"Svelte":{"type":"markup","color":"#ff3e00","tm_scope":"source.svelte","ace_mode":"html","codemirror_mode":"htmlmixed","codemirror_mime_type":"text/html","extensions":[".svelte"],"language_id":928734530},"Sway":{"type":"programming","color":"#00F58C","extensions":[".sw"],"tm_scope":"source.sway","ace_mode":"rust","codemirror_mode":"rust","codemirror_mime_type":"text/x-rustsrc","language_id":271471144},"Sweave":{"type":"prose","color":"#198ce7","extensions":[".rnw"],"tm_scope":"text.tex.latex.sweave","ace_mode":"tex","language_id":558779190},"Swift":{"type":"programming","color":"#F05138","extensions":[".swift"],"tm_scope":"source.swift","ace_mode":"swift","codemirror_mode":"swift","codemirror_mime_type":"text/x-swift","language_id":362},"SystemVerilog":{"type":"programming","color":"#DAE1C2","extensions":[".sv",".svh",".vh"],"tm_scope":"source.systemverilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-systemverilog","language_id":363},"TI Program":{"type":"programming","ace_mode":"text","color":"#A0AA87","extensions":[".8xp",".8xp.txt"],"language_id":422,"tm_scope":"source.8xp"},"TL-Verilog":{"type":"programming","extensions":[".tlv"],"tm_scope":"source.tlverilog","ace_mode":"verilog","color":"#C40023","language_id":118656070},"TLA":{"type":"programming","color":"#4b0079","extensions":[".tla"],"tm_scope":"source.tla","ace_mode":"text","language_id":364},"TMDL":{"type":"data","color":"#f0c913","extensions":[".tmdl"],"aliases":["Tabular Model Definition Language"],"tm_scope":"source.tmdl","ace_mode":"text","language_id":769162295},"TOML":{"type":"data","color":"#9c4221","extensions":[".toml",".toml.example"],"filenames":["Cargo.lock","Cargo.toml.orig","Gopkg.lock","Pipfile","mise.local.lock","mise.lock","pdm.lock","poetry.lock","uv.lock"],"tm_scope":"source.toml","ace_mode":"toml","codemirror_mode":"toml","codemirror_mime_type":"text/x-toml","language_id":365},"TSPLIB data":{"aliases":["travelling salesman problem","traveling salesman problem"],"type":"data","extensions":[".tsp"],"tm_scope":"none","ace_mode":"text","language_id":89289301},"TSQL":{"type":"programming","color":"#e38c00","extensions":[".sql"],"ace_mode":"sql","tm_scope":"source.tsql","language_id":918334941},"TSV":{"type":"data","color":"#237346","ace_mode":"tsv","tm_scope":"source.tsv","extensions":[".tsv",".vcf"],"aliases":["tab-seperated values"],"language_id":1035892117},"TSX":{"type":"programming","color":"#3178c6","group":"TypeScript","aliases":["typescriptreact"],"extensions":[".tsx"],"tm_scope":"source.tsx","ace_mode":"tsx","codemirror_mode":"jsx","codemirror_mime_type":"text/typescript-jsx","language_id":94901924},"TXL":{"type":"programming","color":"#0178b8","extensions":[".txl"],"tm_scope":"source.txl","ace_mode":"text","language_id":366},"Tact":{"type":"programming","color":"#48b5ff","extensions":[".tact"],"ace_mode":"text","tm_scope":"source.tact","language_id":606708469},"Talon":{"type":"programming","ace_mode":"text","color":"#333333","extensions":[".talon"],"tm_scope":"source.talon","language_id":959889508},"Tcl":{"type":"programming","color":"#e4cc98","extensions":[".tcl",".adp",".sdc",".tcl.in",".tm",".xdc"],"aliases":["sdc","xdc"],"filenames":["owh","starfield"],"interpreters":["tclsh","wish"],"tm_scope":"source.tcl","ace_mode":"tcl","codemirror_mode":"tcl","codemirror_mime_type":"text/x-tcl","language_id":367},"Tcsh":{"type":"programming","group":"Shell","extensions":[".tcsh",".csh"],"interpreters":["tcsh","csh"],"tm_scope":"source.shell","ace_mode":"sh","codemirror_mode":"shell","codemirror_mime_type":"text/x-sh","language_id":368},"TeX":{"type":"markup","color":"#3D6117","ace_mode":"tex","codemirror_mode":"stex","codemirror_mime_type":"text/x-stex","tm_scope":"text.tex.latex","wrap":true,"aliases":["latex"],"extensions":[".tex",".aux",".bbx",".cbx",".cls",".dtx",".ins",".lbx",".ltx",".mkii",".mkiv",".mkvi",".sty",".toc"],"language_id":369},"Tea":{"type":"markup","extensions":[".tea"],"tm_scope":"source.tea","ace_mode":"text","language_id":370},"Teal":{"type":"programming","extensions":[".tl"],"color":"#00B1BC","tm_scope":"source.teal","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","interpreters":["tl"],"language_id":719038619},"Terra":{"type":"programming","extensions":[".t"],"color":"#00004c","tm_scope":"source.terra","ace_mode":"lua","codemirror_mode":"lua","codemirror_mime_type":"text/x-lua","interpreters":["lua"],"language_id":371},"Terraform Template":{"type":"markup","extensions":[".tftpl"],"color":"#7b42bb","tm_scope":"source.hcl.terraform","ace_mode":"ruby","codemirror_mode":"ruby","codemirror_mime_type":"text/x-ruby","group":"HCL","language_id":856832701},"Texinfo":{"type":"prose","wrap":true,"extensions":[".texinfo",".texi",".txi"],"ace_mode":"text","tm_scope":"text.texinfo","interpreters":["makeinfo"],"language_id":988020015},"Text":{"type":"prose","wrap":true,"aliases":["fundamental","plain text"],"extensions":[".txt",".fr",".nb",".ncl",".no"],"filenames":["CITATION","CITATIONS","COPYING","COPYING.regex","COPYRIGHT.regex","FONTLOG","INSTALL","INSTALL.mysql","LICENSE","LICENSE.mysql","NEWS","README.me","README.mysql","README.nss","click.me","delete.me","keep.me","package.mask","package.use.mask","package.use.stable.mask","read.me","readme.1st","test.me","use.mask","use.stable.mask"],"tm_scope":"none","ace_mode":"text","language_id":372},"TextGrid":{"type":"data","color":"#c8506d","tm_scope":"source.textgrid","ace_mode":"text","extensions":[".TextGrid"],"language_id":965696054},"TextMate Properties":{"type":"data","color":"#df66e4","aliases":["tm-properties"],"filenames":[".tm_properties"],"ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","tm_scope":"source.tm-properties","language_id":981795023},"Textile":{"type":"prose","color":"#ffe7ac","ace_mode":"textile","codemirror_mode":"textile","codemirror_mime_type":"text/x-textile","wrap":true,"extensions":[".textile"],"tm_scope":"none","language_id":373},"Thrift":{"type":"programming","color":"#D12127","tm_scope":"source.thrift","extensions":[".thrift"],"ace_mode":"text","language_id":374},"Toit":{"type":"programming","color":"#c2c9fb","extensions":[".toit"],"tm_scope":"source.toit","ace_mode":"text","language_id":356554395},"Tor Config":{"type":"data","color":"#59316b","filenames":["torrc"],"tm_scope":"source.torrc","ace_mode":"apache_conf","aliases":["torrc"],"language_id":1016912802},"Tree-sitter Query":{"type":"programming","color":"#8ea64c","aliases":["tsq"],"extensions":[".scm"],"tm_scope":"source.scm","ace_mode":"text","language_id":436081647},"Turing":{"type":"programming","color":"#cf142b","extensions":[".t",".tu"],"tm_scope":"source.turing","ace_mode":"text","language_id":375},"Turtle":{"type":"data","extensions":[".ttl"],"tm_scope":"source.turtle","ace_mode":"turtle","codemirror_mode":"turtle","codemirror_mime_type":"text/turtle","language_id":376},"Twig":{"type":"markup","color":"#c1d026","extensions":[".twig"],"tm_scope":"text.html.twig","ace_mode":"twig","codemirror_mode":"twig","codemirror_mime_type":"text/x-twig","language_id":377},"Type Language":{"type":"data","aliases":["tl"],"extensions":[".tl"],"tm_scope":"source.tl","ace_mode":"text","language_id":632765617},"TypeScript":{"type":"programming","color":"#3178c6","aliases":["ts"],"interpreters":["bun","deno","ts-node","tsx"],"extensions":[".ts",".cts",".mts"],"tm_scope":"source.ts","ace_mode":"typescript","codemirror_mode":"javascript","codemirror_mime_type":"application/typescript","language_id":378},"TypeSpec":{"type":"programming","color":"#4A3665","aliases":["tsp"],"extensions":[".tsp"],"tm_scope":"source.tsp","ace_mode":"text","language_id":952272597},"Typst":{"type":"programming","color":"#239dad","aliases":["typ"],"extensions":[".typ"],"tm_scope":"source.typst","ace_mode":"text","language_id":704730682},"Unified Parallel C":{"type":"programming","color":"#4e3617","group":"C","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","extensions":[".upc"],"tm_scope":"source.c","language_id":379},"Unity3D Asset":{"type":"data","color":"#222c37","ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","extensions":[".anim",".asset",".mask",".mat",".meta",".prefab",".unity"],"tm_scope":"source.yaml","language_id":380},"Unix Assembly":{"type":"programming","group":"Assembly","extensions":[".s",".ms"],"aliases":["gas","gnu asm","unix asm"],"tm_scope":"source.x86","ace_mode":"assembly_x86","language_id":120},"Uno":{"type":"programming","color":"#9933cc","extensions":[".uno"],"ace_mode":"csharp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csharp","tm_scope":"source.cs","language_id":381},"UnrealScript":{"type":"programming","color":"#a54c4d","extensions":[".uc"],"tm_scope":"source.java","ace_mode":"java","codemirror_mode":"clike","codemirror_mime_type":"text/x-java","language_id":382},"Untyped Plutus Core":{"type":"programming","color":"#36adbd","ace_mode":"text","extensions":[".uplc"],"tm_scope":"source.uplc","language_id":1061635506},"UrWeb":{"type":"programming","color":"#ccccee","aliases":["Ur/Web","Ur"],"extensions":[".ur",".urs"],"tm_scope":"source.ur","ace_mode":"text","language_id":383},"V":{"type":"programming","color":"#4f87c4","aliases":["vlang"],"extensions":[".v"],"tm_scope":"source.v","ace_mode":"golang","codemirror_mode":"go","codemirror_mime_type":"text/x-go","language_id":603371597},"VBA":{"type":"programming","color":"#867db1","extensions":[".bas",".cls",".frm",".vba"],"tm_scope":"source.vba","aliases":["visual basic for applications"],"ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":399230729},"VBScript":{"type":"programming","color":"#15dcdc","extensions":[".vbs"],"tm_scope":"source.vbnet","ace_mode":"vbscript","codemirror_mode":"vbscript","codemirror_mime_type":"text/vbscript","language_id":408016005},"VCL":{"type":"programming","color":"#148AA8","extensions":[".vcl"],"tm_scope":"source.vcl","ace_mode":"text","language_id":384},"VHDL":{"type":"programming","color":"#adb2cb","extensions":[".vhdl",".vhd",".vhf",".vhi",".vho",".vhs",".vht",".vhw"],"tm_scope":"source.vhdl","ace_mode":"vhdl","codemirror_mode":"vhdl","codemirror_mime_type":"text/x-vhdl","language_id":385},"Vala":{"type":"programming","color":"#a56de2","extensions":[".vala",".vapi"],"tm_scope":"source.vala","ace_mode":"vala","language_id":386},"Valve Data Format":{"type":"data","color":"#f26025","aliases":["keyvalues","vdf"],"extensions":[".vdf"],"ace_mode":"text","tm_scope":"source.keyvalues","language_id":544060961},"Velocity Template Language":{"type":"markup","color":"#507cff","aliases":["vtl","velocity"],"extensions":[".vtl"],"ace_mode":"velocity","tm_scope":"source.velocity","codemirror_mode":"velocity","codemirror_mime_type":"text/velocity","language_id":292377326},"Vento":{"type":"markup","color":"#ff0080","extensions":[".vto"],"tm_scope":"source.vento","ace_mode":"text","language_id":757053899},"Verilog":{"type":"programming","color":"#b2b7f8","extensions":[".v",".veo"],"tm_scope":"source.verilog","ace_mode":"verilog","codemirror_mode":"verilog","codemirror_mime_type":"text/x-verilog","language_id":387},"Vim Help File":{"type":"prose","color":"#199f4b","aliases":["help","vimhelp"],"extensions":[".txt"],"tm_scope":"text.vim-help","ace_mode":"text","language_id":508563686},"Vim Script":{"type":"programming","color":"#199f4b","tm_scope":"source.viml","aliases":["vim","viml","nvim","vimscript"],"extensions":[".vim",".vba",".vimrc",".vmb"],"filenames":[".exrc",".gvimrc",".nvimrc",".vimrc","_vimrc","gvimrc","nvimrc","vimrc"],"ace_mode":"text","language_id":388},"Vim Snippet":{"type":"markup","color":"#199f4b","aliases":["SnipMate","UltiSnip","UltiSnips","NeoSnippet"],"extensions":[".snip",".snippet",".snippets"],"tm_scope":"source.vim-snippet","ace_mode":"text","language_id":81265970},"Visual Basic .NET":{"type":"programming","color":"#945db7","extensions":[".vb",".vbhtml"],"aliases":["visual basic","vbnet","vb .net","vb.net"],"tm_scope":"source.vbnet","ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":389},"Visual Basic 6.0":{"type":"programming","color":"#2c6353","extensions":[".bas",".cls",".ctl",".Dsr",".frm"],"tm_scope":"source.vba","aliases":["vb6","vb 6","visual basic 6","visual basic classic","classic visual basic"],"ace_mode":"text","codemirror_mode":"vb","codemirror_mime_type":"text/x-vb","language_id":679594952},"Volt":{"type":"programming","color":"#1F1F1F","extensions":[".volt"],"tm_scope":"source.d","ace_mode":"d","codemirror_mode":"d","codemirror_mime_type":"text/x-d","language_id":390},"Vue":{"type":"markup","color":"#41b883","extensions":[".vue"],"tm_scope":"text.html.vue","ace_mode":"vue","codemirror_mode":"vue","codemirror_mime_type":"text/x-vue","language_id":391},"Vyper":{"type":"programming","extensions":[".vy"],"color":"#9F4CF2","ace_mode":"text","tm_scope":"source.vyper","language_id":1055641948},"WDL":{"aliases":["Workflow Description Language"],"type":"programming","color":"#42f1f4","extensions":[".wdl"],"tm_scope":"source.wdl","ace_mode":"text","language_id":374521672},"WGSL":{"type":"programming","color":"#1a5e9a","extensions":[".wgsl"],"tm_scope":"source.wgsl","ace_mode":"text","language_id":836605993},"Wavefront Material":{"type":"data","extensions":[".mtl"],"tm_scope":"source.wavefront.mtl","ace_mode":"text","language_id":392},"Wavefront Object":{"type":"data","extensions":[".obj"],"tm_scope":"source.wavefront.obj","ace_mode":"text","language_id":393},"Web Ontology Language":{"type":"data","color":"#5b70bd","extensions":[".owl"],"tm_scope":"text.xml","ace_mode":"xml","language_id":394},"WebAssembly":{"type":"programming","color":"#04133b","extensions":[".wast",".wat"],"aliases":["wast","wasm"],"tm_scope":"source.webassembly","ace_mode":"lisp","codemirror_mode":"wast","codemirror_mime_type":"text/webassembly","language_id":956556503},"WebAssembly Interface Type":{"type":"data","color":"#6250e7","extensions":[".wit"],"aliases":["wit"],"ace_mode":"text","tm_scope":"source.wit","codemirror_mode":"webidl","codemirror_mime_type":"text/x-webidl","language_id":134534086},"WebIDL":{"type":"programming","extensions":[".webidl"],"tm_scope":"source.webidl","ace_mode":"text","codemirror_mode":"webidl","codemirror_mime_type":"text/x-webidl","language_id":395},"WebVTT":{"type":"data","wrap":true,"aliases":["vtt"],"extensions":[".vtt"],"tm_scope":"text.vtt","ace_mode":"text","language_id":658679714},"Wget Config":{"type":"data","group":"INI","aliases":["wgetrc"],"filenames":[".wgetrc"],"tm_scope":"source.wgetrc","ace_mode":"text","language_id":668457123},"Whiley":{"type":"programming","color":"#d5c397","extensions":[".whiley"],"tm_scope":"source.whiley","ace_mode":"text","language_id":888779559},"Wikitext":{"type":"prose","color":"#fc5757","wrap":true,"aliases":["mediawiki","wiki"],"extensions":[".mediawiki",".wiki",".wikitext"],"tm_scope":"text.html.mediawiki","ace_mode":"mediawiki","language_id":228},"Win32 Message File":{"type":"data","extensions":[".mc"],"tm_scope":"source.win32-messages","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":950967261},"Windows Registry Entries":{"type":"data","color":"#52d5ff","extensions":[".reg"],"tm_scope":"source.reg","ace_mode":"ini","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":969674868},"Witcher Script":{"type":"programming","color":"#ff0000","extensions":[".ws"],"ace_mode":"text","tm_scope":"source.witcherscript","language_id":686821385},"Wolfram Language":{"type":"programming","color":"#dd1100","extensions":[".mathematica",".cdf",".m",".ma",".mt",".nb",".nbp",".wl",".wls",".wlt"],"aliases":["mathematica","mma","wolfram","wolfram lang","wl"],"interpreters":["wolfram","WolframKernel","wolframscript","math","MathKernel","MathematicaScript","WolframNB","Mathematica"],"tm_scope":"source.mathematica","ace_mode":"text","codemirror_mode":"mathematica","codemirror_mime_type":"text/x-mathematica","language_id":224},"Wollok":{"type":"programming","color":"#a23738","extensions":[".wlk"],"ace_mode":"wollok","tm_scope":"source.wollok","language_id":632745969},"World of Warcraft Addon Data":{"type":"data","color":"#f7e43f","extensions":[".toc"],"tm_scope":"source.toc","ace_mode":"text","language_id":396},"Wren":{"type":"programming","color":"#383838","aliases":["wrenlang"],"extensions":[".wren"],"tm_scope":"source.wren","ace_mode":"text","language_id":713580619},"X BitMap":{"type":"data","group":"C","aliases":["xbm"],"extensions":[".xbm"],"ace_mode":"c_cpp","tm_scope":"source.c","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":782911107},"X Font Directory Index":{"type":"data","filenames":["encodings.dir","fonts.alias","fonts.dir","fonts.scale"],"tm_scope":"source.fontdir","ace_mode":"text","language_id":208700028},"X PixMap":{"type":"data","group":"C","aliases":["xpm"],"extensions":[".xpm",".pm"],"ace_mode":"c_cpp","tm_scope":"source.c","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":781846279},"X10":{"type":"programming","aliases":["xten"],"ace_mode":"text","extensions":[".x10"],"color":"#4B6BEF","tm_scope":"source.x10","language_id":397},"XC":{"type":"programming","color":"#99DA07","extensions":[".xc"],"tm_scope":"source.xc","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":398},"XCompose":{"type":"data","filenames":[".XCompose","XCompose","xcompose"],"tm_scope":"config.xcompose","ace_mode":"text","language_id":225167241},"XML":{"type":"data","color":"#0060ac","tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","aliases":["rss","xsd","wsdl"],"extensions":[".xml",".adml",".admx",".ant",".axaml",".axml",".builds",".ccproj",".ccxml",".clixml",".cproject",".cscfg",".csdef",".csl",".csproj",".ct",".depproj",".dita",".ditamap",".ditaval",".dll.config",".dotsettings",".filters",".fsproj",".fxml",".glade",".gml",".gmx",".gpx",".grxml",".gst",".hzp",".icls",".iml",".ivy",".jelly",".jsproj",".kml",".launch",".mdpolicy",".mjml",".mm",".mod",".mojo",".mxml",".natvis",".ncl",".ndproj",".nproj",".nuspec",".odd",".osm",".pkgproj",".pluginspec",".proj",".props",".ps1xml",".psc1",".pt",".pubxml",".qhelp",".rdf",".res",".resx",".rs",".rss",".sch",".scxml",".sfproj",".shproj",".slnx",".srdf",".storyboard",".sublime-snippet",".sw",".targets",".tml",".ts",".tsx",".typ",".ui",".urdf",".ux",".vbproj",".vcxproj",".vsixmanifest",".vssettings",".vstemplate",".vxml",".wixproj",".workflow",".wsdl",".wsf",".wxi",".wxl",".wxs",".x3d",".xacro",".xaml",".xib",".xlf",".xliff",".xmi",".xml.dist",".xmp",".xproj",".xsd",".xspec",".xul",".zcml"],"filenames":[".classpath",".cproject",".project","App.config","NuGet.config","Settings.StyleCop","Web.Debug.config","Web.Release.config","Web.config","packages.config"],"language_id":399},"XML Property List":{"type":"data","color":"#0060ac","group":"XML","extensions":[".plist",".stTheme",".tmCommand",".tmLanguage",".tmPreferences",".tmSnippet",".tmTheme"],"tm_scope":"text.xml.plist","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":75622871},"XPages":{"type":"data","extensions":[".xsp-config",".xsp.metadata"],"tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":400},"XProc":{"type":"programming","extensions":[".xpl",".xproc"],"tm_scope":"text.xml","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","language_id":401},"XQuery":{"type":"programming","color":"#5232e7","extensions":[".xquery",".xq",".xql",".xqm",".xqy"],"ace_mode":"xquery","codemirror_mode":"xquery","codemirror_mime_type":"application/xquery","tm_scope":"source.xq","language_id":402},"XS":{"type":"programming","extensions":[".xs"],"tm_scope":"source.c","ace_mode":"c_cpp","codemirror_mode":"clike","codemirror_mime_type":"text/x-csrc","language_id":403},"XSLT":{"type":"programming","aliases":["xsl"],"extensions":[".xslt",".xsl"],"tm_scope":"text.xml.xsl","ace_mode":"xml","codemirror_mode":"xml","codemirror_mime_type":"text/xml","color":"#EB8CEB","language_id":404},"Xmake":{"type":"programming","color":"#22a079","filenames":["xmake.lua"],"tm_scope":"source.xmake","ace_mode":"text","language_id":225223071},"Xojo":{"type":"programming","color":"#81bd41","extensions":[".xojo_code",".xojo_menu",".xojo_report",".xojo_script",".xojo_toolbar",".xojo_window"],"tm_scope":"source.xojo","ace_mode":"text","language_id":405},"Xonsh":{"type":"programming","color":"#285EEF","extensions":[".xsh"],"tm_scope":"source.python","ace_mode":"text","codemirror_mode":"python","codemirror_mime_type":"text/x-python","language_id":614078284},"Xtend":{"type":"programming","color":"#24255d","extensions":[".xtend"],"tm_scope":"source.xtend","ace_mode":"text","language_id":406},"YAML":{"type":"data","color":"#cb171e","tm_scope":"source.yaml","aliases":["yml"],"extensions":[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],"filenames":[".clang-format",".clang-tidy",".clangd",".gemrc","CITATION.cff","glide.lock","pixi.lock","yarn.lock"],"ace_mode":"yaml","codemirror_mode":"yaml","codemirror_mime_type":"text/x-yaml","language_id":407},"YANG":{"type":"data","extensions":[".yang"],"tm_scope":"source.yang","ace_mode":"text","language_id":408},"YARA":{"type":"programming","color":"#220000","ace_mode":"text","extensions":[".yar",".yara"],"tm_scope":"source.yara","language_id":805122868},"YASnippet":{"type":"markup","aliases":["snippet","yas"],"color":"#32AB90","extensions":[".yasnippet"],"tm_scope":"source.yasnippet","ace_mode":"text","language_id":378760102},"Yacc":{"type":"programming","extensions":[".y",".yacc",".yy"],"tm_scope":"source.yacc","ace_mode":"text","color":"#4B6C4B","language_id":409},"Yul":{"type":"programming","color":"#794932","ace_mode":"text","tm_scope":"source.yul","extensions":[".yul"],"language_id":237469033},"ZAP":{"type":"programming","color":"#0d665e","extensions":[".zap",".xzap"],"tm_scope":"source.zap","ace_mode":"text","language_id":952972794},"ZIL":{"type":"programming","color":"#dc75e5","extensions":[".zil",".mud"],"tm_scope":"source.zil","ace_mode":"text","language_id":973483626},"Zeek":{"type":"programming","aliases":["bro"],"extensions":[".zeek",".bro"],"tm_scope":"source.zeek","ace_mode":"zeek","language_id":40},"ZenScript":{"type":"programming","color":"#00BCD1","extensions":[".zs"],"tm_scope":"source.zenscript","ace_mode":"text","language_id":494938890},"Zephir":{"type":"programming","color":"#118f9e","extensions":[".zep"],"tm_scope":"source.php.zephir","ace_mode":"php","language_id":410},"Zig":{"type":"programming","color":"#ec915c","extensions":[".zig",".zig.zon"],"tm_scope":"source.zig","ace_mode":"zig","language_id":646424281},"Zimpl":{"type":"programming","color":"#d67711","extensions":[".zimpl",".zmpl",".zpl"],"tm_scope":"none","ace_mode":"text","language_id":411},"Zmodel":{"type":"data","color":"#ff7100","extensions":[".zmodel"],"tm_scope":"source.zmodel","ace_mode":"text","language_id":803760908},"cURL Config":{"type":"data","group":"INI","aliases":["curlrc"],"filenames":[".curlrc","_curlrc"],"tm_scope":"source.curlrc","ace_mode":"text","language_id":992375436},"crontab":{"type":"data","color":"#ead7ac","aliases":["cron","cron table"],"filenames":["crontab"],"tm_scope":"text.crontab","ace_mode":"tcl","language_id":705203557},"desktop":{"type":"data","extensions":[".desktop",".desktop.in",".service"],"tm_scope":"source.desktop","ace_mode":"text","language_id":412},"dircolors":{"type":"data","extensions":[".dircolors"],"filenames":[".dir_colors",".dircolors","DIR_COLORS","_dir_colors","_dircolors","dir_colors"],"tm_scope":"source.dircolors","ace_mode":"text","language_id":691605112},"eC":{"type":"programming","color":"#913960","extensions":[".ec",".eh"],"tm_scope":"source.c.ec","ace_mode":"text","language_id":413},"edn":{"type":"data","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"application/edn","extensions":[".edn"],"tm_scope":"source.clojure","language_id":414},"fish":{"type":"programming","color":"#4aae47","group":"Shell","interpreters":["fish"],"extensions":[".fish"],"tm_scope":"source.fish","ace_mode":"text","language_id":415},"hoon":{"type":"programming","color":"#00b171","tm_scope":"source.hoon","ace_mode":"text","extensions":[".hoon"],"language_id":560883276},"iCalendar":{"type":"data","color":"#ec564c","extensions":[".ics",".ical"],"tm_scope":"source.iCalendar","aliases":["iCal"],"ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":98384424},"jq":{"color":"#c7254e","ace_mode":"text","type":"programming","extensions":[".jq"],"interpreters":["gojq","jaq","jq","jqjq","jqq","query-json"],"tm_scope":"source.jq","language_id":905371884},"kvlang":{"type":"markup","ace_mode":"text","extensions":[".kv"],"color":"#1da6e0","tm_scope":"source.python.kivy","language_id":970675279},"mIRC Script":{"type":"programming","color":"#3d57c3","extensions":[".mrc"],"tm_scope":"source.msl","ace_mode":"text","language_id":517654727},"mcfunction":{"type":"programming","color":"#E22837","extensions":[".mcfunction"],"tm_scope":"source.mcfunction","ace_mode":"text","language_id":462488745},"mdsvex":{"type":"markup","color":"#5f9ea0","tm_scope":"none","ace_mode":"markdown","codemirror_mode":"gfm","codemirror_mime_type":"text/x-gfm","wrap":true,"extensions":[".svx"],"language_id":566198445},"mupad":{"type":"programming","color":"#244963","extensions":[".mu"],"tm_scope":"source.mupad","ace_mode":"text","language_id":416},"nanorc":{"type":"data","color":"#2d004d","group":"INI","extensions":[".nanorc"],"filenames":[".nanorc","nanorc"],"tm_scope":"source.nanorc","ace_mode":"text","language_id":775996197},"nesC":{"type":"programming","color":"#94B0C7","extensions":[".nc"],"ace_mode":"text","tm_scope":"source.nesc","language_id":417},"ooc":{"type":"programming","color":"#b0b77e","extensions":[".ooc"],"tm_scope":"source.ooc","ace_mode":"text","language_id":418},"q":{"type":"programming","extensions":[".q"],"tm_scope":"source.q","ace_mode":"text","codemirror_mode":"q","codemirror_mime_type":"text/x-q","color":"#0040cd","language_id":970539067},"reStructuredText":{"type":"prose","color":"#141414","wrap":true,"aliases":["rst"],"extensions":[".rst",".rest",".rest.txt",".rst.txt"],"tm_scope":"text.restructuredtext","ace_mode":"rst","codemirror_mode":"rst","codemirror_mime_type":"text/x-rst","language_id":419},"robots.txt":{"type":"data","aliases":["robots","robots txt"],"filenames":["robots.txt"],"ace_mode":"text","tm_scope":"text.robots-txt","language_id":674736065},"sed":{"type":"programming","color":"#64b970","extensions":[".sed"],"interpreters":["gsed","minised","sed","ssed"],"ace_mode":"text","tm_scope":"source.sed","language_id":847830017},"templ":{"type":"markup","color":"#66D0DD","extensions":[".templ"],"ace_mode":"text","tm_scope":"source.templ","language_id":795579337},"vCard":{"type":"data","color":"#ee2647","extensions":[".vcf"],"tm_scope":"source.vcard","aliases":["virtual contact file","electronic business card"],"ace_mode":"properties","codemirror_mode":"properties","codemirror_mime_type":"text/x-properties","language_id":851476558},"wisp":{"type":"programming","ace_mode":"clojure","codemirror_mode":"clojure","codemirror_mime_type":"text/x-clojure","color":"#7582D1","extensions":[".wisp"],"tm_scope":"source.clojure","language_id":420},"xBase":{"type":"programming","color":"#403a40","aliases":["advpl","clipper","foxpro"],"extensions":[".prg",".ch",".prw"],"tm_scope":"source.harbour","ace_mode":"text","language_id":421}}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license https://github.com/onury/invert-color */
!function(r,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):r.invert=n()}(this,function(){"use strict";var t=Math.sqrt(1.05*.05)-.05,n=/^(?:[0-9a-f]{3}){1,2}$/i,i={black:"#000000",white:"#ffffff",threshold:t};function o(r){if("#"===r.slice(0,1)&&(r=r.slice(1)),!n.test(r))throw new Error('Invalid HEX color: "'+r+'"');return 3===r.length&&(r=r[0]+r[0]+r[1]+r[1]+r[2]+r[2]),[parseInt(r.slice(0,2),16),parseInt(r.slice(2,4),16),parseInt(r.slice(4,6),16)]}function f(r){if(!r)throw new Error("Invalid color value");return Array.isArray(r)?r:"string"==typeof r?o(r):[r.r,r.g,r.b]}function u(r,n,t){var e=!0===n?i:Object.assign({},i,n);return function(r){var n,t,e=[];for(n=0;n<r.length;n++)t=r[n]/255,e[n]=t<=.03928?t/12.92:Math.pow((t+.055)/1.055,2.4);return.2126*e[0]+.7152*e[1]+.0722*e[2]}(r)>e.threshold?t?o(e.black):e.black:t?o(e.white):e.white}function r(r,n){return void 0===n&&(n=!1),r=f(r),n?u(r,n):"#"+r.map(function(r){return n=(255-r).toString(16),void 0===t&&(t=2),(new Array(t).join("0")+n).slice(-t);var n,t}).join("")}return function(r){function n(r,n){r=f(r);var t,e=n?u(r,n,!0):r.map(function(r){return 255-r});return{r:(t=e)[0],g:t[1],b:t[2]}}r.asRGB=n,r.asRgbArray=function(r,n){return r=f(r),n?u(r,n,!0):r.map(function(r){return 255-r})},r.defaultThreshold=t,r.asRgbObject=n}(r||(r={})),r});

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = [{"id":0,"component_name":"Patch","qa_url":"https://github.com/gpennington/django-boilerplate/pull/8","diff_url":"https://github.com/gpennington/django-boilerplate/pull/8.diff","created_date":"2012-03-19","accepted_date":null,"title":"Fix missing endblock error.","actor":0},{"id":1,"component_name":"Patch","qa_url":"https://github.com/vim-scripts/Tail-Bundle/pull/1","diff_url":"https://github.com/vim-scripts/Tail-Bundle/pull/1.diff","created_date":"2012-03-22","accepted_date":null,"title":"mispelling","actor":1},{"id":2,"component_name":"Patch","qa_url":"https://github.com/vim-scripts/Tail-Bundle/pull/2","diff_url":"https://github.com/vim-scripts/Tail-Bundle/pull/2.diff","created_date":"2012-03-22","accepted_date":null,"title":"Enhancements to split pane log viewing","actor":1},{"id":3,"component_name":"Patch","qa_url":"https://github.com/ahutchings/kohana-modules/pull/82","diff_url":"https://github.com/ahutchings/kohana-modules/pull/82.diff","created_date":"2012-05-24","accepted_date":"2012-05-24","title":"Add raven module","actor":2},{"id":4,"component_name":"Patch","qa_url":"https://github.com/cburgmer/cjklib/pull/1","diff_url":"https://github.com/cburgmer/cjklib/pull/1.diff","created_date":"2012-08-05","accepted_date":null,"title":"Configuring install location","actor":3},{"id":5,"component_name":"Patch","qa_url":"https://github.com/readthedocs/readthedocs.org/pull/229","diff_url":"https://github.com/readthedocs/readthedocs.org/pull/229.diff","created_date":"2012-08-11","accepted_date":"2012-08-21","title":"typo for log.error on tastyapi client for Crate.io","actor":4},{"id":6,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/82","diff_url":"https://github.com/aurajs/aura/pull/82.diff","created_date":"2012-08-15","accepted_date":"2012-08-18","title":"make aura files pass jshint","actor":5},{"id":7,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/83","diff_url":"https://github.com/aurajs/aura/pull/83.diff","created_date":"2012-08-15","accepted_date":null,"title":"Remove extraneous per-file jshint options and globals","actor":5},{"id":8,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette/pull/219","diff_url":"https://github.com/marionettejs/backbone.marionette/pull/219.diff","created_date":"2012-08-15","accepted_date":"2012-08-16","title":"Documentation update, BindTo to EventBinder.","actor":6},{"id":9,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/88","diff_url":"https://github.com/aurajs/aura/pull/88.diff","created_date":"2012-08-20","accepted_date":"2012-08-22","title":"Tabs to 2 spaces, idiomatic.js / jsbeautify, cleaning","actor":5},{"id":10,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette/pull/227","diff_url":"https://github.com/marionettejs/backbone.marionette/pull/227.diff","created_date":"2012-08-22","accepted_date":null,"title":"comment typo in async.itemView.js ","actor":6},{"id":11,"component_name":"Patch","qa_url":"https://github.com/spolu/dwm.vim/pull/8","diff_url":"https://github.com/spolu/dwm.vim/pull/8.diff","created_date":"2012-08-23","accepted_date":"2012-08-24","title":"Cleaning, trailing ws, indentation, newlines","actor":7},{"id":12,"component_name":"Patch","qa_url":"https://github.com/spolu/dwm.vim/pull/9","diff_url":"https://github.com/spolu/dwm.vim/pull/9.diff","created_date":"2012-08-23","accepted_date":null,"title":"Vertical resizing with Ctrl-H and Ctrl-L","actor":7},{"id":13,"component_name":"Patch","qa_url":"https://github.com/mxriverlynn/backbone.marionette.async/pull/1","diff_url":"https://github.com/mxriverlynn/backbone.marionette.async/pull/1.diff","created_date":"2012-09-05","accepted_date":null,"title":"Typo in comments","actor":8},{"id":14,"component_name":"Patch","qa_url":"https://github.com/mxriverlynn/backbone.marionette.async/pull/2","diff_url":"https://github.com/mxriverlynn/backbone.marionette.async/pull/2.diff","created_date":"2012-09-05","accepted_date":null,"title":"Typo","actor":8},{"id":15,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette.async/pull/3","diff_url":"https://github.com/marionettejs/backbone.marionette.async/pull/3.diff","created_date":"2012-09-05","accepted_date":"2012-09-06","title":"Comment typo.","actor":8},{"id":16,"component_name":"Patch","qa_url":"https://github.com/funkbit/django-dynamicresponse/pull/3","diff_url":"https://github.com/funkbit/django-dynamicresponse/pull/3.diff","created_date":"2012-09-09","accepted_date":"2012-09-19","title":"Clean trailing whitespace","actor":9},{"id":17,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette/pull/244","diff_url":"https://github.com/marionettejs/backbone.marionette/pull/244.diff","created_date":"2012-09-11","accepted_date":"2012-09-11","title":"Update docs/marionette.eventaggregator.md (fix URL)","actor":6},{"id":18,"component_name":"Patch","qa_url":"https://github.com/powmedia/backbone-deep-model/pull/23","diff_url":"https://github.com/powmedia/backbone-deep-model/pull/23.diff","created_date":"2012-09-11","accepted_date":"2012-10-12","title":"JSHint linting","actor":10},{"id":19,"component_name":"Patch","qa_url":"https://github.com/jarus/flask-rst/pull/16","diff_url":"https://github.com/jarus/flask-rst/pull/16.diff","created_date":"2012-09-14","accepted_date":"2012-09-14","title":"Correct flask module paths","actor":11},{"id":20,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette/pull/256","diff_url":"https://github.com/marionettejs/backbone.marionette/pull/256.diff","created_date":"2012-09-24","accepted_date":null,"title":"Backbone.Marionette check for DOM library argument","actor":6},{"id":21,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/126","diff_url":"https://github.com/aurajs/aura/pull/126.diff","created_date":"2012-10-03","accepted_date":"2012-10-06","title":"Contribution guidelines","actor":5},{"id":22,"component_name":"Patch","qa_url":"https://github.com/marionettejs/backbone.marionette/pull/271","diff_url":"https://github.com/marionettejs/backbone.marionette/pull/271.diff","created_date":"2012-10-05","accepted_date":null,"title":"Documentation fix in MarionetteApplication","actor":6},{"id":23,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/136","diff_url":"https://github.com/aurajs/aura/pull/136.diff","created_date":"2012-10-11","accepted_date":"2012-10-11","title":"Basic routing example for demo","actor":5},{"id":24,"component_name":"Patch","qa_url":"https://github.com/zaiste/tmuxed/pull/2","diff_url":"https://github.com/zaiste/tmuxed/pull/2.diff","created_date":"2012-10-17","accepted_date":"2012-10-18","title":"CPU meter like tmux-mem-cpu-load","actor":12},{"id":25,"component_name":"Patch","qa_url":"https://github.com/cburgmer/cjklib/pull/4","diff_url":"https://github.com/cburgmer/cjklib/pull/4.diff","created_date":"2012-10-18","accepted_date":null,"title":"Fix SQL error with mysql on charactershanghaineseipa","actor":3},{"id":26,"component_name":"Patch","qa_url":"https://github.com/pallets/flask/pull/617","diff_url":"https://github.com/pallets/flask/pull/617.diff","created_date":"2012-10-19","accepted_date":"2013-01-25","title":"jQuery example: submit on enter, focus field on load, ajax to callback function, \" to '.","actor":13},{"id":27,"component_name":"Patch","qa_url":"https://github.com/twbs/bootstrap/pull/5954","diff_url":"https://github.com/twbs/bootstrap/pull/5954.diff","created_date":"2012-11-19","accepted_date":"2012-11-19","title":"Fix typo in reset.less","actor":14},{"id":28,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/158","diff_url":"https://github.com/aurajs/aura/pull/158.diff","created_date":"2012-11-20","accepted_date":null,"title":"Individual sandbox injection into widgets (rebase'd)","actor":5},{"id":29,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/169","diff_url":"https://github.com/aurajs/aura/pull/169.diff","created_date":"2012-11-24","accepted_date":null,"title":"pubsub + perms: wildcards, namespaces","actor":5},{"id":30,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/177","diff_url":"https://github.com/aurajs/aura/pull/177.diff","created_date":"2012-12-15","accepted_date":null,"title":"pubsub + perms: wildcards, namespaces (topics for permissions)","actor":5},{"id":31,"component_name":"Patch","qa_url":"https://github.com/aurajs/aura/pull/178","diff_url":"https://github.com/aurajs/aura/pull/178.diff","created_date":"2012-12-26","accepted_date":"2013-01-05","title":"pubsub + perms: wildcards, namespaces (sandbox permissions)","actor":5},{"id":32,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/1","diff_url":"https://github.com/sbellity/aura-express/pull/1.diff","created_date":"2013-01-11","accepted_date":"2013-01-11","title":"Docs submodule","actor":15},{"id":33,"component_name":"Patch","qa_url":"https://github.com/sindresorhus/grunt-recess/pull/22","diff_url":"https://github.com/sindresorhus/grunt-recess/pull/22.diff","created_date":"2013-01-17","accepted_date":"2013-01-17","title":"Updating to support new this.filesSrc property per gruntjs/grunt#606.","actor":16},{"id":34,"component_name":"Patch","qa_url":"https://github.com/kmiyashiro/grunt-mocha/pull/41","diff_url":"https://github.com/kmiyashiro/grunt-mocha/pull/41.diff","created_date":"2013-01-18","accepted_date":"2013-01-21","title":"Add support for URL's in latest grunt. Unit test for phantomjs connect s...","actor":17},{"id":35,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/2","diff_url":"https://github.com/sbellity/aura-express/pull/2.diff","created_date":"2013-01-19","accepted_date":"2013-01-19","title":"Update for grunt 0.4 rc5/rc6","actor":15},{"id":36,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/3","diff_url":"https://github.com/sbellity/aura-express/pull/3.diff","created_date":"2013-01-20","accepted_date":"2013-01-20","title":"Latest package updates for grunt 0.4 rc5/rc6 for modularize branch","actor":15},{"id":37,"component_name":"Patch","qa_url":"https://github.com/kmiyashiro/grunt-mocha/pull/42","diff_url":"https://github.com/kmiyashiro/grunt-mocha/pull/42.diff","created_date":"2013-01-21","accepted_date":"2013-02-13","title":"Code tweaks, Travis and documentation updates.","actor":17},{"id":38,"component_name":"Patch","qa_url":"https://github.com/xioup/underscoreDeepExtend/pull/1","diff_url":"https://github.com/xioup/underscoreDeepExtend/pull/1.diff","created_date":"2013-01-23","accepted_date":"2013-01-25","title":"Typo","actor":18},{"id":39,"component_name":"Patch","qa_url":"https://github.com/sindresorhus/grunt-recess/pull/24","diff_url":"https://github.com/sindresorhus/grunt-recess/pull/24.diff","created_date":"2013-01-24","accepted_date":null,"title":"bump version number 0.2.1 for srcFiles fix.","actor":16},{"id":40,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/4","diff_url":"https://github.com/sbellity/aura-express/pull/4.diff","created_date":"2013-01-26","accepted_date":null,"title":"Update package.json to normal npm, docs ref","actor":15},{"id":41,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/5","diff_url":"https://github.com/sbellity/aura-express/pull/5.diff","created_date":"2013-01-26","accepted_date":"2013-01-26","title":"Update docs ref and grunt-mocha to normal npm package","actor":15},{"id":42,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express/pull/6","diff_url":"https://github.com/sbellity/aura-express/pull/6.diff","created_date":"2013-01-27","accepted_date":"2013-01-27","title":"Extra notes","actor":15},{"id":43,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express-example/pull/1","diff_url":"https://github.com/sbellity/aura-express-example/pull/1.diff","created_date":"2013-01-27","accepted_date":null,"title":"Fix paths for extensions.","actor":19},{"id":44,"component_name":"Patch","qa_url":"https://github.com/sbellity/aura-express-example/pull/2","diff_url":"https://github.com/sbellity/aura-express-example/pull/2.diff","created_date":"2013-01-27","accepted_date":"2013-01-27","title":"Fix paths to use bower component extensions","actor":19},{"id":45,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt/pull/3640","diff_url":"https://github.com/saltstack/salt/pull/3640.diff","created_date":"2013-02-07","accepted_date":"2013-02-08","title":"Fix links to OS X installation docs","actor":20},{"id":46,"component_name":"Patch","qa_url":"https://github.com/vmware-archive/salt-vim/pull/8","diff_url":"https://github.com/vmware-archive/salt-vim/pull/8.diff","created_date":"2013-02-17","accepted_date":"2013-02-17","title":"Delimeter for NERDCommenter","actor":21},{"id":47,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt/pull/3761","diff_url":"https://github.com/saltstack/salt/pull/3761.diff","created_date":"2013-02-17","accepted_date":"2013-02-21","title":"Recurse mode / chmod permissions for file.directory refs: #3471.","actor":20},{"id":48,"component_name":"Patch","qa_url":"https://github.com/tactivos/grunt-cdn/pull/4","diff_url":"https://github.com/tactivos/grunt-cdn/pull/4.diff","created_date":"2013-02-20","accepted_date":null,"title":"Grunt 0.4 updates - not fully tested. #2 #3","actor":22},{"id":49,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt/pull/3829","diff_url":"https://github.com/saltstack/salt/pull/3829.diff","created_date":"2013-02-23","accepted_date":"2013-02-24","title":"Make sure makedirs: True accounts for case where a trailing slash exists","actor":20},{"id":50,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt/pull/3830","diff_url":"https://github.com/saltstack/salt/pull/3830.diff","created_date":"2013-02-24","accepted_date":"2013-02-24","title":"modules.pip editable to handle use case with local module w/o egg.","actor":20},{"id":51,"component_name":"Patch","qa_url":"https://github.com/stevenbenner/jquery-powertip/pull/55","diff_url":"https://github.com/stevenbenner/jquery-powertip/pull/55.diff","created_date":"2013-02-26","accepted_date":"2013-03-09","title":"AMD Wrapper","actor":23},{"id":52,"component_name":"Patch","qa_url":"https://github.com/zaiste/tmuxed/pull/5","diff_url":"https://github.com/zaiste/tmuxed/pull/5.diff","created_date":"2013-05-04","accepted_date":"2013-05-04","title":"Improve memory readings","actor":12},{"id":53,"component_name":"Patch","qa_url":"https://github.com/gruntjs/grunt-contrib-livereload/pull/46","diff_url":"https://github.com/gruntjs/grunt-contrib-livereload/pull/46.diff","created_date":"2013-05-20","accepted_date":"2013-05-21","title":"Typo readme.md","actor":24},{"id":54,"component_name":"Patch","qa_url":"https://github.com/noveogroup/backbone.iobind/pull/40","diff_url":"https://github.com/noveogroup/backbone.iobind/pull/40.diff","created_date":"2013-05-21","accepted_date":null,"title":"Add define() to UMD to make proper AMD package","actor":25},{"id":55,"component_name":"Patch","qa_url":"https://github.com/gorakhargosh/watchdog/pull/185","diff_url":"https://github.com/gorakhargosh/watchdog/pull/185.diff","created_date":"2013-10-17","accepted_date":"2013-10-24","title":"Readability, enable pygments highlighting in README.rst","actor":26},{"id":56,"component_name":"Patch","qa_url":"https://github.com/remi/teamocil/pull/51","diff_url":"https://github.com/remi/teamocil/pull/51.diff","created_date":"2013-10-17","accepted_date":null,"title":"Travis to test multiple version of tmux","actor":27},{"id":57,"component_name":"Patch","qa_url":"https://github.com/tmuxinator/tmuxinator/pull/164","diff_url":"https://github.com/tmuxinator/tmuxinator/pull/164.diff","created_date":"2013-10-17","accepted_date":"2013-10-18","title":"travis test matrix against multiple tmux versions","actor":28},{"id":58,"component_name":"Patch","qa_url":"https://github.com/neithere/argh/pull/48","diff_url":"https://github.com/neithere/argh/pull/48.diff","created_date":"2013-10-27","accepted_date":"2013-11-04","title":"README to README.rst for github project page formatting","actor":29},{"id":59,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/14","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/14.diff","created_date":"2013-11-03","accepted_date":"2013-11-04","title":"Python package","actor":30},{"id":60,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/19","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/19.diff","created_date":"2013-11-04","accepted_date":"2013-11-04","title":"Pythonic things","actor":30},{"id":61,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/20","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/20.diff","created_date":"2013-11-04","accepted_date":"2013-11-04","title":"Sphinx sass updates for sidebar, images, autodoc api","actor":30},{"id":62,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/28","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/28.diff","created_date":"2013-11-05","accepted_date":"2013-11-05","title":"New demo content, sass fixes for inline code, autodoc code. Styling for code.","actor":30},{"id":63,"component_name":"Patch","qa_url":"https://github.com/alex-rudakov/sphinx-argparse/pull/2","diff_url":"https://github.com/alex-rudakov/sphinx-argparse/pull/2.diff","created_date":"2013-11-05","accepted_date":"2013-11-06","title":"Fix issue where Sub-commands: would show where no definition items exist...","actor":31},{"id":64,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/38","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/38.diff","created_date":"2013-11-05","accepted_date":"2013-11-05","title":"Examples for issue #34 and #35 for dave tomorrow","actor":30},{"id":65,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/47","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/47.diff","created_date":"2013-11-07","accepted_date":"2013-11-07","title":"Add demo.txt from docutils project to demo. Add it as a page to toc.","actor":30},{"id":66,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/49","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/49.diff","created_date":"2013-11-07","accepted_date":"2013-11-07","title":"Demo docs for list. Show padding/spacing issues with links / inline lite...","actor":30},{"id":67,"component_name":"Patch","qa_url":"https://github.com/pallets/werkzeug/pull/462","diff_url":"https://github.com/pallets/werkzeug/pull/462.diff","created_date":"2013-11-18","accepted_date":"2014-01-05","title":"Update LICENSE 2013","actor":32},{"id":68,"component_name":"Patch","qa_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/63","diff_url":"https://github.com/readthedocs/sphinx_rtd_theme/pull/63.diff","created_date":"2013-11-25","accepted_date":null,"title":"Github badge via theme option","actor":30},{"id":69,"component_name":"Patch","qa_url":"https://github.com/amitu/importd/pull/21","diff_url":"https://github.com/amitu/importd/pull/21.diff","created_date":"2013-11-28","accepted_date":"2013-11-28","title":"README: rst fixes, highlighting.","actor":33},{"id":70,"component_name":"Patch","qa_url":"https://github.com/neiesc/awesome-minimalist/pull/19","diff_url":"https://github.com/neiesc/awesome-minimalist/pull/19.diff","created_date":"2013-12-18","accepted_date":"2013-12-18","title":"Minimalist front-end frameworks for JS + DOM. Backbone, spine, aura.","actor":34},{"id":71,"component_name":"Patch","qa_url":"https://github.com/djangopackages/djangopackages/pull/264","diff_url":"https://github.com/djangopackages/djangopackages/pull/264.diff","created_date":"2014-01-01","accepted_date":"2014-01-02","title":"Fix features list indent in README.rst.","actor":35},{"id":72,"component_name":"Patch","qa_url":"https://github.com/ScottDuckworth/python-anyvcs/pull/38","diff_url":"https://github.com/ScottDuckworth/python-anyvcs/pull/38.diff","created_date":"2014-01-06","accepted_date":"2014-01-21","title":"Reorganize sphinx docs to more common format.","actor":36},{"id":73,"component_name":"Patch","qa_url":"https://github.com/ScottDuckworth/python-anyvcs/pull/39","diff_url":"https://github.com/ScottDuckworth/python-anyvcs/pull/39.diff","created_date":"2014-01-06","accepted_date":"2014-01-21","title":"PEP8 Indentation, lines and spacing.","actor":36},{"id":74,"component_name":"Patch","qa_url":"https://github.com/OCamlPro/ocp-indent/pull/111","diff_url":"https://github.com/OCamlPro/ocp-indent/pull/111.diff","created_date":"2014-01-09","accepted_date":"2014-01-09","title":"Correct OPAM post-message for vim plugin.","actor":37},{"id":75,"component_name":"Patch","qa_url":"https://github.com/pallets/werkzeug/pull/483","diff_url":"https://github.com/pallets/werkzeug/pull/483.diff","created_date":"2014-01-16","accepted_date":"2014-03-21","title":"Remove duplicate test for utils.import_string.","actor":32},{"id":76,"component_name":"Patch","qa_url":"https://github.com/frictionlessdata/datapackage/pull/91","diff_url":"https://github.com/frictionlessdata/datapackage/pull/91.diff","created_date":"2014-01-19","accepted_date":"2014-01-20","title":"Fix ReST list indentation.","actor":38},{"id":77,"component_name":"Patch","qa_url":"https://github.com/Shougo/unite.vim/pull/474","diff_url":"https://github.com/Shougo/unite.vim/pull/474.diff","created_date":"2014-01-31","accepted_date":"2014-01-31","title":"doc: Typo in file_rec","actor":39},{"id":78,"component_name":"Patch","qa_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/16","diff_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/16.diff","created_date":"2014-02-03","accepted_date":"2014-02-20","title":"Remove broken link to lucuma. Add link to my fork.","actor":40},{"id":79,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/8","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/8.diff","created_date":"2014-03-18","accepted_date":"2014-03-20","title":"For #5, modernize python package, testsuite.","actor":41},{"id":80,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/10","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/10.diff","created_date":"2014-03-20","accepted_date":"2014-03-20","title":"#6 PEP8 / autopep8","actor":41},{"id":81,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/13","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/13.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"Fix pypi badge.","actor":41},{"id":82,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/14","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/14.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"Note about python version support","actor":41},{"id":83,"component_name":"Patch","qa_url":"https://github.com/zzzeek/sqlalchemy/pull/81","diff_url":"https://github.com/zzzeek/sqlalchemy/pull/81.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"Fix tag typo in changelog_09","actor":42},{"id":84,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/15","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/15.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"#7 ReadTheDocs support","actor":41},{"id":85,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/16","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/16.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"Don't cover `tests/__init__`, `__init__`, `__about__` or `_compat`.","actor":41},{"id":86,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/17","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/17.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"Docs: fix installation page, show pip install on README.","actor":41},{"id":87,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/18","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/18.diff","created_date":"2014-03-21","accepted_date":"2014-03-21","title":"MANIFEST.in","actor":41},{"id":88,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/20","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/20.diff","created_date":"2014-03-21","accepted_date":"2014-03-22","title":"Python 3 support, fix #2.","actor":41},{"id":89,"component_name":"Patch","qa_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/21","diff_url":"https://github.com/monetizeio/sqlalchemy-orm-tree/pull/21.diff","created_date":"2014-03-29","accepted_date":"2015-05-23","title":"travis-ci: #19 Test against matrix of sqlalchemy versions","actor":41},{"id":90,"component_name":"Patch","qa_url":"https://github.com/enkore/i3pystatus/pull/47","diff_url":"https://github.com/enkore/i3pystatus/pull/47.diff","created_date":"2014-04-05","accepted_date":null,"title":"README: Weather module displays incorrect args","actor":43},{"id":91,"component_name":"Patch","qa_url":"https://github.com/funkbit/django-dynamicresponse/pull/5","diff_url":"https://github.com/funkbit/django-dynamicresponse/pull/5.diff","created_date":"2014-04-21","accepted_date":null,"title":"Check for json in standard lib, if not check simplejson in django.utils fix #4","actor":9},{"id":92,"component_name":"Patch","qa_url":"https://github.com/funkbit/django-dynamicresponse/pull/7","diff_url":"https://github.com/funkbit/django-dynamicresponse/pull/7.diff","created_date":"2014-04-21","accepted_date":null,"title":"Fix #6: Make AuthenticationMiddleware optional.","actor":9},{"id":93,"component_name":"Patch","qa_url":"https://github.com/klen/.vim/pull/5","diff_url":"https://github.com/klen/.vim/pull/5.diff","created_date":"2014-04-21","accepted_date":"2014-04-22","title":"Fix type xhtml","actor":44},{"id":94,"component_name":"Patch","qa_url":"https://github.com/maksimr/vim-jsbeautify/pull/54","diff_url":"https://github.com/maksimr/vim-jsbeautify/pull/54.diff","created_date":"2014-05-06","accepted_date":"2014-05-06","title":"Fix typo in code","actor":45},{"id":95,"component_name":"Patch","qa_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/25","diff_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/25.diff","created_date":"2014-05-23","accepted_date":"2014-05-24","title":"README Fix link to comparison tony/cookiecutter-pypackage","actor":40},{"id":96,"component_name":"Patch","qa_url":"https://github.com/mxriverlynn/backbone.modelbinding/pull/88","diff_url":"https://github.com/mxriverlynn/backbone.modelbinding/pull/88.diff","created_date":"2014-05-25","accepted_date":"2014-05-27","title":"Add a link to Backbone.Stickit.","actor":46},{"id":97,"component_name":"Patch","qa_url":"https://github.com/pallets-eco/flask-security-3.0/pull/284","diff_url":"https://github.com/pallets-eco/flask-security-3.0/pull/284.diff","created_date":"2014-07-16","accepted_date":"2014-09-17","title":"Typo","actor":47},{"id":98,"component_name":"Patch","qa_url":"https://github.com/caolan/forms/pull/139","diff_url":"https://github.com/caolan/forms/pull/139.diff","created_date":"2014-07-29","accepted_date":"2014-08-23","title":"README readability, highlighting updates","actor":48},{"id":99,"component_name":"Patch","qa_url":"https://github.com/gu-fan/riv.vim/pull/69","diff_url":"https://github.com/gu-fan/riv.vim/pull/69.diff","created_date":"2014-08-06","accepted_date":"2014-08-06","title":"Typo","actor":49},{"id":100,"component_name":"Patch","qa_url":"https://github.com/mjumbewu/djangobars/pull/8","diff_url":"https://github.com/mjumbewu/djangobars/pull/8.diff","created_date":"2014-08-24","accepted_date":null,"title":"Fix #7, djangobars response imports prevents HandlebarsResponse from import","actor":50},{"id":101,"component_name":"Patch","qa_url":"https://github.com/wbond/pybars3/pull/7","diff_url":"https://github.com/wbond/pybars3/pull/7.diff","created_date":"2014-08-25","accepted_date":"2014-09-05","title":"Correct typo to pymeta","actor":51},{"id":102,"component_name":"Patch","qa_url":"https://github.com/facebook/facebook-python-business-sdk/pull/2","diff_url":"https://github.com/facebook/facebook-python-business-sdk/pull/2.diff","created_date":"2014-09-07","accepted_date":"2014-09-07","title":"Code doc typos for enum mixins","actor":52},{"id":103,"component_name":"Patch","qa_url":"https://github.com/pallets/werkzeug/pull/601","diff_url":"https://github.com/pallets/werkzeug/pull/601.diff","created_date":"2014-09-23","accepted_date":"2014-09-23","title":"Typo capitalization docstring param","actor":32},{"id":104,"component_name":"Patch","qa_url":"https://github.com/django-guardian/django-guardian/pull/265","diff_url":"https://github.com/django-guardian/django-guardian/pull/265.diff","created_date":"2014-09-26","accepted_date":"2014-09-26","title":"Typo in PermissionsRequiredMixin","actor":53},{"id":105,"component_name":"Patch","qa_url":"https://github.com/facebook/facebook-python-business-sdk/pull/4","diff_url":"https://github.com/facebook/facebook-python-business-sdk/pull/4.diff","created_date":"2014-09-28","accepted_date":"2014-09-29","title":"Fix typo timezone_id in ad accounts","actor":52},{"id":106,"component_name":"Patch","qa_url":"https://github.com/lokku/jquery-nstslider/pull/15","diff_url":"https://github.com/lokku/jquery-nstslider/pull/15.diff","created_date":"2014-10-27","accepted_date":"2014-10-27","title":"Add valueToPx to public methods","actor":54},{"id":107,"component_name":"Patch","qa_url":"https://github.com/ndparker/rjsmin/pull/3","diff_url":"https://github.com/ndparker/rjsmin/pull/3.diff","created_date":"2014-11-12","accepted_date":null,"title":"Bump pypy version to 2.4","actor":55},{"id":108,"component_name":"Patch","qa_url":"https://github.com/miracle2k/django-assets/pull/48","diff_url":"https://github.com/miracle2k/django-assets/pull/48.diff","created_date":"2014-11-15","accepted_date":"2015-08-21","title":"Support for depends in Bundle and Django template tags","actor":56},{"id":109,"component_name":"Patch","qa_url":"https://github.com/ycm-core/YouCompleteMe/pull/1269","diff_url":"https://github.com/ycm-core/YouCompleteMe/pull/1269.diff","created_date":"2014-12-03","accepted_date":"2014-12-04","title":"Update documentation with FreeBSD installation instructions","actor":57},{"id":110,"component_name":"Patch","qa_url":"https://github.com/ycm-core/YouCompleteMe/pull/1271","diff_url":"https://github.com/ycm-core/YouCompleteMe/pull/1271.diff","created_date":"2014-12-05","accepted_date":"2014-12-10","title":"FreeBSD installation, add system LD_LIBRARY_PATH","actor":57},{"id":111,"component_name":"Patch","qa_url":"https://github.com/fabric/fabric/pull/1229","diff_url":"https://github.com/fabric/fabric/pull/1229.diff","created_date":"2014-12-08","accepted_date":null,"title":"Docs: add ref to env.host and env.roledefs","actor":58},{"id":112,"component_name":"Patch","qa_url":"https://github.com/pinax/django-user-accounts/pull/162","diff_url":"https://github.com/pinax/django-user-accounts/pull/162.diff","created_date":"2014-12-30","accepted_date":"2015-02-01","title":"Docs: use full code-blocks for python highlighting","actor":59},{"id":113,"component_name":"Patch","qa_url":"https://github.com/pinax/django-user-accounts/pull/163","diff_url":"https://github.com/pinax/django-user-accounts/pull/163.diff","created_date":"2014-12-30","accepted_date":"2015-02-01","title":"Sphinx config typo","actor":59},{"id":114,"component_name":"Patch","qa_url":"https://github.com/honza/vim-snippets/pull/504","diff_url":"https://github.com/honza/vim-snippets/pull/504.diff","created_date":"2015-01-07","accepted_date":"2015-01-08","title":"Snippet for python prompt toolkit embed","actor":60},{"id":115,"component_name":"Patch","qa_url":"https://github.com/guibog/stud/pull/1","diff_url":"https://github.com/guibog/stud/pull/1.diff","created_date":"2015-01-24","accepted_date":null,"title":"Get this documented / packaged","actor":61},{"id":116,"component_name":"Patch","qa_url":"https://github.com/gorakhargosh/watchdog/pull/295","diff_url":"https://github.com/gorakhargosh/watchdog/pull/295.diff","created_date":"2015-01-26","accepted_date":"2015-01-26","title":"changelog.rst indentation","actor":26},{"id":117,"component_name":"Patch","qa_url":"https://github.com/readthedocs/readthedocs.org/pull/1152","diff_url":"https://github.com/readthedocs/readthedocs.org/pull/1152.diff","created_date":"2015-02-11","accepted_date":"2015-02-12","title":"Add back update_repos_pull","actor":4},{"id":118,"component_name":"Patch","qa_url":"https://github.com/Alir3z4/django-markwhat/pull/11","diff_url":"https://github.com/Alir3z4/django-markwhat/pull/11.diff","created_date":"2015-03-15","accepted_date":"2015-03-15","title":"Correct capitalization / spacing for reStructuredText and docutils","actor":62},{"id":119,"component_name":"Patch","qa_url":"https://github.com/Alir3z4/django-markwhat/pull/12","diff_url":"https://github.com/Alir3z4/django-markwhat/pull/12.diff","created_date":"2015-03-15","accepted_date":"2015-03-15","title":"PEP440 compliance with version number","actor":62},{"id":120,"component_name":"Patch","qa_url":"https://github.com/saltstack-formulas/mysql-formula/pull/65","diff_url":"https://github.com/saltstack-formulas/mysql-formula/pull/65.diff","created_date":"2015-03-19","accepted_date":"2015-03-20","title":"import_users.py: Improvements","actor":63},{"id":121,"component_name":"Patch","qa_url":"https://github.com/realpython/python-guide/pull/528","diff_url":"https://github.com/realpython/python-guide/pull/528.diff","created_date":"2015-03-20","accepted_date":"2015-09-20","title":"Add ptpython to other tools","actor":64},{"id":122,"component_name":"Patch","qa_url":"https://github.com/honza/vim-snippets/pull/547","diff_url":"https://github.com/honza/vim-snippets/pull/547.diff","created_date":"2015-03-20","accepted_date":"2015-03-23","title":"Update prompt_toolkit to ptpython, fix argument defaults.","actor":60},{"id":123,"component_name":"Patch","qa_url":"https://github.com/terryma/vim-multiple-cursors/pull/126","diff_url":"https://github.com/terryma/vim-multiple-cursors/pull/126.diff","created_date":"2015-03-20","accepted_date":"2015-05-28","title":"Fix #27: allow <Ctrl-c> to quit highlight mode. Document in README.md","actor":65},{"id":124,"component_name":"Patch","qa_url":"https://github.com/terryma/vim-multiple-cursors/pull/127","diff_url":"https://github.com/terryma/vim-multiple-cursors/pull/127.diff","created_date":"2015-03-20","accepted_date":"2015-03-20","title":"Highlight syntax of multiline code in viml","actor":65},{"id":125,"component_name":"Patch","qa_url":"https://github.com/bayandin/awesome-awesomeness/pull/152","diff_url":"https://github.com/bayandin/awesome-awesomeness/pull/152.diff","created_date":"2015-03-26","accepted_date":"2016-12-02","title":"Add awesome-sqlalchemy","actor":66},{"id":126,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/1817","diff_url":"https://github.com/sphinx-doc/sphinx/pull/1817.diff","created_date":"2015-03-27","accepted_date":null,"title":"quickstart-build: add space to comments to suppress E265 sirens","actor":67},{"id":127,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/22","diff_url":"https://github.com/jeaye/color_coded/pull/22.diff","created_date":"2015-04-05","accepted_date":"2015-04-05","title":"README: Note on debian installation dependencies","actor":68},{"id":128,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/24","diff_url":"https://github.com/jeaye/color_coded/pull/24.diff","created_date":"2015-04-05","accepted_date":null,"title":"Autoconf macro for finding lua shared libraries. Fix #23","actor":68},{"id":129,"component_name":"Patch","qa_url":"https://github.com/vim-jp/vim-vimlparser/pull/18","diff_url":"https://github.com/vim-jp/vim-vimlparser/pull/18.diff","created_date":"2015-04-06","accepted_date":"2015-04-06","title":"Create LICENSE, fix #17.","actor":69},{"id":130,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/38","diff_url":"https://github.com/jeaye/color_coded/pull/38.diff","created_date":"2015-04-12","accepted_date":"2015-04-12","title":"Ignore CMake output in case built in main directory. Required for NeoBundle.","actor":68},{"id":131,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/40","diff_url":"https://github.com/jeaye/color_coded/pull/40.diff","created_date":"2015-04-12","accepted_date":"2015-04-12","title":"Fix #35: Add NeoBundle documentation, separate section for Vundle / Pathogen","actor":68},{"id":132,"component_name":"Patch","qa_url":"https://github.com/jeffh/sniffer/pull/26","diff_url":"https://github.com/jeffh/sniffer/pull/26.diff","created_date":"2015-04-12","accepted_date":"2015-04-13","title":"Remove print statement from pyinotify scanner","actor":70},{"id":133,"component_name":"Patch","qa_url":"https://github.com/jeffh/sniffer/pull/27","diff_url":"https://github.com/jeffh/sniffer/pull/27.diff","created_date":"2015-04-12","accepted_date":"2015-04-13","title":"reST corrections. python source code highlighting and list fix.","actor":70},{"id":134,"component_name":"Patch","qa_url":"https://github.com/facebook/pyre2/pull/4","diff_url":"https://github.com/facebook/pyre2/pull/4.diff","created_date":"2015-04-12","accepted_date":null,"title":"Update pyre2 link to github","actor":71},{"id":135,"component_name":"Patch","qa_url":"https://github.com/gogs/docs/pull/41","diff_url":"https://github.com/gogs/docs/pull/41.diff","created_date":"2015-04-16","accepted_date":"2015-04-17","title":"Correct branch name","actor":72},{"id":136,"component_name":"Patch","qa_url":"https://github.com/gogs/gogs/pull/1216","diff_url":"https://github.com/gogs/gogs/pull/1216.diff","created_date":"2015-04-18","accepted_date":"2015-04-18","title":"SSH config options","actor":73},{"id":137,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt-bootstrap/pull/583","diff_url":"https://github.com/saltstack/salt-bootstrap/pull/583.diff","created_date":"2015-04-20","accepted_date":"2015-04-22","title":"README: code directive fixes","actor":74},{"id":138,"component_name":"Patch","qa_url":"https://github.com/saltstack-formulas/salt-formula/pull/124","diff_url":"https://github.com/saltstack-formulas/salt-formula/pull/124.diff","created_date":"2015-04-20","accepted_date":null,"title":"Pillar example: Fix duplicate master keys","actor":75},{"id":139,"component_name":"Patch","qa_url":"https://github.com/saltstack-formulas/uwsgi-formula/pull/1","diff_url":"https://github.com/saltstack-formulas/uwsgi-formula/pull/1.diff","created_date":"2015-04-23","accepted_date":"2015-04-23","title":"Fix function lookup in uwsgi.pip","actor":76},{"id":140,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/51","diff_url":"https://github.com/jeaye/color_coded/pull/51.diff","created_date":"2015-04-30","accepted_date":"2015-04-30","title":"Instructions for building from FreeBSD / PCBSD","actor":68},{"id":141,"component_name":"Patch","qa_url":"https://github.com/dotnet/coreclr/pull/899","diff_url":"https://github.com/dotnet/coreclr/pull/899.diff","created_date":"2015-05-01","accepted_date":"2015-05-01","title":"FreeBSD instructions: clarify minimum version of Clang / build argument","actor":77},{"id":142,"component_name":"Patch","qa_url":"https://github.com/dotnet/coreclr/pull/900","diff_url":"https://github.com/dotnet/coreclr/pull/900.diff","created_date":"2015-05-01","accepted_date":"2015-05-01","title":"Documentation: Inline source should use single backticks","actor":77},{"id":143,"component_name":"Patch","qa_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/59","diff_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/59.diff","created_date":"2015-05-05","accepted_date":"2015-08-10","title":"Update link to cookiecutter-pypackage-pythonic","actor":40},{"id":144,"component_name":"Patch","qa_url":"https://github.com/cookiecutter-flask/cookiecutter-flask/pull/39","diff_url":"https://github.com/cookiecutter-flask/cookiecutter-flask/pull/39.diff","created_date":"2015-05-05","accepted_date":null,"title":"Add link to my flask cookiecutter project","actor":78},{"id":145,"component_name":"Patch","qa_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/60","diff_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage/pull/60.diff","created_date":"2015-05-05","accepted_date":"2015-08-07","title":"Travis-ci and badge test cookiecutter-pypackage","actor":40},{"id":146,"component_name":"Patch","qa_url":"https://github.com/cookiecutter/cookiecutter/pull/452","diff_url":"https://github.com/cookiecutter/cookiecutter/pull/452.diff","created_date":"2015-05-09","accepted_date":null,"title":"output_dir for python API invocation + parametrize output_dir tests","actor":79},{"id":147,"component_name":"Patch","qa_url":"https://github.com/Shougo/neocomplete.vim/pull/404","diff_url":"https://github.com/Shougo/neocomplete.vim/pull/404.diff","created_date":"2015-05-11","accepted_date":"2015-05-11","title":"docs: [B] buffer, a list of buffer keywords?","actor":80},{"id":148,"component_name":"Patch","qa_url":"https://github.com/dotnet/coreclr/pull/997","diff_url":"https://github.com/dotnet/coreclr/pull/997.diff","created_date":"2015-05-14","accepted_date":"2015-05-14","title":"[trivial] chmod +x freebsd lldb script","actor":77},{"id":149,"component_name":"Patch","qa_url":"https://github.com/pennersr/django-allauth/pull/948","diff_url":"https://github.com/pennersr/django-allauth/pull/948.diff","created_date":"2015-05-15","accepted_date":"2015-05-18","title":"Fix django 1.8 RequestSite error on LoginView","actor":81},{"id":150,"component_name":"Patch","qa_url":"https://github.com/readthedocs/readthedocs.org/pull/1274","diff_url":"https://github.com/readthedocs/readthedocs.org/pull/1274.diff","created_date":"2015-05-18","accepted_date":"2015-05-21","title":"[trivial] vcs_support: organize imports","actor":4},{"id":151,"component_name":"Patch","qa_url":"https://github.com/liuxinyu95/AlgoXY/pull/16","diff_url":"https://github.com/liuxinyu95/AlgoXY/pull/16.diff","created_date":"2015-05-28","accepted_date":"2015-05-28","title":"Use recursive $(MAKE). Fixes compatibility issues with non-GNU toolchains (BSD systems).","actor":82},{"id":152,"component_name":"Patch","qa_url":"https://github.com/OAI/OpenAPI-Specification/pull/385","diff_url":"https://github.com/OAI/OpenAPI-Specification/pull/385.diff","created_date":"2015-06-04","accepted_date":"2015-06-04","title":"Fix pet store demo link","actor":83},{"id":153,"component_name":"Patch","qa_url":"https://github.com/lambdalisue/vim-pyenv/pull/12","diff_url":"https://github.com/lambdalisue/vim-pyenv/pull/12.diff","created_date":"2015-07-01","accepted_date":"2015-07-01","title":"typo in README example","actor":84},{"id":154,"component_name":"Patch","qa_url":"https://github.com/mui/material-ui/pull/1057","diff_url":"https://github.com/mui/material-ui/pull/1057.diff","created_date":"2015-07-07","accepted_date":"2015-07-07","title":"Icon Builder: handle user-specified SVG collections (not just material-ui-icon)","actor":85},{"id":155,"component_name":"Patch","qa_url":"https://github.com/mui/material-ui/pull/1130","diff_url":"https://github.com/mui/material-ui/pull/1130.diff","created_date":"2015-07-11","accepted_date":"2015-07-16","title":"#1127 #1126 #1125 #1139 Icon builder tests, grunt, templating","actor":85},{"id":156,"component_name":"Patch","qa_url":"https://github.com/looplab/fsm/pull/9","diff_url":"https://github.com/looplab/fsm/pull/9.diff","created_date":"2015-07-22","accepted_date":"2015-11-09","title":"Examples import correction","actor":86},{"id":157,"component_name":"Patch","qa_url":"https://github.com/kivy/kivy/pull/3537","diff_url":"https://github.com/kivy/kivy/pull/3537.diff","created_date":"2015-07-25","accepted_date":"2015-07-29","title":"docs: fix cython link in installation-linux.rst","actor":87},{"id":158,"component_name":"Patch","qa_url":"https://github.com/kivy-garden/garden.filebrowser/pull/10","diff_url":"https://github.com/kivy-garden/garden.filebrowser/pull/10.diff","created_date":"2015-07-29","accepted_date":"2016-05-09","title":"README.rst tweaks","actor":88},{"id":159,"component_name":"Patch","qa_url":"https://github.com/kivy/python-for-android/pull/426","diff_url":"https://github.com/kivy/python-for-android/pull/426.diff","created_date":"2015-07-31","accepted_date":"2015-07-31","title":"README: reStructuredText highlighting / indentation touchups","actor":89},{"id":160,"component_name":"Patch","qa_url":"https://github.com/dotnet/coreclr/pull/1336","diff_url":"https://github.com/dotnet/coreclr/pull/1336.diff","created_date":"2015-08-03","accepted_date":"2015-08-05","title":"Update FreeBSD installation docs for LLDB support","actor":77},{"id":161,"component_name":"Patch","qa_url":"https://github.com/kivy/kivy/pull/3559","diff_url":"https://github.com/kivy/kivy/pull/3559.diff","created_date":"2015-08-06","accepted_date":null,"title":"Fix #3558:  text widget search linux font paths on FreeBSD systems","actor":87},{"id":162,"component_name":"Patch","qa_url":"https://github.com/humiaozuzu/awesome-flask/pull/39","diff_url":"https://github.com/humiaozuzu/awesome-flask/pull/39.diff","created_date":"2015-08-09","accepted_date":"2015-09-13","title":"add cookiecutter-flask-pythonic","actor":90},{"id":163,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/85","diff_url":"https://github.com/jeaye/color_coded/pull/85.diff","created_date":"2015-10-31","accepted_date":"2015-10-31","title":"Add boost to OS X installation instructions","actor":68},{"id":164,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/88","diff_url":"https://github.com/jeaye/color_coded/pull/88.diff","created_date":"2015-10-31","accepted_date":null,"title":"Find boost via FindBoost.cmake","actor":68},{"id":165,"component_name":"Patch","qa_url":"https://github.com/jakowskidev/uMario_Jakowski/pull/1","diff_url":"https://github.com/jakowskidev/uMario_Jakowski/pull/1.diff","created_date":"2015-11-18","accepted_date":"2015-11-19","title":"Build and run on OS X and FreeBSD (probably Linux too)","actor":91},{"id":166,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/96","diff_url":"https://github.com/jeaye/color_coded/pull/96.diff","created_date":"2015-11-29","accepted_date":"2015-11-29","title":"Use POSIX bash","actor":68},{"id":167,"component_name":"Patch","qa_url":"https://github.com/stefanholek/rl/pull/11","diff_url":"https://github.com/stefanholek/rl/pull/11.diff","created_date":"2015-12-01","accepted_date":null,"title":"Add include paths for FreeBSD systems","actor":92},{"id":168,"component_name":"Patch","qa_url":"https://github.com/aseprite/aseprite/pull/888","diff_url":"https://github.com/aseprite/aseprite/pull/888.diff","created_date":"2015-12-05","accepted_date":"2015-12-05","title":"Fix missing permission bitmasks on FreeBSD","actor":93},{"id":169,"component_name":"Patch","qa_url":"https://github.com/aseprite/aseprite/pull/892","diff_url":"https://github.com/aseprite/aseprite/pull/892.diff","created_date":"2015-12-08","accepted_date":"2015-12-08","title":"Command for scrolling to center of canvas","actor":93},{"id":170,"component_name":"Patch","qa_url":"https://github.com/aseprite/aseprite/pull/893","diff_url":"https://github.com/aseprite/aseprite/pull/893.diff","created_date":"2015-12-08","accepted_date":"2015-12-09","title":"Support for FreeBSD get_app_path","actor":93},{"id":171,"component_name":"Patch","qa_url":"https://github.com/aseprite/aseprite/pull/896","diff_url":"https://github.com/aseprite/aseprite/pull/896.diff","created_date":"2015-12-09","accepted_date":"2015-12-10","title":"Ignore cmake build dir","actor":93},{"id":172,"component_name":"Patch","qa_url":"https://github.com/alex-rudakov/sphinx-argparse/pull/35","diff_url":"https://github.com/alex-rudakov/sphinx-argparse/pull/35.diff","created_date":"2015-12-11","accepted_date":"2016-10-04","title":"Minor typo","actor":31},{"id":173,"component_name":"Patch","qa_url":"https://github.com/wagtail/wagtail/pull/2094","diff_url":"https://github.com/wagtail/wagtail/pull/2094.diff","created_date":"2016-01-08","accepted_date":"2016-01-08","title":"Un-dim shell snippet in README","actor":94},{"id":174,"component_name":"Patch","qa_url":"https://github.com/thewtex/tmux-mem-cpu-load/pull/30","diff_url":"https://github.com/thewtex/tmux-mem-cpu-load/pull/30.diff","created_date":"2016-01-09","accepted_date":"2016-01-09","title":"Fix FreeBSD memory usage","actor":95},{"id":175,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/21","diff_url":"https://github.com/oxygine/oxygine-framework/pull/21.diff","created_date":"2016-01-10","accepted_date":"2016-01-13","title":"Fix C++ code sample highlighting in README","actor":96},{"id":176,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/22","diff_url":"https://github.com/oxygine/oxygine-framework/pull/22.diff","created_date":"2016-01-11","accepted_date":"2016-01-15","title":"FreeBSD Compatibility, find SDL2, libpng, libjpeg via CMake","actor":96},{"id":177,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/pymux/pull/34","diff_url":"https://github.com/prompt-toolkit/pymux/pull/34.diff","created_date":"2016-01-11","accepted_date":null,"title":"Fix FreeBSD compatibilty on startup","actor":97},{"id":178,"component_name":"Patch","qa_url":"https://github.com/solarus-games/solarus/pull/824","diff_url":"https://github.com/solarus-games/solarus/pull/824.diff","created_date":"2016-01-18","accepted_date":null,"title":"Document prerequisites to build on OS X","actor":98},{"id":179,"component_name":"Patch","qa_url":"https://github.com/xavierd/clang_complete/pull/468","diff_url":"https://github.com/xavierd/clang_complete/pull/468.diff","created_date":"2016-01-18","accepted_date":"2016-01-18","title":"Fix completion minimum pattern length","actor":99},{"id":180,"component_name":"Patch","qa_url":"https://github.com/pyston/pyston_v1/pull/1072","diff_url":"https://github.com/pyston/pyston_v1/pull/1072.diff","created_date":"2016-01-25","accepted_date":"2016-01-29","title":"Switch to /usr/bin/env sh for portability","actor":100},{"id":181,"component_name":"Patch","qa_url":"https://github.com/pyston/pyston_v1/pull/1073","diff_url":"https://github.com/pyston/pyston_v1/pull/1073.diff","created_date":"2016-01-25","accepted_date":"2016-01-29","title":"Search for gmake and make when building","actor":100},{"id":182,"component_name":"Patch","qa_url":"https://github.com/vinzenz/libpypa/pull/50","diff_url":"https://github.com/vinzenz/libpypa/pull/50.diff","created_date":"2016-01-25","accepted_date":"2016-01-26","title":"Add FindGMP.cmake module","actor":101},{"id":183,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/28","diff_url":"https://github.com/oxygine/oxygine-framework/pull/28.diff","created_date":"2016-01-26","accepted_date":null,"title":"Remove unneeded -Wswitch","actor":96},{"id":184,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/29","diff_url":"https://github.com/oxygine/oxygine-framework/pull/29.diff","created_date":"2016-01-26","accepted_date":"2016-01-26","title":"PEP8 clean up for python tools","actor":96},{"id":185,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/30","diff_url":"https://github.com/oxygine/oxygine-framework/pull/30.diff","created_date":"2016-01-26","accepted_date":null,"title":"FreeBSD support and improve Linux compatibility","actor":96},{"id":186,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/31","diff_url":"https://github.com/oxygine/oxygine-framework/pull/31.diff","created_date":"2016-01-26","accepted_date":"2016-01-26","title":"FreeBSD support and improve Linux compatibility","actor":96},{"id":187,"component_name":"Patch","qa_url":"https://github.com/jessevdk/cldoc/pull/115","diff_url":"https://github.com/jessevdk/cldoc/pull/115.diff","created_date":"2016-01-26","accepted_date":null,"title":"Add some CMake documentation to the example README","actor":102},{"id":188,"component_name":"Patch","qa_url":"https://github.com/binder-project/binder-web-prototype/pull/19","diff_url":"https://github.com/binder-project/binder-web-prototype/pull/19.diff","created_date":"2016-01-29","accepted_date":"2016-01-30","title":"Fix URL to chatroom","actor":103},{"id":189,"component_name":"Patch","qa_url":"https://github.com/oxygine/oxygine-framework/pull/35","diff_url":"https://github.com/oxygine/oxygine-framework/pull/35.diff","created_date":"2016-01-30","accepted_date":"2016-02-01","title":"[wip] mingw fixes","actor":96},{"id":190,"component_name":"Patch","qa_url":"https://github.com/pyston/pyston_v1/pull/1085","diff_url":"https://github.com/pyston/pyston_v1/pull/1085.diff","created_date":"2016-01-30","accepted_date":"2016-01-31","title":"Fix finding GMP on FreeBSD","actor":100},{"id":191,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/113","diff_url":"https://github.com/jeaye/color_coded/pull/113.diff","created_date":"2016-02-01","accepted_date":"2016-02-02","title":"Update FindLua module to find lua 5.3","actor":68},{"id":192,"component_name":"Patch","qa_url":"https://github.com/jeaye/color_coded/pull/114","diff_url":"https://github.com/jeaye/color_coded/pull/114.diff","created_date":"2016-02-01","accepted_date":"2016-04-21","title":"Revamp build infrastructure for Clang/LLVM","actor":68},{"id":193,"component_name":"Patch","qa_url":"https://github.com/vlajos/misspell-fixer/pull/14","diff_url":"https://github.com/vlajos/misspell-fixer/pull/14.diff","created_date":"2016-02-16","accepted_date":"2016-02-16","title":"Use more portable shebang for finding bash","actor":104},{"id":194,"component_name":"Patch","qa_url":"https://github.com/freebsd/freebsd-src/pull/59","diff_url":"https://github.com/freebsd/freebsd-src/pull/59.diff","created_date":"2016-02-18","accepted_date":null,"title":"Fix typo in SCU_PTSGRTC_READ","actor":105},{"id":195,"component_name":"Patch","qa_url":"https://github.com/freebsd/freebsd-src/pull/60","diff_url":"https://github.com/freebsd/freebsd-src/pull/60.diff","created_date":"2016-02-18","accepted_date":null,"title":"Fix typo in libi386","actor":105},{"id":196,"component_name":"Patch","qa_url":"https://github.com/django-extensions/django-extensions/pull/845","diff_url":"https://github.com/django-extensions/django-extensions/pull/845.diff","created_date":"2016-02-28","accepted_date":"2016-05-10","title":"Prevent 2nd reload of debugger on runserver_plus","actor":106},{"id":197,"component_name":"Patch","qa_url":"https://github.com/xavierd/clang_complete/pull/477","diff_url":"https://github.com/xavierd/clang_complete/pull/477.diff","created_date":"2016-03-03","accepted_date":"2016-03-03","title":"Fix typo in docs","actor":99},{"id":198,"component_name":"Patch","qa_url":"https://github.com/deoplete-plugins/deoplete-jedi/pull/14","diff_url":"https://github.com/deoplete-plugins/deoplete-jedi/pull/14.diff","created_date":"2016-03-04","accepted_date":"2016-03-05","title":"Add issue template from deoplete.nvim","actor":107},{"id":199,"component_name":"Patch","qa_url":"https://github.com/spf13/viper/pull/166","diff_url":"https://github.com/spf13/viper/pull/166.diff","created_date":"2016-03-07","accepted_date":null,"title":"Fix typo","actor":108},{"id":200,"component_name":"Patch","qa_url":"https://github.com/sass/libsass/pull/1972","diff_url":"https://github.com/sass/libsass/pull/1972.diff","created_date":"2016-04-02","accepted_date":"2016-04-03","title":"Fix DEBUG print template","actor":109},{"id":201,"component_name":"Patch","qa_url":"https://github.com/Masterminds/vcs/pull/25","diff_url":"https://github.com/Masterminds/vcs/pull/25.diff","created_date":"2016-04-13","accepted_date":"2016-04-13","title":"Make RunFromDir exportable","actor":110},{"id":202,"component_name":"Patch","qa_url":"https://github.com/Masterminds/vcs/pull/26","diff_url":"https://github.com/Masterminds/vcs/pull/26.diff","created_date":"2016-04-13","accepted_date":"2016-04-15","title":"Add support for initializing git repositories","actor":110},{"id":203,"component_name":"Patch","qa_url":"https://github.com/sass/libsass-python/pull/149","diff_url":"https://github.com/sass/libsass-python/pull/149.diff","created_date":"2016-04-24","accepted_date":null,"title":"Update libsass to fix materializecss crash","actor":111},{"id":204,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/2489","diff_url":"https://github.com/sphinx-doc/sphinx/pull/2489.diff","created_date":"2016-04-25","accepted_date":null,"title":"Allow entering builder class via application init","actor":67},{"id":205,"component_name":"Patch","qa_url":"https://github.com/aseprite/aseprite/pull/1097","diff_url":"https://github.com/aseprite/aseprite/pull/1097.diff","created_date":"2016-04-26","accepted_date":"2016-04-26","title":"Update installation instructions for Skia and OS X","actor":93},{"id":206,"component_name":"Patch","qa_url":"https://github.com/vinta/awesome-python/pull/632","diff_url":"https://github.com/vinta/awesome-python/pull/632.diff","created_date":"2016-04-30","accepted_date":null,"title":"Add kaptan (configuration manager)","actor":112},{"id":207,"component_name":"Patch","qa_url":"https://github.com/vinta/awesome-python/pull/633","diff_url":"https://github.com/vinta/awesome-python/pull/633.diff","created_date":"2016-04-30","accepted_date":null,"title":"Add tmuxp - tmux session manager","actor":112},{"id":208,"component_name":"Patch","qa_url":"https://github.com/vinta/awesome-python/pull/634","diff_url":"https://github.com/vinta/awesome-python/pull/634.diff","created_date":"2016-04-30","accepted_date":null,"title":"Add vcspull - mass clone/update projects from vcs","actor":112},{"id":209,"component_name":"Patch","qa_url":"https://github.com/Masterminds/vcs/pull/42","diff_url":"https://github.com/Masterminds/vcs/pull/42.diff","created_date":"2016-05-05","accepted_date":null,"title":"Flexible exec","actor":110},{"id":210,"component_name":"Patch","qa_url":"https://github.com/django-extensions/django-extensions/pull/891","diff_url":"https://github.com/django-extensions/django-extensions/pull/891.diff","created_date":"2016-05-10","accepted_date":"2016-05-10","title":"Fix indentation in 1.6.7 changelog","actor":106},{"id":211,"component_name":"Patch","qa_url":"https://github.com/wheybags/guichan/pull/1","diff_url":"https://github.com/wheybags/guichan/pull/1.diff","created_date":"2016-05-14","accepted_date":"2016-05-23","title":"Quiet down build error in CMake 3.5.2","actor":113},{"id":212,"component_name":"Patch","qa_url":"https://github.com/celery/case/pull/2","diff_url":"https://github.com/celery/case/pull/2.diff","created_date":"2016-05-18","accepted_date":"2018-01-18","title":"Only require unittest2 on python < 2.7","actor":114},{"id":213,"component_name":"Patch","qa_url":"https://github.com/celery/case/pull/3","diff_url":"https://github.com/celery/case/pull/3.diff","created_date":"2016-05-18","accepted_date":"2016-05-18","title":"Add mute decorator to suppress stdout with no return","actor":114},{"id":214,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/291","diff_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/291.diff","created_date":"2016-05-19","accepted_date":null,"title":"Add FreeBSD to supported systems","actor":115},{"id":215,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/292","diff_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/292.diff","created_date":"2016-05-19","accepted_date":null,"title":"Ignore common virtualenv locations","actor":115},{"id":216,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/pyvim/pull/82","diff_url":"https://github.com/prompt-toolkit/pyvim/pull/82.diff","created_date":"2016-05-19","accepted_date":null,"title":"Filter file hook for path completer","actor":116},{"id":217,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/295","diff_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/295.diff","created_date":"2016-05-19","accepted_date":null,"title":"Allow filtering of directories","actor":115},{"id":218,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/pyvim/pull/84","diff_url":"https://github.com/prompt-toolkit/pyvim/pull/84.diff","created_date":"2016-05-21","accepted_date":null,"title":"Get tests back online","actor":116},{"id":219,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/301","diff_url":"https://github.com/prompt-toolkit/python-prompt-toolkit/pull/301.diff","created_date":"2016-05-25","accepted_date":null,"title":"Move tests to py.test","actor":115},{"id":220,"component_name":"Patch","qa_url":"https://github.com/ternjs/tern_for_vim/pull/141","diff_url":"https://github.com/ternjs/tern_for_vim/pull/141.diff","created_date":"2016-05-25","accepted_date":null,"title":"Add LICENSE","actor":117},{"id":221,"component_name":"Patch","qa_url":"https://github.com/jelmer/dulwich/pull/432","diff_url":"https://github.com/jelmer/dulwich/pull/432.diff","created_date":"2016-06-03","accepted_date":null,"title":"Update COPYING to reflect license transition","actor":118},{"id":222,"component_name":"Patch","qa_url":"https://github.com/mawww/kakoune/pull/693","diff_url":"https://github.com/mawww/kakoune/pull/693.diff","created_date":"2016-06-07","accepted_date":null,"title":"[RFC] CLI front-end restructuring","actor":119},{"id":223,"component_name":"Patch","qa_url":"https://github.com/python-cmake-buildsystem/python-cmake-buildsystem/pull/133","diff_url":"https://github.com/python-cmake-buildsystem/python-cmake-buildsystem/pull/133.diff","created_date":"2016-06-11","accepted_date":"2016-06-12","title":"Fix #132 libffi directory on FreeBSD 11-CURRENT","actor":120},{"id":224,"component_name":"Patch","qa_url":"https://github.com/python-cmake-buildsystem/python-cmake-buildsystem/pull/136","diff_url":"https://github.com/python-cmake-buildsystem/python-cmake-buildsystem/pull/136.diff","created_date":"2016-06-12","accepted_date":null,"title":"Fix #134, FreeBSD Support, additional introspections","actor":120},{"id":225,"component_name":"Patch","qa_url":"https://github.com/jcfr/pys4ext/pull/2","diff_url":"https://github.com/jcfr/pys4ext/pull/2.diff","created_date":"2016-06-21","accepted_date":null,"title":"Updates for update-to-uselibvcs","actor":121},{"id":226,"component_name":"Patch","qa_url":"https://github.com/tmux/tmux/pull/466","diff_url":"https://github.com/tmux/tmux/pull/466.diff","created_date":"2016-06-25","accepted_date":null,"title":"remove duplicate compat/daemon.c","actor":122},{"id":227,"component_name":"Patch","qa_url":"https://github.com/mawww/kakoune/pull/721","diff_url":"https://github.com/mawww/kakoune/pull/721.diff","created_date":"2016-07-03","accepted_date":null,"title":"Add CMakeLists.txt to contrib","actor":119},{"id":228,"component_name":"Patch","qa_url":"https://github.com/gabime/spdlog/pull/254","diff_url":"https://github.com/gabime/spdlog/pull/254.diff","created_date":"2016-08-01","accepted_date":"2016-08-01","title":"Add FreeBSD compatibility defs","actor":123},{"id":229,"component_name":"Patch","qa_url":"https://github.com/wjakob/nanogui/pull/128","diff_url":"https://github.com/wjakob/nanogui/pull/128.diff","created_date":"2016-09-13","accepted_date":"2016-09-13","title":"Include /usr/local/include on BSD systems","actor":124},{"id":230,"component_name":"Patch","qa_url":"https://github.com/wjakob/nanogui/pull/147","diff_url":"https://github.com/wjakob/nanogui/pull/147.diff","created_date":"2016-10-15","accepted_date":"2016-10-28","title":"fix missing library on BSD systems","actor":124},{"id":231,"component_name":"Patch","qa_url":"https://github.com/pypi/warehouse/pull/1615","diff_url":"https://github.com/pypi/warehouse/pull/1615.diff","created_date":"2016-12-22","accepted_date":"2016-12-22","title":"add new lxml req hash, fixes #1614","actor":125},{"id":232,"component_name":"Patch","qa_url":"https://github.com/prymitive/bootstrap-breadcrumbs/pull/29","diff_url":"https://github.com/prymitive/bootstrap-breadcrumbs/pull/29.diff","created_date":"2017-02-04","accepted_date":"2017-02-05","title":"fix quotes in docs","actor":126},{"id":233,"component_name":"Patch","qa_url":"https://github.com/django-mptt/django-mptt/pull/561","diff_url":"https://github.com/django-mptt/django-mptt/pull/561.diff","created_date":"2017-04-22","accepted_date":"2017-07-10","title":"Update doc links","actor":127},{"id":234,"component_name":"Patch","qa_url":"https://github.com/django-mptt/django-mptt/pull/562","diff_url":"https://github.com/django-mptt/django-mptt/pull/562.diff","created_date":"2017-04-22","accepted_date":"2017-04-23","title":"Update copyright year","actor":127},{"id":235,"component_name":"Patch","qa_url":"https://github.com/django-mptt/django-mptt/pull/563","diff_url":"https://github.com/django-mptt/django-mptt/pull/563.diff","created_date":"2017-04-22","accepted_date":"2017-04-23","title":"Remove indentation of list in readme","actor":127},{"id":236,"component_name":"Patch","qa_url":"https://github.com/kivy/kivy/pull/5134","diff_url":"https://github.com/kivy/kivy/pull/5134.diff","created_date":"2017-04-22","accepted_date":"2017-04-26","title":"Update readme for building docs","actor":87},{"id":237,"component_name":"Patch","qa_url":"https://github.com/pallets/flask/pull/2369","diff_url":"https://github.com/pallets/flask/pull/2369.diff","created_date":"2017-06-12","accepted_date":"2017-06-13","title":"Add docutils label for templates page","actor":13},{"id":238,"component_name":"Patch","qa_url":"https://github.com/pallets/flask/pull/2370","diff_url":"https://github.com/pallets/flask/pull/2370.diff","created_date":"2017-06-12","accepted_date":"2017-06-13","title":"Add docutils label for class-based views","actor":13},{"id":239,"component_name":"Patch","qa_url":"https://github.com/django-commons/django-polymorphic/pull/301","diff_url":"https://github.com/django-commons/django-polymorphic/pull/301.diff","created_date":"2017-07-06","accepted_date":"2017-07-12","title":"Fix sublist output in README","actor":128},{"id":240,"component_name":"Patch","qa_url":"https://github.com/davedash/django-fixture-magic/pull/57","diff_url":"https://github.com/davedash/django-fixture-magic/pull/57.diff","created_date":"2017-07-12","accepted_date":"2018-05-30","title":"Fix highlighting / indentation","actor":129},{"id":241,"component_name":"Patch","qa_url":"https://github.com/github/markup/pull/1082","diff_url":"https://github.com/github/markup/pull/1082.diff","created_date":"2017-07-13","accepted_date":"2017-07-31","title":"Tweak param signature for kbd role","actor":130},{"id":242,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/3945","diff_url":"https://github.com/sphinx-doc/sphinx/pull/3945.diff","created_date":"2017-07-18","accepted_date":"2017-07-22","title":"Add label for c++ domain","actor":67},{"id":243,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/3950","diff_url":"https://github.com/sphinx-doc/sphinx/pull/3950.diff","created_date":"2017-07-19","accepted_date":"2017-07-21","title":"Fix typo in TocTree warning","actor":67},{"id":244,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/21","diff_url":"https://github.com/hellysmile/django-activeurl/pull/21.diff","created_date":"2017-07-24","accepted_date":"2017-07-25","title":"Update tests for python 3.6, django 1.10+","actor":131},{"id":245,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/22","diff_url":"https://github.com/hellysmile/django-activeurl/pull/22.diff","created_date":"2017-07-25","accepted_date":"2017-07-25","title":"support for ignoring get params #20","actor":131},{"id":246,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/25","diff_url":"https://github.com/hellysmile/django-activeurl/pull/25.diff","created_date":"2017-07-27","accepted_date":"2017-07-27","title":"use `__about__` for package metadata on docs and setup","actor":131},{"id":247,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/27","diff_url":"https://github.com/hellysmile/django-activeurl/pull/27.diff","created_date":"2017-07-27","accepted_date":"2017-07-27","title":"add changelog per #26","actor":131},{"id":248,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/28","diff_url":"https://github.com/hellysmile/django-activeurl/pull/28.diff","created_date":"2017-07-27","accepted_date":"2017-07-27","title":"add AUTHORS","actor":131},{"id":249,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/29","diff_url":"https://github.com/hellysmile/django-activeurl/pull/29.diff","created_date":"2017-07-27","accepted_date":"2017-07-27","title":"Refactor tests","actor":131},{"id":250,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/31","diff_url":"https://github.com/hellysmile/django-activeurl/pull/31.diff","created_date":"2017-07-27","accepted_date":"2017-07-28","title":"improve sphinx output","actor":131},{"id":251,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/32","diff_url":"https://github.com/hellysmile/django-activeurl/pull/32.diff","created_date":"2017-07-28","accepted_date":"2017-07-28","title":"balance sections in readme","actor":131},{"id":252,"component_name":"Patch","qa_url":"https://github.com/jimmynotjim/scrollnav/pull/83","diff_url":"https://github.com/jimmynotjim/scrollnav/pull/83.diff","created_date":"2017-08-10","accepted_date":"2017-08-10","title":"Fix readme typo","actor":132},{"id":253,"component_name":"Patch","qa_url":"https://github.com/janpaepke/ScrollMagic/pull/710","diff_url":"https://github.com/janpaepke/ScrollMagic/pull/710.diff","created_date":"2017-08-11","accepted_date":"2018-10-19","title":"Fix typos","actor":133},{"id":254,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinxcontrib-websupport/pull/3","diff_url":"https://github.com/sphinx-doc/sphinxcontrib-websupport/pull/3.diff","created_date":"2017-08-13","accepted_date":"2017-10-07","title":"add buildername and confoverrides support to WebSupport","actor":134},{"id":255,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinxcontrib-websupport/pull/5","diff_url":"https://github.com/sphinx-doc/sphinxcontrib-websupport/pull/5.diff","created_date":"2017-08-18","accepted_date":"2017-10-07","title":"fix reference back to sphinx #4","actor":134},{"id":256,"component_name":"Patch","qa_url":"https://github.com/heroku/heroku-repo/pull/74","diff_url":"https://github.com/heroku/heroku-repo/pull/74.diff","created_date":"2017-08-18","accepted_date":"2017-08-18","title":"Fix typo","actor":135},{"id":257,"component_name":"Patch","qa_url":"https://github.com/carltongibson/django-filter/pull/760","diff_url":"https://github.com/carltongibson/django-filter/pull/760.diff","created_date":"2017-08-22","accepted_date":"2017-08-22","title":"use urlencode from django.utils.http","actor":136},{"id":258,"component_name":"Patch","qa_url":"https://github.com/carltongibson/django-filter/pull/761","diff_url":"https://github.com/carltongibson/django-filter/pull/761.diff","created_date":"2017-08-22","accepted_date":"2017-08-22","title":"housekeeping: sort imports","actor":136},{"id":259,"component_name":"Patch","qa_url":"https://github.com/darklow/social-share-kit/pull/65","diff_url":"https://github.com/darklow/social-share-kit/pull/65.diff","created_date":"2017-08-29","accepted_date":null,"title":"add scss (#58)","actor":137},{"id":260,"component_name":"Patch","qa_url":"https://github.com/avinassh/haxor/pull/13","diff_url":"https://github.com/avinassh/haxor/pull/13.diff","created_date":"2017-10-11","accepted_date":"2017-10-15","title":"Loosen requests dependency","actor":138},{"id":261,"component_name":"Patch","qa_url":"https://github.com/fabtools/fabtools/pull/360","diff_url":"https://github.com/fabtools/fabtools/pull/360.diff","created_date":"2017-10-13","accepted_date":"2018-03-07","title":"Add fabric3 support for Python 3 systems","actor":139},{"id":262,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/4161","diff_url":"https://github.com/sphinx-doc/sphinx/pull/4161.diff","created_date":"2017-10-17","accepted_date":"2017-10-18","title":"Typo","actor":67},{"id":263,"component_name":"Patch","qa_url":"https://github.com/pygments/pygments.rb/pull/184","diff_url":"https://github.com/pygments/pygments.rb/pull/184.diff","created_date":"2017-11-08","accepted_date":"2021-01-05","title":"remove unused imports, lint with PEP8","actor":140},{"id":264,"component_name":"Patch","qa_url":"https://github.com/readthedocs/readthedocs.org/pull/3340","diff_url":"https://github.com/readthedocs/readthedocs.org/pull/3340.diff","created_date":"2017-12-01","accepted_date":"2017-12-01","title":"Fix isort link","actor":4},{"id":265,"component_name":"Patch","qa_url":"https://github.com/django-commons/django-polymorphic/pull/327","diff_url":"https://github.com/django-commons/django-polymorphic/pull/327.diff","created_date":"2017-12-06","accepted_date":null,"title":"update MIDDLEWARE variable","actor":128},{"id":266,"component_name":"Patch","qa_url":"https://github.com/django-commons/django-polymorphic/pull/328","diff_url":"https://github.com/django-commons/django-polymorphic/pull/328.diff","created_date":"2017-12-06","accepted_date":null,"title":"update tests + CI against django 2.0, fix #325","actor":128},{"id":267,"component_name":"Patch","qa_url":"https://github.com/django-commons/django-polymorphic/pull/330","diff_url":"https://github.com/django-commons/django-polymorphic/pull/330.diff","created_date":"2017-12-06","accepted_date":null,"title":"fix typo in admin","actor":128},{"id":268,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/83","diff_url":"https://github.com/jazzband/django-robots/pull/83.diff","created_date":"2017-12-07","accepted_date":"2017-12-11","title":"Django 2.0","actor":141},{"id":269,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-model-utils/pull/298","diff_url":"https://github.com/jazzband/django-model-utils/pull/298.diff","created_date":"2017-12-07","accepted_date":"2017-12-11","title":"Django 2.0 support","actor":142},{"id":270,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-model-utils/pull/300","diff_url":"https://github.com/jazzband/django-model-utils/pull/300.diff","created_date":"2017-12-11","accepted_date":"2017-12-11","title":"Remove update travis script","actor":142},{"id":271,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-model-utils/pull/301","diff_url":"https://github.com/jazzband/django-model-utils/pull/301.diff","created_date":"2017-12-11","accepted_date":"2017-12-11","title":"Add codecov to travis","actor":142},{"id":272,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-model-utils/pull/302","diff_url":"https://github.com/jazzband/django-model-utils/pull/302.diff","created_date":"2017-12-12","accepted_date":"2017-12-12","title":"use codecov button on readme","actor":142},{"id":273,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-model-utils/pull/306","diff_url":"https://github.com/jazzband/django-model-utils/pull/306.diff","created_date":"2017-12-17","accepted_date":"2017-12-17","title":"Simplify version mentioning in README, classifiers","actor":142},{"id":274,"component_name":"Patch","qa_url":"https://github.com/justquick/django-activity-stream/pull/363","diff_url":"https://github.com/justquick/django-activity-stream/pull/363.diff","created_date":"2017-12-18","accepted_date":"2017-12-19","title":"Fix FOSSA license scan button","actor":143},{"id":275,"component_name":"Patch","qa_url":"https://github.com/pennersr/django-allauth/pull/1912","diff_url":"https://github.com/pennersr/django-allauth/pull/1912.diff","created_date":"2017-12-22","accepted_date":"2018-01-16","title":"Fix typo in test setting","actor":81},{"id":276,"component_name":"Patch","qa_url":"https://github.com/zsh-users/zsh-completions/pull/547","diff_url":"https://github.com/zsh-users/zsh-completions/pull/547.diff","created_date":"2017-12-23","accepted_date":"2018-11-05","title":"improve tmuxp load completions","actor":144},{"id":277,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest-django/pull/566","diff_url":"https://github.com/pytest-dev/pytest-django/pull/566.diff","created_date":"2017-12-26","accepted_date":"2018-01-18","title":"Update copyright year, README for Django 2.0, add django versions to setup.py","actor":145},{"id":278,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest-django/pull/568","diff_url":"https://github.com/pytest-dev/pytest-django/pull/568.diff","created_date":"2017-12-26","accepted_date":null,"title":"Add fixtures for user request factories, clients","actor":145},{"id":279,"component_name":"Patch","qa_url":"https://github.com/yarnpkg/website/pull/770","diff_url":"https://github.com/yarnpkg/website/pull/770.diff","created_date":"2018-02-08","accepted_date":"2018-02-08","title":"Fix typo","actor":146},{"id":280,"component_name":"Patch","qa_url":"https://github.com/JedWatson/react-select/pull/2363","diff_url":"https://github.com/JedWatson/react-select/pull/2363.diff","created_date":"2018-02-09","accepted_date":"2018-02-11","title":"Fix indentation in README code snippet","actor":147},{"id":281,"component_name":"Patch","qa_url":"https://github.com/indico/indico-plugins/pull/65","diff_url":"https://github.com/indico/indico-plugins/pull/65.diff","created_date":"2018-04-27","accepted_date":"2018-05-04","title":"Remove duplicate mimetype","actor":148},{"id":282,"component_name":"Patch","qa_url":"https://github.com/bitprophet/releases/pull/76","diff_url":"https://github.com/bitprophet/releases/pull/76.diff","created_date":"2018-06-23","accepted_date":null,"title":"Support for tags with prefix (rebased)","actor":149},{"id":283,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/alabaster/pull/136","diff_url":"https://github.com/sphinx-doc/alabaster/pull/136.diff","created_date":"2018-06-24","accepted_date":null,"title":"Bump version dev requirements to Sphinx 1.8 and below","actor":150},{"id":284,"component_name":"Patch","qa_url":"https://github.com/MongoEngine/mongoengine/pull/1813","diff_url":"https://github.com/MongoEngine/mongoengine/pull/1813.diff","created_date":"2018-06-27","accepted_date":"2018-06-28","title":"Fix a typo","actor":151},{"id":285,"component_name":"Patch","qa_url":"https://github.com/powerline/fonts/pull/288","diff_url":"https://github.com/powerline/fonts/pull/288.diff","created_date":"2018-07-27","accepted_date":"2018-07-27","title":"Ignore fontconfig .uuid generation","actor":152},{"id":286,"component_name":"Patch","qa_url":"https://github.com/JedWatson/react-select/pull/2971","diff_url":"https://github.com/JedWatson/react-select/pull/2971.diff","created_date":"2018-08-26","accepted_date":"2018-08-27","title":"Typo: isMult -> isMulti","actor":147},{"id":287,"component_name":"Patch","qa_url":"https://github.com/pallets-eco/flask-admin/pull/1714","diff_url":"https://github.com/pallets-eco/flask-admin/pull/1714.diff","created_date":"2018-09-30","accepted_date":"2018-09-30","title":"Add missing class_name to bootstrap 2/3 menu items","actor":153},{"id":288,"component_name":"Patch","qa_url":"https://github.com/muatik/flask-profiler/pull/89","diff_url":"https://github.com/muatik/flask-profiler/pull/89.diff","created_date":"2018-10-10","accepted_date":null,"title":"README Tweaks","actor":154},{"id":289,"component_name":"Patch","qa_url":"https://github.com/psf/black/pull/561","diff_url":"https://github.com/psf/black/pull/561.diff","created_date":"2018-10-12","accepted_date":"2018-10-29","title":"Typo","actor":155},{"id":290,"component_name":"Patch","qa_url":"https://github.com/MongoEngine/flask-mongoengine/pull/346","diff_url":"https://github.com/MongoEngine/flask-mongoengine/pull/346.diff","created_date":"2018-10-13","accepted_date":null,"title":"Upgrade tracking for pymongo >= 3.6.0","actor":156},{"id":291,"component_name":"Patch","qa_url":"https://github.com/MongoEngine/flask-mongoengine/pull/347","diff_url":"https://github.com/MongoEngine/flask-mongoengine/pull/347.diff","created_date":"2018-10-13","accepted_date":null,"title":"Update CI / packaging to be in sync with MongoEngine","actor":156},{"id":292,"component_name":"Patch","qa_url":"https://github.com/mongodb/mongo-python-driver/pull/379","diff_url":"https://github.com/mongodb/mongo-python-driver/pull/379.diff","created_date":"2018-10-18","accepted_date":"2018-10-25","title":"Remove unused import","actor":157},{"id":293,"component_name":"Patch","qa_url":"https://github.com/doableware/djongo/pull/200","diff_url":"https://github.com/doableware/djongo/pull/200.diff","created_date":"2018-10-27","accepted_date":"2018-11-09","title":"Typo fix and highlighting","actor":158},{"id":294,"component_name":"Patch","qa_url":"https://github.com/graphql-python/graphene/pull/868","diff_url":"https://github.com/graphql-python/graphene/pull/868.diff","created_date":"2018-11-26","accepted_date":null,"title":"resolve_type: Tests for Interface","actor":159},{"id":295,"component_name":"Patch","qa_url":"https://github.com/python-openxml/python-docx/pull/587","diff_url":"https://github.com/python-openxml/python-docx/pull/587.diff","created_date":"2018-12-15","accepted_date":null,"title":"Fix linter warning for Python 3.8+ support for collections","actor":160},{"id":296,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/66","diff_url":"https://github.com/2fd/graphdoc/pull/66.diff","created_date":"2018-12-18","accepted_date":"2019-06-18","title":"Fix typo","actor":161},{"id":297,"component_name":"Patch","qa_url":"https://github.com/hasura/sphinx-graphiql/pull/1","diff_url":"https://github.com/hasura/sphinx-graphiql/pull/1.diff","created_date":"2018-12-20","accepted_date":null,"title":"Fix imports on Python 3","actor":162},{"id":298,"component_name":"Patch","qa_url":"https://github.com/hasura/sphinx-graphiql/pull/2","diff_url":"https://github.com/hasura/sphinx-graphiql/pull/2.diff","created_date":"2018-12-20","accepted_date":null,"title":"Use jinja2 to render html","actor":162},{"id":299,"component_name":"Patch","qa_url":"https://github.com/hasura/sphinx-graphiql/pull/3","diff_url":"https://github.com/hasura/sphinx-graphiql/pull/3.diff","created_date":"2018-12-20","accepted_date":null,"title":"Fix Directive import for newer sphinx versions","actor":162},{"id":300,"component_name":"Patch","qa_url":"https://github.com/hasura/sphinx-graphiql/pull/4","diff_url":"https://github.com/hasura/sphinx-graphiql/pull/4.diff","created_date":"2018-12-20","accepted_date":null,"title":"Update gitignore","actor":162},{"id":301,"component_name":"Patch","qa_url":"https://github.com/miracle2k/django-assets/pull/95","diff_url":"https://github.com/miracle2k/django-assets/pull/95.diff","created_date":"2019-01-07","accepted_date":null,"title":"Invoke pytest plugin manually (avoid breaking non-django pytest cases)","actor":56},{"id":302,"component_name":"Patch","qa_url":"https://github.com/miracle2k/django-assets/pull/96","diff_url":"https://github.com/miracle2k/django-assets/pull/96.diff","created_date":"2019-01-07","accepted_date":"2019-12-20","title":"Try to fix travis, bump travis version, rm deadsnakes","actor":56},{"id":303,"component_name":"Patch","qa_url":"https://github.com/mindsdb/minds-platform/pull/117","diff_url":"https://github.com/mindsdb/minds-platform/pull/117.diff","created_date":"2019-03-25","accepted_date":"2019-03-26","title":"Refactor package metadata","actor":163},{"id":304,"component_name":"Patch","qa_url":"https://github.com/thewtex/tmux-mem-cpu-load/pull/58","diff_url":"https://github.com/thewtex/tmux-mem-cpu-load/pull/58.diff","created_date":"2019-04-22","accepted_date":"2019-06-18","title":":see_no_evil: Ignore ninja generated files","actor":95},{"id":305,"component_name":"Patch","qa_url":"https://github.com/django-webpack/django-webpack-loader/pull/197","diff_url":"https://github.com/django-webpack/django-webpack-loader/pull/197.diff","created_date":"2019-04-28","accepted_date":"2019-08-10","title":"Typo","actor":164},{"id":306,"component_name":"Patch","qa_url":"https://github.com/neoclide/coc.nvim/pull/749","diff_url":"https://github.com/neoclide/coc.nvim/pull/749.diff","created_date":"2019-05-03","accepted_date":"2019-05-03","title":"Typo","actor":165},{"id":307,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest-splinter/pull/123","diff_url":"https://github.com/pytest-dev/pytest-splinter/pull/123.diff","created_date":"2019-05-13","accepted_date":"2020-09-12","title":"Simplify --splinter-headless","actor":166},{"id":308,"component_name":"Patch","qa_url":"https://github.com/florimondmanca/djangorestframework-api-key/pull/31","diff_url":"https://github.com/florimondmanca/djangorestframework-api-key/pull/31.diff","created_date":"2019-05-14","accepted_date":"2019-05-14","title":"Fix hashers that emit periods (Fix #22)","actor":167},{"id":309,"component_name":"Patch","qa_url":"https://github.com/ofw/curlify/pull/13","diff_url":"https://github.com/ofw/curlify/pull/13.diff","created_date":"2019-06-05","accepted_date":null,"title":"Python 3 compatibility","actor":168},{"id":310,"component_name":"Patch","qa_url":"https://github.com/ofw/curlify/pull/14","diff_url":"https://github.com/ofw/curlify/pull/14.diff","created_date":"2019-06-06","accepted_date":null,"title":"Python 3 compat, tests","actor":168},{"id":311,"component_name":"Patch","qa_url":"https://github.com/celery/django-celery/pull/570","diff_url":"https://github.com/celery/django-celery/pull/570.diff","created_date":"2019-06-07","accepted_date":"2019-06-07","title":"README fixes","actor":169},{"id":312,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-celery-monitor/pull/114","diff_url":"https://github.com/jazzband/django-celery-monitor/pull/114.diff","created_date":"2019-06-19","accepted_date":null,"title":"Django 2.2 support","actor":170},{"id":313,"component_name":"Patch","qa_url":"https://github.com/webpack/webpack.js.org/pull/3155","diff_url":"https://github.com/webpack/webpack.js.org/pull/3155.diff","created_date":"2019-06-29","accepted_date":"2019-07-01","title":"Typo","actor":171},{"id":314,"component_name":"Patch","qa_url":"https://github.com/lukasvinclav/django-admin-actions/pull/3","diff_url":"https://github.com/lukasvinclav/django-admin-actions/pull/3.diff","created_date":"2019-06-30","accepted_date":"2019-07-01","title":"Support UUID / int object id's","actor":172},{"id":315,"component_name":"Patch","qa_url":"https://github.com/gaearon/react-hot-loader/pull/1297","diff_url":"https://github.com/gaearon/react-hot-loader/pull/1297.diff","created_date":"2019-07-09","accepted_date":"2019-07-09","title":"Typo","actor":173},{"id":316,"component_name":"Patch","qa_url":"https://github.com/collab-project/videojs-record/pull/385","diff_url":"https://github.com/collab-project/videojs-record/pull/385.diff","created_date":"2019-07-15","accepted_date":"2019-07-16","title":"Support for capturing screen + audio","actor":174},{"id":317,"component_name":"Patch","qa_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/37632","diff_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/37632.diff","created_date":"2019-08-14","accepted_date":"2019-08-16","title":"video.js: Add missing option to controlBar","actor":175},{"id":318,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/76","diff_url":"https://github.com/2fd/graphdoc/pull/76.diff","created_date":"2019-08-27","accepted_date":null,"title":"README: Indentation and newline fixes","actor":161},{"id":319,"component_name":"Patch","qa_url":"https://github.com/web-ridge/gqlgen-sqlboiler/pull/2","diff_url":"https://github.com/web-ridge/gqlgen-sqlboiler/pull/2.diff","created_date":"2019-10-15","accepted_date":"2019-10-15","title":"Update LICENSE to MIT","actor":176},{"id":320,"component_name":"Patch","qa_url":"https://github.com/actions/checkout/pull/79","diff_url":"https://github.com/actions/checkout/pull/79.diff","created_date":"2019-11-29","accepted_date":null,"title":"README: Readability tweaks","actor":177},{"id":321,"component_name":"Patch","qa_url":"https://github.com/django/django/pull/12173","diff_url":"https://github.com/django/django/pull/12173.diff","created_date":"2019-12-02","accepted_date":null,"title":"Allow configuring session cache prefix","actor":178},{"id":322,"component_name":"Patch","qa_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/37","diff_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/37.diff","created_date":"2019-12-17","accepted_date":null,"title":"Relax django/other project dependencies, fix travis","actor":179},{"id":323,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/45","diff_url":"https://github.com/hellysmile/django-activeurl/pull/45.diff","created_date":"2019-12-24","accepted_date":"2019-12-24","title":"Travis tweaks, remove python 3.3 and 3.4, sort imports, isort config, add django 2.2","actor":131},{"id":324,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/47","diff_url":"https://github.com/hellysmile/django-activeurl/pull/47.diff","created_date":"2019-12-24","accepted_date":null,"title":"Django 3.0 support","actor":131},{"id":325,"component_name":"Patch","qa_url":"https://github.com/meloncafe/django-activeurl/pull/1","diff_url":"https://github.com/meloncafe/django-activeurl/pull/1.diff","created_date":"2019-12-24","accepted_date":null,"title":"Django 3.0","actor":131},{"id":326,"component_name":"Patch","qa_url":"https://github.com/frontarm/navi-website/pull/18","diff_url":"https://github.com/frontarm/navi-website/pull/18.diff","created_date":"2019-12-30","accepted_date":"2020-10-08","title":"Typo","actor":180},{"id":327,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/48","diff_url":"https://github.com/hellysmile/django-activeurl/pull/48.diff","created_date":"2020-01-01","accepted_date":"2020-01-26","title":"Travis/Tox: Remove versions <2.2, Add 3.0","actor":131},{"id":328,"component_name":"Patch","qa_url":"https://github.com/django-cms/django-classy-tags/pull/51","diff_url":"https://github.com/django-cms/django-classy-tags/pull/51.diff","created_date":"2020-01-01","accepted_date":null,"title":"Django 3 support via compat modules (based on #50)","actor":181},{"id":329,"component_name":"Patch","qa_url":"https://github.com/frontarm/navi/pull/166","diff_url":"https://github.com/frontarm/navi/pull/166.diff","created_date":"2020-01-04","accepted_date":"2020-01-05","title":"Fix prefetching on mount (fixes #165)","actor":182},{"id":330,"component_name":"Patch","qa_url":"https://github.com/tobi-wan-kenobi/bumblebee-status/pull/533","diff_url":"https://github.com/tobi-wan-kenobi/bumblebee-status/pull/533.diff","created_date":"2020-01-26","accepted_date":"2020-01-29","title":"Python package","actor":183},{"id":331,"component_name":"Patch","qa_url":"https://github.com/hellysmile/django-activeurl/pull/50","diff_url":"https://github.com/hellysmile/django-activeurl/pull/50.diff","created_date":"2020-01-26","accepted_date":"2020-01-26","title":"Version 0.2.0","actor":131},{"id":332,"component_name":"Patch","qa_url":"https://github.com/webpack/changelog-v5/pull/20","diff_url":"https://github.com/webpack/changelog-v5/pull/20.diff","created_date":"2020-02-07","accepted_date":"2020-02-07","title":"Typo","actor":184},{"id":333,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/390","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/390.diff","created_date":"2020-02-08","accepted_date":"2020-02-27","title":"Typings: Support custom icons","actor":185},{"id":334,"component_name":"Patch","qa_url":"https://github.com/mmtrt/leagueoflegends/pull/113","diff_url":"https://github.com/mmtrt/leagueoflegends/pull/113.diff","created_date":"2020-02-23","accepted_date":"2020-02-24","title":"Typo","actor":186},{"id":335,"component_name":"Patch","qa_url":"https://github.com/pouchdb-community/pouchdb-replication-stream/pull/81","diff_url":"https://github.com/pouchdb-community/pouchdb-replication-stream/pull/81.diff","created_date":"2020-03-21","accepted_date":null,"title":"Typo","actor":187},{"id":336,"component_name":"Patch","qa_url":"https://github.com/trilogy-group/contently-videojs-annotation-comments/pull/65","diff_url":"https://github.com/trilogy-group/contently-videojs-annotation-comments/pull/65.diff","created_date":"2020-05-06","accepted_date":null,"title":"Typo","actor":188},{"id":337,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/990","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/990.diff","created_date":"2020-06-27","accepted_date":"2020-06-27","title":"Typo","actor":185},{"id":338,"component_name":"Patch","qa_url":"https://github.com/instructure/canvas-lms/pull/1664","diff_url":"https://github.com/instructure/canvas-lms/pull/1664.diff","created_date":"2020-07-02","accepted_date":null,"title":"Fix small typo in docs","actor":189},{"id":339,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/1","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/1.diff","created_date":"2020-07-06","accepted_date":"2021-12-06","title":"Formatting: Use 4-space indentation","actor":190},{"id":340,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/3","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/3.diff","created_date":"2020-07-06","accepted_date":null,"title":"docs: Typo fixes, highlighting","actor":190},{"id":341,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/1","diff_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/1.diff","created_date":"2020-07-06","accepted_date":null,"title":"Docs: Typo / package name fixes","actor":191},{"id":342,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/2","diff_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/2.diff","created_date":"2020-07-06","accepted_date":null,"title":"Run black on codebase","actor":191},{"id":343,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/4","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/4.diff","created_date":"2020-07-06","accepted_date":null,"title":"Fix exception name","actor":190},{"id":344,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/3","diff_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/3.diff","created_date":"2020-07-06","accepted_date":null,"title":"Fix exception module name","actor":191},{"id":345,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/5","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/5.diff","created_date":"2020-07-06","accepted_date":null,"title":"Fix packaging","actor":190},{"id":346,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/4","diff_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/4.diff","created_date":"2020-07-06","accepted_date":null,"title":"Fix packaging","actor":191},{"id":347,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/6","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/6.diff","created_date":"2020-07-11","accepted_date":null,"title":"Python 3 support, packaging, docs tweaks, code fixes, CI","actor":190},{"id":348,"component_name":"Patch","qa_url":"https://github.com/romkatv/powerlevel10k-media/pull/1","diff_url":"https://github.com/romkatv/powerlevel10k-media/pull/1.diff","created_date":"2020-07-15","accepted_date":null,"title":"Ignore fontconfig .uuid generation","actor":192},{"id":349,"component_name":"Patch","qa_url":"https://github.com/django-extensions/django-extensions/pull/1554","diff_url":"https://github.com/django-extensions/django-extensions/pull/1554.diff","created_date":"2020-07-16","accepted_date":"2020-07-16","title":"show_dsn: Fix crash with django-postgres-extra","actor":106},{"id":350,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/1301","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/1301.diff","created_date":"2020-07-18","accepted_date":"2020-07-19","title":"fix: typo in responsive-styles","actor":185},{"id":351,"component_name":"Patch","qa_url":"https://github.com/alexmojaki/futurecoder/pull/24","diff_url":"https://github.com/alexmojaki/futurecoder/pull/24.diff","created_date":"2020-07-25","accepted_date":"2020-07-25","title":"Add flake8, ignore migrations","actor":193},{"id":352,"component_name":"Patch","qa_url":"https://github.com/alexmojaki/futurecoder/pull/25","diff_url":"https://github.com/alexmojaki/futurecoder/pull/25.diff","created_date":"2020-07-25","accepted_date":"2020-07-25","title":"isort: Sort imports","actor":193},{"id":353,"component_name":"Patch","qa_url":"https://github.com/alexmojaki/futurecoder/pull/26","diff_url":"https://github.com/alexmojaki/futurecoder/pull/26.diff","created_date":"2020-07-26","accepted_date":"2020-07-26","title":"poetry: Add flake8, isort","actor":193},{"id":354,"component_name":"Patch","qa_url":"https://github.com/dschep/install-poetry-action/pull/12","diff_url":"https://github.com/dschep/install-poetry-action/pull/12.diff","created_date":"2020-08-02","accepted_date":null,"title":"Update get-poetry.py to use python-poetry org URL","actor":194},{"id":355,"component_name":"Patch","qa_url":"https://github.com/daizutabi/mkapi/pull/23","diff_url":"https://github.com/daizutabi/mkapi/pull/23.diff","created_date":"2020-08-02","accepted_date":"2020-08-03","title":"Handle parsing empty line","actor":195},{"id":356,"component_name":"Patch","qa_url":"https://github.com/daizutabi/mkapi/pull/24","diff_url":"https://github.com/daizutabi/mkapi/pull/24.diff","created_date":"2020-08-02","accepted_date":"2020-08-03","title":"Typo","actor":195},{"id":357,"component_name":"Patch","qa_url":"https://github.com/daizutabi/mkapi/pull/27","diff_url":"https://github.com/daizutabi/mkapi/pull/27.diff","created_date":"2020-08-02","accepted_date":"2020-12-20","title":"Fix crash when parsing / splitting property, or using stdlib base clase","actor":195},{"id":358,"component_name":"Patch","qa_url":"https://github.com/python-social-auth/social-app-django/pull/266","diff_url":"https://github.com/python-social-auth/social-app-django/pull/266.diff","created_date":"2020-08-05","accepted_date":"2021-03-01","title":"Update JSONField for django 3.1+","actor":196},{"id":359,"component_name":"Patch","qa_url":"https://github.com/getsentry/sentry-docs/pull/1975","diff_url":"https://github.com/getsentry/sentry-docs/pull/1975.diff","created_date":"2020-08-07","accepted_date":"2020-08-07","title":"fix(python): Typo in fingerprint rpc example","actor":197},{"id":360,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/5","diff_url":"https://github.com/Qencode-Corp/qencode-api-python3-client/pull/5.diff","created_date":"2020-08-10","accepted_date":null,"title":"Run black on codebase","actor":191},{"id":361,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/1789","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/1789.diff","created_date":"2020-08-23","accepted_date":null,"title":"chore: add selectors for :only-of-type, :only-child","actor":185},{"id":362,"component_name":"Patch","qa_url":"https://github.com/django-statsd/django-statsd/pull/125","diff_url":"https://github.com/django-statsd/django-statsd/pull/125.diff","created_date":"2020-09-04","accepted_date":null,"title":"Typo","actor":198},{"id":363,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/1965","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/1965.diff","created_date":"2020-09-05","accepted_date":"2020-09-06","title":"chore(theme-tools): Make GlobalStyleProps exportable","actor":185},{"id":364,"component_name":"Patch","qa_url":"https://github.com/jaredpalmer/the-platform/pull/96","diff_url":"https://github.com/jaredpalmer/the-platform/pull/96.diff","created_date":"2020-09-07","accepted_date":null,"title":"utils/throttle: Typing updates","actor":199},{"id":365,"component_name":"Patch","qa_url":"https://github.com/jschneier/django-storages/pull/929","diff_url":"https://github.com/jschneier/django-storages/pull/929.diff","created_date":"2020-09-08","accepted_date":"2020-09-09","title":"Docs: Fix block highlighting","actor":200},{"id":366,"component_name":"Patch","qa_url":"https://github.com/NickeManarin/ScreenToGif/pull/728","diff_url":"https://github.com/NickeManarin/ScreenToGif/pull/728.diff","created_date":"2020-09-30","accepted_date":"2020-09-30","title":"Spelling / translation fixes","actor":201},{"id":367,"component_name":"Patch","qa_url":"https://github.com/relay-tools/relay-hooks/pull/119","diff_url":"https://github.com/relay-tools/relay-hooks/pull/119.diff","created_date":"2020-10-06","accepted_date":"2020-10-07","title":"README: Formatting / indentation","actor":202},{"id":368,"component_name":"Patch","qa_url":"https://github.com/relay-tools/relay-hooks/pull/120","diff_url":"https://github.com/relay-tools/relay-hooks/pull/120.diff","created_date":"2020-10-06","accepted_date":"2020-10-07","title":"Update RelayHooks-Introduction","actor":202},{"id":369,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry/pull/3166","diff_url":"https://github.com/python-poetry/poetry/pull/3166.diff","created_date":"2020-10-09","accepted_date":null,"title":"Changelog updates for 1.1.1 + 1.1.2","actor":203},{"id":370,"component_name":"Patch","qa_url":"https://github.com/Undistraction/gatsby-plugin-node-fields/pull/19","diff_url":"https://github.com/Undistraction/gatsby-plugin-node-fields/pull/19.diff","created_date":"2020-11-26","accepted_date":"2021-07-19","title":"Typo","actor":204},{"id":371,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/586","diff_url":"https://github.com/salesforce/akita/pull/586.diff","created_date":"2020-12-28","accepted_date":"2020-12-28","title":"docs: Fix link","actor":205},{"id":372,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/587","diff_url":"https://github.com/salesforce/akita/pull/587.diff","created_date":"2020-12-28","accepted_date":"2020-12-28","title":"chore(docs): remove package-lock.json","actor":205},{"id":373,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/588","diff_url":"https://github.com/salesforce/akita/pull/588.diff","created_date":"2020-12-28","accepted_date":"2020-12-28","title":"docs(devtools): fix broken image","actor":205},{"id":374,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/589","diff_url":"https://github.com/salesforce/akita/pull/589.diff","created_date":"2020-12-28","accepted_date":"2020-12-28","title":"chore(docs): add serve and clear cmds","actor":205},{"id":375,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/590","diff_url":"https://github.com/salesforce/akita/pull/590.diff","created_date":"2020-12-28","accepted_date":"2020-12-28","title":"chore(docs): update dependencies","actor":205},{"id":376,"component_name":"Patch","qa_url":"https://github.com/salesforce/akita/pull/594","diff_url":"https://github.com/salesforce/akita/pull/594.diff","created_date":"2020-12-30","accepted_date":"2020-12-30","title":"docs(ui): definite assignment assertion modifiers for initial state","actor":205},{"id":377,"component_name":"Patch","qa_url":"https://github.com/kulshekhar/ts-jest/pull/2242","diff_url":"https://github.com/kulshekhar/ts-jest/pull/2242.diff","created_date":"2021-01-02","accepted_date":"2021-01-02","title":"docs: Fix yarn command","actor":206},{"id":378,"component_name":"Patch","qa_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/50363","diff_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/50363.diff","created_date":"2021-01-02","accepted_date":"2021-01-05","title":"[@types/plotly.js]: Add missing automargin prop to data","actor":175},{"id":379,"component_name":"Patch","qa_url":"https://github.com/plotly/graphing-library-docs/pull/106","diff_url":"https://github.com/plotly/graphing-library-docs/pull/106.diff","created_date":"2021-01-02","accepted_date":"2021-01-04","title":"[plotly.js] Fundamentals -> Text templates: Fix links to point to JS","actor":207},{"id":380,"component_name":"Patch","qa_url":"https://github.com/alibaba/hooks/pull/817","diff_url":"https://github.com/alibaba/hooks/pull/817.diff","created_date":"2021-01-04","accepted_date":"2021-01-04","title":"fix: typo","actor":208},{"id":381,"component_name":"Patch","qa_url":"https://github.com/alibaba/hooks/pull/818","diff_url":"https://github.com/alibaba/hooks/pull/818.diff","created_date":"2021-01-04","accepted_date":"2021-01-04","title":"chore: highlight","actor":208},{"id":382,"component_name":"Patch","qa_url":"https://github.com/plouc/nivo/pull/1380","diff_url":"https://github.com/plouc/nivo/pull/1380.diff","created_date":"2021-01-07","accepted_date":"2021-01-07","title":"Typo","actor":209},{"id":383,"component_name":"Patch","qa_url":"https://github.com/preactjs/preact-www/pull/737","diff_url":"https://github.com/preactjs/preact-www/pull/737.diff","created_date":"2021-01-10","accepted_date":"2021-01-11","title":"TypeScript: Add babelrc example","actor":210},{"id":384,"component_name":"Patch","qa_url":"https://github.com/python-social-auth/social-app-django/pull/291","diff_url":"https://github.com/python-social-auth/social-app-django/pull/291.diff","created_date":"2021-01-12","accepted_date":"2021-01-15","title":"Changelog: Fix url to 4.0.0","actor":196},{"id":385,"component_name":"Patch","qa_url":"https://github.com/escaped/django-inline-actions/pull/40","diff_url":"https://github.com/escaped/django-inline-actions/pull/40.diff","created_date":"2021-01-22","accepted_date":null,"title":"ModelAdminMixin: Only remove 'render_inline_actions' if exists","actor":211},{"id":386,"component_name":"Patch","qa_url":"https://github.com/ecomfe/zrender/pull/704","diff_url":"https://github.com/ecomfe/zrender/pull/704.diff","created_date":"2021-01-24","accepted_date":"2021-01-24","title":"README: Minor wording tweak","actor":212},{"id":387,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/298","diff_url":"https://github.com/2fd/graphdoc/pull/298.diff","created_date":"2021-01-24","accepted_date":null,"title":"Remove lodash: unused","actor":161},{"id":388,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/300","diff_url":"https://github.com/2fd/graphdoc/pull/300.diff","created_date":"2021-01-24","accepted_date":null,"title":"Normalize styling: Part 1: Configuration","actor":161},{"id":389,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/301","diff_url":"https://github.com/2fd/graphdoc/pull/301.diff","created_date":"2021-01-24","accepted_date":null,"title":"Normalize styling: Part 2: Run formatter","actor":161},{"id":390,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/302","diff_url":"https://github.com/2fd/graphdoc/pull/302.diff","created_date":"2021-01-24","accepted_date":null,"title":"ci: Cache npm","actor":161},{"id":391,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/303","diff_url":"https://github.com/2fd/graphdoc/pull/303.diff","created_date":"2021-01-24","accepted_date":null,"title":"ci: Update Actions @v1 -> @v2","actor":161},{"id":392,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/304","diff_url":"https://github.com/2fd/graphdoc/pull/304.diff","created_date":"2021-01-24","accepted_date":null,"title":"ci: Don't update npm ","actor":161},{"id":393,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/305","diff_url":"https://github.com/2fd/graphdoc/pull/305.diff","created_date":"2021-01-24","accepted_date":null,"title":"Jest/chai: Update packages, typings","actor":161},{"id":394,"component_name":"Patch","qa_url":"https://github.com/2fd/graphdoc/pull/306","diff_url":"https://github.com/2fd/graphdoc/pull/306.diff","created_date":"2021-01-24","accepted_date":null,"title":"CI: Remove unsupported node releases (6.x, 8.x)","actor":161},{"id":395,"component_name":"Patch","qa_url":"https://github.com/exogen/graphql-markdown/pull/61","diff_url":"https://github.com/exogen/graphql-markdown/pull/61.diff","created_date":"2021-01-26","accepted_date":null,"title":"loadSchemaJSON.js: Sync with npm run format","actor":213},{"id":396,"component_name":"Patch","qa_url":"https://github.com/exogen/graphql-markdown/pull/63","diff_url":"https://github.com/exogen/graphql-markdown/pull/63.diff","created_date":"2021-01-26","accepted_date":null,"title":"Add .prettierrc, run prettier with format command","actor":213},{"id":397,"component_name":"Patch","qa_url":"https://github.com/exogen/graphql-markdown/pull/64","diff_url":"https://github.com/exogen/graphql-markdown/pull/64.diff","created_date":"2021-01-26","accepted_date":null,"title":"Normalize / sync with prettier (prettier @ v2)","actor":213},{"id":398,"component_name":"Patch","qa_url":"https://github.com/FactoryBoy/factory_boy/pull/840","diff_url":"https://github.com/FactoryBoy/factory_boy/pull/840.diff","created_date":"2021-02-12","accepted_date":"2021-02-12","title":"Docs: Fix extra quote","actor":214},{"id":399,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9111","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9111.diff","created_date":"2021-02-25","accepted_date":"2021-03-01","title":"Docs (editor-balloon): Fix package name / url","actor":215},{"id":400,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9125","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9125.diff","created_date":"2021-02-26","accepted_date":"2021-03-01","title":"chore(ckeditor5-upload): Fix typo","actor":215},{"id":401,"component_name":"Patch","qa_url":"https://github.com/just-jeb/angular-builders/pull/943","diff_url":"https://github.com/just-jeb/angular-builders/pull/943.diff","created_date":"2021-03-02","accepted_date":"2021-03-04","title":"chore: fix typo in issue template","actor":216},{"id":402,"component_name":"Patch","qa_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/51517","diff_url":"https://github.com/DefinitelyTyped/DefinitelyTyped/pull/51517.diff","created_date":"2021-03-02","accepted_date":"2021-03-02","title":"redux-sentry-middleware: Support @sentry/browser 6.x in typings","actor":175},{"id":403,"component_name":"Patch","qa_url":"https://github.com/ionelmc/django-prefetch/pull/19","diff_url":"https://github.com/ionelmc/django-prefetch/pull/19.diff","created_date":"2021-03-07","accepted_date":"2021-03-22","title":"Typo","actor":217},{"id":404,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9204","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9204.diff","created_date":"2021-03-10","accepted_date":"2021-03-30","title":"editorconfig: Use single quotes","actor":215},{"id":405,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9311","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9311.diff","created_date":"2021-03-21","accepted_date":null,"title":"Pass icon color as stroke via .ck-icon__stroke","actor":215},{"id":406,"component_name":"Patch","qa_url":"https://github.com/chodorowicz/ts-debounce/pull/44","diff_url":"https://github.com/chodorowicz/ts-debounce/pull/44.diff","created_date":"2021-03-23","accepted_date":"2021-04-02","title":"Fix typo","actor":218},{"id":407,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9375","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9375.diff","created_date":"2021-03-26","accepted_date":null,"title":"MediaEmbed: Set custom element name","actor":215},{"id":408,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9418","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9418.diff","created_date":"2021-04-03","accepted_date":null,"title":"MediaEmbed: Override custom element names","actor":215},{"id":409,"component_name":"Patch","qa_url":"https://github.com/facebook/docusaurus/pull/4568","diff_url":"https://github.com/facebook/docusaurus/pull/4568.diff","created_date":"2021-04-03","accepted_date":"2021-04-05","title":"docs(v2): add social-embed to showcase","actor":219},{"id":410,"component_name":"Patch","qa_url":"https://github.com/modernweb-dev/web/pull/1378","diff_url":"https://github.com/modernweb-dev/web/pull/1378.diff","created_date":"2021-04-04","accepted_date":"2021-04-07","title":"chore(typo)","actor":220},{"id":411,"component_name":"Patch","qa_url":"https://github.com/pyutils/line_profiler/pull/56","diff_url":"https://github.com/pyutils/line_profiler/pull/56.diff","created_date":"2021-04-06","accepted_date":"2021-04-06","title":"README: Remove RunSnakeRun (unmaintained)","actor":221},{"id":412,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9528","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9528.diff","created_date":"2021-04-20","accepted_date":"2021-04-22","title":"chore: Fix typos","actor":215},{"id":413,"component_name":"Patch","qa_url":"https://github.com/chintan9/plyr-react/pull/536","diff_url":"https://github.com/chintan9/plyr-react/pull/536.diff","created_date":"2021-04-21","accepted_date":"2021-04-27","title":"Passthrough <video> props via HTMLProps","actor":222},{"id":414,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9540","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9540.diff","created_date":"2021-04-21","accepted_date":null,"title":"Add optional editorClass config (proof of concept)","actor":215},{"id":415,"component_name":"Patch","qa_url":"https://github.com/daniyalzade/django_reverse_admin/pull/271","diff_url":"https://github.com/daniyalzade/django_reverse_admin/pull/271.diff","created_date":"2021-06-01","accepted_date":"2024-05-01","title":"Fix Typo","actor":223},{"id":416,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9817","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9817.diff","created_date":"2021-06-02","accepted_date":null,"title":"Developer loop sample: yarn start","actor":215},{"id":417,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/9820","diff_url":"https://github.com/ckeditor/ckeditor5/pull/9820.diff","created_date":"2021-06-03","accepted_date":null,"title":"Media Embed: Add `automaticEmbed` option to provider","actor":215},{"id":418,"component_name":"Patch","qa_url":"https://github.com/icd2k3/react-scroll-into-view-if-needed/pull/21","diff_url":"https://github.com/icd2k3/react-scroll-into-view-if-needed/pull/21.diff","created_date":"2021-06-06","accepted_date":"2021-06-08","title":"Fix loading in SSR (gatsby, next.js)","actor":224},{"id":419,"component_name":"Patch","qa_url":"https://github.com/sampotts/plyr/pull/2242","diff_url":"https://github.com/sampotts/plyr/pull/2242.diff","created_date":"2021-06-10","accepted_date":"2021-09-29","title":"README: Link to svelte project","actor":225},{"id":420,"component_name":"Patch","qa_url":"https://github.com/just-jeb/angular-builders/pull/1004","diff_url":"https://github.com/just-jeb/angular-builders/pull/1004.diff","created_date":"2021-06-17","accepted_date":"2021-06-27","title":"Chore: fix typo","actor":216},{"id":421,"component_name":"Patch","qa_url":"https://github.com/xnimorz/use-debounce/pull/116","diff_url":"https://github.com/xnimorz/use-debounce/pull/116.diff","created_date":"2021-06-20","accepted_date":"2021-06-20","title":"chore: fix typo","actor":226},{"id":422,"component_name":"Patch","qa_url":"https://github.com/Mrtenz/gatsby-plugin-aws-elasticsearch/pull/10","diff_url":"https://github.com/Mrtenz/gatsby-plugin-aws-elasticsearch/pull/10.diff","created_date":"2021-06-20","accepted_date":null,"title":"Elasticsearch js","actor":227},{"id":423,"component_name":"Patch","qa_url":"https://github.com/gatsbyjs/gatsby/pull/32403","diff_url":"https://github.com/gatsbyjs/gatsby/pull/32403.diff","created_date":"2021-07-17","accepted_date":null,"title":"feat(gatsby-plugin-image): Export isGatsbyImageData(Parent) type","actor":228},{"id":424,"component_name":"Patch","qa_url":"https://github.com/cobrateam/splinter/pull/903","diff_url":"https://github.com/cobrateam/splinter/pull/903.diff","created_date":"2021-07-29","accepted_date":null,"title":"`is_element_visible`: Check for `StaleElementReferenceException`","actor":229},{"id":425,"component_name":"Patch","qa_url":"https://github.com/terence410/ts-google-drive/pull/1","diff_url":"https://github.com/terence410/ts-google-drive/pull/1.diff","created_date":"2021-07-30","accepted_date":null,"title":"Fix typo in class name","actor":230},{"id":426,"component_name":"Patch","qa_url":"https://github.com/dangcuuson/graphql-schema-typescript/pull/61","diff_url":"https://github.com/dangcuuson/graphql-schema-typescript/pull/61.diff","created_date":"2021-07-31","accepted_date":null,"title":"GraphQL 15 support","actor":231},{"id":427,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/4577","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/4577.diff","created_date":"2021-08-15","accepted_date":"2021-08-16","title":"fix(docs): update branch name in `contributing.md`","actor":185},{"id":428,"component_name":"Patch","qa_url":"https://github.com/chakra-ui/chakra-ui/pull/5125","diff_url":"https://github.com/chakra-ui/chakra-ui/pull/5125.diff","created_date":"2021-11-20","accepted_date":"2021-11-21","title":"chore: Fix typo","actor":185},{"id":429,"component_name":"Patch","qa_url":"https://github.com/smartvokat/esbuild-plugin-relay/pull/2","diff_url":"https://github.com/smartvokat/esbuild-plugin-relay/pull/2.diff","created_date":"2021-11-21","accepted_date":"2021-12-06","title":"chore: Update node, typescript, relay","actor":232},{"id":430,"component_name":"Patch","qa_url":"https://github.com/asdf-community/asdf-poetry/pull/14","diff_url":"https://github.com/asdf-community/asdf-poetry/pull/14.diff","created_date":"2021-11-25","accepted_date":null,"title":"`install-poetry.py`: Use for `1.1.9` and up","actor":233},{"id":431,"component_name":"Patch","qa_url":"https://github.com/asdf-community/asdf-poetry/pull/15","diff_url":"https://github.com/asdf-community/asdf-poetry/pull/15.diff","created_date":"2021-11-25","accepted_date":"2021-11-27","title":"`install-poetry.py`: Use new official install location","actor":233},{"id":432,"component_name":"Patch","qa_url":"https://github.com/asdf-community/asdf-poetry/pull/16","diff_url":"https://github.com/asdf-community/asdf-poetry/pull/16.diff","created_date":"2021-11-27","accepted_date":"2021-11-28","title":"`ASDF_POETRY_INSTALL_URL`: Optionally override installer URL","actor":233},{"id":433,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/16","diff_url":"https://github.com/zaproxy/actions-common/pull/16.diff","created_date":"2021-12-02","accepted_date":null,"title":"See #17 (wrong branch opened, wrong order)","actor":234},{"id":434,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/17","diff_url":"https://github.com/zaproxy/actions-common/pull/17.diff","created_date":"2021-12-02","accepted_date":null,"title":"Update `package-lock.json` npm lockfile v2 (NPM v7+)","actor":234},{"id":435,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/18","diff_url":"https://github.com/zaproxy/actions-common/pull/18.diff","created_date":"2021-12-02","accepted_date":null,"title":"Update packages (including GH actions)","actor":234},{"id":436,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/21","diff_url":"https://github.com/zaproxy/actions-common/pull/21.diff","created_date":"2021-12-03","accepted_date":null,"title":"`artifactName`: Fix multiple issues being created when passed (WIP)","actor":234},{"id":437,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/22","diff_url":"https://github.com/zaproxy/actions-common/pull/22.diff","created_date":"2021-12-03","accepted_date":null,"title":"Optional PR: Move optional params to object (WIP)","actor":234},{"id":438,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/23","diff_url":"https://github.com/zaproxy/actions-common/pull/23.diff","created_date":"2021-12-04","accepted_date":"2022-02-23","title":"chore (package.json): Add license, `\"zaproxy\"` to keywords","actor":234},{"id":439,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/24","diff_url":"https://github.com/zaproxy/actions-common/pull/24.diff","created_date":"2021-12-04","accepted_date":null,"title":"Add `.nvmrc` for node version with npm v6 as default ","actor":234},{"id":440,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/25","diff_url":"https://github.com/zaproxy/actions-common/pull/25.diff","created_date":"2021-12-04","accepted_date":null,"title":"Basic eslint (`npm run eslint`, config file)","actor":234},{"id":441,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/26","diff_url":"https://github.com/zaproxy/actions-common/pull/26.diff","created_date":"2021-12-04","accepted_date":null,"title":"Basic eslint fixes","actor":234},{"id":442,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/27","diff_url":"https://github.com/zaproxy/actions-common/pull/27.diff","created_date":"2021-12-04","accepted_date":null,"title":"Basic eslint fixes - optional chaining","actor":234},{"id":443,"component_name":"Patch","qa_url":"https://github.com/zaproxy/actions-common/pull/28","diff_url":"https://github.com/zaproxy/actions-common/pull/28.diff","created_date":"2021-12-06","accepted_date":null,"title":"Format with `prettier` (`npm run format`)","actor":234},{"id":444,"component_name":"Patch","qa_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/9","diff_url":"https://github.com/Qencode-Corp/qencode-api-python-client/pull/9.diff","created_date":"2021-12-11","accepted_date":null,"title":"Poetry package management, basic github action, isort","actor":190},{"id":445,"component_name":"Patch","qa_url":"https://github.com/django-extensions/django-extensions/pull/1692","diff_url":"https://github.com/django-extensions/django-extensions/pull/1692.diff","created_date":"2021-12-14","accepted_date":"2022-06-11","title":"setup.py: Add project URLs for pypi","actor":106},{"id":446,"component_name":"Patch","qa_url":"https://github.com/cobrateam/splinter/pull/970","diff_url":"https://github.com/cobrateam/splinter/pull/970.diff","created_date":"2021-12-20","accepted_date":"2022-01-05","title":"`setup.py`: Add project URLs for PyPI","actor":229},{"id":447,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/27","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/27.diff","created_date":"2021-12-30","accepted_date":"2021-12-31","title":"Handle noop rename table (fixes #26)","actor":235},{"id":448,"component_name":"Patch","qa_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/81","diff_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/81.diff","created_date":"2022-01-05","accepted_date":null,"title":"`django`: Loosen version constraint for django 2.2 users","actor":179},{"id":449,"component_name":"Patch","qa_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/83","diff_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/83.diff","created_date":"2022-01-05","accepted_date":null,"title":"Django 4.0 support, loosen version constraints","actor":179},{"id":450,"component_name":"Patch","qa_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/84","diff_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs/pull/84.diff","created_date":"2022-01-05","accepted_date":null,"title":"CI: Run tests on pull requests","actor":179},{"id":451,"component_name":"Patch","qa_url":"https://github.com/pennersr/django-allauth/pull/3005","diff_url":"https://github.com/pennersr/django-allauth/pull/3005.diff","created_date":"2022-01-05","accepted_date":"2022-02-03","title":"`setup.py`: Add project URLs for PyPi","actor":81},{"id":452,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/120","diff_url":"https://github.com/jazzband/django-robots/pull/120.diff","created_date":"2022-01-05","accepted_date":"2022-01-06","title":"Deprecate python 3.6","actor":141},{"id":453,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/121","diff_url":"https://github.com/jazzband/django-robots/pull/121.diff","created_date":"2022-01-06","accepted_date":"2022-01-06","title":"docs(CHANGES): Update for next release","actor":141},{"id":454,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/122","diff_url":"https://github.com/jazzband/django-robots/pull/122.diff","created_date":"2022-01-06","accepted_date":"2022-01-06","title":"Add .pre-commit-config.yaml","actor":141},{"id":455,"component_name":"Patch","qa_url":"https://github.com/jazzband/website/pull/988","diff_url":"https://github.com/jazzband/website/pull/988.diff","created_date":"2022-01-06","accepted_date":"2022-02-11","title":"chore(releases): fix typo","actor":146},{"id":456,"component_name":"Patch","qa_url":"https://github.com/ambitioninc/django-manager-utils/pull/127","diff_url":"https://github.com/ambitioninc/django-manager-utils/pull/127.diff","created_date":"2022-01-06","accepted_date":null,"title":"Fix django 4.0 compatibility (remove `providing_args`)","actor":236},{"id":457,"component_name":"Patch","qa_url":"https://github.com/redis/redis-py/pull/1867","diff_url":"https://github.com/redis/redis-py/pull/1867.diff","created_date":"2022-01-06","accepted_date":"2022-01-10","title":"`setup.py`: Add project_urls for PyPI","actor":237},{"id":458,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/123","diff_url":"https://github.com/jazzband/django-robots/pull/123.diff","created_date":"2022-01-08","accepted_date":"2022-01-08","title":"v5.0","actor":141},{"id":459,"component_name":"Patch","qa_url":"https://github.com/Kludex/uvicorn/pull/1312","diff_url":"https://github.com/Kludex/uvicorn/pull/1312.diff","created_date":"2022-01-08","accepted_date":null,"title":"Refactor/vendorize typings","actor":238},{"id":460,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry-core/pull/263","diff_url":"https://github.com/python-poetry/poetry-core/pull/263.diff","created_date":"2022-01-16","accepted_date":"2022-02-03","title":"Deprecate Python 3.6","actor":239},{"id":461,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry/pull/5055","diff_url":"https://github.com/python-poetry/poetry/pull/5055.diff","created_date":"2022-01-18","accepted_date":"2022-01-23","title":"pyproject: Drop python 3.6","actor":203},{"id":462,"component_name":"Patch","qa_url":"https://github.com/python-poetry/install.python-poetry.org/pull/11","diff_url":"https://github.com/python-poetry/install.python-poetry.org/pull/11.diff","created_date":"2022-01-22","accepted_date":null,"title":"Deprecate Python 3.6","actor":240},{"id":463,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry-core/pull/265","diff_url":"https://github.com/python-poetry/poetry-core/pull/265.diff","created_date":"2022-01-22","accepted_date":"2022-02-05","title":"CI (python matrix): Update to 3.10","actor":239},{"id":464,"component_name":"Patch","qa_url":"https://github.com/dangcuuson/graphql-schema-typescript/pull/70","diff_url":"https://github.com/dangcuuson/graphql-schema-typescript/pull/70.diff","created_date":"2022-02-10","accepted_date":"2023-12-23","title":"chore: Fix typo","actor":231},{"id":465,"component_name":"Patch","qa_url":"https://github.com/Kludex/uvicorn/pull/1373","diff_url":"https://github.com/Kludex/uvicorn/pull/1373.diff","created_date":"2022-02-11","accepted_date":null,"title":"chore(mypy): Loosen scope typing to `dict`","actor":238},{"id":466,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/44","diff_url":"https://github.com/clokep/celery-batches/pull/44.diff","created_date":"2022-02-19","accepted_date":"2022-02-22","title":"`.gitignore`: Ignore virtualenvs","actor":241},{"id":467,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/45","diff_url":"https://github.com/clokep/celery-batches/pull/45.diff","created_date":"2022-02-19","accepted_date":"2022-02-22","title":"Docs: Spring cleaning","actor":241},{"id":468,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/46","diff_url":"https://github.com/clokep/celery-batches/pull/46.diff","created_date":"2022-02-19","accepted_date":"2022-02-22","title":"LICENSE: Update for copyright years, make perpetual","actor":241},{"id":469,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/47","diff_url":"https://github.com/clokep/celery-batches/pull/47.diff","created_date":"2022-02-19","accepted_date":"2022-02-22","title":"README: Add pypi badge","actor":241},{"id":470,"component_name":"Patch","qa_url":"https://github.com/Anidetrix/rollup-plugin-styles/pull/209","diff_url":"https://github.com/Anidetrix/rollup-plugin-styles/pull/209.diff","created_date":"2022-02-20","accepted_date":"2022-02-26","title":"chore(README): typo","actor":242},{"id":471,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/49","diff_url":"https://github.com/clokep/celery-batches/pull/49.diff","created_date":"2022-02-22","accepted_date":"2022-02-22","title":"docs(example): Disambiguate `requests` example","actor":241},{"id":472,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/50","diff_url":"https://github.com/clokep/celery-batches/pull/50.diff","created_date":"2022-02-22","accepted_date":"2022-02-22","title":"docs(CHANGELOG): Split changes by type","actor":241},{"id":473,"component_name":"Patch","qa_url":"https://github.com/steinitzu/celery-singleton/pull/41","diff_url":"https://github.com/steinitzu/celery-singleton/pull/41.diff","created_date":"2022-02-22","accepted_date":"2022-10-02","title":"chore(docs): Typo fix","actor":243},{"id":474,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/52","diff_url":"https://github.com/clokep/celery-batches/pull/52.diff","created_date":"2022-02-23","accepted_date":"2022-02-23","title":"build(pypi): Add sponsor link","actor":241},{"id":475,"component_name":"Patch","qa_url":"https://github.com/steinitzu/celery-singleton/pull/43","diff_url":"https://github.com/steinitzu/celery-singleton/pull/43.diff","created_date":"2022-02-23","accepted_date":"2022-10-02","title":"chore(docs) : Small typo","actor":243},{"id":476,"component_name":"Patch","qa_url":"https://github.com/steinitzu/celery-singleton/pull/44","diff_url":"https://github.com/steinitzu/celery-singleton/pull/44.diff","created_date":"2022-02-23","accepted_date":"2022-10-02","title":"Optional setting `single_json_encoder_class`: Set `json`-compatible encoder class to `generate_lock()`","actor":243},{"id":477,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/55","diff_url":"https://github.com/clokep/celery-batches/pull/55.diff","created_date":"2022-02-24","accepted_date":"2022-02-24","title":"docs: Demo furo theme","actor":241},{"id":478,"component_name":"Patch","qa_url":"https://github.com/scoutapp/scout_apm_python/pull/732","diff_url":"https://github.com/scoutapp/scout_apm_python/pull/732.diff","created_date":"2022-02-24","accepted_date":"2022-03-03","title":"celery: Skip tagging `delivery_info` if missing from request","actor":244},{"id":479,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry/pull/5237","diff_url":"https://github.com/python-poetry/poetry/pull/5237.diff","created_date":"2022-02-25","accepted_date":"2022-02-26","title":"chore(CHANGES): Fix heading level","actor":203},{"id":480,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/32","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/32.diff","created_date":"2022-02-26","accepted_date":"2022-02-28","title":"chore(README): Fix typo","actor":235},{"id":481,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinxext-opengraph/pull/58","diff_url":"https://github.com/sphinx-doc/sphinxext-opengraph/pull/58.diff","created_date":"2022-02-27","accepted_date":"2022-02-27","title":"chore(README) Typo fix","actor":245},{"id":482,"component_name":"Patch","qa_url":"https://github.com/neoclide/vim-jsx-improve/pull/57","diff_url":"https://github.com/neoclide/vim-jsx-improve/pull/57.diff","created_date":"2022-02-28","accepted_date":"2022-02-28","title":"docs(README): Update org","actor":246},{"id":483,"component_name":"Patch","qa_url":"https://github.com/dotansimha/graphql-code-generator/pull/7593","diff_url":"https://github.com/dotansimha/graphql-code-generator/pull/7593.diff","created_date":"2022-02-28","accepted_date":"2022-03-03","title":"docs(relay-operation-optimizer): Fix URL","actor":247},{"id":484,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/33","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/33.diff","created_date":"2022-03-01","accepted_date":"2022-03-02","title":"chore(README): typo fix","actor":235},{"id":485,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/34","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/34.diff","created_date":"2022-03-05","accepted_date":"2022-03-05","title":"docs: Rewrite Transactions FIFO waiting","actor":235},{"id":486,"component_name":"Patch","qa_url":"https://github.com/python-poetry/poetry/pull/5278","diff_url":"https://github.com/python-poetry/poetry/pull/5278.diff","created_date":"2022-03-05","accepted_date":"2022-03-24","title":"Fix typo: occured -> occurred (`get-poetry.py`)","actor":203},{"id":487,"component_name":"Patch","qa_url":"https://github.com/fish2000/pygments-csv-lexer/pull/2","diff_url":"https://github.com/fish2000/pygments-csv-lexer/pull/2.diff","created_date":"2022-03-11","accepted_date":null,"title":"`CsvLexer`: Consolidate regex pattern","actor":248},{"id":488,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/36","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/36.diff","created_date":"2022-03-13","accepted_date":"2022-03-13","title":"Run prettier on README.md (`npx prettier --no-config --write README.md`)","actor":235},{"id":489,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/37","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/37.diff","created_date":"2022-03-13","accepted_date":"2022-03-13","title":"ci: Add `.pre-commit-config.yaml`","actor":235},{"id":490,"component_name":"Patch","qa_url":"https://github.com/github/advisory-database/pull/108","diff_url":"https://github.com/github/advisory-database/pull/108.diff","created_date":"2022-03-15","accepted_date":"2022-03-15","title":"Contribution to \"The package libvcs before 0.11.1 are vulnerable to...\"","actor":249},{"id":491,"component_name":"Patch","qa_url":"https://github.com/rothgar/awesome-tuis/pull/53","diff_url":"https://github.com/rothgar/awesome-tuis/pull/53.diff","created_date":"2022-03-17","accepted_date":"2022-03-17","title":"chore: typo","actor":250},{"id":492,"component_name":"Patch","qa_url":"https://github.com/luizyao/pytest-pyppeteer/pull/33","diff_url":"https://github.com/luizyao/pytest-pyppeteer/pull/33.diff","created_date":"2022-03-29","accepted_date":"2022-03-31","title":"build: Project URLs for PyPI","actor":251},{"id":493,"component_name":"Patch","qa_url":"https://github.com/stripe/stripe-python/pull/786","diff_url":"https://github.com/stripe/stripe-python/pull/786.diff","created_date":"2022-03-30","accepted_date":"2022-04-15","title":"PyPI / project URLs: Link to CHANGES.md","actor":252},{"id":494,"component_name":"Patch","qa_url":"https://github.com/saltstack/salt/pull/61939","diff_url":"https://github.com/saltstack/salt/pull/61939.diff","created_date":"2022-04-09","accepted_date":"2022-06-15","title":"chore(pty.py): Fix link to broken cpython mirror","actor":20},{"id":495,"component_name":"Patch","qa_url":"https://github.com/getmoto/moto/pull/5019","diff_url":"https://github.com/getmoto/moto/pull/5019.diff","created_date":"2022-04-11","accepted_date":"2022-04-12","title":"build(setup.py): Add issues, changelog link to PyPI","actor":253},{"id":496,"component_name":"Patch","qa_url":"https://github.com/prettier/prettier/pull/12656","diff_url":"https://github.com/prettier/prettier/pull/12656.diff","created_date":"2022-04-16","accepted_date":null,"title":"docs(pre-commit): Use the new syntax","actor":254},{"id":497,"component_name":"Patch","qa_url":"https://github.com/pre-commit/mirrors-prettier/pull/21","diff_url":"https://github.com/pre-commit/mirrors-prettier/pull/21.diff","created_date":"2022-04-16","accepted_date":null,"title":"docs(pre-commit): Use the new syntax","actor":255},{"id":498,"component_name":"Patch","qa_url":"https://github.com/python/typing/pull/1147","diff_url":"https://github.com/python/typing/pull/1147.diff","created_date":"2022-04-18","accepted_date":"2022-04-18","title":"pyproject.toml: Add PyPI Project URLs","actor":256},{"id":499,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/129","diff_url":"https://github.com/jazzband/django-robots/pull/129.diff","created_date":"2022-04-23","accepted_date":null,"title":"Django migrations for 5.0","actor":141},{"id":500,"component_name":"Patch","qa_url":"https://github.com/gatsbyjs/node-potrace/pull/2","diff_url":"https://github.com/gatsbyjs/node-potrace/pull/2.diff","created_date":"2022-04-30","accepted_date":null,"title":"chore(README): Note LGPLv3","actor":257},{"id":501,"component_name":"Patch","qa_url":"https://github.com/gatsbyjs/node-potrace/pull/3","diff_url":"https://github.com/gatsbyjs/node-potrace/pull/3.diff","created_date":"2022-04-30","accepted_date":null,"title":"build(package.json): GPL-3.0 -> LGPL-3.0","actor":257},{"id":502,"component_name":"Patch","qa_url":"https://github.com/NickeManarin/ScreenToGif/pull/1112","diff_url":"https://github.com/NickeManarin/ScreenToGif/pull/1112.diff","created_date":"2022-05-05","accepted_date":"2022-05-15","title":"ScreenToGif: Fix typos","actor":201},{"id":503,"component_name":"Patch","qa_url":"https://github.com/zdharma-continuum/zinit/pull/288","diff_url":"https://github.com/zdharma-continuum/zinit/pull/288.diff","created_date":"2022-05-24","accepted_date":"2022-05-28","title":"docs(README): Fix migration link","actor":258},{"id":504,"component_name":"Patch","qa_url":"https://github.com/vim-autoformat/vim-autoformat/pull/375","diff_url":"https://github.com/vim-autoformat/vim-autoformat/pull/375.diff","created_date":"2022-05-27","accepted_date":"2022-05-27","title":"chore(README): Update git org name","actor":259},{"id":505,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest/pull/10013","diff_url":"https://github.com/pytest-dev/pytest/pull/10013.diff","created_date":"2022-06-01","accepted_date":"2022-06-02","title":"docs(monkeypatch): Fix autodoc reference links","actor":260},{"id":506,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest/pull/10017","diff_url":"https://github.com/pytest-dev/pytest/pull/10017.diff","created_date":"2022-06-02","accepted_date":"2022-06-02","title":"[6.2.x] docs(monkeypatch): Fix autodoc reference links","actor":260},{"id":507,"component_name":"Patch","qa_url":"https://github.com/pypa/pip/pull/11208","diff_url":"https://github.com/pypa/pip/pull/11208.diff","created_date":"2022-06-25","accepted_date":null,"title":"vcs(git): Remove redundant scheme for `git+ssh`","actor":261},{"id":508,"component_name":"Patch","qa_url":"https://github.com/react-component/tooltip/pull/346","diff_url":"https://github.com/react-component/tooltip/pull/346.diff","created_date":"2022-07-04","accepted_date":"2022-07-04","title":"chore(README)","actor":262},{"id":509,"component_name":"Patch","qa_url":"https://github.com/ambitioninc/django-manager-utils/pull/128","diff_url":"https://github.com/ambitioninc/django-manager-utils/pull/128.diff","created_date":"2022-07-05","accepted_date":"2022-08-23","title":"build(project_urls): Add PyPI links to changelog and issues","actor":236},{"id":510,"component_name":"Patch","qa_url":"https://github.com/pypa/pip/pull/11244","diff_url":"https://github.com/pypa/pip/pull/11244.diff","created_date":"2022-07-09","accepted_date":"2022-07-15","title":"docs(vcs support): Missing spaces, fix svn editable installs","actor":261},{"id":511,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/31","diff_url":"https://github.com/twmr/pytest-sphinx/pull/31.diff","created_date":"2022-07-12","accepted_date":null,"title":"(WIP) Myst parser: `.md` + `{eval-rst}` support","actor":263},{"id":512,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/32","diff_url":"https://github.com/twmr/pytest-sphinx/pull/32.diff","created_date":"2022-07-12","accepted_date":"2022-07-12","title":"chore(.gitignore): Ignore virtualenv directories","actor":263},{"id":513,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/33","diff_url":"https://github.com/twmr/pytest-sphinx/pull/33.diff","created_date":"2022-07-12","accepted_date":"2022-07-12","title":"Use verbose regular expression","actor":263},{"id":514,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/34","diff_url":"https://github.com/twmr/pytest-sphinx/pull/34.diff","created_date":"2022-07-12","accepted_date":"2022-07-12","title":"Use named group regular expression","actor":263},{"id":515,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/35","diff_url":"https://github.com/twmr/pytest-sphinx/pull/35.diff","created_date":"2022-07-13","accepted_date":"2022-07-15","title":"test_sphinx_doctest.py: Assert `doctest` directive","actor":263},{"id":516,"component_name":"Patch","qa_url":"https://github.com/joke2k/faker/pull/1683","diff_url":"https://github.com/joke2k/faker/pull/1683.diff","created_date":"2022-07-14","accepted_date":"2022-07-15","title":"build(setup.py): Add `project_urls`","actor":264},{"id":517,"component_name":"Patch","qa_url":"https://github.com/spulec/freezegun/pull/458","diff_url":"https://github.com/spulec/freezegun/pull/458.diff","created_date":"2022-07-14","accepted_date":"2022-07-15","title":"build(project_urls): Add project URLs for PyPI","actor":265},{"id":518,"component_name":"Patch","qa_url":"https://github.com/SeleniumHQ/selenium/pull/10880","diff_url":"https://github.com/SeleniumHQ/selenium/pull/10880.diff","created_date":"2022-07-15","accepted_date":"2022-08-05","title":"[py] build(setup.py): Add `project_urls` for PyPI","actor":266},{"id":519,"component_name":"Patch","qa_url":"https://github.com/getsentry/responses/pull/568","diff_url":"https://github.com/getsentry/responses/pull/568.diff","created_date":"2022-07-15","accepted_date":"2022-07-15","title":"build(setup.py): Add `project_urls` for PyPI","actor":267},{"id":520,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest-splinter/pull/159","diff_url":"https://github.com/pytest-dev/pytest-splinter/pull/159.diff","created_date":"2022-07-19","accepted_date":"2022-07-29","title":"build(setup.py): Add `project_urls` for PyPI","actor":166},{"id":521,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/1083","diff_url":"https://github.com/typeddjango/django-stubs/pull/1083.diff","created_date":"2022-08-01","accepted_date":"2022-08-01","title":"docs(README): Fix indentation in list and examples","actor":268},{"id":522,"component_name":"Patch","qa_url":"https://github.com/iamishalkin/cyrtd/pull/2","diff_url":"https://github.com/iamishalkin/cyrtd/pull/2.diff","created_date":"2022-08-21","accepted_date":null,"title":"chore(README): Typo","actor":269},{"id":523,"component_name":"Patch","qa_url":"https://github.com/igor-raits/sphinxcontrib-issuetracker/pull/26","diff_url":"https://github.com/igor-raits/sphinxcontrib-issuetracker/pull/26.diff","created_date":"2022-08-27","accepted_date":null,"title":"Markdown","actor":270},{"id":524,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/38","diff_url":"https://github.com/twmr/pytest-sphinx/pull/38.diff","created_date":"2022-09-03","accepted_date":null,"title":"WIP: Docutils parser","actor":263},{"id":525,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/41","diff_url":"https://github.com/twmr/pytest-sphinx/pull/41.diff","created_date":"2022-09-03","accepted_date":"2022-09-04","title":"setup.py -> pyproject.toml (PEP 621)","actor":263},{"id":526,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/42","diff_url":"https://github.com/twmr/pytest-sphinx/pull/42.diff","created_date":"2022-09-03","accepted_date":"2022-09-04","title":"ci,build: Add flake8, black, isort (and wire into CI)","actor":263},{"id":527,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/43","diff_url":"https://github.com/twmr/pytest-sphinx/pull/43.diff","created_date":"2022-09-04","accepted_date":"2022-09-05","title":"build(deps): Fix typo in package name","actor":263},{"id":528,"component_name":"Patch","qa_url":"https://github.com/sphinx-doc/sphinx/pull/10802","diff_url":"https://github.com/sphinx-doc/sphinx/pull/10802.diff","created_date":"2022-09-05","accepted_date":"2022-09-09","title":"Correct `is_allowed_version()`'s example tests","actor":67},{"id":529,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/45","diff_url":"https://github.com/twmr/pytest-sphinx/pull/45.diff","created_date":"2022-09-05","accepted_date":"2022-09-05","title":"`src/` layout structure","actor":263},{"id":530,"component_name":"Patch","qa_url":"https://github.com/xnimorz/use-debounce/pull/141","diff_url":"https://github.com/xnimorz/use-debounce/pull/141.diff","created_date":"2022-09-06","accepted_date":"2022-09-11","title":"docs(README): Fix `useCallback`s","actor":226},{"id":531,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/47","diff_url":"https://github.com/twmr/pytest-sphinx/pull/47.diff","created_date":"2022-09-07","accepted_date":null,"title":"Flake8 plugins: comprehensions and bugbear","actor":263},{"id":532,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/49","diff_url":"https://github.com/twmr/pytest-sphinx/pull/49.diff","created_date":"2022-09-07","accepted_date":"2022-09-07","title":"Add `mypy`","actor":263},{"id":533,"component_name":"Patch","qa_url":"https://github.com/twmr/pytest-sphinx/pull/50","diff_url":"https://github.com/twmr/pytest-sphinx/pull/50.diff","created_date":"2022-09-08","accepted_date":"2022-09-08","title":"mypy: Add `--strict` typings","actor":263},{"id":534,"component_name":"Patch","qa_url":"https://github.com/etianen/django-reversion/pull/921","diff_url":"https://github.com/etianen/django-reversion/pull/921.diff","created_date":"2022-09-21","accepted_date":"2022-10-02","title":"`_safe_revert`: Add a `logging` statement for `IntegrityError`","actor":271},{"id":535,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest/pull/10313","diff_url":"https://github.com/pytest-dev/pytest/pull/10313.diff","created_date":"2022-09-24","accepted_date":"2022-10-07","title":"Export `pytest.DoctestItem` for typing / runtime purposes","actor":260},{"id":536,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest/pull/10384","diff_url":"https://github.com/pytest-dev/pytest/pull/10384.diff","created_date":"2022-10-14","accepted_date":"2022-10-15","title":"🔧 `--no-showlocals` to negate `addopts` w/ `--showlocals`","actor":260},{"id":537,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/137","diff_url":"https://github.com/jazzband/django-robots/pull/137.diff","created_date":"2022-10-15","accepted_date":null,"title":"refactor!: poetry, github action overhaul, pyenv / asdf versions","actor":141},{"id":538,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/138","diff_url":"https://github.com/jazzband/django-robots/pull/138.diff","created_date":"2022-10-15","accepted_date":"2022-10-15","title":"build: Remove django south migrations","actor":141},{"id":539,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/140","diff_url":"https://github.com/jazzband/django-robots/pull/140.diff","created_date":"2022-10-15","accepted_date":null,"title":"refactor!(settings): Simplify settings structure for pytest","actor":141},{"id":540,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/141","diff_url":"https://github.com/jazzband/django-robots/pull/141.diff","created_date":"2022-10-15","accepted_date":"2022-10-15","title":"6.x onramp","actor":141},{"id":541,"component_name":"Patch","qa_url":"https://github.com/mobxjs/mobx/pull/3542","diff_url":"https://github.com/mobxjs/mobx/pull/3542.diff","created_date":"2022-10-16","accepted_date":"2022-10-16","title":"docs(collection-utilities): Add missing import","actor":272},{"id":542,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/378","diff_url":"https://github.com/kislyuk/argcomplete/pull/378.diff","created_date":"2022-10-17","accepted_date":"2023-02-13","title":"mypy: Basic typings","actor":273},{"id":543,"component_name":"Patch","qa_url":"https://github.com/jaredLunde/react-hook/pull/238","diff_url":"https://github.com/jaredLunde/react-hook/pull/238.diff","created_date":"2022-10-17","accepted_date":"2022-10-18","title":"chore(hover): Fix typo","actor":274},{"id":544,"component_name":"Patch","qa_url":"https://github.com/DSpace/dspace-angular/pull/1909","diff_url":"https://github.com/DSpace/dspace-angular/pull/1909.diff","created_date":"2022-10-17","accepted_date":"2022-10-18","title":"chore(README): fix typo","actor":275},{"id":545,"component_name":"Patch","qa_url":"https://github.com/openshift/jenkins-openshift-login-plugin/pull/137","diff_url":"https://github.com/openshift/jenkins-openshift-login-plugin/pull/137.diff","created_date":"2022-10-17","accepted_date":"2022-10-18","title":"chore(README): fix typo","actor":276},{"id":546,"component_name":"Patch","qa_url":"https://github.com/jazzband/help/pull/312","diff_url":"https://github.com/jazzband/help/pull/312.diff","created_date":"2022-10-18","accepted_date":"2022-11-28","title":"docs(README): Update URL","actor":277},{"id":547,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/379","diff_url":"https://github.com/kislyuk/argcomplete/pull/379.diff","created_date":"2022-10-22","accepted_date":"2022-10-23","title":"Tests: Disable bracketed paste by default","actor":273},{"id":548,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/380","diff_url":"https://github.com/kislyuk/argcomplete/pull/380.diff","created_date":"2022-10-22","accepted_date":"2022-10-22","title":"`.gitignore` for contributors","actor":273},{"id":549,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/381","diff_url":"https://github.com/kislyuk/argcomplete/pull/381.diff","created_date":"2022-10-22","accepted_date":"2022-10-22","title":"chore: flake8, black updates for contributors","actor":273},{"id":550,"component_name":"Patch","qa_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/39","diff_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations/pull/39.diff","created_date":"2022-10-30","accepted_date":null,"title":"fix(django 4.1): Restrict sql_create_sequence to < django 4.1","actor":235},{"id":551,"component_name":"Patch","qa_url":"https://github.com/MichaelAquilina/zsh-autoswitch-virtualenv/pull/186","diff_url":"https://github.com/MichaelAquilina/zsh-autoswitch-virtualenv/pull/186.diff","created_date":"2022-11-02","accepted_date":null,"title":"Initiate migration of license GPLv3 -> MIT","actor":278},{"id":552,"component_name":"Patch","qa_url":"https://github.com/etianen/django-reversion/pull/927","diff_url":"https://github.com/etianen/django-reversion/pull/927.diff","created_date":"2022-11-10","accepted_date":"2022-11-12","title":"fix(_safe_revert): Missing f-string","actor":271},{"id":553,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/386","diff_url":"https://github.com/kislyuk/argcomplete/pull/386.diff","created_date":"2022-11-13","accepted_date":null,"title":"ci(actions): Bump actions to mute warnings","actor":273},{"id":554,"component_name":"Patch","qa_url":"https://github.com/getsentry/responses/pull/605","diff_url":"https://github.com/getsentry/responses/pull/605.diff","created_date":"2022-11-13","accepted_date":"2022-11-14","title":"ci(actions): Bump actions to resolve CI warnings","actor":267},{"id":555,"component_name":"Patch","qa_url":"https://github.com/mmarkelov/react-nouislider/pull/53","diff_url":"https://github.com/mmarkelov/react-nouislider/pull/53.diff","created_date":"2022-11-20","accepted_date":null,"title":"docs(README): Fix path to nouislider CSS","actor":279},{"id":556,"component_name":"Patch","qa_url":"https://github.com/lit/lit/pull/3476","diff_url":"https://github.com/lit/lit/pull/3476.diff","created_date":"2022-11-26","accepted_date":"2022-11-30","title":"docs: Use backticks to escape tags","actor":280},{"id":557,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/397","diff_url":"https://github.com/kislyuk/argcomplete/pull/397.diff","created_date":"2022-12-25","accepted_date":null,"title":"mypy: Full annotations","actor":273},{"id":558,"component_name":"Patch","qa_url":"https://github.com/kislyuk/argcomplete/pull/401","diff_url":"https://github.com/kislyuk/argcomplete/pull/401.diff","created_date":"2023-02-18","accepted_date":"2023-03-05","title":"mypy: Strict annotations / typings","actor":273},{"id":559,"component_name":"Patch","qa_url":"https://github.com/oscartbeaumont/vite-plugin-relay/pull/474","diff_url":"https://github.com/oscartbeaumont/vite-plugin-relay/pull/474.diff","created_date":"2023-03-19","accepted_date":"2023-03-19","title":"chore(README): Typo fix","actor":281},{"id":560,"component_name":"Patch","qa_url":"https://github.com/mobxjs/mobx/pull/3667","diff_url":"https://github.com/mobxjs/mobx/pull/3667.diff","created_date":"2023-03-26","accepted_date":"2023-03-26","title":"fix(mobx-react-lite): Add missing dependency","actor":272},{"id":561,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/13798","diff_url":"https://github.com/ckeditor/ckeditor5/pull/13798.diff","created_date":"2023-03-30","accepted_date":"2023-04-12","title":"docs (engine): Small typo","actor":215},{"id":562,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/ptpython/pull/550","diff_url":"https://github.com/prompt-toolkit/ptpython/pull/550.diff","created_date":"2023-09-04","accepted_date":null,"title":"[RFC] `run_config()`: skip interrupt if `config_file` not found","actor":282},{"id":563,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/ptpython/pull/551","diff_url":"https://github.com/prompt-toolkit/ptpython/pull/551.diff","created_date":"2023-09-04","accepted_date":"2023-11-03","title":"[RFC] `run_config()`: skip interrupt unless explicitly passed `config_file`","actor":282},{"id":564,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/1747","diff_url":"https://github.com/typeddjango/django-stubs/pull/1747.diff","created_date":"2023-10-01","accepted_date":"2023-10-01","title":"docs(README): Fix link to django_stubs_ext","actor":268},{"id":565,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/1748","diff_url":"https://github.com/typeddjango/django-stubs/pull/1748.diff","created_date":"2023-10-01","accepted_date":"2023-10-01","title":"docs(contributing): Fix link to django_stubs_ext","actor":268},{"id":566,"component_name":"Patch","qa_url":"https://github.com/terraform-aws-modules/terraform-aws-cloudfront/pull/119","diff_url":"https://github.com/terraform-aws-modules/terraform-aws-cloudfront/pull/119.diff","created_date":"2023-10-09","accepted_date":"2023-10-11","title":"docs: Update path param `aws_cloudfront_function` in example","actor":283},{"id":567,"component_name":"Patch","qa_url":"https://github.com/DataDog/dd-trace-py/pull/7228","diff_url":"https://github.com/DataDog/dd-trace-py/pull/7228.diff","created_date":"2023-10-11","accepted_date":"2023-10-16","title":"chore: update pypi changelog link","actor":284},{"id":568,"component_name":"Patch","qa_url":"https://github.com/fellowapp/graphql-core-promise/pull/2","diff_url":"https://github.com/fellowapp/graphql-core-promise/pull/2.diff","created_date":"2023-10-22","accepted_date":null,"title":"ci: Add basic `py.test` run across python versions","actor":285},{"id":569,"component_name":"Patch","qa_url":"https://github.com/phenixdigital/phoenix_storybook/pull/386","diff_url":"https://github.com/phenixdigital/phoenix_storybook/pull/386.diff","created_date":"2023-11-10","accepted_date":"2023-11-11","title":"Docs: Add guides/testing.md","actor":286},{"id":570,"component_name":"Patch","qa_url":"https://github.com/jazzband/django-robots/pull/149","diff_url":"https://github.com/jazzband/django-robots/pull/149.diff","created_date":"2023-12-09","accepted_date":"2023-12-09","title":"Format migration with black","actor":141},{"id":571,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/ptpython/pull/565","diff_url":"https://github.com/prompt-toolkit/ptpython/pull/565.diff","created_date":"2023-12-17","accepted_date":"2024-02-06","title":"docs(README): Fix PyPI and CI buttons","actor":282},{"id":572,"component_name":"Patch","qa_url":"https://github.com/prompt-toolkit/ptpython/pull/567","diff_url":"https://github.com/prompt-toolkit/ptpython/pull/567.diff","created_date":"2023-12-17","accepted_date":"2024-02-06","title":"Package: Add PyPI Links to repo, issues, and changelog","actor":282},{"id":573,"component_name":"Patch","qa_url":"https://github.com/fannheyward/coc-biome/pull/12","diff_url":"https://github.com/fannheyward/coc-biome/pull/12.diff","created_date":"2023-12-31","accepted_date":"2024-01-02","title":"Fallback to `os.tmpdir()` if no `TMPDIR` set","actor":287},{"id":574,"component_name":"Patch","qa_url":"https://github.com/mansenfranzen/autodoc_pydantic/pull/200","diff_url":"https://github.com/mansenfranzen/autodoc_pydantic/pull/200.diff","created_date":"2024-02-08","accepted_date":"2024-03-12","title":"chore(examples): Typo","actor":288},{"id":575,"component_name":"Patch","qa_url":"https://github.com/ansible/ansible-navigator/pull/1687","diff_url":"https://github.com/ansible/ansible-navigator/pull/1687.diff","created_date":"2024-02-13","accepted_date":"2024-03-26","title":"Test suite: Support for libtmux 0.30.1+","actor":289},{"id":576,"component_name":"Patch","qa_url":"https://github.com/alexxcons/alexxcons.github.io/pull/7","diff_url":"https://github.com/alexxcons/alexxcons.github.io/pull/7.diff","created_date":"2024-02-19","accepted_date":"2024-02-20","title":"Typo fix","actor":290},{"id":577,"component_name":"Patch","qa_url":"https://github.com/tailwindlabs/headlessui/pull/3021","diff_url":"https://github.com/tailwindlabs/headlessui/pull/3021.diff","created_date":"2024-03-02","accepted_date":"2024-03-12","title":"chore / bikeshed: Remove `.tsbuildinfo`","actor":291},{"id":578,"component_name":"Patch","qa_url":"https://github.com/biomejs/biome/pull/1957","diff_url":"https://github.com/biomejs/biome/pull/1957.diff","created_date":"2024-03-03","accepted_date":"2024-03-03","title":"docs: Fix indentation on code example","actor":292},{"id":579,"component_name":"Patch","qa_url":"https://github.com/python/typeshed/pull/11550","diff_url":"https://github.com/python/typeshed/pull/11550.diff","created_date":"2024-03-09","accepted_date":"2024-03-09","title":"`docutils`: Use `ClassVar` for `Directive` class variables","actor":293},{"id":580,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/16015","diff_url":"https://github.com/ckeditor/ckeditor5/pull/16015.diff","created_date":"2024-03-12","accepted_date":"2024-03-21","title":"Fix (image): Fix typo in imagecaption css variable (highligted -> highlighted)","actor":215},{"id":581,"component_name":"Patch","qa_url":"https://github.com/NixOS/nixpkgs/pull/305791","diff_url":"https://github.com/NixOS/nixpkgs/pull/305791.diff","created_date":"2024-04-21","accepted_date":"2024-04-24","title":"tmuxp: Remove kaptan and click dependency (unused)","actor":294},{"id":582,"component_name":"Patch","qa_url":"https://github.com/apple/corenet/pull/3","diff_url":"https://github.com/apple/corenet/pull/3.diff","created_date":"2024-04-24","accepted_date":"2024-04-30","title":"docs(CONTRIBUTING): Fix spelling","actor":295},{"id":583,"component_name":"Patch","qa_url":"https://github.com/apple/corenet/pull/4","diff_url":"https://github.com/apple/corenet/pull/4.diff","created_date":"2024-04-24","accepted_date":"2024-05-03","title":"chore(corenet): Fix typos","actor":295},{"id":584,"component_name":"Patch","qa_url":"https://github.com/apple/corenet/pull/5","diff_url":"https://github.com/apple/corenet/pull/5.diff","created_date":"2024-04-24","accepted_date":"2024-05-01","title":"chore(mlx_examples): Fix typos","actor":295},{"id":585,"component_name":"Patch","qa_url":"https://github.com/apple/axlearn/pull/420","diff_url":"https://github.com/apple/axlearn/pull/420.diff","created_date":"2024-04-24","accepted_date":"2024-05-29","title":"chore(axlearn): Fix typos","actor":296},{"id":586,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/2121","diff_url":"https://github.com/typeddjango/django-stubs/pull/2121.diff","created_date":"2024-05-03","accepted_date":"2024-05-03","title":"`BaseBackend.get_user`: Relax `user_id` param type","actor":268},{"id":587,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/2141","diff_url":"https://github.com/typeddjango/django-stubs/pull/2141.diff","created_date":"2024-05-09","accepted_date":"2024-05-09","title":"Relax typing of `backend` in `django.contrib.auth` (`ModelBackend` -> `BaseBackend`)","actor":268},{"id":588,"component_name":"Patch","qa_url":"https://github.com/frontarm/navi-website/pull/52","diff_url":"https://github.com/frontarm/navi-website/pull/52.diff","created_date":"2024-05-11","accepted_date":null,"title":"chore(authenticated-routes): Fix typo","actor":180},{"id":589,"component_name":"Patch","qa_url":"https://github.com/PacificGilly/poetry_to_uv/pull/1","diff_url":"https://github.com/PacificGilly/poetry_to_uv/pull/1.diff","created_date":"2024-05-16","accepted_date":"2024-05-22","title":"Handle pyproject.toml with no `source`","actor":297},{"id":590,"component_name":"Patch","qa_url":"https://github.com/PacificGilly/poetry_to_uv/pull/2","diff_url":"https://github.com/PacificGilly/poetry_to_uv/pull/2.diff","created_date":"2024-05-16","accepted_date":null,"title":"Improve handling with VCS dependencies","actor":297},{"id":591,"component_name":"Patch","qa_url":"https://github.com/typeddjango/django-stubs/pull/2180","diff_url":"https://github.com/typeddjango/django-stubs/pull/2180.diff","created_date":"2024-05-24","accepted_date":"2024-05-25","title":"`AbstractBaseSession`: Use model fields for subclassed cases","actor":268},{"id":592,"component_name":"Patch","qa_url":"https://github.com/clokep/celery-batches/pull/89","diff_url":"https://github.com/clokep/celery-batches/pull/89.diff","created_date":"2024-06-01","accepted_date":null,"title":"Remove upper constraint for `celery`","actor":241},{"id":593,"component_name":"Patch","qa_url":"https://github.com/django-ordered-model/django-ordered-model/pull/326","diff_url":"https://github.com/django-ordered-model/django-ordered-model/pull/326.diff","created_date":"2024-07-12","accepted_date":"2024-07-15","title":"chore(OrderedInlineModelAdminMixin): Fix typo in docstring","actor":298},{"id":594,"component_name":"Patch","qa_url":"https://github.com/remirror/remirror/pull/2297","diff_url":"https://github.com/remirror/remirror/pull/2297.diff","created_date":"2024-10-19","accepted_date":null,"title":"chore(storybook-react[persistent-selection]) Fix wording","actor":299},{"id":595,"component_name":"Patch","qa_url":"https://github.com/aafigure/aafigure/pull/7","diff_url":"https://github.com/aafigure/aafigure/pull/7.diff","created_date":"2024-10-26","accepted_date":null,"title":"chore(aafigure) Fix `SyntaxWarning` via literal string (fixes #6)","actor":300},{"id":596,"component_name":"Patch","qa_url":"https://github.com/open-feature/openfeature.dev/pull/811","diff_url":"https://github.com/open-feature/openfeature.dev/pull/811.diff","created_date":"2024-11-16","accepted_date":"2024-11-18","title":"chore(catering-to-the-client-side) Typo corrections","actor":301},{"id":597,"component_name":"Patch","qa_url":"https://github.com/Lodin/react-vtree/pull/101","diff_url":"https://github.com/Lodin/react-vtree/pull/101.diff","created_date":"2025-02-09","accepted_date":null,"title":"chore(README) Fix phrasing","actor":302},{"id":598,"component_name":"Patch","qa_url":"https://github.com/pytest-dev/pytest/pull/13267","diff_url":"https://github.com/pytest-dev/pytest/pull/13267.diff","created_date":"2025-03-02","accepted_date":"2025-03-02","title":"chore(changelog) Minor typo fix","actor":260},{"id":599,"component_name":"Patch","qa_url":"https://github.com/vitejs/vite-plugin-react/pull/463","diff_url":"https://github.com/vitejs/vite-plugin-react/pull/463.diff","created_date":"2025-04-19","accepted_date":"2025-04-19","title":"chore: fix link in changelog","actor":303},{"id":600,"component_name":"Patch","qa_url":"https://github.com/awslabs/cli-agent-orchestrator/pull/31","diff_url":"https://github.com/awslabs/cli-agent-orchestrator/pull/31.diff","created_date":"2025-12-07","accepted_date":"2025-12-19","title":"libtmux: Bump to v0.51.0, update method name","actor":304},{"id":601,"component_name":"Patch","qa_url":"https://github.com/SDGLBL/mcp-claude-code/pull/28","diff_url":"https://github.com/SDGLBL/mcp-claude-code/pull/28.diff","created_date":"2025-12-07","accepted_date":null,"title":"Bump libtmux to v0.51.0, update method names","actor":305},{"id":602,"component_name":"Patch","qa_url":"https://github.com/OpenHands/OpenHands/pull/11937","diff_url":"https://github.com/OpenHands/OpenHands/pull/11937.diff","created_date":"2025-12-07","accepted_date":null,"title":"libtmux: Bump v0.46.2 -> v0.51.0, update methods / properties","actor":306},{"id":603,"component_name":"Patch","qa_url":"https://github.com/withastro/astro/pull/15015","diff_url":"https://github.com/withastro/astro/pull/15015.diff","created_date":"2025-12-13","accepted_date":"2026-01-28","title":"Add `devToolbar.placement` configuration option","actor":307},{"id":604,"component_name":"Patch","qa_url":"https://github.com/OpenHands/software-agent-sdk/pull/1561","diff_url":"https://github.com/OpenHands/software-agent-sdk/pull/1561.diff","created_date":"2025-12-31","accepted_date":"2026-01-01","title":"build(deps): Bump libtmux to >=0.53.0 for v0.51.0 hard deprecations","actor":308},{"id":605,"component_name":"Patch","qa_url":"https://github.com/ckeditor/ckeditor5/pull/19733","diff_url":"https://github.com/ckeditor/ckeditor5/pull/19733.diff","created_date":"2026-02-03","accepted_date":null,"title":"chore(CHANGES) Fix typo in year","actor":215}]

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = [{"id":0,"type":"Open Source","name":"django-boilerplate","url":null,"repo_url":"https://github.com/gpennington/django-boilerplate","languages":["Python"]},{"id":1,"type":"Open Source","name":"Tail-Bundle","url":"http://www.vim.org/scripts/script.php?script_id=1714","repo_url":"https://github.com/vim-scripts/Tail-Bundle","languages":["Vim Script"]},{"id":2,"type":"Open Source","name":"kohana-modules","url":"http://kohana-modules.com/pages/add-a-module","repo_url":"https://github.com/ahutchings/kohana-modules"},{"id":3,"type":"Open Source","name":"cjklib","url":null,"repo_url":"https://github.com/cburgmer/cjklib","languages":["Python"]},{"id":4,"type":"Open Source","name":"readthedocs.org","url":"https://readthedocs.org/","repo_url":"https://github.com/readthedocs/readthedocs.org","languages":["Python"]},{"id":5,"type":"Open Source","name":"aura","url":"","repo_url":"https://github.com/aurajs/aura","languages":["JavaScript"]},{"id":6,"type":"Open Source","name":"backbone.marionette","url":"https://marionettejs.com","repo_url":"https://github.com/marionettejs/backbone.marionette","languages":["JavaScript"]},{"id":7,"type":"Open Source","name":"dwm.vim","url":"http://www.vim.org/scripts/script.php?script_id=4186","repo_url":"https://github.com/spolu/dwm.vim","languages":["Vim Script"]},{"id":8,"type":"Open Source","name":"backbone.marionette.async","url":null,"repo_url":"https://github.com/mxriverlynn/backbone.marionette.async","languages":["JavaScript"]},{"id":9,"type":"Open Source","name":"django-dynamicresponse","url":"http://pypi.python.org/pypi/django-dynamicresponse","repo_url":"https://github.com/funkbit/django-dynamicresponse","languages":["Python"]},{"id":10,"type":"Open Source","name":"backbone-deep-model","url":"","repo_url":"https://github.com/powmedia/backbone-deep-model","languages":["JavaScript"]},{"id":11,"type":"Open Source","name":"flask-rst","url":"","repo_url":"https://github.com/jarus/flask-rst","languages":["Python"]},{"id":12,"type":"Open Source","name":"tmuxed","url":"","repo_url":"https://github.com/zaiste/tmuxed","languages":["Python"]},{"id":13,"type":"Open Source","name":"flask","url":"https://flask.palletsprojects.com","repo_url":"https://github.com/pallets/flask","languages":["Python"]},{"id":14,"type":"Open Source","name":"bootstrap","url":"https://getbootstrap.com","repo_url":"https://github.com/twbs/bootstrap","languages":["MDX"]},{"id":15,"type":"Open Source","name":"aura-express","url":null,"repo_url":"https://github.com/sbellity/aura-express","languages":["JavaScript"]},{"id":16,"type":"Open Source","name":"grunt-recess","url":"","repo_url":"https://github.com/sindresorhus/grunt-recess","languages":["JavaScript"]},{"id":17,"type":"Open Source","name":"grunt-mocha","url":"","repo_url":"https://github.com/kmiyashiro/grunt-mocha","languages":["JavaScript"]},{"id":18,"type":"Open Source","name":"underscoreDeepExtend","url":" https://gist.github.com/1868955","repo_url":"https://github.com/xioup/underscoreDeepExtend","languages":["JavaScript"]},{"id":19,"type":"Open Source","name":"aura-express-example","url":null,"repo_url":"https://github.com/sbellity/aura-express-example","languages":["JavaScript"]},{"id":20,"type":"Open Source","name":"salt","url":"https://docs.saltproject.io/salt/install-guide/en/latest/","repo_url":"https://github.com/saltstack/salt","languages":["Python"]},{"id":21,"type":"Open Source","name":"salt-vim","url":"","repo_url":"https://github.com/vmware-archive/salt-vim","languages":["Vim Script"]},{"id":22,"type":"Open Source","name":"grunt-cdn","url":null,"repo_url":"https://github.com/tactivos/grunt-cdn","languages":["JavaScript"]},{"id":23,"type":"Open Source","name":"jquery-powertip","url":"https://stevenbenner.github.io/jquery-powertip/","repo_url":"https://github.com/stevenbenner/jquery-powertip","languages":["JavaScript"]},{"id":24,"type":"Open Source","name":"grunt-contrib-livereload","url":"http://gruntjs.com/","repo_url":"https://github.com/gruntjs/grunt-contrib-livereload","languages":["JavaScript"]},{"id":25,"type":"Open Source","name":"backbone.iobind","url":"https://noveogroup.github.io/backbone.iobind/","repo_url":"https://github.com/noveogroup/backbone.iobind","languages":["JavaScript"]},{"id":26,"type":"Open Source","name":"watchdog","url":"http://packages.python.org/watchdog/","repo_url":"https://github.com/gorakhargosh/watchdog","languages":["Python"]},{"id":27,"type":"Open Source","name":"teamocil","url":"","repo_url":"https://github.com/remi/teamocil","languages":["Ruby"]},{"id":28,"type":"Open Source","name":"tmuxinator","url":"","repo_url":"https://github.com/tmuxinator/tmuxinator","languages":["Ruby"]},{"id":29,"type":"Open Source","name":"argh","url":"http://argh.rtfd.org","repo_url":"https://github.com/neithere/argh","languages":["Python"]},{"id":30,"type":"Open Source","name":"sphinx_rtd_theme","url":"https://sphinx-rtd-theme.readthedocs.io/","repo_url":"https://github.com/readthedocs/sphinx_rtd_theme","languages":["Sass"]},{"id":31,"type":"Open Source","name":"sphinx-argparse","url":null,"repo_url":"https://github.com/alex-rudakov/sphinx-argparse","languages":["Python"]},{"id":32,"type":"Open Source","name":"werkzeug","url":"https://werkzeug.palletsprojects.com","repo_url":"https://github.com/pallets/werkzeug","languages":["Python"]},{"id":33,"type":"Open Source","name":"importd","url":"http://amitu.com/importd/","repo_url":"https://github.com/amitu/importd","languages":["Python"]},{"id":34,"type":"Open Source","name":"awesome-minimalist","url":"https://neiesc.github.io/awesome-minimalist/","repo_url":"https://github.com/neiesc/awesome-minimalist","languages":["Astro"]},{"id":35,"type":"Open Source","name":"djangopackages","url":"https://djangopackages.org","repo_url":"https://github.com/djangopackages/djangopackages","languages":["Python"]},{"id":36,"type":"Open Source","name":"python-anyvcs","url":null,"repo_url":"https://github.com/ScottDuckworth/python-anyvcs","languages":["Python"]},{"id":37,"type":"Open Source","name":"ocp-indent","url":"http://www.typerex.org/ocp-indent.html","repo_url":"https://github.com/OCamlPro/ocp-indent","languages":["Raku"]},{"id":38,"type":"Open Source","name":"datapackage","url":"https://datapackage.org","repo_url":"https://github.com/frictionlessdata/datapackage","languages":["MDX"]},{"id":39,"type":"Open Source","name":"unite.vim","url":"http://www.vim.org/scripts/script.php?script_id=3396","repo_url":"https://github.com/Shougo/unite.vim","languages":["Vim Script"]},{"id":40,"type":"Open Source","name":"cookiecutter-pypackage","url":"","repo_url":"https://github.com/audreyfeldroy/cookiecutter-pypackage","languages":["Python"]},{"id":41,"type":"Open Source","name":"sqlalchemy-orm-tree","url":"","repo_url":"https://github.com/monetizeio/sqlalchemy-orm-tree","languages":["Python"]},{"id":42,"type":"Open Source","name":"sqlalchemy","url":"https://www.sqlalchemy.org","repo_url":"https://github.com/zzzeek/sqlalchemy","languages":["Python"]},{"id":43,"type":"Open Source","name":"i3pystatus","url":"https://i3pystatus.readthedocs.io/","repo_url":"https://github.com/enkore/i3pystatus","languages":["Python"]},{"id":44,"type":"Open Source","name":".vim","url":"","repo_url":"https://github.com/klen/.vim","languages":["Vim Script"]},{"id":45,"type":"Open Source","name":"vim-jsbeautify","url":"","repo_url":"https://github.com/maksimr/vim-jsbeautify","languages":["Vim Script"]},{"id":46,"type":"Open Source","name":"backbone.modelbinding","url":"","repo_url":"https://github.com/mxriverlynn/backbone.modelbinding","languages":["JavaScript"]},{"id":47,"type":"Open Source","name":"flask-security-3.0","url":"","repo_url":"https://github.com/pallets-eco/flask-security-3.0","languages":["Python"]},{"id":48,"type":"Open Source","name":"forms","url":"","repo_url":"https://github.com/caolan/forms","languages":["JavaScript"]},{"id":49,"type":"Open Source","name":"riv.vim","url":"","repo_url":"https://github.com/gu-fan/riv.vim","languages":["Vim Script"]},{"id":50,"type":"Open Source","name":"djangobars","url":null,"repo_url":"https://github.com/mjumbewu/djangobars","languages":["Python"]},{"id":51,"type":"Open Source","name":"pybars3","url":"","repo_url":"https://github.com/wbond/pybars3","languages":["Python"]},{"id":52,"type":"Open Source","name":"facebook-python-business-sdk","url":"https://developers.facebook.com/docs/business-sdk","repo_url":"https://github.com/facebook/facebook-python-business-sdk","languages":["Python"]},{"id":53,"type":"Open Source","name":"django-guardian","url":"https://django-guardian.readthedocs.io/","repo_url":"https://github.com/django-guardian/django-guardian","languages":["Python"]},{"id":54,"type":"Open Source","name":"jquery-nstslider","url":null,"repo_url":"https://github.com/lokku/jquery-nstslider","languages":["JavaScript"]},{"id":55,"type":"Open Source","name":"rjsmin","url":"http://opensource.perlig.de/rjsmin/","repo_url":"https://github.com/ndparker/rjsmin","languages":["Python"]},{"id":56,"type":"Open Source","name":"django-assets","url":"","repo_url":"https://github.com/miracle2k/django-assets","languages":["Python"]},{"id":57,"type":"Open Source","name":"YouCompleteMe","url":"http://ycm-core.github.io/YouCompleteMe/","repo_url":"https://github.com/ycm-core/YouCompleteMe","languages":["Python"]},{"id":58,"type":"Open Source","name":"fabric","url":"http://fabfile.org","repo_url":"https://github.com/fabric/fabric","languages":["Python"]},{"id":59,"type":"Open Source","name":"django-user-accounts","url":"","repo_url":"https://github.com/pinax/django-user-accounts","languages":["Python"]},{"id":60,"type":"Open Source","name":"vim-snippets","url":"","repo_url":"https://github.com/honza/vim-snippets","languages":["Vim Snippet"]},{"id":61,"type":"Open Source","name":"stud","url":null,"repo_url":"https://github.com/guibog/stud","languages":["Python"]},{"id":62,"type":"Open Source","name":"django-markwhat","url":"http://pypi.python.org/pypi/django-markwhat","repo_url":"https://github.com/Alir3z4/django-markwhat","languages":["Python"]},{"id":63,"type":"Open Source","name":"mysql-formula","url":"http://docs.saltstack.com/en/latest/topics/development/conventions/formulas.html","repo_url":"https://github.com/saltstack-formulas/mysql-formula","languages":["SaltStack"]},{"id":64,"type":"Open Source","name":"python-guide","url":"https://docs.python-guide.org","repo_url":"https://github.com/realpython/python-guide","languages":["Batchfile"]},{"id":65,"type":"Open Source","name":"vim-multiple-cursors","url":null,"repo_url":"https://github.com/terryma/vim-multiple-cursors","languages":["Vim Script"]},{"id":66,"type":"Open Source","name":"awesome-awesomeness","url":"","repo_url":"https://github.com/bayandin/awesome-awesomeness","languages":["Ruby"]},{"id":67,"type":"Open Source","name":"sphinx","url":"https://www.sphinx-doc.org/","repo_url":"https://github.com/sphinx-doc/sphinx","languages":["Python"]},{"id":68,"type":"Open Source","name":"color_coded","url":"","repo_url":"https://github.com/jeaye/color_coded","languages":["C++"]},{"id":69,"type":"Open Source","name":"vim-vimlparser","url":"","repo_url":"https://github.com/vim-jp/vim-vimlparser","languages":["Vim Script"]},{"id":70,"type":"Open Source","name":"sniffer","url":"http://pypi.python.org/pypi/sniffer","repo_url":"https://github.com/jeffh/sniffer","languages":["Python"]},{"id":71,"type":"Open Source","name":"pyre2","url":"","repo_url":"https://github.com/facebook/pyre2","languages":["C++"]},{"id":72,"type":"Open Source","name":"docs","url":"https://gogs.io/docs","repo_url":"https://github.com/gogs/docs"},{"id":73,"type":"Open Source","name":"gogs","url":"https://gogs.io","repo_url":"https://github.com/gogs/gogs","languages":["Go"]},{"id":74,"type":"Open Source","name":"salt-bootstrap","url":"","repo_url":"https://github.com/saltstack/salt-bootstrap","languages":["Shell"]},{"id":75,"type":"Open Source","name":"salt-formula","url":"http://docs.saltstack.com/en/latest/topics/development/conventions/formulas.html","repo_url":"https://github.com/saltstack-formulas/salt-formula","languages":["SaltStack"]},{"id":76,"type":"Open Source","name":"uwsgi-formula","url":"http://docs.saltstack.com/en/latest/topics/development/conventions/formulas.html","repo_url":"https://github.com/saltstack-formulas/uwsgi-formula","languages":["SaltStack"]},{"id":77,"type":"Open Source","name":"coreclr","url":"https://docs.microsoft.com/dotnet/core/","repo_url":"https://github.com/dotnet/coreclr"},{"id":78,"type":"Open Source","name":"cookiecutter-flask","url":"","repo_url":"https://github.com/cookiecutter-flask/cookiecutter-flask","languages":["Python"]},{"id":79,"type":"Open Source","name":"cookiecutter","url":"https://pypi.org/project/cookiecutter/","repo_url":"https://github.com/cookiecutter/cookiecutter","languages":["Python"]},{"id":80,"type":"Open Source","name":"neocomplete.vim","url":"","repo_url":"https://github.com/Shougo/neocomplete.vim","languages":["Vim Script"]},{"id":81,"type":"Open Source","name":"django-allauth","url":"https://allauth.org","repo_url":"https://github.com/pennersr/django-allauth","languages":["Python"]},{"id":82,"type":"Open Source","name":"AlgoXY","url":"","repo_url":"https://github.com/liuxinyu95/AlgoXY","languages":["TeX"]},{"id":83,"type":"Open Source","name":"OpenAPI-Specification","url":"https://openapis.org","repo_url":"https://github.com/OAI/OpenAPI-Specification","languages":["Markdown"]},{"id":84,"type":"Open Source","name":"vim-pyenv","url":null,"repo_url":"https://github.com/lambdalisue/vim-pyenv","languages":["Vim Script"]},{"id":85,"type":"Open Source","name":"material-ui","url":"https://mui.com/material-ui/","repo_url":"https://github.com/mui/material-ui","languages":["JavaScript"]},{"id":86,"type":"Open Source","name":"fsm","url":null,"repo_url":"https://github.com/looplab/fsm","languages":["Go"]},{"id":87,"type":"Open Source","name":"kivy","url":"https://kivy.org","repo_url":"https://github.com/kivy/kivy","languages":["Python"]},{"id":88,"type":"Open Source","name":"garden.filebrowser","url":"","repo_url":"https://github.com/kivy-garden/garden.filebrowser","languages":["Python"]},{"id":89,"type":"Open Source","name":"python-for-android","url":"https://python-for-android.readthedocs.io","repo_url":"https://github.com/kivy/python-for-android","languages":["Python"]},{"id":90,"type":"Open Source","name":"awesome-flask","url":"","repo_url":"https://github.com/humiaozuzu/awesome-flask"},{"id":91,"type":"Open Source","name":"uMario_Jakowski","url":null,"repo_url":"https://github.com/jakowskidev/uMario_Jakowski","languages":["C++"]},{"id":92,"type":"Open Source","name":"rl","url":"https://pypi.org/project/rl/","repo_url":"https://github.com/stefanholek/rl","languages":["Python"]},{"id":93,"type":"Open Source","name":"aseprite","url":"https://www.aseprite.org","repo_url":"https://github.com/aseprite/aseprite","languages":["C++"]},{"id":94,"type":"Open Source","name":"wagtail","url":"https://wagtail.org","repo_url":"https://github.com/wagtail/wagtail","languages":["Python"]},{"id":95,"type":"Open Source","name":"tmux-mem-cpu-load","url":"","repo_url":"https://github.com/thewtex/tmux-mem-cpu-load","languages":["C++"]},{"id":96,"type":"Open Source","name":"oxygine-framework","url":"http://oxygine.org/","repo_url":"https://github.com/oxygine/oxygine-framework","languages":["C++"]},{"id":97,"type":"Open Source","name":"pymux","url":"","repo_url":"https://github.com/prompt-toolkit/pymux","languages":["Python"]},{"id":98,"type":"Open Source","name":"solarus","url":"http://www.solarus-games.org","repo_url":"https://github.com/solarus-games/solarus","languages":["C++"]},{"id":99,"type":"Open Source","name":"clang_complete","url":"http://www.vim.org/scripts/script.php?script_id=3302","repo_url":"https://github.com/xavierd/clang_complete","languages":["Python"]},{"id":100,"type":"Open Source","name":"pyston_v1","url":"https://github.com/pyston/pyston/","repo_url":"https://github.com/pyston/pyston_v1"},{"id":101,"type":"Open Source","name":"libpypa","url":"","repo_url":"https://github.com/vinzenz/libpypa","languages":["C++"]},{"id":102,"type":"Open Source","name":"cldoc","url":null,"repo_url":"https://github.com/jessevdk/cldoc","languages":["Python"]},{"id":103,"type":"Open Source","name":"binder-web-prototype","url":"","repo_url":"https://github.com/binder-project/binder-web-prototype","languages":["HTML"]},{"id":104,"type":"Open Source","name":"misspell-fixer","url":"https://github.com/vlajos/misspell-fixer","repo_url":"https://github.com/vlajos/misspell-fixer","languages":["sed"]},{"id":105,"type":"Open Source","name":"freebsd-src","url":"https://www.FreeBSD.org","repo_url":"https://github.com/freebsd/freebsd-src","languages":["C"]},{"id":106,"type":"Open Source","name":"django-extensions","url":"https://django-extensions.readthedocs.io","repo_url":"https://github.com/django-extensions/django-extensions","languages":["Python"]},{"id":107,"type":"Open Source","name":"deoplete-jedi","url":"","repo_url":"https://github.com/deoplete-plugins/deoplete-jedi","languages":["Python"]},{"id":108,"type":"Open Source","name":"viper","url":null,"repo_url":"https://github.com/spf13/viper","languages":["Go"]},{"id":109,"type":"Open Source","name":"libsass","url":"https://sass-lang.com/libsass","repo_url":"https://github.com/sass/libsass","languages":["C++"]},{"id":110,"type":"Open Source","name":"vcs","url":"","repo_url":"https://github.com/Masterminds/vcs","languages":["Go"]},{"id":111,"type":"Open Source","name":"libsass-python","url":"https://sass.github.io/libsass-python/","repo_url":"https://github.com/sass/libsass-python","languages":["Python"]},{"id":112,"type":"Open Source","name":"awesome-python","url":"https://awesome-python.com/","repo_url":"https://github.com/vinta/awesome-python","languages":["Python"]},{"id":113,"type":"Open Source","name":"guichan","url":"","repo_url":"https://github.com/wheybags/guichan","languages":["C++"]},{"id":114,"type":"Open Source","name":"case","url":null,"repo_url":"https://github.com/celery/case","languages":["Python"]},{"id":115,"type":"Open Source","name":"python-prompt-toolkit","url":"https://python-prompt-toolkit.readthedocs.io/","repo_url":"https://github.com/prompt-toolkit/python-prompt-toolkit","languages":["Python"]},{"id":116,"type":"Open Source","name":"pyvim","url":"","repo_url":"https://github.com/prompt-toolkit/pyvim","languages":["Python"]},{"id":117,"type":"Open Source","name":"tern_for_vim","url":null,"repo_url":"https://github.com/ternjs/tern_for_vim","languages":["Python"]},{"id":118,"type":"Open Source","name":"dulwich","url":"https://www.dulwich.io/","repo_url":"https://github.com/jelmer/dulwich","languages":["Python"]},{"id":119,"type":"Open Source","name":"kakoune","url":"http://kakoune.org","repo_url":"https://github.com/mawww/kakoune","languages":["C++"]},{"id":120,"type":"Open Source","name":"python-cmake-buildsystem","url":"","repo_url":"https://github.com/python-cmake-buildsystem/python-cmake-buildsystem","languages":["CMake"]},{"id":121,"type":"Open Source","name":"pys4ext","url":"","repo_url":"https://github.com/jcfr/pys4ext","languages":["Python"]},{"id":122,"type":"Open Source","name":"tmux","url":"","repo_url":"https://github.com/tmux/tmux","languages":["C"]},{"id":123,"type":"Open Source","name":"spdlog","url":"","repo_url":"https://github.com/gabime/spdlog","languages":["C++"]},{"id":124,"type":"Open Source","name":"nanogui","url":null,"repo_url":"https://github.com/wjakob/nanogui","languages":["C++"]},{"id":125,"type":"Open Source","name":"warehouse","url":"https://pypi.org","repo_url":"https://github.com/pypi/warehouse","languages":["Python"]},{"id":126,"type":"Open Source","name":"bootstrap-breadcrumbs","url":"django-bootstrap-breadcrumbs.readthedocs.org","repo_url":"https://github.com/prymitive/bootstrap-breadcrumbs","languages":["Python"]},{"id":127,"type":"Open Source","name":"django-mptt","url":"https://django-mptt.readthedocs.io/","repo_url":"https://github.com/django-mptt/django-mptt","languages":["Python"]},{"id":128,"type":"Open Source","name":"django-polymorphic","url":"https://django-polymorphic.rtfd.io","repo_url":"https://github.com/django-commons/django-polymorphic","languages":["Python"]},{"id":129,"type":"Open Source","name":"django-fixture-magic","url":"","repo_url":"https://github.com/davedash/django-fixture-magic","languages":["Python"]},{"id":130,"type":"Open Source","name":"markup","url":"","repo_url":"https://github.com/github/markup","languages":["Ruby"]},{"id":131,"type":"Open Source","name":"django-activeurl","url":"http://django-activeurl.readthedocs.io/en/latest/","repo_url":"https://github.com/hellysmile/django-activeurl","languages":["Python"]},{"id":132,"type":"Open Source","name":"scrollnav","url":"http://scrollnav.com","repo_url":"https://github.com/jimmynotjim/scrollnav","languages":["JavaScript"]},{"id":133,"type":"Open Source","name":"ScrollMagic","url":"http://ScrollMagic.io","repo_url":"https://github.com/janpaepke/ScrollMagic","languages":["TypeScript"]},{"id":134,"type":"Open Source","name":"sphinxcontrib-websupport","url":null,"repo_url":"https://github.com/sphinx-doc/sphinxcontrib-websupport","languages":["Python"]},{"id":135,"type":"Open Source","name":"heroku-repo","url":"","repo_url":"https://github.com/heroku/heroku-repo","languages":["TypeScript"]},{"id":136,"type":"Open Source","name":"django-filter","url":"https://django-filter.readthedocs.io/en/main/","repo_url":"https://github.com/carltongibson/django-filter","languages":["Python"]},{"id":137,"type":"Open Source","name":"social-share-kit","url":"http://socialsharekit.com","repo_url":"https://github.com/darklow/social-share-kit","languages":["CSS"]},{"id":138,"type":"Open Source","name":"haxor","url":null,"repo_url":"https://github.com/avinassh/haxor","languages":["Python"]},{"id":139,"type":"Open Source","name":"fabtools","url":"http://fabtools.readthedocs.org/","repo_url":"https://github.com/fabtools/fabtools","languages":["Python"]},{"id":140,"type":"Open Source","name":"pygments.rb","url":"","repo_url":"https://github.com/pygments/pygments.rb","languages":["Ruby"]},{"id":141,"type":"Open Source","name":"django-robots","url":"https://django-robots.readthedocs.io","repo_url":"https://github.com/jazzband/django-robots","languages":["Python"]},{"id":142,"type":"Open Source","name":"django-model-utils","url":"https://django-model-utils.readthedocs.io","repo_url":"https://github.com/jazzband/django-model-utils","languages":["Python"]},{"id":143,"type":"Open Source","name":"django-activity-stream","url":"http://django-activity-stream.rtfd.io/en/latest/","repo_url":"https://github.com/justquick/django-activity-stream","languages":["Python"]},{"id":144,"type":"Open Source","name":"zsh-completions","url":"","repo_url":"https://github.com/zsh-users/zsh-completions","languages":["Shell"]},{"id":145,"type":"Open Source","name":"pytest-django","url":"https://pytest-django.readthedocs.io/","repo_url":"https://github.com/pytest-dev/pytest-django","languages":["Python"]},{"id":146,"type":"Open Source","name":"website","url":"https://classic.yarnpkg.com","repo_url":"https://github.com/yarnpkg/website","languages":["JavaScript"]},{"id":147,"type":"Open Source","name":"react-select","url":"https://react-select.com/","repo_url":"https://github.com/JedWatson/react-select","languages":["TypeScript"]},{"id":148,"type":"Open Source","name":"indico-plugins","url":"","repo_url":"https://github.com/indico/indico-plugins","languages":["Python"]},{"id":149,"type":"Open Source","name":"releases","url":"http://releases.readthedocs.io/","repo_url":"https://github.com/bitprophet/releases","languages":["Python"]},{"id":150,"type":"Open Source","name":"alabaster","url":"http://alabaster.readthedocs.io/","repo_url":"https://github.com/sphinx-doc/alabaster","languages":["HTML"]},{"id":151,"type":"Open Source","name":"mongoengine","url":"https://mongoengine-odm.readthedocs.io","repo_url":"https://github.com/MongoEngine/mongoengine","languages":["Python"]},{"id":152,"type":"Open Source","name":"fonts","url":null,"repo_url":"https://github.com/powerline/fonts","languages":["Shell"]},{"id":153,"type":"Open Source","name":"flask-admin","url":"https://flask-admin.readthedocs.io","repo_url":"https://github.com/pallets-eco/flask-admin","languages":["Python"]},{"id":154,"type":"Open Source","name":"flask-profiler","url":"","repo_url":"https://github.com/muatik/flask-profiler","languages":["Python"]},{"id":155,"type":"Open Source","name":"black","url":"https://black.readthedocs.io/en/stable/","repo_url":"https://github.com/psf/black","languages":["Python"]},{"id":156,"type":"Open Source","name":"flask-mongoengine","url":"","repo_url":"https://github.com/MongoEngine/flask-mongoengine","languages":["Python"]},{"id":157,"type":"Open Source","name":"mongo-python-driver","url":"https://www.mongodb.com/docs/languages/python/pymongo-driver/current/","repo_url":"https://github.com/mongodb/mongo-python-driver","languages":["Python"]},{"id":158,"type":"Open Source","name":"djongo","url":"https://www.djongomapper.com","repo_url":"https://github.com/doableware/djongo","languages":["Python"]},{"id":159,"type":"Open Source","name":"graphene","url":"http://graphene-python.org/","repo_url":"https://github.com/graphql-python/graphene","languages":["Python"]},{"id":160,"type":"Open Source","name":"python-docx","url":null,"repo_url":"https://github.com/python-openxml/python-docx","languages":["Python"]},{"id":161,"type":"Open Source","name":"graphdoc","url":"https://2fd.github.io/graphdoc","repo_url":"https://github.com/2fd/graphdoc","languages":["TypeScript"]},{"id":162,"type":"Open Source","name":"sphinx-graphiql","url":"","repo_url":"https://github.com/hasura/sphinx-graphiql","languages":["JavaScript"]},{"id":163,"type":"Open Source","name":"minds-platform","url":"https://mindsdb.com","repo_url":"https://github.com/mindsdb/minds-platform","languages":["Python"]},{"id":164,"type":"Open Source","name":"django-webpack-loader","url":"","repo_url":"https://github.com/django-webpack/django-webpack-loader","languages":["Python"]},{"id":165,"type":"Open Source","name":"coc.nvim","url":"","repo_url":"https://github.com/neoclide/coc.nvim","languages":["TypeScript"]},{"id":166,"type":"Open Source","name":"pytest-splinter","url":"","repo_url":"https://github.com/pytest-dev/pytest-splinter","languages":["Python"]},{"id":167,"type":"Open Source","name":"djangorestframework-api-key","url":"https://florimondmanca.github.io/djangorestframework-api-key/","repo_url":"https://github.com/florimondmanca/djangorestframework-api-key","languages":["Python"]},{"id":168,"type":"Open Source","name":"curlify","url":null,"repo_url":"https://github.com/ofw/curlify","languages":["Python"]},{"id":169,"type":"Open Source","name":"django-celery","url":"http://celery.github.com/django-celery","repo_url":"https://github.com/celery/django-celery","languages":["Python"]},{"id":170,"type":"Open Source","name":"django-celery-monitor","url":"https://django-celery-monitor.readthedocs.io/","repo_url":"https://github.com/jazzband/django-celery-monitor","languages":["Python"]},{"id":171,"type":"Open Source","name":"webpack.js.org","url":"https://webpack.js.org","repo_url":"https://github.com/webpack/webpack.js.org","languages":["MDX"]},{"id":172,"type":"Open Source","name":"django-admin-actions","url":"","repo_url":"https://github.com/lukasvinclav/django-admin-actions","languages":["Python"]},{"id":173,"type":"Open Source","name":"react-hot-loader","url":"http://gaearon.github.io/react-hot-loader/","repo_url":"https://github.com/gaearon/react-hot-loader","languages":["JavaScript"]},{"id":174,"type":"Open Source","name":"videojs-record","url":"https://collab-project.github.io/videojs-record","repo_url":"https://github.com/collab-project/videojs-record","languages":["JavaScript"]},{"id":175,"type":"Open Source","name":"DefinitelyTyped","url":"","repo_url":"https://github.com/DefinitelyTyped/DefinitelyTyped","languages":["TypeScript"]},{"id":176,"type":"Open Source","name":"gqlgen-sqlboiler","url":"","repo_url":"https://github.com/web-ridge/gqlgen-sqlboiler","languages":["Go"]},{"id":177,"type":"Open Source","name":"checkout","url":"https://github.com/features/actions","repo_url":"https://github.com/actions/checkout","languages":["TypeScript"]},{"id":178,"type":"Open Source","name":"django","url":"https://www.djangoproject.com/","repo_url":"https://github.com/django/django","languages":["Python"]},{"id":179,"type":"Open Source","name":"DjangoChannelsGraphqlWs","url":null,"repo_url":"https://github.com/psevensas/DjangoChannelsGraphqlWs","languages":["Python"]},{"id":180,"type":"Open Source","name":"navi-website","url":"https://frontarm.com/navi/","repo_url":"https://github.com/frontarm/navi-website","languages":["MDX"]},{"id":181,"type":"Open Source","name":"django-classy-tags","url":"http://django-classy-tags.rtfd.org","repo_url":"https://github.com/django-cms/django-classy-tags","languages":["Python"]},{"id":182,"type":"Open Source","name":"navi","url":"https://frontarm.com/navi/","repo_url":"https://github.com/frontarm/navi","languages":["TypeScript"]},{"id":183,"type":"Open Source","name":"bumblebee-status","url":"https://bumblebee-status.readthedocs.io/en/main/","repo_url":"https://github.com/tobi-wan-kenobi/bumblebee-status","languages":["Python"]},{"id":184,"type":"Open Source","name":"changelog-v5","url":null,"repo_url":"https://github.com/webpack/changelog-v5"},{"id":185,"type":"Open Source","name":"chakra-ui","url":"https://chakra-ui.com","repo_url":"https://github.com/chakra-ui/chakra-ui","languages":["TypeScript"]},{"id":186,"type":"Open Source","name":"leagueoflegends","url":"https://snapcraft.io/leagueoflegends","repo_url":"https://github.com/mmtrt/leagueoflegends","languages":["Shell"]},{"id":187,"type":"Open Source","name":"pouchdb-replication-stream","url":"","repo_url":"https://github.com/pouchdb-community/pouchdb-replication-stream","languages":["JavaScript"]},{"id":188,"type":"Open Source","name":"contently-videojs-annotation-comments","url":"https://contently.github.io/videojs-annotation-comments/","repo_url":"https://github.com/trilogy-group/contently-videojs-annotation-comments","languages":["JavaScript"]},{"id":189,"type":"Open Source","name":"canvas-lms","url":"https://github.com/instructure/canvas-lms/wiki","repo_url":"https://github.com/instructure/canvas-lms","languages":["Ruby"]},{"id":190,"type":"Open Source","name":"qencode-api-python-client","url":"https://cloud.qencode.com","repo_url":"https://github.com/Qencode-Corp/qencode-api-python-client","languages":["Python"]},{"id":191,"type":"Open Source","name":"qencode-api-python3-client","url":null,"repo_url":"https://github.com/Qencode-Corp/qencode-api-python3-client","languages":["Python"]},{"id":192,"type":"Open Source","name":"powerlevel10k-media","url":null,"repo_url":"https://github.com/romkatv/powerlevel10k-media"},{"id":193,"type":"Open Source","name":"futurecoder","url":"https://futurecoder.io/","repo_url":"https://github.com/alexmojaki/futurecoder","languages":["Python"]},{"id":194,"type":"Open Source","name":"install-poetry-action","url":null,"repo_url":"https://github.com/dschep/install-poetry-action","languages":["TypeScript"]},{"id":195,"type":"Open Source","name":"mkapi","url":"https://daizutabi.github.io/mkapi/","repo_url":"https://github.com/daizutabi/mkapi","languages":["Python"]},{"id":196,"type":"Open Source","name":"social-app-django","url":"https://python-social-auth.readthedocs.io/","repo_url":"https://github.com/python-social-auth/social-app-django","languages":["Python"]},{"id":197,"type":"Open Source","name":"sentry-docs","url":"https://docs.sentry.io","repo_url":"https://github.com/getsentry/sentry-docs","languages":["MDX"]},{"id":198,"type":"Open Source","name":"django-statsd","url":"http://django-statsd.readthedocs.org/en/latest/index.html","repo_url":"https://github.com/django-statsd/django-statsd","languages":["Python"]},{"id":199,"type":"Open Source","name":"the-platform","url":"","repo_url":"https://github.com/jaredpalmer/the-platform","languages":["TypeScript"]},{"id":200,"type":"Open Source","name":"django-storages","url":"","repo_url":"https://github.com/jschneier/django-storages","languages":["Python"]},{"id":201,"type":"Open Source","name":"ScreenToGif","url":"http://www.screentogif.com","repo_url":"https://github.com/NickeManarin/ScreenToGif","languages":["C#"]},{"id":202,"type":"Open Source","name":"relay-hooks","url":"https://relay-tools.github.io/relay-hooks/docs/relay-hooks.html","repo_url":"https://github.com/relay-tools/relay-hooks","languages":["TypeScript"]},{"id":203,"type":"Open Source","name":"poetry","url":"https://python-poetry.org","repo_url":"https://github.com/python-poetry/poetry","languages":["Python"]},{"id":204,"type":"Open Source","name":"gatsby-plugin-node-fields","url":"","repo_url":"https://github.com/Undistraction/gatsby-plugin-node-fields","languages":["JavaScript"]},{"id":205,"type":"Open Source","name":"akita","url":"https://salesforce.github.io/akita/","repo_url":"https://github.com/salesforce/akita","languages":["TypeScript"]},{"id":206,"type":"Open Source","name":"ts-jest","url":"https://kulshekhar.github.io/ts-jest","repo_url":"https://github.com/kulshekhar/ts-jest","languages":["TypeScript"]},{"id":207,"type":"Open Source","name":"graphing-library-docs","url":"https://plotly.com/graphing-libraries","repo_url":"https://github.com/plotly/graphing-library-docs","languages":["Jupyter Notebook"]},{"id":208,"type":"Open Source","name":"hooks","url":"https://ahooks.js.org/","repo_url":"https://github.com/alibaba/hooks","languages":["TypeScript"]},{"id":209,"type":"Open Source","name":"nivo","url":"https://nivo.rocks","repo_url":"https://github.com/plouc/nivo","languages":["TypeScript"]},{"id":210,"type":"Open Source","name":"preact-www","url":"https://preactjs.com","repo_url":"https://github.com/preactjs/preact-www","languages":["JavaScript"]},{"id":211,"type":"Open Source","name":"django-inline-actions","url":"","repo_url":"https://github.com/escaped/django-inline-actions","languages":["Python"]},{"id":212,"type":"Open Source","name":"zrender","url":"https://ecomfe.github.io/zrender-doc/public/","repo_url":"https://github.com/ecomfe/zrender","languages":["TypeScript"]},{"id":213,"type":"Open Source","name":"graphql-markdown","url":"","repo_url":"https://github.com/exogen/graphql-markdown","languages":["JavaScript"]},{"id":214,"type":"Open Source","name":"factory_boy","url":"https://factoryboy.readthedocs.io/","repo_url":"https://github.com/FactoryBoy/factory_boy","languages":["Python"]},{"id":215,"type":"Open Source","name":"ckeditor5","url":"https://ckeditor.com","repo_url":"https://github.com/ckeditor/ckeditor5","languages":["Rich Text Format"]},{"id":216,"type":"Open Source","name":"angular-builders","url":"","repo_url":"https://github.com/just-jeb/angular-builders","languages":["TypeScript"]},{"id":217,"type":"Open Source","name":"django-prefetch","url":"https://pypi.python.org/pypi/django-prefetch","repo_url":"https://github.com/ionelmc/django-prefetch","languages":["Python"]},{"id":218,"type":"Open Source","name":"ts-debounce","url":null,"repo_url":"https://github.com/chodorowicz/ts-debounce","languages":["TypeScript"]},{"id":219,"type":"Open Source","name":"docusaurus","url":"https://docusaurus.io","repo_url":"https://github.com/facebook/docusaurus","languages":["TypeScript"]},{"id":220,"type":"Open Source","name":"web","url":"https://modern-web.dev","repo_url":"https://github.com/modernweb-dev/web","languages":["TypeScript"]},{"id":221,"type":"Open Source","name":"line_profiler","url":null,"repo_url":"https://github.com/pyutils/line_profiler","languages":["Python"]},{"id":222,"type":"Open Source","name":"plyr-react","url":"https://github.com/chintan9/plyr-react","repo_url":"https://github.com/chintan9/plyr-react","languages":["TypeScript"]},{"id":223,"type":"Open Source","name":"django_reverse_admin","url":null,"repo_url":"https://github.com/daniyalzade/django_reverse_admin","languages":["Python"]},{"id":224,"type":"Open Source","name":"react-scroll-into-view-if-needed","url":"https://codesandbox.io/s/3j4qjp7yp","repo_url":"https://github.com/icd2k3/react-scroll-into-view-if-needed","languages":["JavaScript"]},{"id":225,"type":"Open Source","name":"plyr","url":"https://plyr.io","repo_url":"https://github.com/sampotts/plyr","languages":["JavaScript"]},{"id":226,"type":"Open Source","name":"use-debounce","url":null,"repo_url":"https://github.com/xnimorz/use-debounce","languages":["TypeScript"]},{"id":227,"type":"Open Source","name":"gatsby-plugin-aws-elasticsearch","url":null,"repo_url":"https://github.com/Mrtenz/gatsby-plugin-aws-elasticsearch","languages":["TypeScript"]},{"id":228,"type":"Open Source","name":"gatsby","url":"https://www.gatsbyjs.com","repo_url":"https://github.com/gatsbyjs/gatsby","languages":["JavaScript"]},{"id":229,"type":"Open Source","name":"splinter","url":"http://splinter.readthedocs.org/en/stable/index.html","repo_url":"https://github.com/cobrateam/splinter","languages":["Python"]},{"id":230,"type":"Open Source","name":"ts-google-drive","url":null,"repo_url":"https://github.com/terence410/ts-google-drive","languages":["TypeScript"]},{"id":231,"type":"Open Source","name":"graphql-schema-typescript","url":null,"repo_url":"https://github.com/dangcuuson/graphql-schema-typescript","languages":["TypeScript"]},{"id":232,"type":"Open Source","name":"esbuild-plugin-relay","url":"","repo_url":"https://github.com/smartvokat/esbuild-plugin-relay","languages":["TypeScript"]},{"id":233,"type":"Open Source","name":"asdf-poetry","url":"https://github.com/asdf-vm/asdf","repo_url":"https://github.com/asdf-community/asdf-poetry","languages":["Shell"]},{"id":234,"type":"Open Source","name":"actions-common","url":null,"repo_url":"https://github.com/zaproxy/actions-common","languages":["TypeScript"]},{"id":235,"type":"Open Source","name":"django-pg-zero-downtime-migrations","url":null,"repo_url":"https://github.com/tbicr/django-pg-zero-downtime-migrations","languages":["Python"]},{"id":236,"type":"Open Source","name":"django-manager-utils","url":null,"repo_url":"https://github.com/ambitioninc/django-manager-utils","languages":["Python"]},{"id":237,"type":"Open Source","name":"redis-py","url":"","repo_url":"https://github.com/redis/redis-py","languages":["Python"]},{"id":238,"type":"Open Source","name":"uvicorn","url":"https://uvicorn.dev","repo_url":"https://github.com/Kludex/uvicorn","languages":["Python"]},{"id":239,"type":"Open Source","name":"poetry-core","url":"","repo_url":"https://github.com/python-poetry/poetry-core","languages":["Python"]},{"id":240,"type":"Open Source","name":"install.python-poetry.org","url":"https://install.python-poetry.org","repo_url":"https://github.com/python-poetry/install.python-poetry.org","languages":["Python"]},{"id":241,"type":"Open Source","name":"celery-batches","url":"https://celery-batches.readthedocs.io/","repo_url":"https://github.com/clokep/celery-batches","languages":["Python"]},{"id":242,"type":"Open Source","name":"rollup-plugin-styles","url":"https://anidetrix.github.io/rollup-plugin-styles","repo_url":"https://github.com/Anidetrix/rollup-plugin-styles","languages":["TypeScript"]},{"id":243,"type":"Open Source","name":"celery-singleton","url":"","repo_url":"https://github.com/steinitzu/celery-singleton","languages":["Python"]},{"id":244,"type":"Open Source","name":"scout_apm_python","url":"https://scoutapm.com","repo_url":"https://github.com/scoutapp/scout_apm_python","languages":["Python"]},{"id":245,"type":"Open Source","name":"sphinxext-opengraph","url":"https://sphinxext-opengraph.readthedocs.io","repo_url":"https://github.com/sphinx-doc/sphinxext-opengraph","languages":["Python"]},{"id":246,"type":"Open Source","name":"vim-jsx-improve","url":"","repo_url":"https://github.com/neoclide/vim-jsx-improve","languages":["Vim Script"]},{"id":247,"type":"Open Source","name":"graphql-code-generator","url":"https://the-guild.dev/graphql/codegen/","repo_url":"https://github.com/dotansimha/graphql-code-generator","languages":["TypeScript"]},{"id":248,"type":"Open Source","name":"pygments-csv-lexer","url":null,"repo_url":"https://github.com/fish2000/pygments-csv-lexer","languages":["Python"]},{"id":249,"type":"Open Source","name":"advisory-database","url":null,"repo_url":"https://github.com/github/advisory-database"},{"id":250,"type":"Open Source","name":"awesome-tuis","url":null,"repo_url":"https://github.com/rothgar/awesome-tuis"},{"id":251,"type":"Open Source","name":"pytest-pyppeteer","url":"","repo_url":"https://github.com/luizyao/pytest-pyppeteer","languages":["Python"]},{"id":252,"type":"Open Source","name":"stripe-python","url":"https://stripe.com","repo_url":"https://github.com/stripe/stripe-python","languages":["Python"]},{"id":253,"type":"Open Source","name":"moto","url":"http://docs.getmoto.org/en/latest/","repo_url":"https://github.com/getmoto/moto","languages":["Python"]},{"id":254,"type":"Open Source","name":"prettier","url":"https://prettier.io","repo_url":"https://github.com/prettier/prettier","languages":["JavaScript"]},{"id":255,"type":"Open Source","name":"mirrors-prettier","url":null,"repo_url":"https://github.com/pre-commit/mirrors-prettier"},{"id":256,"type":"Open Source","name":"typing","url":"https://typing.python.org/en/latest/","repo_url":"https://github.com/python/typing","languages":["Python"]},{"id":257,"type":"Open Source","name":"node-potrace","url":null,"repo_url":"https://github.com/gatsbyjs/node-potrace","languages":["JavaScript"]},{"id":258,"type":"Open Source","name":"zinit","url":"","repo_url":"https://github.com/zdharma-continuum/zinit","languages":["Shell"]},{"id":259,"type":"Open Source","name":"vim-autoformat","url":"","repo_url":"https://github.com/vim-autoformat/vim-autoformat","languages":["Vim Script"]},{"id":260,"type":"Open Source","name":"pytest","url":"https://pytest.org","repo_url":"https://github.com/pytest-dev/pytest","languages":["Python"]},{"id":261,"type":"Open Source","name":"pip","url":"https://pip.pypa.io/","repo_url":"https://github.com/pypa/pip","languages":["Python"]},{"id":262,"type":"Open Source","name":"tooltip","url":"http://react-component.github.io/tooltip/","repo_url":"https://github.com/react-component/tooltip","languages":["TypeScript"]},{"id":263,"type":"Open Source","name":"pytest-sphinx","url":"","repo_url":"https://github.com/twmr/pytest-sphinx","languages":["Python"]},{"id":264,"type":"Open Source","name":"faker","url":"https://faker.readthedocs.io","repo_url":"https://github.com/joke2k/faker","languages":["Python"]},{"id":265,"type":"Open Source","name":"freezegun","url":null,"repo_url":"https://github.com/spulec/freezegun","languages":["Python"]},{"id":266,"type":"Open Source","name":"selenium","url":"https://selenium.dev","repo_url":"https://github.com/SeleniumHQ/selenium","languages":["Java"]},{"id":267,"type":"Open Source","name":"responses","url":"","repo_url":"https://github.com/getsentry/responses","languages":["Python"]},{"id":268,"type":"Open Source","name":"django-stubs","url":"","repo_url":"https://github.com/typeddjango/django-stubs","languages":["Python"]},{"id":269,"type":"Open Source","name":"cyrtd","url":null,"repo_url":"https://github.com/iamishalkin/cyrtd","languages":["Python"]},{"id":270,"type":"Open Source","name":"sphinxcontrib-issuetracker","url":"","repo_url":"https://github.com/igor-raits/sphinxcontrib-issuetracker","languages":["Python"]},{"id":271,"type":"Open Source","name":"django-reversion","url":"https://django-reversion.readthedocs.io","repo_url":"https://github.com/etianen/django-reversion","languages":["Python"]},{"id":272,"type":"Open Source","name":"mobx","url":"http://mobx.js.org","repo_url":"https://github.com/mobxjs/mobx","languages":["TypeScript"]},{"id":273,"type":"Open Source","name":"argcomplete","url":"https://kislyuk.github.io/argcomplete/","repo_url":"https://github.com/kislyuk/argcomplete","languages":["Python"]},{"id":274,"type":"Open Source","name":"react-hook","url":"https://npmjs.com/org/react-hook","repo_url":"https://github.com/jaredLunde/react-hook","languages":["TypeScript"]},{"id":275,"type":"Open Source","name":"dspace-angular","url":"https://wiki.lyrasis.org/display/DSDOC9x/","repo_url":"https://github.com/DSpace/dspace-angular","languages":["TypeScript"]},{"id":276,"type":"Open Source","name":"jenkins-openshift-login-plugin","url":null,"repo_url":"https://github.com/openshift/jenkins-openshift-login-plugin","languages":["HTML"]},{"id":277,"type":"Open Source","name":"help","url":"https://jazzband.co/roadies","repo_url":"https://github.com/jazzband/help"},{"id":278,"type":"Open Source","name":"zsh-autoswitch-virtualenv","url":"","repo_url":"https://github.com/MichaelAquilina/zsh-autoswitch-virtualenv","languages":["Shell"]},{"id":279,"type":"Open Source","name":"react-nouislider","url":"https://mmarkelov.github.io/react-nouislider/","repo_url":"https://github.com/mmarkelov/react-nouislider","languages":["JavaScript"]},{"id":280,"type":"Open Source","name":"lit","url":"https://lit.dev","repo_url":"https://github.com/lit/lit","languages":["TypeScript"]},{"id":281,"type":"Open Source","name":"vite-plugin-relay","url":"","repo_url":"https://github.com/oscartbeaumont/vite-plugin-relay","languages":["TypeScript"]},{"id":282,"type":"Open Source","name":"ptpython","url":"","repo_url":"https://github.com/prompt-toolkit/ptpython","languages":["Python"]},{"id":283,"type":"Open Source","name":"terraform-aws-cloudfront","url":"https://registry.terraform.io/modules/terraform-aws-modules/cloudfront/aws","repo_url":"https://github.com/terraform-aws-modules/terraform-aws-cloudfront","languages":["HCL"]},{"id":284,"type":"Open Source","name":"dd-trace-py","url":"https://ddtrace.readthedocs.io/","repo_url":"https://github.com/DataDog/dd-trace-py","languages":["Python"]},{"id":285,"type":"Open Source","name":"graphql-core-promise","url":null,"repo_url":"https://github.com/fellowapp/graphql-core-promise","languages":["Python"]},{"id":286,"type":"Open Source","name":"phoenix_storybook","url":"","repo_url":"https://github.com/phenixdigital/phoenix_storybook","languages":["Elixir"]},{"id":287,"type":"Open Source","name":"coc-biome","url":null,"repo_url":"https://github.com/fannheyward/coc-biome","languages":["TypeScript"]},{"id":288,"type":"Open Source","name":"autodoc_pydantic","url":"","repo_url":"https://github.com/mansenfranzen/autodoc_pydantic","languages":["Python"]},{"id":289,"type":"Open Source","name":"ansible-navigator","url":"https://ansible.readthedocs.io/projects/navigator/","repo_url":"https://github.com/ansible/ansible-navigator","languages":["Python"]},{"id":290,"type":"Open Source","name":"alexxcons.github.io","url":null,"repo_url":"https://github.com/alexxcons/alexxcons.github.io","languages":["HTML"]},{"id":291,"type":"Open Source","name":"headlessui","url":"https://headlessui.com","repo_url":"https://github.com/tailwindlabs/headlessui","languages":["TypeScript"]},{"id":292,"type":"Open Source","name":"biome","url":"https://biomejs.dev","repo_url":"https://github.com/biomejs/biome","languages":["Rust"]},{"id":293,"type":"Open Source","name":"typeshed","url":"","repo_url":"https://github.com/python/typeshed","languages":["Python"]},{"id":294,"type":"Open Source","name":"nixpkgs","url":"","repo_url":"https://github.com/NixOS/nixpkgs","languages":["Nix"]},{"id":295,"type":"Open Source","name":"corenet","url":"","repo_url":"https://github.com/apple/corenet","languages":["Jupyter Notebook"]},{"id":296,"type":"Open Source","name":"axlearn","url":"","repo_url":"https://github.com/apple/axlearn","languages":["Python"]},{"id":297,"type":"Open Source","name":"poetry_to_uv","url":null,"repo_url":"https://github.com/PacificGilly/poetry_to_uv","languages":["Python"]},{"id":298,"type":"Open Source","name":"django-ordered-model","url":"","repo_url":"https://github.com/django-ordered-model/django-ordered-model","languages":["Python"]},{"id":299,"type":"Open Source","name":"remirror","url":"https://remirror.io","repo_url":"https://github.com/remirror/remirror","languages":["TypeScript"]},{"id":300,"type":"Open Source","name":"aafigure","url":null,"repo_url":"https://github.com/aafigure/aafigure","languages":["Python"]},{"id":301,"type":"Open Source","name":"openfeature.dev","url":"https://openfeature.dev","repo_url":"https://github.com/open-feature/openfeature.dev","languages":["TypeScript"]},{"id":302,"type":"Open Source","name":"react-vtree","url":"https://lodin.github.io/react-vtree/","repo_url":"https://github.com/Lodin/react-vtree","languages":["TypeScript"]},{"id":303,"type":"Open Source","name":"vite-plugin-react","url":"","repo_url":"https://github.com/vitejs/vite-plugin-react","languages":["TypeScript"]},{"id":304,"type":"Open Source","name":"cli-agent-orchestrator","url":null,"repo_url":"https://github.com/awslabs/cli-agent-orchestrator","languages":["Python"]},{"id":305,"type":"Open Source","name":"mcp-claude-code","url":"","repo_url":"https://github.com/SDGLBL/mcp-claude-code","languages":["Python"]},{"id":306,"type":"Open Source","name":"OpenHands","url":"https://openhands.dev","repo_url":"https://github.com/OpenHands/OpenHands","languages":["Python"]},{"id":307,"type":"Open Source","name":"astro","url":"https://astro.build","repo_url":"https://github.com/withastro/astro","languages":["TypeScript"]},{"id":308,"type":"Open Source","name":"software-agent-sdk","url":"","repo_url":"https://github.com/OpenHands/software-agent-sdk","languages":["Python"]}]

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = [{"id":20000,"component_name":"SoftwareApp","created_date":"2013-10-08","title":"Created the tmuxp project","actor":10000},{"id":20001,"component_name":"SoftwareApp","created_date":"2017-04-17","title":"Created the unihan-etl project","actor":10004},{"id":20002,"component_name":"SoftwareApp","created_date":"2013-05-20","title":"Created the CLI interface to the cihai project","actor":10003},{"id":20003,"component_name":"SoftwareLib","created_date":"2016-10-08","title":"Created the libtmux project","actor":10001},{"id":20004,"component_name":"SoftwareLib","created_date":"2017-04-16","title":"Created the cihai CJK (Chinese, Japanese, Korean) data project","actor":10002},{"id":20005,"component_name":"SoftwareLib","created_date":"2017-05-29","title":"Created a database backend for UNIHAN","actor":10005},{"id":20006,"component_name":"SoftwareLib","created_date":"2017-11-26","title":"Created a django package, django-slugify-processor","actor":10006},{"id":20007,"component_name":"SoftwareLib","created_date":"2016-06-20","title":"Decoupled libvcs from vcspull","actor":10008},{"id":20008,"component_name":"SoftwareApp","created_date":"2013-10-06","title":"Created vcspull synchronization tool for git/mercurial/subversion","actor":10007},{"id":20009,"component_name":"SoftwareApp","created_date":"2021-03-26","title":"Created web component for social media embeds","actor":10010},{"id":20010,"component_name":"SoftwareLib","created_date":"2021-04-01","title":"Decoupled library utilities from social-media web component","actor":10009},{"id":30000,"component_name":"Patch","created_date":"2007-04-12","accepted_date":"2007-06-18","qa_url":"https://www.drupal.org/project/event/issues/143542","diff_url":"https://www.drupal.org/files/issues/event_32.patch","title":"Improving RSS feeds","actor":20000},{"id":30001,"component_name":"Patch","created_date":"2008-01-23","accepted_date":"2008-02-06","qa_url":"https://www.drupal.org/project/drupal/issues/213172","diff_url":"https://www.drupal.org/files/issues/color_imageless_0.patch","title":"Eliminate Color.module base_image requirement on 6.0","actor":20001},{"id":30002,"component_name":"Patch","created_date":"2014-12-27","accepted_date":"2015-02-24","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=196303","diff_url":"https://bz-attachments.freebsd.org/attachment.cgi?id=150996","title":"x11-fonts/lohit: Fix typo in files/pkg-message.in","actor":20002},{"id":30003,"component_name":"Patch","created_date":"2016-02-19","accepted_date":"2016-04-06","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=207336","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=167177","title":"Storage Controller Interface driver - typo in unimplemented macro in scic_sds_controller_registers.h","actor":20002},{"id":30004,"component_name":"Patch","created_date":"2016-02-19","accepted_date":null,"qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=207337","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=167179","title":"libi386: typo in struct in pxe.h","actor":20002},{"id":30005,"component_name":"Patch","created_date":"2017-03-04","accepted_date":"2017-03-30","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=216672","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=180483","title":"[NEW PORT] devel/py-libtmux: python API for tmux","actor":20002},{"id":30006,"component_name":"Patch","created_date":"2014-12-29","accepted_date":"2015-03-22","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=196306","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=151072","title":"[NEW PORT] devel/py-kaptan: Config file parser for json, yaml and ini files","actor":20002},{"id":30007,"component_name":"Patch","created_date":"2016-01-07","accepted_date":"2016-01-09","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=205987","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=165189","title":"sysutils/py-tmuxp: Update to 0.9.3 for tmux 2.1 compatibility","actor":20002},{"id":30008,"component_name":"Patch","created_date":"2014-12-29","accepted_date":"2015-03-22","qa_url":"https://bugs.freebsd.org/bugzilla/show_bug.cgi?id=196307","diff_url":"https://bugs.freebsd.org/bugzilla/attachment.cgi?id=151080","title":"[NEW PORT] sysutils/py-tmuxp: Session manager for tmux","actor":20002},{"id":40000,"component_name":"Work","created_date":"2014-04-01","end_date":"2015-02-05","title":"Full-stack Developer at Boostable","description":"Node.js / Sail.js -> Django. Stripe integration czar","actor":50003},{"id":40001,"component_name":"Work","created_date":"2017-01-01","title":"Founder and Programmer at devel.tech","description":"What happens when a scrappy open source programmer wants to build his own utopia for programmers.","actor":40000},{"id":40002,"component_name":"Work","created_date":"2008-01-01","end_date":"2011-01-01","title":"Software Developer","description":"Developing Drupal based SAAS platform, attending conferences, sales via GoToMeeting/Video conferences","actor":50000},{"id":40003,"component_name":"Work","created_date":"2011-10-01","end_date":"2012-01-01","title":"Software Developer","description":"NYU Poly + Bloomberg incubator on Varick. Social media campaign at 1-800-Flowers. Single Page JS applications and Facebook API. (Acquired by Merkle.)","actor":50001},{"id":40004,"component_name":"Work","created_date":"2012-11-01","end_date":"2013-04-01","title":"Software Developer","description":"Back with MORE love for making social social media campaigns for awesome customers like 1-800-Flowers, Marie Claire, and Elle","duties":["Facebook API"],"actor":50002},{"id":40005,"component_name":"Work","created_date":"2018-03-01","title":"Senior Developer at Peergrade","description":"Peer Grading Platform","actor":50004},{"id":50000,"component_name":"Publication","created_date":"2017-01-01","title":"Published The Tao of tmux","actor":30000},{"id":60000,"component_name":"Volunteer","created_date":"2013-01-01","title":"System Administrator at Wengu","actor":40002},{"id":70000,"component_name":"Website","created_date":"2013-01-01","title":"Inherited HSKFlashCards from Xoogler, Jacob Marble","actor":40001},{"id":70001,"component_name":"Article","created_date":"2017-07-04","title":"Django vs Flask","actor":40000,"url":"https://devel.tech/features/django-vs-flask","featured":{"HN":"https://news.ycombinator.com/item?id=14690638","/r/python":"https://www.reddit.com/r/Python/comments/6iti1z/django_vs_flask_a_practitioners_perspective_2017/","/r/flask":"https://www.reddit.com/r/flask/comments/6itkvf/django_vs_flask_a_practitioners_perspective_2017/","/r/django":"https://www.reddit.com/r/django/comments/6iti8o/django_vs_flask_a_practitioners_perspective_2017/"}}]

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = [{"id":10000,"type":"Open Source","name":"tmuxp","url":"https://tmuxp.git-pull.com/","repo_url":"https://github.com/tmux-python/tmuxp/","docs_url":"https://tmuxp.git-pull.com","api_url":"https://tmuxp.git-pull.com/api/","ci_url":"https://travis-ci.org/tmux-python/tmuxp","coverage_url":"https://codecov.io/gh/tmux-python/tmuxp","changelog_url":"https://tmuxp.git-pull.com/history.html","issues_url":"https://github.com/tmux-python/tmuxp/issues","browse_code_tests_url":"https://github.com/tmux-python/tmuxp/tree/master/tests","browse_code_url":"https://github.com/tmux-python/tmuxp/tree/master/src/tmuxp","languages":["Python"],"logo":"https://tmuxp.git-pull.com/_static/img/tmuxp.svg"},{"id":10001,"type":"Open Source","name":"libtmux","url":"https://libtmux.git-pull.com/","repo_url":"https://github.com/tmux-python/libtmux/","docs_url":"https://libtmux.git-pull.com","api_url":"https://libtmux.git-pull.com/api/","ci_url":"https://travis-ci.org/tmux-python/libtmux","coverage_url":"https://codecov.io/gh/tmux-python/libtmux","changelog_url":"https://libtmux.git-pull.com/history.html","issues_url":"https://github.com/tmux-python/libtmux/issues","browse_code_tests_url":"https://github.com/tmux-python/libtmux/tree/master/tests","browse_code_url":"https://github.com/tmux-python/libtmux/tree/master/src/libtmux","languages":["Python"],"logo":"https://libtmux.git-pull.com/_static/img/libtmux.svg"},{"id":10002,"type":"Open Source","name":"cihai","url":"https://cihai.git-pull.com/","repo_url":"https://github.com/cihai/cihai/","docs_url":"https://cihai.git-pull.com","api_url":"https://cihai.git-pull.com/api/","ci_url":"https://travis-ci.org/cihai/cihai","coverage_url":"https://codecov.io/gh/cihai/cihai","changelog_url":"https://cihai.git-pull.com/history.html","issues_url":"https://github.com/cihai/cihai/issues","browse_code_tests_url":"https://github.com/cihai/cihai/tree/master/tests","browse_code_url":"https://github.com/cihai/cihai/tree/master/src/cihai","languages":["Python"],"logo":"https://cihai.git-pull.com/_static/img/cihai.svg"},{"id":10003,"type":"Open Source","name":"cihai-cli","url":"https://cihai-cli.git-pull.com/","repo_url":"https://github.com/cihai-cli/cihai-cli/","docs_url":"https://cihai-cli.git-pull.com","api_url":"https://cihai-cli.git-pull.com/api/","ci_url":"https://travis-ci.org/cihai/cihai-cli","coverage_url":"https://codecov.io/gh/cihai/cihai-cli","changelog_url":"https://cihai-cli.git-pull.com/history.html","issues_url":"https://github.com/cihai/cihai-cli/issues","browse_code_tests_url":"https://github.com/cihai/cli/tree/master/tests","browse_code_url":"https://github.com/cihai/cli/tree/master/src/cihai_cli","languages":["Python"],"logo":"https://cihai-cli.git-pull.com/_static/img/cihai.svg"},{"id":10004,"type":"Open Source","name":"unihan-etl","url":"https://unihan-etl.git-pull.com/","repo_url":"https://github.com/cihai/unihan-etl/","docs_url":"https://unihan-etl.git-pull.com","api_url":"https://unihan-etl.git-pull.com/api/","ci_url":"https://travis-ci.org/cihai/unihan-etl","coverage_url":"https://codecov.io/gh/cihai/unihan-etl","changelog_url":"https://unihan-etl.git-pull.com/history.html","issues_url":"https://github.com/cihai/unihan-etl/issues","browse_code_tests_url":"https://github.com/cihai/unihan-etl/tree/master/tests","browse_code_url":"https://github.com/cihai/unihan-etl/tree/master/src/unihan_etl","languages":["Python"],"logo":"https://unihan-etl.git-pull.com/_static/img/cihai.svg"},{"id":10005,"type":"Open Source","name":"unihan-db","url":"https://unihan-db.git-pull.com/","repo_url":"https://github.com/cihai/unihan-db/","docs_url":"https://unihan-db.git-pull.com","api_url":"https://unihan-db.git-pull.com/api/","ci_url":"https://travis-ci.org/cihai/unihan-db","coverage_url":"https://codecov.io/gh/cihai/unihan-db","changelog_url":"https://unihan-db.git-pull.com/history.html","issues_url":"https://github.com/cihai/unihan-db/issues","browse_code_tests_url":"https://github.com/cihai/unihan-db/tree/master/tests","browse_code_url":"https://github.com/cihai/unihan-db/tree/master/src/unihan_db","languages":["Python"],"logo":"https://unihan-db.git-pull.com/_static/img/cihai.svg"},{"id":10006,"type":"Open Source","name":"django-slugify-processor","url":"https://django-slugify-processor.git-pull.com/","repo_url":"https://github.com/tony/django-slugify-processor/","docs_url":"https://django-slugify-processor.git-pull.com","api_url":"https://django-slugify-processor.git-pull.com/api.html","ci_url":"https://travis-ci.org/tony/django-slugify-processor","coverage_url":"https://codecov.io/gh/tony/django-slugify-processor","changelog_url":"https://django-slugify-processor.git-pull.com/history.html","issues_url":"https://github.com/tony/django-slugify-processor/issues","browse_code_tests_url":"https://github.com/tony/django-slugify-processor/tree/master/tests","browse_code_url":"https://github.com/tony/django-slugify-processor/tree/master/src/django_slugify_processor","languages":["Python"]},{"id":10007,"type":"Open Source","name":"vcspull","url":"https://vcspull.git-pull.com/","repo_url":"https://github.com/vcs-python/vcspull/","docs_url":"https://vcspull.git-pull.com","api_url":"https://vcspull.git-pull.com/api/","ci_url":"https://travis-ci.org/vcs-python/vcspull","coverage_url":"https://codecov.io/gh/vcs-python/vcspull","changelog_url":"https://vcspull.git-pull.com/history.html","issues_url":"https://github.com/vcs-python/vcspull/issues","browse_code_tests_url":"https://github.com/vcs-python/vcspull/tree/master/tests","browse_code_url":"https://github.com/vcs-python/vcspull/tree/master/src/vcspull","languages":["Python"],"logo":"https://vcspull.git-pull.com/_static/img/vcspull.svg"},{"id":10008,"type":"Open Source","name":"libvcs","url":"https://libvcs.git-pull.com/","repo_url":"https://github.com/vcs-python/libvcs/","docs_url":"https://libvcs.git-pull.com","api_url":"https://libvcs.git-pull.com/internals/","ci_url":"https://travis-ci.org/vcs-python/libvcs","coverage_url":"https://codecov.io/gh/vcs-python/libvcs","changelog_url":"https://libvcs.git-pull.com/history.html","issues_url":"https://github.com/vcs-python/libvcs/issues","browse_code_tests_url":"https://github.com/vcs-python/libvcs/tree/master/tests","browse_code_url":"https://github.com/vcs-python/libvcs/tree/master/src/libvcs","languages":["Python"],"logo":"https://libvcs.git-pull.com/_static/img/libvcs.svg"},{"id":10009,"type":"Open Source","name":"@social-embed/lib","url":"https://social-embed.git-pull.com/","repo_url":"https://github.com/social-embed/social-embed/","docs_url":"https://social-embed.git-pull.com","ci_url":"https://github.com/social-embed/social-embed/actions","changelog_url":"https://github.com/social-embed/social-embed/blob/master/CHANGES.md","issues_url":"https://github.com/social-embed/social-embed/labels/component%3Alib","browse_code_tests_url":"https://github.com/social-embed/social-embed/tree/master/packages/lib/test","browse_code_url":"https://github.com/social-embed/social-embed/tree/master/packages/lib","languages":["TypeScript","JavaScript"]},{"id":10010,"org":"Open Source","name":"@social-embed/wc","url":"https://social-embed.git-pull.com/","repo_url":"https://github.com/social-embed/social-embed/","docs_url":"https://social-embed.git-pull.com","ci_url":"https://github.com/social-embed/social-embed/actions","changelog_url":"https://github.com/social-embed/social-embed/blob/master/CHANGES.md","issues_url":"https://github.com/social-embed/social-embed/labels/component%3Awc","browse_code_tests_url":"https://github.com/social-embed/social-embed/tree/master/packages/wc/test","browse_code_url":"https://github.com/social-embed/social-embed/tree/master/packages/wc","languages":["TypeScript","JavaScript"]},{"id":20000,"type":"Open Source","name":"Drupal Events","url":"https://www.drupal.org/project/event","repo_url":"https://cgit.drupalcode.org/event","docs_url":"https://www.drupal.org/documentation/modules/event","issues_url":"https://www.drupal.org/project/issues/event?categories=All","changelog_url":"https://www.drupal.org/node/3238/commits","browse_code_url":"https://cgit.drupalcode.org/event","languages":["PHP"]},{"id":20001,"type":"Open Source","name":"Drupal","url":"https://www.drupal.org/project/drupal","repo_url":"https://cgit.drupalcode.org/drupal","docs_url":"https://www.drupal.org/documentation/modules/drupal","issues_url":"https://www.drupal.org/project/issues/drupal?categories=All","changelog_url":"https://www.drupal.org/list-changes/drupal","browse_code_url":"https://cgit.drupalcode.org/drupal","languages":["PHP"]},{"id":20002,"type":"Open Source","name":"FreeBSD (Main tracker/bugzilla)","url":"https://www.freebsd.org","repo_url":"https://svn.freebsd.org/","docs_url":"https://www.freebsd.org/docs.html","issues_url":"https://bugs.freebsd.org/bugzilla/","changelog_url":"https://www.freebsd.org/releases/","browse_code_url":"https://github.com/freebsd/freebsd","languages":["Makefile"]},{"id":30000,"type":"Publication","name":"The Tao of tmux","url":"https://leanpub.com/the-tao-of-tmux","logo":"/static/img/taooftmux.png","languages":["Markdown","ShellScript"],"leanpub_url":"https://leanpub.com/the-tao-of-tmux","amazon_url":"http://amzn.to/2gPfRhC","goodreads_url":"https://www.goodreads.com/book/show/33246223-the-tao-of-tmux"},{"id":40000,"type":"Company","name":"devel.tech","url":"https://devel.tech/","logo":"/static/img/develtech.png","languages":["JavaScript","Python"]},{"id":40001,"type":"Website","name":"HSK FlashCards","url":"https://www.hskflashcards.com/","logo":"/static/img/hsk.png","languages":["JavaScript","Python"]},{"id":40002,"type":"Website","name":"Wengu","url":"http://wengu.tartarie.com/","logo":"/static/img/wengu.jpg","languages":["PHP"]},{"id":50000,"type":"Company","name":"Buzzr","url":"https://buzzr.com","logo":"/static/img/buzzr.jpg","languages":["JavaScript","PHP"]},{"id":50001,"type":"Company","name":"Social Amp","url":"https://web.archive.org/web/20160302231819/http://www.socialamp.com:80/","old_url":"https://socialamp.com","logo":"/static/img/socialamp.png","languages":["JavaScript","PHP"]},{"id":50002,"type":"Company","name":"Merkle","url":"https://www.merkleinc.com","logo":"/static/img/merkle.png","languages":["JavaScript","PHP"]},{"id":50003,"type":"Company","name":"Boostable","url":"https://web.archive.org/web/20150727124553/https://www.boostable.com/","old_url":"https://boostable.com","logo":"/static/img/boostable.png","languages":["JavaScript","Python"]},{"id":50004,"type":"Company","name":"Peergrade","url":"https://www.peergrade.io","logo":"/static/img/peergrade-blue.png","languages":["JavaScript","Python"]}]

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toggleActivity = exports.toggleActivity = function toggleActivity(id) {
  return {
    type: 'TOGGLE_ACTIVITY',
    id: id
  };
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(34);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(37);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(38);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _props = __webpack_require__(108);

var _constants = __webpack_require__(67);

var _Activity = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityList = function (_React$Component) {
  (0, _inherits3.default)(ActivityList, _React$Component);

  function ActivityList() {
    (0, _classCallCheck3.default)(this, ActivityList);
    return (0, _possibleConstructorReturn3.default)(this, (ActivityList.__proto__ || (0, _getPrototypeOf2.default)(ActivityList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActivityList, [{
    key: 'render',
    value: function render() {
      var activities = this.props.activities;

      var items = activities.map(function (item) {
        var component = _Activity.Components[item.component_name];
        return _react2.default.createElement(component, (0, _assign2.default)({
          key: item['id'],
          activityType: _constants.activityTypes.find(function (a) {
            return item.component_name === a.component_name;
          }).singular_name
        }, item));
      });

      return _react2.default.createElement(
        'div',
        { className: 'list' },
        _react2.default.createElement(
          'div',
          null,
          items
        )
      );
    }
  }]);
  return ActivityList;
}(_react2.default.Component);

ActivityList.propTypes = _props.activityListProp;
exports.default = ActivityList;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(209);
module.exports = __webpack_require__(0).Object.getPrototypeOf;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(19);
var $getPrototypeOf = __webpack_require__(85);

__webpack_require__(104)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(212);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(214), __esModule: true };

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
__webpack_require__(86);
module.exports = __webpack_require__(68).f('iterator');


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(216), __esModule: true };

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217);
__webpack_require__(78);
__webpack_require__(222);
__webpack_require__(223);
module.exports = __webpack_require__(0).Symbol;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(5);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(81);
var META = __webpack_require__(218).KEY;
var $fails = __webpack_require__(17);
var shared = __webpack_require__(53);
var setToStringTag = __webpack_require__(30);
var uid = __webpack_require__(29);
var wks = __webpack_require__(3);
var wksExt = __webpack_require__(68);
var wksDefine = __webpack_require__(69);
var enumKeys = __webpack_require__(219);
var isArray = __webpack_require__(220);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(10);
var toObject = __webpack_require__(19);
var toIObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(49);
var createDesc = __webpack_require__(21);
var _create = __webpack_require__(50);
var gOPNExt = __webpack_require__(221);
var $GOPD = __webpack_require__(107);
var $GOPS = __webpack_require__(57);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(18);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(106).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(25).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(20)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(29)('meta');
var isObject = __webpack_require__(10);
var has = __webpack_require__(12);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(17)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(57);
var pIE = __webpack_require__(25);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(23);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(13);
var gOPN = __webpack_require__(106).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('asyncIterator');


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('observable');


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(225), __esModule: true };

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
module.exports = __webpack_require__(0).Object.setPrototypeOf;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(227).set });


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(7);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(16)(Function.call, __webpack_require__(107).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(229), __esModule: true };

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(230);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(50) });


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = undefined;

var _getPrototypeOf = __webpack_require__(34);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(37);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(38);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _props = __webpack_require__(108);

var _Boxes = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function (_React$Component) {
  (0, _inherits3.default)(Row, _React$Component);

  function Row() {
    (0, _classCallCheck3.default)(this, Row);
    return (0, _possibleConstructorReturn3.default)(this, (Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).apply(this, arguments));
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-10 col-md-offset-1 col-xs-12' },
          _react2.default.createElement(
            'div',
            { className: 'box' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-4 col-xs-12 item' },
                this.props.leftbox
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-8 col-xs-12 item' },
                this.props.rightbox
              )
            )
          )
        )
      );
    }
  }]);
  return Row;
}(_react2.default.Component);

var Activity = function (_React$Component2) {
  (0, _inherits3.default)(Activity, _React$Component2);

  function Activity() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, Activity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).call.apply(_ref, [this].concat(args))), _this2), _this2.leftbox = _react2.default.createElement(_Boxes.LeftBox, _this2.props), _this2.rightbox = _react2.default.createElement(_Boxes.RightBox, _this2.props), _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(Activity, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Row, { leftbox: this.leftbox, rightbox: this.rightbox });
    }
  }]);
  return Activity;
}(_react2.default.Component);

Activity.propTypes = _props.activityProp;

var Patch = function (_Activity) {
  (0, _inherits3.default)(Patch, _Activity);

  function Patch() {
    var _ref2;

    var _temp2, _this3, _ret2;

    (0, _classCallCheck3.default)(this, Patch);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Patch.__proto__ || (0, _getPrototypeOf2.default)(Patch)).call.apply(_ref2, [this].concat(args))), _this3), _this3.rightbox = _react2.default.createElement(_Boxes.PatchRightBox, _this3.props), _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret2);
  }

  return Patch;
}(Activity);

var Publication = function (_Activity2) {
  (0, _inherits3.default)(Publication, _Activity2);

  function Publication() {
    var _ref3;

    var _temp3, _this4, _ret3;

    (0, _classCallCheck3.default)(this, Publication);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Publication.__proto__ || (0, _getPrototypeOf2.default)(Publication)).call.apply(_ref3, [this].concat(args))), _this4), _this4.rightbox = _react2.default.createElement(_Boxes.PublicationRightBox, _this4.props), _temp3), (0, _possibleConstructorReturn3.default)(_this4, _ret3);
  }

  return Publication;
}(Activity);

var Article = function (_Activity3) {
  (0, _inherits3.default)(Article, _Activity3);

  function Article() {
    var _ref4;

    var _temp4, _this5, _ret4;

    (0, _classCallCheck3.default)(this, Article);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = Article.__proto__ || (0, _getPrototypeOf2.default)(Article)).call.apply(_ref4, [this].concat(args))), _this5), _this5.rightbox = _react2.default.createElement(_Boxes.ArticleRightBox, _this5.props), _temp4), (0, _possibleConstructorReturn3.default)(_this5, _ret4);
  }

  return Article;
}(Activity);

var SoftwareLib = function (_Activity4) {
  (0, _inherits3.default)(SoftwareLib, _Activity4);

  function SoftwareLib() {
    var _ref5;

    var _temp5, _this6, _ret5;

    (0, _classCallCheck3.default)(this, SoftwareLib);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret5 = (_temp5 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref5 = SoftwareLib.__proto__ || (0, _getPrototypeOf2.default)(SoftwareLib)).call.apply(_ref5, [this].concat(args))), _this6), _this6.rightbox = _react2.default.createElement(_Boxes.SoftwareRightBox, _this6.props), _temp5), (0, _possibleConstructorReturn3.default)(_this6, _ret5);
  }

  return SoftwareLib;
}(Activity);

var SoftwareApp = function (_Activity5) {
  (0, _inherits3.default)(SoftwareApp, _Activity5);

  function SoftwareApp() {
    var _ref6;

    var _temp6, _this7, _ret6;

    (0, _classCallCheck3.default)(this, SoftwareApp);

    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _ret6 = (_temp6 = (_this7 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = SoftwareApp.__proto__ || (0, _getPrototypeOf2.default)(SoftwareApp)).call.apply(_ref6, [this].concat(args))), _this7), _this7.rightbox = _react2.default.createElement(_Boxes.SoftwareRightBox, _this7.props), _temp6), (0, _possibleConstructorReturn3.default)(_this7, _ret6);
  }

  return SoftwareApp;
}(Activity);

var Components = exports.Components = {
  Patch: Patch,
  Article: Article,
  Work: Activity,
  SoftwareLib: SoftwareLib,
  SoftwareApp: SoftwareApp,
  Volunteer: Activity,
  Publication: Publication,
  Website: Activity
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoftwareRightBox = exports.ArticleRightBox = exports.PublicationRightBox = exports.PatchRightBox = exports.RightBox = exports.LeftBox = undefined;

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactOcticon = __webpack_require__(233);

var _reactOcticon2 = _interopRequireDefault(_reactOcticon);

var _reactMoment = __webpack_require__(237);

var _reactMoment2 = _interopRequireDefault(_reactMoment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftBox = exports.LeftBox = function LeftBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    _react2.default.createElement(
      'h2',
      null,
      props.activityType
    ),
    _react2.default.createElement(
      'p',
      { className: 'align-octicon' },
      _react2.default.createElement(
        'small',
        null,
        _react2.default.createElement(_reactOcticon2.default, { name: 'clock' }),
        _react2.default.createElement(
          'span',
          null,
          ' ',
          _react2.default.createElement(
            _reactMoment2.default,
            { fromNow: true },
            props.created_date
          ),
          ' '
        ),
        '(',
        props.created_date,
        ')'
      )
    ),
    props.actor.languages ? props.actor.languages.map(function (language, i) {
      return _react2.default.createElement(
        'span',
        {
          className: 'tag language-tag',
          key: i,
          style: language.color ? {
            backgroundColor: language.color,
            color: language.textColor
          } : {}
        },
        language.name
      );
    }) : null
  );
};

var RightBox = exports.RightBox = function RightBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    props.actor.logo && props.actor.logo.length > 0 && _react2.default.createElement(
      'a',
      {
        href: props.actor.url,
        target: '_blank',
        className: 'align-octicon',
        rel: 'noopener noreferrer'
      },
      _react2.default.createElement('img', {
        src: props.actor.logo,
        className: 'logo',
        style: { maxWidth: 400 },
        alt: props.actor.name
      })
    ),
    _react2.default.createElement(
      'h3',
      null,
      _react2.default.createElement(
        'a',
        {
          href: props.qa_url,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: 'activity-title'
        },
        props.title
      )
    )
  );
};

var PatchRightBox = exports.PatchRightBox = function PatchRightBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    _react2.default.createElement(
      'h3',
      { className: 'align-octicon-bottom' },
      _react2.default.createElement(
        'a',
        {
          href: props.qa_url,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: 'activity-title'
        },
        _react2.default.createElement(_reactOcticon2.default, { name: 'mark-github', label: 'View on GitHub' }),
        ' ',
        props.title
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'em',
        null,
        'was contributed to the',
        ' ',
        _react2.default.createElement(
          'a',
          {
            href: props.actor.url,
            rel: 'noopener noreferrer',
            target: '_blank',
            className: 'muted-link'
          },
          props.actor.name
        ),
        ' ',
        'project'
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'small',
        null,
        _react2.default.createElement(
          'a',
          {
            href: props.actor.repo_url,
            rel: 'noopener noreferrer',
            target: '_blank',
            className: 'muted-link align-octicon'
          },
          _react2.default.createElement(_reactOcticon2.default, { name: 'repo', label: 'GH' }),
          'Repository',
          ' '
        ),
        props.in_re_url && props.in_re_url.length > 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              href: props.in_re_url,
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'issue'
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              href: props.qa_url,
              rel: 'noopener noreferrer',
              target: '_blank',
              className: 'muted-link align-octicon'
            },
            _react2.default.createElement(_reactOcticon2.default, { name: 'git-pull-request', label: 'Pull Request' }),
            'Pull Request'
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          ' ',
          _react2.default.createElement(
            'a',
            {
              href: props.diff_url,
              rel: 'noopener noreferrer',
              target: '_blank',
              className: 'muted-link align-octicon'
            },
            _react2.default.createElement(_reactOcticon2.default, { name: 'diff', label: 'Diff' }),
            '.diff File'
          )
        )
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'small',
        null,
        props.accepted_date ? _react2.default.createElement(
          'span',
          { className: 'align-octicon' },
          _react2.default.createElement(_reactOcticon2.default, { name: 'check', label: 'Merged' }),
          'Accepted ',
          props.accepted_date
        ) : _react2.default.createElement(
          'em',
          null,
          'Unmerged'
        )
      )
    )
  );
};

var PublicationRightBox = exports.PublicationRightBox = function PublicationRightBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    _react2.default.createElement(
      'h3',
      { className: 'align-octicon-bottom' },
      _react2.default.createElement(
        'a',
        {
          href: props.actor.url,
          rel: 'noopener noreferrer',
          target: '_blank',
          className: 'activity-title'
        },
        props.title
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'small',
        null,
        'Seen on',
        ' ',
        props.actor.leanpub_url && props.actor.leanpub_url.length > 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              href: props.actor.leanpub_url,
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'Leanpub'
          )
        ),
        ' ',
        props.actor.amazon_url && props.actor.amazon_url.length > 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              href: props.actor.amazon_url,
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'Amazon'
          )
        ),
        ' ',
        props.actor.goodreads_url && props.actor.goodreads_url.length > 0 && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              href: props.actor.goodreads_url,
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'Goodreads'
          )
        )
      )
    )
  );
};

var ArticleRightBox = exports.ArticleRightBox = function ArticleRightBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    _react2.default.createElement(
      'h3',
      { className: 'align-octicon-bottom' },
      _react2.default.createElement(
        'a',
        {
          href: props.actor.url,
          rel: 'noopener noreferrer',
          target: '_blank',
          className: 'activity-title'
        },
        props.title
      )
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'small',
        null,
        'Discussed on',
        ' ',
        props.featured ? (0, _keys2.default)(props.featured).map(function (title) {
          return _react2.default.createElement(
            'span',
            { key: title },
            _react2.default.createElement(
              'a',
              {
                href: props.featured[title],
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              title
            ),
            ' '
          );
        }) : null
      )
    )
  );
};

var SoftwareRightBox = exports.SoftwareRightBox = function SoftwareRightBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'box' },
    props.actor.logo && props.actor.logo.length > 0 && _react2.default.createElement(
      'a',
      {
        href: props.actor.url,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'align-octicon'
      },
      _react2.default.createElement('img', {
        src: props.actor.logo,
        className: 'logo',
        style: { maxWidth: 200 },
        alt: props.actor.name
      })
    ),
    _react2.default.createElement(
      'h3',
      { className: 'align-octicon-bottom' },
      _react2.default.createElement(
        'a',
        {
          href: props.actor.url,
          rel: 'noopener noreferrer',
          target: '_blank',
          className: 'activity-title'
        },
        props.title
      )
    ),
    _react2.default.createElement(
      'small',
      { className: 'bottompad10' },
      _react2.default.createElement(
        'div',
        { className: 'software-project-links' },
        props.actor.url && props.actor.url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.url,
            rel: 'noopener noreferrer',
            target: '_blank',
            className: 'align-octicon'
          },
          _react2.default.createElement(_reactOcticon2.default, { name: 'home', label: 'Website' }),
          ' Website'
        ),
        props.actor.repo_url && props.actor.repo_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.repo_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'mark-github', label: 'Repo' }),
          ' GitHub'
        ),
        props.actor.docs_url && props.actor.docs_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.docs_url,
            target: '_blank',
            className: 'align-octicon',
            rel: 'noopener noreferrer'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'book', label: 'Docs' }),
          ' Docs'
        ),
        props.actor.api_url && props.actor.api_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.api_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'search', label: 'API' }),
          ' API'
        ),
        props.actor.coverage_url && props.actor.coverage_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.coverage_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'graph', label: 'Coverage' }),
          ' Coverage'
        ),
        props.actor.ci_url && props.actor.ci_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.ci_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'dashboard', label: 'CI' }),
          ' CI'
        ),
        props.actor.browse_code_url && props.actor.browse_code_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.browse_code_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'code', label: 'CI' }),
          ' Browse Code'
        ),
        props.actor.browse_code_tests_url && props.actor.browse_code_tests_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.browse_code_tests_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          '(tests)'
        ),
        props.actor.issues_url && props.actor.issues_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.issues_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'comment-discussion', label: 'CI' }),
          ' Issues'
        ),
        props.actor.changelog_url && props.actor.changelog_url.length > 0 && _react2.default.createElement(
          'a',
          {
            href: props.actor.changelog_url,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'align-octicon'
          },
          ' ',
          _react2.default.createElement(_reactOcticon2.default, { name: 'list-unordered', label: 'Changelog' }),
          ' ',
          'Changelog'
        )
      )
    )
  );
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

__webpack_require__(234);

var _Octicon = __webpack_require__(235);

var _Octicon2 = _interopRequireDefault(_Octicon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Octicon2.default;
module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

__webpack_require__(236);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconNames =  false ? 'alert arrow-down arrow-left arrow-right arrow-small-down arrow-small-left arrow-small-right arrow-small-up arrow-up beaker bell bold book bookmark briefcase broadcast browser bug calendar check checklist chevron-down chevron-left chevron-right chevron-up circle-slash circuit-board clippy clock cloud-download cloud-upload code comment-discussion comment credit-card dash dashboard database desktop-download device-camera-video device-camera device-desktop device-mobile diff-added diff-ignored diff-modified diff-removed diff-renamed diff ellipses ellipsis eye file-binary file-code file-directory file-media file-pdf file-submodule file-symlink-directory file-symlink-file file-text file-zip file flame fold gear gift gist-secret gist git-branch git-commit git-compare git-merge git-pull-request globe grabber graph heart history home horizontal-rule hubot inbox info issue-closed issue-opened issue-reopened italic jersey key keyboard law light-bulb link-external link list-ordered list-unordered location lock logo-gist logo-github mail-read mail-reply mail mark-github markdown megaphone mention milestone mirror mortar-board mute no-newline octoface organization package paintcan pencil person pin plug plus-small plus primitive-dot primitive-square pulse question quote radio-tower reply repo-clone repo-force-push repo-forked repo-pull repo-push repo rocket rss ruby search server settings shield sign-in sign-out smiley squirrel star stop sync tag tasklist telescope terminal text-size three-bars thumbsdown thumbsup tools trashcan triangle-down triangle-left triangle-right triangle-up unfold unmute unverified verified versions watch x zap'.split(' ') : [];

var Octicon = (_temp = _class = function (_React$Component) {
  _inherits(Octicon, _React$Component);

  function Octicon() {
    _classCallCheck(this, Octicon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Octicon.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        className = _props.className,
        mega = _props.mega,
        spin = _props.spin,
        props = _objectWithoutProperties(_props, ['name', 'className', 'mega', 'spin']);

    var classNames = [mega ? 'mega-octicon' : 'octicon', 'octicon-' + name];
    if (spin) {
      classNames.push('spin-octicon');
    }
    if (className) {
      classNames.push(className);
    }
    return _react2.default.createElement('span', _extends({}, props, { className: classNames.join(' ') }));
  };

  return Octicon;
}(_react2.default.Component), _class.defaultProps = {
  mega: false,
  spin: false
}, _temp);
exports.default = Octicon;
Octicon.propTypes =  false ? {
  name: _propTypes2.default.oneOf(iconNames).isRequired,
  className: _propTypes2.default.string,
  mega: _propTypes2.default.bool,
  spin: _propTypes2.default.bool
} : {};
module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(64),__webpack_require__(1)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){e.exports=n(3)()},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";var r=n(4);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,a){if(a!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){var r,o,i,a,l;
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
a=this,l=function(e){var t=!1,n=!1,r="escape years months weeks days hours minutes seconds milliseconds general".split(" "),o=[{type:"seconds",targets:[{type:"minutes",value:60},{type:"hours",value:3600},{type:"days",value:86400},{type:"weeks",value:604800},{type:"months",value:2678400},{type:"years",value:31536e3}]},{type:"minutes",targets:[{type:"hours",value:60},{type:"days",value:1440},{type:"weeks",value:10080},{type:"months",value:44640},{type:"years",value:525600}]},{type:"hours",targets:[{type:"days",value:24},{type:"weeks",value:168},{type:"months",value:744},{type:"years",value:8760}]},{type:"days",targets:[{type:"weeks",value:7},{type:"months",value:31},{type:"years",value:365}]},{type:"months",targets:[{type:"years",value:12}]}];function i(e,t){return!(t.length>e.length)&&-1!==e.indexOf(t)}function a(e){for(var t="";e;)t+="0",e-=1;return t}function l(e,t,r){var o,i,u,s=t.useToLocaleString,c=t.useGrouping,m=c&&t.grouping.slice(),f=t.maximumSignificantDigits,p=t.minimumIntegerDigits||1,g=t.fractionDigits||0,y=t.groupingSeparator,h=t.decimalSeparator;if(s&&r){var d={minimumIntegerDigits:p,useGrouping:c};if(g&&(d.maximumFractionDigits=g,d.minimumFractionDigits=g),f&&e>0&&(d.maximumSignificantDigits=f),!n){var v=w({},t);v.useGrouping=!1,v.decimalSeparator=".",e=parseFloat(l(e,v),10)}return e.toLocaleString(r,d)}var b=(f?e.toPrecision(f+1):e.toFixed(g+1)).split("e");u=b[1]||"",i=(b=b[0].split("."))[1]||"";var S=(o=b[0]||"").length,T=i.length,_=S+T,x=o+i;(f&&_===f+1||!f&&T===g+1)&&((x=function(e){for(var t=e.split("").reverse(),n=0,r=!0;r&&n<t.length;)n?"9"===t[n]?t[n]="0":(t[n]=(parseInt(t[n],10)+1).toString(),r=!1):(parseInt(t[n],10)<5&&(r=!1),t[n]="0"),n+=1;return r&&t.push("1"),t.reverse().join("")}(x)).length===_+1&&(S+=1),T&&(x=x.slice(0,-1)),o=x.slice(0,S),i=x.slice(S)),f&&(i=i.replace(/0*$/,""));var O=parseInt(u,10);O>0?i.length<=O?(o+=i+=a(O-i.length),i=""):(o+=i.slice(0,O),i=i.slice(O)):O<0&&(i=a(Math.abs(O)-o.length)+o+i,o="0"),f||((i=i.slice(0,g)).length<g&&(i+=a(g-i.length)),o.length<p&&(o=a(p-o.length)+o));var V,D="";if(c)for(b=o;b.length;)m.length&&(V=m.shift()),D&&(D=y+D),D=b.slice(-V)+D,b=b.slice(0,-V);else D=o;return i&&(D=D+h+i),D}function u(e,t){return e.label.length>t.label.length?-1:e.label.length<t.label.length?1:0}var s,c={durationLabelsStandard:{S:"millisecond",SS:"milliseconds",s:"second",ss:"seconds",m:"minute",mm:"minutes",h:"hour",hh:"hours",d:"day",dd:"days",w:"week",ww:"weeks",M:"month",MM:"months",y:"year",yy:"years"},durationLabelsShort:{S:"msec",SS:"msecs",s:"sec",ss:"secs",m:"min",mm:"mins",h:"hr",hh:"hrs",d:"dy",dd:"dys",w:"wk",ww:"wks",M:"mo",MM:"mos",y:"yr",yy:"yrs"},durationTimeTemplates:{HMS:"h:mm:ss",HM:"h:mm",MS:"m:ss"},durationLabelTypes:[{type:"standard",string:"__"},{type:"short",string:"_"}],durationPluralKey:function(e,t,n){return 1===t&&null===n?e:e+e}};function m(e){return"[object Array]"===Object.prototype.toString.call(e)}function f(e){return"[object Object]"===Object.prototype.toString.call(e)}function p(e,t){var n,r=0,o=e&&e.length||0;for("function"!=typeof t&&(n=t,t=function(e){return e===n});r<o;){if(t(e[r]))return e[r];r+=1}}function g(e,t){var n=0,r=e.length;if(e&&r)for(;n<r;){if(!1===t(e[n],n))return;n+=1}}function y(e,t){var n=0,r=e.length,o=[];if(!e||!r)return o;for(;n<r;)o[n]=t(e[n],n),n+=1;return o}function h(e,t){return y(e,function(e){return e[t]})}function d(e){var t=[];return g(e,function(e){e&&t.push(e)}),t}function v(e){var t=[];return g(e,function(e){p(t,e)||t.push(e)}),t}function b(e,t){var n=[];return g(e,function(e){g(t,function(t){e===t&&n.push(e)})}),v(n)}function S(e,t){var n=[];return g(e,function(r,o){if(!t(r))return n=e.slice(o),!1}),n}function w(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function T(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function _(e,t){var n=0,r=e.length;if(!e||!r)return!1;for(;n<r;){if(!0===t(e[n],n))return!0;n+=1}return!1}function x(){var e,t=[].slice.call(arguments),n={};if(g(t,function(t,r){if(!r){if(!m(t))throw"Expected array as the first argument to durationsFormat.";e=t}"string"!=typeof t&&"function"!=typeof t?"number"!=typeof t?f(t)&&w(n,t):n.precision=t:n.template=t}),!e||!e.length)return[];n.returnMomentTypes=!0;var o,i=y(e,function(e){return e.format(n)}),a=b(r,v(h((o=[],g(i,function(e){o=o.concat(e)}),o),"type"))),l=n.largest;return l&&(a=a.slice(0,l)),n.returnMomentTypes=!1,n.outputTypes=a,y(e,function(e){return e.format(n)})}function O(){var n=[].slice.call(arguments),a=w({},this.format.defaults),s=this.asMilliseconds(),x=this.asMonths();"function"==typeof this.isValid&&!1===this.isValid()&&(s=0,x=0);var O=s<0,V=e.duration(Math.abs(s),"milliseconds"),D=e.duration(Math.abs(x),"months");g(n,function(e){"string"!=typeof e&&"function"!=typeof e?"number"!=typeof e?f(e)&&w(a,e):a.precision=e:a.template=e});var L={years:"y",months:"M",weeks:"w",days:"d",hours:"h",minutes:"m",seconds:"s",milliseconds:"S"},j={escape:/\[(.+?)\]/,years:/\*?[Yy]+/,months:/\*?M+/,weeks:/\*?[Ww]+/,days:/\*?[Dd]+/,hours:/\*?[Hh]+/,minutes:/\*?m+/,seconds:/\*?s+/,milliseconds:/\*?S+/,general:/.+?/};a.types=r;var M=function(e){return p(r,function(t){return j[t].test(e)})},k=new RegExp(y(r,function(e){return j[e].source}).join("|"),"g");a.duration=this;var P="function"==typeof a.template?a.template.apply(a):a.template,E=a.outputTypes,F=a.returnMomentTypes,I=a.largest,C=[];E||(m(a.stopTrim)&&(a.stopTrim=a.stopTrim.join("")),a.stopTrim&&g(a.stopTrim.match(k),function(e){var t=M(e);"escape"!==t&&"general"!==t&&C.push(t)}));var N=e.localeData();N||(N={}),g(T(c),function(e){"function"!=typeof c[e]?N["_"+e]||(N["_"+e]=c[e]):N[e]||(N[e]=c[e])}),g(T(N._durationTimeTemplates),function(e){P=P.replace("_"+e+"_",N._durationTimeTemplates[e])});var G=a.userLocale||e.locale(),R=a.useLeftUnits,U=a.usePlural,q=a.precision,z=a.forceLength,H=a.useGrouping,W=a.trunc,$=a.useSignificantDigits&&q>0,A=$?a.precision:0,B=A,K=a.minValue,Y=!1,J=a.maxValue,Q=!1,X=a.useToLocaleString,Z=a.groupingSeparator,ee=a.decimalSeparator,te=a.grouping;X=X&&t;var ne=a.trim;m(ne)&&(ne=ne.join(" ")),null===ne&&(I||J||$)&&(ne="all"),null!==ne&&!0!==ne&&"left"!==ne&&"right"!==ne||(ne="large"),!1===ne&&(ne="");var re=function(e){return e.test(ne)},oe=/both/,ie=/^all|[^sm]all/,ae=I>0||_([/large/,oe,ie],re),le=_([/small/,oe,ie],re),ue=_([/mid/,ie],re),se=_([/final/,ie],re),ce=y(P.match(k),function(e,t){var n=M(e);return"*"===e.slice(0,1)&&(e=e.slice(1),"escape"!==n&&"general"!==n&&C.push(n)),{index:t,length:e.length,text:"",token:"escape"===n?e.replace(j.escape,"$1"):e,type:"escape"===n||"general"===n?null:n}}),me={index:0,length:0,token:"",text:"",type:null},fe=[];R&&ce.reverse(),g(ce,function(e){if(e.type)return(me.type||me.text)&&fe.push(me),void(me=e);R?me.text=e.token+me.text:me.text+=e.token}),(me.type||me.text)&&fe.push(me),R&&fe.reverse();var pe=b(r,v(d(h(fe,"type"))));if(!pe.length)return h(fe,"text").join("");pe=y(pe,function(e,t){var n,r=t+1===pe.length,o=!t;n="years"===e||"months"===e?D.as(e):V.as(e);var i=Math.floor(n),l=n-i,u=p(fe,function(t){return e===t.type});return o&&J&&n>J&&(Q=!0),r&&K&&Math.abs(a.duration.as(e))<K&&(Y=!0),o&&null===z&&u.length>1&&(z=!0),V.subtract(i,e),D.subtract(i,e),{rawValue:n,wholeValue:i,decimalValue:r?l:0,isSmallest:r,isLargest:o,type:e,tokenLength:u.length}});var ge,ye=W?Math.floor:Math.round,he=function(e,t){var n=Math.pow(10,t);return ye(e*n)/n},de=!1,ve=!1,be=function(e,t){var n={useGrouping:H,groupingSeparator:Z,decimalSeparator:ee,grouping:te,useToLocaleString:X};return $&&(A<=0?(e.rawValue=0,e.wholeValue=0,e.decimalValue=0):(n.maximumSignificantDigits=A,e.significantDigits=A)),Q&&!ve&&(e.isLargest?(e.wholeValue=J,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),Y&&!ve&&(e.isSmallest?(e.wholeValue=K,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),e.isSmallest||e.significantDigits&&e.significantDigits-e.wholeValue.toString().length<=0?q<0?e.value=he(e.wholeValue,q):0===q?e.value=ye(e.wholeValue+e.decimalValue):$?(e.value=W?he(e.rawValue,A-e.wholeValue.toString().length):e.rawValue,e.wholeValue&&(A-=e.wholeValue.toString().length)):(n.fractionDigits=q,e.value=W?e.wholeValue+he(e.decimalValue,q):e.wholeValue+e.decimalValue):$&&e.wholeValue?(e.value=Math.round(he(e.wholeValue,e.significantDigits-e.wholeValue.toString().length)),A-=e.wholeValue.toString().length):e.value=e.wholeValue,e.tokenLength>1&&(z||de)&&(n.minimumIntegerDigits=e.tokenLength,ve&&n.maximumSignificantDigits<e.tokenLength&&delete n.maximumSignificantDigits),!de&&(e.value>0||""===ne||p(C,e.type)||p(E,e.type))&&(de=!0),e.formattedValue=l(e.value,n,G),n.useGrouping=!1,n.decimalSeparator=".",e.formattedValueEn=l(e.value,n,"en"),2===e.tokenLength&&"milliseconds"===e.type&&(e.formattedValueMS=l(e.value,{minimumIntegerDigits:3,useGrouping:!1},"en").slice(0,2)),e};if((pe=d(pe=y(pe,be))).length>1){var Se=function(e){return p(pe,function(t){return t.type===e})};g(o,function(e){var t=Se(e.type);t&&g(e.targets,function(e){var n=Se(e.type);n&&parseInt(t.formattedValueEn,10)===e.value&&(t.rawValue=0,t.wholeValue=0,t.decimalValue=0,n.rawValue+=1,n.wholeValue+=1,n.decimalValue=0,n.formattedValueEn=n.wholeValue.toString(),ve=!0)})})}return ve&&(de=!1,A=B,pe=d(pe=y(pe,be))),!E||Q&&!a.trim?(ae&&(pe=S(pe,function(e){return!e.isSmallest&&!e.wholeValue&&!p(C,e.type)})),I&&pe.length&&(pe=pe.slice(0,I)),le&&pe.length>1&&(ge=function(e){return!e.wholeValue&&!p(C,e.type)&&!e.isLargest},pe=S(pe.slice().reverse(),ge).reverse()),ue&&(pe=d(pe=y(pe,function(e,t){return t>0&&t<pe.length-1&&!e.wholeValue?null:e}))),!se||1!==pe.length||pe[0].wholeValue||!W&&pe[0].isSmallest&&pe[0].rawValue<K||(pe=[])):pe=d(pe=y(pe,function(e){return p(E,function(t){return e.type===t})?e:null})),F?pe:(g(fe,function(e){var t=L[e.type],n=p(pe,function(t){return t.type===e.type});if(t&&n){var r=n.formattedValueEn.split(".");r[0]=parseInt(r[0],10),r[1]?r[1]=parseFloat("0."+r[1],10):r[1]=null;var o=N.durationPluralKey(t,r[0],r[1]),a=function(e,t){var n=[];return g(T(t),function(r){if("_durationLabels"===r.slice(0,15)){var o=r.slice(15).toLowerCase();g(T(t[r]),function(i){i.slice(0,1)===e&&n.push({type:o,key:i,label:t[r][i]})})}}),n}(t,N),l=!1,s={};g(N._durationLabelTypes,function(t){var n=p(a,function(e){return e.type===t.type&&e.key===o});n&&(s[n.type]=n.label,i(e.text,t.string)&&(e.text=e.text.replace(t.string,n.label),l=!0))}),U&&!l&&(a.sort(u),g(a,function(t){return s[t.type]===t.label?!i(e.text,t.label)&&void 0:i(e.text,t.label)?(e.text=e.text.replace(t.label,s[t.type]),!1):void 0}))}}),(fe=y(fe,function(e){if(!e.type)return e.text;var t=p(pe,function(t){return t.type===e.type});if(!t)return"";var n="";return R&&(n+=e.text),(O&&Q||!O&&Y)&&(n+="< ",Q=!1,Y=!1),(O&&Y||!O&&Q)&&(n+="> ",Q=!1,Y=!1),O&&(t.value>0||""===ne||p(C,t.type)||p(E,t.type))&&(n+="-",O=!1),"milliseconds"===e.type&&t.formattedValueMS?n+=t.formattedValueMS:n+=t.formattedValue,R||(n+=e.text),n})).join("").replace(/(,| |:|\.)*$/,"").replace(/^(,| |:|\.)*/,""))}function V(){var e=this.duration,t=function(t){return e._data[t]},n=p(this.types,t),r=function(e,t){for(var n=e.length;n-=1;)if(t(e[n]))return e[n]}(this.types,t);switch(n){case"milliseconds":return"S __";case"seconds":case"minutes":return"*_MS_";case"hours":return"_HMS_";case"days":if(n===r)return"d __";case"weeks":return n===r?"w __":(null===this.trim&&(this.trim="both"),"w __, d __, h __");case"months":if(n===r)return"M __";case"years":return n===r?"y __":(null===this.trim&&(this.trim="both"),"y __, M __, d __");default:return null===this.trim&&(this.trim="both"),"y __, d __, h __, m __, s __"}}function D(e){if(!e)throw"Moment Duration Format init cannot find moment instance.";e.duration.format=x,e.duration.fn.format=O,e.duration.fn.format.defaults={trim:null,stopTrim:null,largest:null,maxValue:null,minValue:null,precision:0,trunc:!1,forceLength:null,userLocale:null,usePlural:!0,useLeftUnits:!1,useGrouping:!0,useSignificantDigits:!1,template:V,useToLocaleString:!0,groupingSeparator:",",decimalSeparator:".",grouping:[3]},e.updateLocale("en",c)}return t=!!((s=(s=!0)&&function(){try{(0).toLocaleString("i")}catch(e){return"RangeError"===e.name}return!1}())&&(s=(s=(s=s&&"1"===1..toLocaleString("en",{minimumIntegerDigits:1}))&&"01"===1..toLocaleString("en",{minimumIntegerDigits:2}))&&"001"===1..toLocaleString("en",{minimumIntegerDigits:3}))&&(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumFractionDigits:0,minimumFractionDigits:0}))&&"100.0"===99.99.toLocaleString("en",{maximumFractionDigits:1,minimumFractionDigits:1}))&&"99.99"===99.99.toLocaleString("en",{maximumFractionDigits:2,minimumFractionDigits:2}))&&"99.990"===99.99.toLocaleString("en",{maximumFractionDigits:3,minimumFractionDigits:3}))&&(s=(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:1}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:2}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:3}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:4}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:5}))&&(s=(s=s&&"1,000"===1e3.toLocaleString("en",{useGrouping:!0}))&&"1000"===1e3.toLocaleString("en",{useGrouping:!1}))),n=t&&"3.6"===3.55.toLocaleString("en",{useGrouping:!1,minimumIntegerDigits:1,minimumFractionDigits:1,maximumFractionDigits:1}),D(e),D},o=[n(1)],void 0===(i="function"==typeof(r=l)?r.apply(t,o):r)||(e.exports=i),a&&(a.momentDurationFormatSetup=a.moment?l(a.moment):l)},function(e,t,n){"use strict";n.r(t);var r=n(2),o=n.n(r),i=n(0),a=n.n(i),l=n(1),u=n.n(l);n(5);function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function m(e){return(m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function g(e,t,n){return t&&p(e.prototype,t),n&&p(e,n),e}function y(e,t){return(y=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function h(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,"default",function(){return S});var d=[a.a.string,a.a.number,a.a.array,a.a.object],v=[a.a.string,a.a.array],b=[a.a.object,a.a.bool],S=function(e){function t(e){var n,r,o;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,o=m(t).call(this,e),n=!o||"object"!==s(o)&&"function"!=typeof o?f(r):o,h(f(n),"setTimer",function(){var e=n.props.interval;n.clearTimer(),t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))}),h(f(n),"getTitle",function(){var e=n.props.titleFormat,r=t.getDatetime(n.props),o=e||t.globalFormat;return r.format(o)}),h(f(n),"clearTimer",function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(f(n))}),t.globalMoment||(t.globalMoment=u.a),n.state={content:""},n.timer=null,n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&y(e,t)}(t,o.a.Component),g(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){e instanceof t?-1===t.pooledElements.indexOf(e)&&t.pooledElements.push(e):console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);-1!==n&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,l=e.tz,u=e.local;o=o||e.children,a=a||t.globalParse,u=u||t.globalLocal,l=l||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var s=null;return s=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),l?s=s.tz(l):u&&(s=s.local()),s}},{key:"getContent",value:function(e){var n=e.fromNow,r=e.fromNowDuring,o=e.from,i=e.add,a=e.subtract,l=e.toNow,s=e.to,c=e.ago,m=e.calendar,f=e.diff,p=e.duration,g=e.durationFromNow,y=e.unit,h=e.decimal,d=e.format;d=d||t.globalFormat;var v=t.getDatetime(e);i&&v.add(i),a&&v.subtract(a);var b=Boolean(r)&&-v.diff(u()())<r,S="";return S=d&&!b?v.format(d):o?v.from(o,c):n||b?v.fromNow(c):s?v.to(s,c):l?v.toNow(c):m?v.calendar(null,m):f?v.diff(f,y,h):p?v.diff(p):g?u()().diff(v):v.toString(),(p||g)&&(S=(S=u.a.duration(S)).format(d)),S=(t.globalFilter||e.filter)(S)}}]),g(t,[{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentDidUpdate",value:function(e){var t=this.props.interval;e.interval!==t&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=e||this.props,r=n.onChange,o=t.getContent(n);this.setState({content:o},function(){r(o)})}},{key:"render",value:function(){var e,n,r,i,a=this.props,l=a.withTitle,u=a.element,s=c(a,["withTitle","element"]),m=this.state.content,f=(e=s,n=t.propTypes,r=Object.keys(n),i=Object.assign({},e),Object.keys(i).filter(function(e){return-1!==r.indexOf(e)}).forEach(function(e){return delete i[e]}),i);return l&&(f.title=this.getTitle()),o.a.createElement(u||t.globalElement,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){h(e,t,n[t])})}return e}({dateTime:t.getDatetime(this.props)},f),m)}}],[{key:"getDerivedStateFromProps",value:function(e){return{content:t.getContent(e)}}}]),t}();h(S,"propTypes",{element:a.a.any,date:a.a.oneOfType(d),parse:a.a.oneOfType(v),format:a.a.string,add:a.a.object,subtract:a.a.object,ago:a.a.bool,fromNow:a.a.bool,fromNowDuring:a.a.number,from:a.a.oneOfType(d),toNow:a.a.bool,to:a.a.oneOfType(d),calendar:a.a.oneOfType(b),unix:a.a.bool,utc:a.a.bool,local:a.a.bool,tz:a.a.string,withTitle:a.a.bool,titleFormat:a.a.string,locale:a.a.string,interval:a.a.number,diff:a.a.oneOfType(d),duration:a.a.oneOfType(d),durationFromNow:a.a.bool,unit:a.a.string,decimal:a.a.bool,filter:a.a.func,onChange:a.a.func}),h(S,"defaultProps",{element:null,fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,local:!1,unit:null,withTitle:!1,decimal:!1,titleFormat:"",interval:6e4,filter:function(e){return e},onChange:function(){}}),h(S,"globalMoment",null),h(S,"globalLocale",null),h(S,"globalLocal",null),h(S,"globalFormat",null),h(S,"globalParse",null),h(S,"globalFilter",null),h(S,"globalElement","time"),h(S,"globalTimezone",null),h(S,"pooledElements",[]),h(S,"pooledTimer",null)}])});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(34);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(37);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(38);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(240);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(243);

var _reactRedux = __webpack_require__(32);

var _reactCheckboxGroup = __webpack_require__(244);

var _ActivityList = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lenses = function (_React$Component) {
  (0, _inherits3.default)(Lenses, _React$Component);

  function Lenses() {
    (0, _classCallCheck3.default)(this, Lenses);
    return (0, _possibleConstructorReturn3.default)(this, (Lenses.__proto__ || (0, _getPrototypeOf2.default)(Lenses)).apply(this, arguments));
  }

  (0, _createClass3.default)(Lenses, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'row lenses' },
        _react2.default.createElement(
          'div',
          {
            className: 'col-xs-10 col-xs-offset-1',
            style: { textAlign: 'left' }
          },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'selected-actors',
            multi: true,
            simpleValue: true,
            options: this.props.availableActors_select,
            value: this.props.selectedActors.length ? this.props.selectedActors : '',
            placeholder: 'Lookup by Place/Project/Company - e.g. tmuxp, Social Amp, The Tao of tmux',
            onChange: this.props.onSelectedActorChange
          }),
          _react2.default.createElement(_reactSelect2.default, {
            name: 'selected-activity-types',
            multi: true,
            simpleValue: true,
            options: this.props.activityTypes_select,
            value: this.props.selectedActivityTypes.length ? this.props.selectedActivityTypes : '',
            placeholder: 'Filter by Activity Type(s) - e.g. Work, Open Source, Website, Volunteering',
            onChange: this.props.onSelectedActivityTypesChange
          }),
          _react2.default.createElement(_reactSelect2.default, {
            name: 'selected-languages',
            multi: true,
            simpleValue: true,
            options: this.props.availableLanguages_select,
            value: this.props.selectedLanguages.length ? this.props.selectedLanguages : '',
            placeholder: 'Filter by Programming Language(s) - e.g. Python, JavaScript, C++',
            onChange: this.props.onSelectedLanguageChange
          }),
          _react2.default.createElement(
            _reactCheckboxGroup.CheckboxGroup,
            {
              name: 'selected-filters',
              value: this.props.selectedFilters,
              onChange: this.props.onSelectedFiltersChange,
              style: { textAlign: 'center' },
              className: 'row choices',
              checkboxDepth: 3
            },
            (0, _keys2.default)(this.props.filters).map(function (filterChoice) {
              return _react2.default.createElement(
                'div',
                { className: 'col-sm', key: filterChoice },
                _react2.default.createElement(
                  'div',
                  { className: 'box' },
                  _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: filterChoice, id: filterChoice }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: filterChoice },
                    _react2.default.createElement(
                      'span',
                      null,
                      filterChoice
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return Lenses;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(_ActivityList.mapStateToProps, _ActivityList.mapDispatchToProps)(Lenses);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = exports.Checkbox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = exports.Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!(this.props && this.props.checkboxGroup)) {
        throw new Error('The `Checkbox` component must be used as a child of `CheckboxGroup`.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$checkboxGroup = _props.checkboxGroup,
          name = _props$checkboxGroup.name,
          checkedValues = _props$checkboxGroup.checkedValues,
          onChange = _props$checkboxGroup.onChange,
          rest = _objectWithoutProperties(_props, ['checkboxGroup']);

      var optional = {};
      if (checkedValues) {
        optional.checked = checkedValues.indexOf(this.props.value) >= 0;
      }
      if (typeof onChange === 'function') {
        optional.onChange = onChange.bind(null, this.props.value);
      }

      return _react2.default.createElement('input', _extends({}, rest, {
        type: 'checkbox',
        name: name,
        disabled: this.props.disabled
      }, optional));
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.displayName = 'Checkbox';

var CheckboxGroup = exports.CheckboxGroup = function (_Component2) {
  _inherits(CheckboxGroup, _Component2);

  function CheckboxGroup(props) {
    _classCallCheck(this, CheckboxGroup);

    var _this2 = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));

    _this2._prepareBoxes = function (children) {
      var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (depth > maxDepth) {
        return children;
      }

      var checkboxGroup = {
        name: _this2.props.name,
        checkedValues: _this2.state.value,
        onChange: _this2._onCheckboxChange
      };

      return _react2.default.Children.map(children, function (child) {
        if (!(child && child.$$typeof)) {
          return child;
        } else if (child.type === Checkbox) {
          return _react2.default.cloneElement(child, { checkboxGroup: checkboxGroup });
        } else {
          return _react2.default.cloneElement(child, {}, child.props.children ? _react2.default.Children.map(child.props.children, function (c) {
            return _this2._prepareBoxes(c, maxDepth, depth + 1);
          }) : null);
        }
      });
    };

    _this2._isControlledComponent = _this2._isControlledComponent.bind(_this2);
    _this2._onCheckboxChange = _this2._onCheckboxChange.bind(_this2);
    _this2.getValue = _this2.getValue.bind(_this2);
    _this2.state = {
      value: _this2.props.value || _this2.props.defaultValue || []
    };
    return _this2;
  }

  _createClass(CheckboxGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value) {
        this.setState({
          value: newProps.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          Component = _props2.Component,
          name = _props2.name,
          value = _props2.value,
          onChange = _props2.onChange,
          children = _props2.children,
          _props2$checkboxDepth = _props2.checkboxDepth,
          checkboxDepth = _props2$checkboxDepth === undefined ? 1 : _props2$checkboxDepth,
          rest = _objectWithoutProperties(_props2, ['Component', 'name', 'value', 'onChange', 'children', 'checkboxDepth']);

      return _react2.default.createElement(
        Component,
        rest,
        this._prepareBoxes(children, checkboxDepth)
      );
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: '_isControlledComponent',
    value: function _isControlledComponent() {
      return Boolean(this.props.value);
    }
  }, {
    key: '_onCheckboxChange',
    value: function _onCheckboxChange(checkboxValue, event) {
      var newValue = void 0;
      if (event.target.checked) {
        newValue = this.state.value.concat(checkboxValue);
      } else {
        newValue = this.state.value.filter(function (v) {
          return v !== checkboxValue;
        });
      }

      if (this._isControlledComponent()) {
        this.setState({ value: this.props.value });
      } else {
        this.setState({ value: newValue });
      }

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(newValue, event, this.props.name);
      }
    }
  }]);

  return CheckboxGroup;
}(_react.Component);

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.defaultProps = {
  Component: "div"
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(34);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(36);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(37);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(38);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(32);

var _reactChartjs = __webpack_require__(246);

var _ActivityList = __webpack_require__(62);

var _charts = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguagePie = function (_React$Component) {
  (0, _inherits3.default)(LanguagePie, _React$Component);

  function LanguagePie() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LanguagePie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LanguagePie.__proto__ || (0, _getPrototypeOf2.default)(LanguagePie)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (i, proxy) {
      if (i && i.length) {
        var language = i[0]._model.label;
        _this.props.onSelectedLanguageAdd(language);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LanguagePie, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactChartjs.Pie, {
        data: this.props.activitiesPie,
        options: _charts.pieOptions,
        legend: _charts.pieOptions.legend,
        height: 250,
        onElementsClick: this.handleOnClick
      });
    }
  }]);
  return LanguagePie;
}(_react2.default.Component); /* eslint no-underscore-dangle: 0 import/no-extraneous-dependencies: 0 */


var ActivityLine = function (_React$Component2) {
  (0, _inherits3.default)(ActivityLine, _React$Component2);

  function ActivityLine() {
    (0, _classCallCheck3.default)(this, ActivityLine);
    return (0, _possibleConstructorReturn3.default)(this, (ActivityLine.__proto__ || (0, _getPrototypeOf2.default)(ActivityLine)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActivityLine, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactChartjs.Line, {
        data: this.props.activitiesLine,
        options: _charts.timeLineOptions,
        legend: _charts.timeLineOptions.legend
      });
    }
  }]);
  return ActivityLine;
}(_react2.default.Component);

var Charts = function (_React$Component3) {
  (0, _inherits3.default)(Charts, _React$Component3);

  function Charts() {
    (0, _classCallCheck3.default)(this, Charts);
    return (0, _possibleConstructorReturn3.default)(this, (Charts.__proto__ || (0, _getPrototypeOf2.default)(Charts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Charts, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'charts row padBottom' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-2 col-sm-offset-2' },
          _react2.default.createElement(LanguagePie, {
            activitiesPie: this.props.activitiesPie,
            onSelectedLanguageAdd: this.props.onSelectedLanguageAdd,
            selectedLanguages: this.props.selectedLanguages,
            style: {
              width: '100%',
              height: '250px',
              position: 'relative'
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-6' },
          _react2.default.createElement(ActivityLine, {
            activitiesLine: this.props.activitiesLine,
            style: {
              width: '100%',
              height: '250px',
              position: 'relative'
            }
          })
        )
      );
    }
  }]);
  return Charts;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(_ActivityList.mapStateToProps, _ActivityList.mapDispatchToProps)(Charts);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Chart", {
  enumerable: true,
  get: function get() {
    return _chart["default"];
  }
});
exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(14));

var _chart = _interopRequireDefault(__webpack_require__(248));

var _isEqual = _interopRequireDefault(__webpack_require__(249));

var _keyBy = _interopRequireDefault(__webpack_require__(311));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production";

var ChartComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  var _super = _createSuper(ChartComponent);

  function ChartComponent() {
    var _this;

    _classCallCheck(this, ChartComponent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      var instance = _this.chartInstance;
      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
      _this.element = element;
    });

    _this.chartInstance = undefined;
    return _this;
  }

  _createClass(ChartComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.redraw) {
        this.destroyChart();
        this.renderChart();
        return;
      }

      this.updateChart();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          redraw = _this$props2.redraw,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;

      if (nextProps.redraw === true) {
        return true;
      }

      if (height !== nextProps.height || width !== nextProps.width) {
        return true;
      }

      if (type !== nextProps.type) {
        return true;
      }

      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
        return true;
      }

      if (!(0, _isEqual["default"])(options, nextProps.options)) {
        return true;
      }

      var nextData = this.transformDataProp(nextProps);

      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
        return true;
      }

      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "transformDataProp",
    value: function transformDataProp(props) {
      var data = props.data;

      if (typeof data == 'function') {
        var node = this.element;
        return data(node);
      } else {
        return data;
      }
    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
    // this makes impossible to compare the current and next data changes
    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617

  }, {
    key: "memoizeDataProps",
    value: function memoizeDataProps() {
      if (!this.props.data) {
        return;
      }

      var data = this.transformDataProp(this.props);
      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
        datasets: data.datasets && data.datasets.map(function (set) {
          return _objectSpread({}, set);
        })
      });
      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

      return data;
    }
  }, {
    key: "checkDatasets",
    value: function checkDatasets(datasets) {
      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
      var multipleDatasets = datasets.length > 1;

      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
        var shouldWarn = false;
        datasets.forEach(function (dataset) {
          if (!dataset.label) {
            shouldWarn = true;
          }
        });

        if (shouldWarn) {
          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
        }
      }
    }
  }, {
    key: "getCurrentDatasets",
    value: function getCurrentDatasets() {
      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    }
  }, {
    key: "saveCurrentDatasets",
    value: function saveCurrentDatasets() {
      var _this2 = this;

      this.datasets = this.datasets || {};
      var currentDatasets = this.getCurrentDatasets();
      currentDatasets.forEach(function (d) {
        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
      });
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      var _this3 = this;

      var options = this.props.options;
      var data = this.memoizeDataProps(this.props);
      if (!this.chartInstance) return;

      if (options) {
        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
      } // Pipe datasets to chart instance datasets enabling
      // seamless transitions


      var currentDatasets = this.getCurrentDatasets();
      var nextDatasets = data.datasets || [];
      this.checkDatasets(currentDatasets);
      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
      // on each dataset.

      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

        if (current && current.type === next.type && next.data) {
          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
          // The data array must be edited in place. As chart.js adds listeners to it.
          current.data.splice(next.data.length);
          next.data.forEach(function (point, pid) {
            current.data[pid] = next.data[pid];
          });

          var _data = next.data,
              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
          // from next, it will be retained by current and never disappears.
          // Workaround is to set value to null or undefined in next.


          return _objectSpread(_objectSpread({}, current), otherProps);
        } else {
          return next;
        }
      });

      var datasets = data.datasets,
          rest = _objectWithoutProperties(data, ["datasets"]);

      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
      this.chartInstance.update();
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
      var node = this.element;
      var data = this.memoizeDataProps();

      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
        options.legend = legend;
      }

      this.chartInstance = new _chart["default"](node, {
        type: type,
        data: data,
        options: options,
        plugins: plugins
      });
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (!this.chartInstance) {
        return;
      } // Put all of the datasets that have existed in the chart back on the chart
      // so that the metadata associated with this chart get destroyed.
      // This allows the datasets to be used in another chart. This can happen,
      // for example, in a tabbed UI where the chart gets created each time the
      // tab gets switched to the chart and uses the same data).


      this.saveCurrentDatasets();
      var datasets = Object.values(this.datasets);
      this.chartInstance.config.data.datasets = datasets;
      this.chartInstance.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        ref: this.ref,
        height: height,
        width: width,
        id: id,
        onClick: this.handleOnClick
      });
    }
  }]);

  return ChartComponent;
}(_react["default"].Component);

_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
  return d.label;
});

_defineProperty(ChartComponent, "propTypes", {
  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
  getDatasetAtEvent: _propTypes["default"].func,
  getElementAtEvent: _propTypes["default"].func,
  getElementsAtEvent: _propTypes["default"].func,
  height: _propTypes["default"].number,
  legend: _propTypes["default"].object,
  onElementsClick: _propTypes["default"].func,
  options: _propTypes["default"].object,
  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
  redraw: _propTypes["default"].bool,
  type: function type(props, propName, componentName) {
    if (!_chart["default"].controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: _propTypes["default"].number,
  datasetKeyProvider: _propTypes["default"].func
});

_defineProperty(ChartComponent, "defaultProps", {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
});

var _default = ChartComponent;
exports["default"] = _default;

var Doughnut = /*#__PURE__*/function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  var _super2 = _createSuper(Doughnut);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _super2.apply(this, arguments);
  }

  _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref) {
          return _this4.chartInstance = _ref && _ref.chartInstance;
        },
        type: "doughnut"
      }));
    }
  }]);

  return Doughnut;
}(_react["default"].Component);

exports.Doughnut = Doughnut;

var Pie = /*#__PURE__*/function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  var _super3 = _createSuper(Pie);

  function Pie() {
    _classCallCheck(this, Pie);

    return _super3.apply(this, arguments);
  }

  _createClass(Pie, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref2) {
          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
        },
        type: "pie"
      }));
    }
  }]);

  return Pie;
}(_react["default"].Component);

exports.Pie = Pie;

var Line = /*#__PURE__*/function (_React$Component4) {
  _inherits(Line, _React$Component4);

  var _super4 = _createSuper(Line);

  function Line() {
    _classCallCheck(this, Line);

    return _super4.apply(this, arguments);
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref3) {
          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
        },
        type: "line"
      }));
    }
  }]);

  return Line;
}(_react["default"].Component);

exports.Line = Line;

var Bar = /*#__PURE__*/function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  var _super5 = _createSuper(Bar);

  function Bar() {
    _classCallCheck(this, Bar);

    return _super5.apply(this, arguments);
  }

  _createClass(Bar, [{
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref4) {
          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
        },
        type: "bar"
      }));
    }
  }]);

  return Bar;
}(_react["default"].Component);

exports.Bar = Bar;

var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  var _super6 = _createSuper(HorizontalBar);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _super6.apply(this, arguments);
  }

  _createClass(HorizontalBar, [{
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref5) {
          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
        },
        type: "horizontalBar"
      }));
    }
  }]);

  return HorizontalBar;
}(_react["default"].Component);

exports.HorizontalBar = HorizontalBar;

var Radar = /*#__PURE__*/function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  var _super7 = _createSuper(Radar);

  function Radar() {
    _classCallCheck(this, Radar);

    return _super7.apply(this, arguments);
  }

  _createClass(Radar, [{
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref6) {
          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
        },
        type: "radar"
      }));
    }
  }]);

  return Radar;
}(_react["default"].Component);

exports.Radar = Radar;

var Polar = /*#__PURE__*/function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  var _super8 = _createSuper(Polar);

  function Polar() {
    _classCallCheck(this, Polar);

    return _super8.apply(this, arguments);
  }

  _createClass(Polar, [{
    key: "render",
    value: function render() {
      var _this10 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref7) {
          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
        },
        type: "polarArea"
      }));
    }
  }]);

  return Polar;
}(_react["default"].Component);

exports.Polar = Polar;

var Bubble = /*#__PURE__*/function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  var _super9 = _createSuper(Bubble);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _super9.apply(this, arguments);
  }

  _createClass(Bubble, [{
    key: "render",
    value: function render() {
      var _this11 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref8) {
          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
        },
        type: "bubble"
      }));
    }
  }]);

  return Bubble;
}(_react["default"].Component);

exports.Bubble = Bubble;

var Scatter = /*#__PURE__*/function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  var _super10 = _createSuper(Scatter);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _super10.apply(this, arguments);
  }

  _createClass(Scatter, [{
    key: "render",
    value: function render() {
      var _this12 = this;

      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
        ref: function ref(_ref9) {
          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
        },
        type: "scatter"
      }));
    }
  }]);

  return Scatter;
}(_react["default"].Component);

exports.Scatter = Scatter;
var defaults = _chart["default"].defaults;
exports.defaults = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(247)))

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(64); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(70);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(110),
    equalArrays = __webpack_require__(115),
    equalByTag = __webpack_require__(284),
    equalObjects = __webpack_require__(288),
    getTag = __webpack_require__(306),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(117),
    isTypedArray = __webpack_require__(119);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(40);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(40);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(40);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(40);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(39);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(39),
    Map = __webpack_require__(71),
    MapCache = __webpack_require__(73);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(112),
    isMasked = __webpack_require__(264),
    isObject = __webpack_require__(72),
    toSource = __webpack_require__(114);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(265);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(268),
    ListCache = __webpack_require__(39),
    Map = __webpack_require__(71);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(269),
    hashDelete = __webpack_require__(270),
    hashGet = __webpack_require__(271),
    hashHas = __webpack_require__(272),
    hashSet = __webpack_require__(273);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(42);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 270 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(42);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(42);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(42);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(43);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(43);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(43);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(43);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(73),
    setCacheAdd = __webpack_require__(280),
    setCacheHas = __webpack_require__(281);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    Uint8Array = __webpack_require__(285),
    eq = __webpack_require__(111),
    equalArrays = __webpack_require__(115),
    mapToArray = __webpack_require__(286),
    setToArray = __webpack_require__(287);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(289);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(290),
    getSymbols = __webpack_require__(292),
    keys = __webpack_require__(74);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(291),
    isArray = __webpack_require__(9);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(293),
    stubArray = __webpack_require__(294);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(296),
    isArguments = __webpack_require__(116),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(117),
    isIndex = __webpack_require__(118),
    isTypedArray = __webpack_require__(119);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObjectLike = __webpack_require__(27);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isLength = __webpack_require__(75),
    isObjectLike = __webpack_require__(27);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(113);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(303),
    nativeKeys = __webpack_require__(304);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(305);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(307),
    Map = __webpack_require__(71),
    Promise = __webpack_require__(308),
    Set = __webpack_require__(309),
    WeakMap = __webpack_require__(310),
    baseGetTag = __webpack_require__(26),
    toSource = __webpack_require__(114);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(312),
    createAggregator = __webpack_require__(314);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(313);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(15);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(315),
    baseAggregator = __webpack_require__(316),
    baseIteratee = __webpack_require__(322),
    isArray = __webpack_require__(9);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(317);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(318),
    createBaseEach = __webpack_require__(321);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(319),
    keys = __webpack_require__(74);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(320);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(120);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(323),
    baseMatchesProperty = __webpack_require__(326),
    identity = __webpack_require__(337),
    isArray = __webpack_require__(9),
    property = __webpack_require__(338);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(324),
    getMatchData = __webpack_require__(325),
    matchesStrictComparable = __webpack_require__(122);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(110),
    baseIsEqual = __webpack_require__(70);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(121),
    keys = __webpack_require__(74);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(70),
    get = __webpack_require__(327),
    hasIn = __webpack_require__(334),
    isKey = __webpack_require__(76),
    isStrictComparable = __webpack_require__(121),
    matchesStrictComparable = __webpack_require__(122),
    toKey = __webpack_require__(44);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(123);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(329);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(330);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(73);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(332);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    arrayMap = __webpack_require__(333),
    isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(77);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(335),
    hasPath = __webpack_require__(336);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(124),
    isArguments = __webpack_require__(116),
    isArray = __webpack_require__(9),
    isIndex = __webpack_require__(118),
    isLength = __webpack_require__(75),
    toKey = __webpack_require__(44);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(339),
    basePropertyDeep = __webpack_require__(340),
    isKey = __webpack_require__(76),
    toKey = __webpack_require__(44);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(123);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(61);

var _activities = __webpack_require__(342);

var _activities2 = _interopRequireDefault(_activities);

var _actors = __webpack_require__(343);

var _actors2 = _interopRequireDefault(_actors);

var _selectedLanguages = __webpack_require__(344);

var _selectedLanguages2 = _interopRequireDefault(_selectedLanguages);

var _selectedActivityTypes = __webpack_require__(345);

var _selectedActivityTypes2 = _interopRequireDefault(_selectedActivityTypes);

var _selectedActors = __webpack_require__(346);

var _selectedActors2 = _interopRequireDefault(_selectedActors);

var _selectedFilters = __webpack_require__(347);

var _selectedFilters2 = _interopRequireDefault(_selectedFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cvReducers = (0, _redux.combineReducers)({
  actors: _actors2.default,
  selectedActors: _selectedActors2.default,
  activities: _activities2.default,
  languages: function languages() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];
    return state;
  },
  selectedLanguages: _selectedLanguages2.default,
  activityTypes: function activityTypes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];
    return state;
  },
  selectedActivityTypes: _selectedActivityTypes2.default,
  filters: function filters() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];
    return state;
  },
  selectedFilters: _selectedFilters2.default
});

exports.default = cvReducers;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var activities = function activities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
};

exports.default = activities;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actors = function actors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
};

exports.default = actors;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectedLanguages = function selectedLanguages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case 'CHANGE_SELECTED_LANGUAGES':
      return action.value;
    case 'ADD_SELECTED_LANGUAGE':
      var languages = '';
      var language = action.value;
      if (state.indexOf(language) > -1) {
        languages = state;
      } else if (state.length) {
        languages = state + ',' + language;
      } else {
        languages = language;
      }
      return languages;

    default:
      return state;
  }
};

exports.default = selectedLanguages;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectedActivityTypes = function selectedActivityTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case 'CHANGE_SELECTED_ACTIVITY_TYPES':
      return action.value;
    default:
      return state;
  }
};

exports.default = selectedActivityTypes;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectedActors = function selectedActors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case 'CHANGE_SELECTED_ACTORS':
      return action.value;
    default:
      return state;
  }
};

exports.default = selectedActors;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectedFilters = function selectedFilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case 'CHANGE_SELECTED_FILTERS':
      return action.value;
    default:
      return state;
  }
};

exports.default = selectedFilters;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = register;
exports.unregister = unregister;
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    var publicUrl = new URL("", window.location);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', function () {
      var swUrl = "" + '/service-worker.js';

      if (isLocalhost) {
        // This is running on localhost. Lets check if a service worker still exists or not.
        checkValidServiceWorker(swUrl);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(function () {
          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit https://goo.gl/SC7cgQ');
        });
      } else {
        // Is not local host. Just register service worker
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker.register(swUrl).then(function (registration) {
    registration.onupdatefound = function () {
      var installingWorker = registration.installing;
      installingWorker.onstatechange = function () {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // At this point, the old content will have been purged and
            // the fresh content will have been added to the cache.
            // It's the perfect time to display a "New content is
            // available; please refresh." message in your web app.
            console.log('New content is available; please refresh.');
          } else {
            // At this point, everything has been precached.
            // It's the perfect time to display a
            // "Content is cached for offline use." message.
            console.log('Content is cached for offline use.');
          }
        }
      };
    };
  }).catch(function (error) {
    console.error('Error during service worker registration:', error);
  });
}

function checkValidServiceWorker(swUrl) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl).then(function (response) {
    // Ensure service worker exists, and that we really are getting a JS file.
    if (response.status === 404 || response.headers.get('content-type').indexOf('javascript') === -1) {
      // No service worker found. Probably a different app. Reload the page.
      navigator.serviceWorker.ready.then(function (registration) {
        registration.unregister().then(function () {
          window.location.reload();
        });
      });
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW(swUrl);
    }
  }).catch(function () {
    console.log('No internet connection found. App is running in offline mode.');
  });
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.20dc76bb.js